
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8d20"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8d20"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8w6H4", function(module, exports) {

$parcel$export(module.exports, "_config", function () { return _config; });
$parcel$export(module.exports, "_isString", function () { return _isString; });
$parcel$export(module.exports, "_isUndefined", function () { return _isUndefined; });
$parcel$export(module.exports, "_numExp", function () { return _numExp; });
$parcel$export(module.exports, "_numWithUnitExp", function () { return _numWithUnitExp; });
$parcel$export(module.exports, "_relExp", function () { return _relExp; });
$parcel$export(module.exports, "gsap", function () { return gsap; });
$parcel$export(module.exports, "_missingPlugin", function () { return _missingPlugin; });
$parcel$export(module.exports, "_plugins", function () { return _plugins; });
$parcel$export(module.exports, "GSCache", function () { return GSCache; });
$parcel$export(module.exports, "_getCache", function () { return _getCache; });
$parcel$export(module.exports, "toArray", function () { return toArray; });
$parcel$export(module.exports, "_getProperty", function () { return _getProperty; });
$parcel$export(module.exports, "_forEachName", function () { return _forEachName; });
$parcel$export(module.exports, "_round", function () { return _round; });
$parcel$export(module.exports, "_parseRelative", function () { return _parseRelative; });
$parcel$export(module.exports, "_setDefaults", function () { return _setDefaults; });
$parcel$export(module.exports, "_removeLinkedListItem", function () { return _removeLinkedListItem; });
$parcel$export(module.exports, "_ticker", function () { return _ticker; });
$parcel$export(module.exports, "Timeline", function () { return Timeline; });
$parcel$export(module.exports, "Tween", function () { return Tween; });
$parcel$export(module.exports, "getUnit", function () { return getUnit; });
$parcel$export(module.exports, "clamp", function () { return clamp; });
$parcel$export(module.exports, "selector", function () { return selector; });
$parcel$export(module.exports, "shuffle", function () { return shuffle; });
$parcel$export(module.exports, "distribute", function () { return distribute; });
$parcel$export(module.exports, "_roundModifier", function () { return _roundModifier; });
$parcel$export(module.exports, "snap", function () { return snap; });
$parcel$export(module.exports, "random", function () { return random; });
$parcel$export(module.exports, "pipe", function () { return pipe; });
$parcel$export(module.exports, "unitize", function () { return unitize; });
$parcel$export(module.exports, "normalize", function () { return normalize; });
$parcel$export(module.exports, "mapRange", function () { return mapRange; });
$parcel$export(module.exports, "wrap", function () { return wrap; });
$parcel$export(module.exports, "wrapYoyo", function () { return wrapYoyo; });
$parcel$export(module.exports, "_replaceRandom", function () { return _replaceRandom; });
$parcel$export(module.exports, "interpolate", function () { return interpolate; });
$parcel$export(module.exports, "_getSetter", function () { return _getSetter; });
$parcel$export(module.exports, "PropTween", function () { return PropTween; });
$parcel$export(module.exports, "splitColor", function () { return splitColor; });
$parcel$export(module.exports, "_colorExp", function () { return _colorExp; });
$parcel$export(module.exports, "_colorStringFilter", function () { return _colorStringFilter; });
$parcel$export(module.exports, "Animation", function () { return Animation; });
$parcel$export(module.exports, "_renderComplexString", function () { return _renderComplexString; });
$parcel$export(module.exports, "_checkPlugin", function () { return _checkPlugin; });
$parcel$export(module.exports, "_sortPropTweensByPriority", function () { return _sortPropTweensByPriority; });
$parcel$export(module.exports, "Power0", function () { return Power0; });
$parcel$export(module.exports, "Power1", function () { return Power1; });
$parcel$export(module.exports, "Power2", function () { return Power2; });
$parcel$export(module.exports, "Power3", function () { return Power3; });
$parcel$export(module.exports, "Power4", function () { return Power4; });
$parcel$export(module.exports, "Linear", function () { return Linear; });
$parcel$export(module.exports, "Quad", function () { return Quad; });
$parcel$export(module.exports, "Cubic", function () { return Cubic; });
$parcel$export(module.exports, "Quart", function () { return Quart; });
$parcel$export(module.exports, "Quint", function () { return Quint; });
$parcel$export(module.exports, "Strong", function () { return Strong; });
$parcel$export(module.exports, "Elastic", function () { return Elastic; });
$parcel$export(module.exports, "Back", function () { return Back; });
$parcel$export(module.exports, "SteppedEase", function () { return SteppedEase; });
$parcel$export(module.exports, "Bounce", function () { return Bounce; });
$parcel$export(module.exports, "Sine", function () { return Sine; });
$parcel$export(module.exports, "Expo", function () { return Expo; });
$parcel$export(module.exports, "Circ", function () { return Circ; });
$parcel$export(module.exports, "TweenMax", function () { return Tween; });
$parcel$export(module.exports, "TweenLite", function () { return Tween; });
$parcel$export(module.exports, "TimelineMax", function () { return Timeline; });
$parcel$export(module.exports, "TimelineLite", function () { return Timeline; });
$parcel$export(module.exports, "default", function () { return gsap; });
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.14.2
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var _config = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, _defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, _suppressOverwrites, _reverting, _context, _bigNum = 1e8, _tinyNum = 1 / _bigNum, _2PI = Math.PI * 2, _HALF_PI = _2PI / 4, _gsID = 0, _sqrt = Math.sqrt, _cos = Math.cos, _sin = Math.sin, _isString = function _isString(value) {
    return typeof value === "string";
}, _isFunction = function _isFunction(value) {
    return typeof value === "function";
}, _isNumber = function _isNumber(value) {
    return typeof value === "number";
}, _isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, _isObject = function _isObject(value) {
    return typeof value === "object";
}, _isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, _windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, _isFuncOrString = function _isFuncOrString(value) {
    return _isFunction(value) || _isString(value);
}, _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray, _randomExp = /random\([^)]+\)/g, _commaDelimExp = /,\s*/g, _strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/, _delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, _globalTimeline, _win, _coreInitted, _doc, _globals = {}, _installScope = {}, _coreReady, _install = function _install(scope) {
    return (_installScope = _merge(scope, _globals)) && gsap;
}, _missingPlugin = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, _warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, _addGlobal = function _addGlobal(name, obj) {
    return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
}, _emptyFunc = function _emptyFunc() {
    return 0;
}, _startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
}, _revertConfigNoKill = {
    suppressEvents: true,
    kill: false
}, _revertConfig = {
    suppressEvents: true
}, _reservedProps = {}, _lazyTweens = [], _lazyLookup = {}, _lastRenderedFrame, _plugins = {}, _effects = {}, _nextGCFrame = 30, _harnessPlugins = [], _callbackNames = "", _harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    _isObject(target) || _isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = _harnessPlugins.length;
        while(i-- && !_harnessPlugins[i].targetTest(target));
        harnessPlugin = _harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, _getCache = function _getCache(target) {
    return target._gsap || _harness(toArray(target))[0]._gsap;
}, _getProperty = function _getProperty(target, property, v) {
    return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
}, _forEachName = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, _roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
}, // increased precision mostly for timing values.
_parseRelative = function _parseRelative(start, value) {
    var operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
}, _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, _lazyRender = function _lazyRender() {
    var l = _lazyTweens.length, a = _lazyTweens.slice(0), i, tween;
    _lazyLookup = {};
    _lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, _isRevertWorthy = function _isRevertWorthy(animation) {
    return !!(animation._initted || animation._startAt || animation.add);
}, _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    _lazyTweens.length && !_reverting && _lazyRender();
    animation.render(time, suppressEvents, force || !!(_reverting && time < 0 && _isRevertWorthy(animation)));
    _lazyTweens.length && !_reverting && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, _numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
}, _passThrough = function _passThrough(p) {
    return p;
}, _setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function(obj, defaults) {
        for(var p in defaults)p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    };
}, _merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, _mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, _copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, _inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || _globalTimeline, func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;
    if (_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, _arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
}, _uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, _recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
}, _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime = _roundPrecise(tTime / cycleDuration));
    return tTime && whole === tTime ? whole - 1 : whole;
}, _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, _setEnd = function _setEnd(animation) {
    return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
}, _alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        _setEnd(animation);
        parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ _postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
        t = _parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && _removeFromParent(child);
    child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    _isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || _postAddChecks(timeline, child);
    timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
    return timeline;
}, _scrollTrigger = function _scrollTrigger(animation, trigger) {
    return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
}, _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    _initTween(tween, time, tTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
        _lazyTweens.push(tween);
        tween._lazy = [
            tTime,
            suppressEvents
        ];
        return 1;
    }
}, _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
}, _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = _clamp(0, tween._tDur, totalTime);
        iteration = _animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
            // if iteration changed
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && _removeFromParent(tween, 1);
            if (!suppressEvents && !_reverting) {
                _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = _roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && _setEnd(animation);
    skipUncache || _uncache(animation.parent, animation);
    return animation;
}, _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
}, _zeroPosition = {
    _start: 0,
    endTime: _emptyFunc,
    totalDuration: _emptyFunc
}, _parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels, recent = animation._recent || _zeroPosition, clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset, isPercent;
    if (_isString(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, _createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = _isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = _isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = _isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new Tween(params[0], vars, params[varsIndex + 1]);
}, _conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, _clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, getUnit = function getUnit(value, v) {
    return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
    return _conditionalReturn(value, function(v) {
        return _clamp(min, max, v);
    });
}, _slice = [].slice, _isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
}, _flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
    }) || accumulator;
}, // takes any value and returns an Array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
    return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [
        value
    ] : [];
}, selector = function selector(value) {
    value = toArray(value)[0] || _warn("Invalid scope") || {};
    return function(v) {
        var el = value.current || value.nativeElement || value;
        return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
    };
}, shuffle = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = (Math.random() * i) | 0, v = a[--i], a[i] = a[j], a[j] = v); return a;
// for distributing values across an Array. Can accept a number, a function or (most commonly) an object which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array.
distribute = function distribute(v) {
    if (_isFunction(v)) return v;
    var vars = _isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = _parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if (_isString(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                _bigNum
            ])[1];
            if (!wrapAt) {
                max = -_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt < l && wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = _bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && shuffle(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = getUnit(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? _invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, _roundModifier = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
    return function(raw) {
        var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
        return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, snap = function snap(snapTo, value) {
    var isArray = _isArray(snapTo), radius, is2D;
    if (!isArray && _isObject(snapTo)) {
        radius = isArray = snapTo.radius || _bigNum;
        if (snapTo.values) {
            snapTo = toArray(snapTo.values);
            if (is2D = !_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = _roundModifier(snapTo.increment);
    }
    return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = _bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
    });
}, random = function random(min, max, roundingIncrement, returnFunction) {
    return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, pipe = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, unitize = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || getUnit(value));
    };
}, normalize = function normalize(min, max, value) {
    return mapRange(min, max, 0, 1, value);
}, _wrapArray = function _wrapArray(a, wrapper, value) {
    return _conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, wrap = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, wrapYoyo = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, _replaceRandom = function _replaceRandom(s) {
    return s.replace(_randomExp, function(match) {
        //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
        var arIndex = match.indexOf("[") + 1, values = match.substring(arIndex || 7, arIndex ? match.indexOf("]") : match.length - 1).split(_commaDelimExp);
        return random(arIndex ? values : +values[0], arIndex ? 0 : +values[1], +values[2] || 1e-5);
    });
}, mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return _conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, interpolate = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = _isString(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if (_isArray(start) && !_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = _merge(_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return _renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return _conditionalReturn(progress, func);
}, _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = _bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, _callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], prevContext = _context, context = animation._ctx, params, scope, result;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && (_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    _context = prevContext;
    return result;
}, _interrupt = function _interrupt(animation) {
    _removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
    animation.progress() < 1 && _callback(animation, "onInterrupt");
    return animation;
}, _quickTween, _registerPluginQueue = [], _createPlugin = function _createPlugin(config) {
    if (!config) return;
    config = !config.name && config["default"] || config; // UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
    if (_windowExists() || config.headless) {
        // edge case: some build tools may pass in a null/undefined value
        var name = config.name, isFunc = _isFunction(config), Plugin = name && !isFunc && config.init ? function() {
            this._props = [];
        } : config, //in case someone passes in an object that's not a plugin, like CustomEase
        instanceDefaults = {
            init: _emptyFunc,
            render: _renderPropTweens,
            add: _addPropTween,
            kill: _killPropTweensOf,
            modifier: _addPluginModifier,
            rawVars: 0
        }, statics = {
            targetTest: 0,
            get: 0,
            getSetter: _getSetter,
            aliases: {},
            register: 0
        };
        _wake();
        if (config !== Plugin) {
            if (_plugins[name]) return;
            _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods
            _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods
            _plugins[Plugin.prop = name] = Plugin;
            if (config.targetTest) {
                _harnessPlugins.push(Plugin);
                _reservedProps[name] = 1;
            }
            name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
        }
        _addGlobal(name, Plugin);
        config.register && config.register(gsap, Plugin, PropTween);
    } else _registerPluginQueue.push(config);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ _255 = 255, _colorLookup = {
    aqua: [
        0,
        _255,
        _255
    ],
    lime: [
        0,
        _255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        _255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        _255,
        _255,
        _255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        _255,
        _255,
        0
    ],
    orange: [
        _255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        _255,
        0,
        0
    ],
    pink: [
        _255,
        192,
        203
    ],
    cyan: [
        0,
        _255,
        _255
    ],
    transparent: [
        _255,
        _255,
        _255,
        0
    ]
}, // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
_hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
}, splitColor = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? _colorLookup.black : _isNumber(v) ? [
        v >> 16,
        v >> 8 & _255,
        v & _255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if (_colorLookup[v]) a = _colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & _255,
                    a & _255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & _255,
                v & _255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match(_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = _hue(h + 1 / 3, r, g);
                a[1] = _hue(h, r, g);
                a[2] = _hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match(_numExp);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match(_strictNumExp) || _colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / _255;
        g = a[1] / _255;
        b = a[2] / _255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, _colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split(_colorExp).forEach(function(v) {
        var a = v.match(_numWithUnitExp) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, _formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match(_colorExp), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = _colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split(_colorExp);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, _colorExp = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in _colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), _hslExp = /hsl[a]?\(/, _colorStringFilter = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    _colorExp.lastIndex = 0;
    if (_colorExp.test(combined)) {
        toHSL = _hslExp.test(combined);
        a[1] = _formatColors(a[1], toHSL);
        a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ _tickerActive, _ticker = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if (_coreReady) {
                if (!_coreInitted && _windowExists()) {
                    _win = _coreInitted = window;
                    _doc = _win.document || {};
                    _globals.gsap = gsap;
                    (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);
                    _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});
                    _registerPluginQueue.forEach(_createPlugin);
                }
                _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                _tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? cancelAnimationFrame : clearTimeout)(_id);
            _tickerActive = 0;
            _req = _emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback, once, prioritize) {
            var func = once ? function(t, d, f, v) {
                callback(t, d, f, v);
                _self.remove(func);
            } : callback;
            _self.remove(callback);
            _listeners[prioritize ? "unshift" : "push"](func);
            _wake();
            return func;
        },
        remove: function remove(callback, i) {
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), _wake = function _wake() {
    return !_tickerActive && _ticker.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ _easeMap = {}, _customEaseExp = /^[\d.\-M][\d.\-,\s]/, _quotesExp = /["']/g, _parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, _valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, _configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = _easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        _parseObjectInString(split[1])
    ] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
}, _invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
    var child = timeline._first, ease;
    while(child){
        if (child instanceof Timeline) _propagateYoyoEase(child, isYoyo);
        else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
            if (child.timeline) _propagateYoyoEase(child.timeline, isYoyo);
            else {
                ease = child._ease;
                child._ease = child._yEase;
                child._yEase = ease;
                child._yoyo = isYoyo;
            }
        }
        child = child._next;
    }
}, _parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
}, _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    _forEachName(names, function(name) {
        _easeMap[name] = _globals[name] = ease;
        _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, _configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / _2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    p2 = _2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, _configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    _insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    _insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
_insertEase("Expo", function(p) {
    return Math.pow(2, 10 * (p - 1)) * p + p * p * p * p * p * p * (1 - p);
}); // previously 2 ** (10 * (p - 1)) but that doesn't end up with the value quite at the right spot so we do a blended ease to ensure it lands where it should perfectly.
_insertEase("Circ", function(p) {
    return -(_sqrt(1 - p * p) - 1);
});
_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});
_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - _tinyNum;
        return function(p) {
            return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
_defaults.ease = _easeMap["quad.out"];
_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return _callbackNames += name + "," + name + "Params,";
});
var GSCache = function GSCache(target, harness) {
    this.id = _gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : _getProperty;
    this.set = harness ? harness.getSetter : _getSetter;
};
var Animation = /*#__PURE__*/ function() {
    function Animation(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        _setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if (_context) {
            this._ctx = _context;
            _context.data.push(this);
        }
        _tickerActive || _ticker.wake();
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        _wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            _alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent && parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            _addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !this._initted && this._dur && _totalTime || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() >= 0 && this._initted ? 1 : 0;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value, suppressEvents) {
        if (!arguments.length) return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        this.totalTime(_clamp(-Math.abs(this._delay), this.totalDuration(), tTime), suppressEvents !== false);
        _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
        return _recacheAncestors(this);
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
         // possible future addition - if an animation is removed from its parent and then .restart() or .play() or .resume() is called, perhaps we should force it back into the globalTimeline but be careful because what if it's already at its end? We don't want it to just persist forever and not get released for GC.
        // !this.parent && !value && this._tTime < this._tDur && this !== _globalTimeline && _globalTimeline.add(this);
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                _wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = _roundPrecise(value);
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, this._start - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.revert = function revert(config) {
        if (config === void 0) config = _revertConfig;
        var prevIsReverting = _reverting;
        _reverting = config;
        if (_isRevertWorthy(this)) {
            this.timeline && this.timeline.revert(config);
            this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        _reverting = prevIsReverting;
        return this;
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (Math.abs(animation._ts) || 1);
            animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return _onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            var time = this._time;
            this._rDelay = value;
            _onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
        this._dur || (this._zTime = -_tinyNum); // ensures onComplete fires on a zero-duration animation that gets restarted.
        return this;
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this, prevProm = self._prom;
        return new Promise(function(resolve) {
            var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                prevProm && prevProm();
                _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        _interrupt(this);
    };
    return Animation;
}();
_setDefaults(Animation.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var Timeline = /*#__PURE__*/ function(_Animation) {
    _inheritsLoose(Timeline, _Animation);
    function Timeline(vars, position) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = _isNotFalse(vars.sortChildren);
        _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        _createTweenType(0, arguments, this);
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        _createTweenType(1, arguments, this);
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        _createTweenType(2, arguments, this);
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new Tween(targets, vars, _parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new Tween(targets, vars, _parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime), // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
        crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    prevIteration = _roundPrecise(tTime / cycleDuration); // full decimal version of iterations, not the previous iteration (we're reusing prevIteration variable for efficiency)
                    iteration = ~~prevIteration;
                    if (iteration && iteration === prevIteration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://gsap.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && _callback(this, "onRepeat");
                    if (this.vars.repeatRefresh && !isYoyo) {
                        this.invalidate()._lock = 1;
                        prevIteration = iteration; // otherwise, the onStart() may fire on the 2nd iteration.
                    }
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
                    return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                     //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
                    _propagateYoyoEase(this, isYoyo);
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && tTime && dur && !suppressEvents && !prevIteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && _isRevertWorthy(child)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    _setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
            if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        _isNumber(position) || (position = _parsePosition(this, position, child));
        if (!(child instanceof Animation)) {
            if (_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if (_isString(child)) return this.addLabel(child, position);
            if (_isFunction(child)) child = Tween.delayedCall(0, child);
            else return this;
        }
        return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof Tween) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if (_isString(child)) return this.removeLabel(child);
        if (_isFunction(child)) return this.killTweensOf(child);
        child.parent === this && _removeLinkedListItem(this, child);
        if (child === this._recent) this._recent = this._last;
        return _uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = _parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = Tween.delayedCall(0, callback || _emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return _addToTimeline(this, t, _parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = _parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") _removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = toArray(targets), child = this._first, isGlobalTime = _isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof Tween) {
                if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = _parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = Tween.to(tl, _setDefaults({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
            onStart: function onStart() {
                tl.pause();
                if (!initted) {
                    var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, _setDefaults({
            startAt: {
                time: _parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        amount = _roundPrecise(amount);
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return _uncache(this);
    };
    _proto2.invalidate = function invalidate(soft) {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate(soft);
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this, soft);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return _uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = _bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += _roundPrecise(start / self._ts);
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if (_globalTimeline._ts) {
            _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
            _lastRenderedFrame = _ticker.frame;
        }
        if (_ticker.frame >= _nextGCFrame) {
            _nextGCFrame += _config.autoSleep || 120;
            var child = _globalTimeline._first;
            if (!child || !child._ts) {
                if (_config.autoSleep && _ticker._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || _ticker.sleep();
                }
            }
        }
    };
    return Timeline;
}(Animation);
_setDefaults(Timeline.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = _replaceRandom(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match(_complexStringNumExp) || [];
    while(result = _complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = _complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if (_relExp.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    _isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc, pt;
    if (_isString(end)) {
        if (~end.indexOf("random(")) end = _replaceRandom(end);
        if (end.charAt(1) === "=") {
            pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);
            if (pt || pt === 0) // to avoid isNaN, like if someone passes in a value like "!= whatever"
            end = pt;
        }
    }
    if (!optional || parsedStart !== end || _forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
            // fun fact: any number multiplied by "" is evaluated as the number 0!
            pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && _missingPlugin(prop, end);
        return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
    _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));
    if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== _quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, _overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
_forceAllPropTweens, _initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites, tl = tween.timeline, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = _parseEase(ease, _defaults.ease);
    tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;
    if (yoyoEase && tween._yoyo && !tween._repeat) {
        //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
    }
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (!tl || keyframes && !vars.stagger) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? _getCache(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = _copyExcluding(vars, _reservedProps);
        if (prevStartAt) {
            prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
            time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
            // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
            prevStartAt._lazy = 0;
        }
        if (startAt) {
            _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: !prevStartAt && _isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate && function() {
                    return _callback(tween, "onUpdate");
                },
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
            tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
            time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                if (dur && time <= 0 && tTime <= 0) {
                    // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        {
            if (!prevStartAt) {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = _setDefaults({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                _removeFromParent(tween._startAt = Tween.set(targets, p));
                tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
                tween._startAt._sat = tween; // used in globalTime()
                time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
                tween._zTime = time;
                if (!immediateRender) _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && _isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || _harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                _overwritingTween = tween;
                _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                _overwritingTween = 0;
            }
            tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
        }
        hasPriority && _sortPropTweensByPriority(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    keyframes && time <= 0 && tl.render(_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
}, _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time, skipRecursion) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i;
    if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i = tween._targets.length;
        while(i--){
            pt = lookup[i][property];
            if (pt && pt.d && pt.d._pt) {
                // it's a plugin, so find the nested PropTween
                pt = pt.d._pt;
                while(pt && pt.p !== property && pt.fp !== property)// "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
                pt = pt._next;
            }
            if (!pt) {
                // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
                // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
                _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
                tween.vars[property] = "+=0";
                _initTween(tween, time);
                _forceAllPropTweens = 0;
                return skipRecursion ? _warn(property + " not eligible for reset") : 1; // if someone tries to do a quickTo() on a special property like borderRadius which must get split into 4 different properties, that's not eligible for .resetTo().
            }
            ptCache.push(pt);
        }
    }
    i = ptCache.length;
    while(i--){
        rootPT = ptCache[i];
        pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)
        rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
    }
}, _addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? _getCache(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = _merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut", p, a;
    if (_isArray(obj)) {
        a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease
        obj.forEach(function(value, i) {
            return a.push({
                t: i / (obj.length - 1) * 100,
                v: value,
                e: ease
            });
        });
    } else for(p in obj){
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
            t: parseFloat(prop),
            v: obj[p],
            e: ease
        });
    }
}, _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
}, _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", _staggerPropsToSkip = {};
_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
    return _staggerPropsToSkip[name] = 1;
});
var Tween = /*#__PURE__*/ function(_Animation2) {
    _inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = vars.parent || _globalTimeline, parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : toArray(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
            vars = _this3.vars;
            tl = _this3.timeline = new Timeline({
                data: "nested",
                defaults: defaults || {},
                targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
            }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
            tl.kill();
            tl.parent = tl._dp = _assertThisInitialized(_this3);
            tl._start = 0;
            if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
                l = parsedTargets.length;
                staggerFunc = stagger && distribute(stagger);
                if (_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = _copyExcluding(vars, _staggerPropsToSkip);
                    copy.stagger = 0;
                    yoyoEase && (copy.yoyoEase = yoyoEase);
                    staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
                    tl._ease = _easeMap.none;
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            } else if (keyframes) {
                _inheritDefaults(_setDefaults(tl.vars.defaults, {
                    ease: "none"
                }));
                tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
                var time = 0, a, kf, v;
                if (_isArray(keyframes)) {
                    keyframes.forEach(function(frame) {
                        return tl.to(parsedTargets, frame, ">");
                    });
                    tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
                } else {
                    copy = {};
                    for(p in keyframes)p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
                    for(p in copy){
                        a = copy[p].sort(function(a, b) {
                            return a.t - b.t;
                        });
                        time = 0;
                        for(i = 0; i < a.length; i++){
                            kf = a[i];
                            v = {
                                ease: kf.e,
                                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                            };
                            v[p] = kf.v;
                            tl.to(parsedTargets, v, time);
                            time += v.duration;
                        }
                    }
                    tl.duration() < duration && tl.to({}, {
                        duration: duration - tl.duration()
                    }); // in case keyframes didn't go to 100%
                }
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !_suppressOverwrites) {
            _overwritingTween = _assertThisInitialized(_this3);
            _globalTimeline.killTweensOf(parsedTargets);
            _overwritingTween = 0;
        }
        _addToTimeline(parent, _assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay) || 0); //in case delay is negative
        }
        scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) _renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative || this._lazy) {
            // this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && isNegative) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    prevIteration = _roundPrecise(tTime / cycleDuration); // full decimal version of iterations, not the previous iteration (we're reusing prevIteration variable for efficiency)
                    iteration = ~~prevIteration;
                    if (iteration && iteration === prevIteration) {
                        time = dur;
                        iteration--;
                    } else if (time > dur) time = dur;
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) {
                    yoyoEase = this._yEase;
                    time = dur - time;
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted && iteration === prevIteration) {
                    //could be during the repeatDelay part. No need to render and fire callbacks.
                    this._tTime = tTime;
                    return this;
                }
                if (iteration !== prevIteration) {
                    timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock && time !== cycleDuration && this._initted) {
                        // this._time will === cycleDuration when we render at EXACTLY the end of an iteration. Without this condition, it'd often do the repeatRefresh render TWICE (again on the very next tick).
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values. But we also don't want to dump if we're doing a repeatRefresh render!
                return this;
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            if (!prevTime && tTime && !suppressEvents && !prevIteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                _callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate(soft) {
        // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return _Animation2.prototype.invalidate.call(this, soft);
    };
    _proto3.resetTo = function resetTo(property, value, start, startIsRelative, skipRecursion) {
        _tickerActive || _ticker.wake();
        this._ts || this.play();
        var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || _initTween(this, time);
        ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
        // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
        // if (_isObject(property)) { // performance optimization
        // 	for (p in property) {
        // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
        // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        // 		}
        // 	}
        // } else {
        if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time, skipRecursion)) return this.resetTo(property, value, start, startIsRelative, 1); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
         //}
        _alignPlayhead(this, 0);
        this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            this.parent ? _interrupt(this) : this.scrollTrigger && this.scrollTrigger.kill(!!_reverting);
            return this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? toArray(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return _interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if (_isString(vars)) {
                p = {};
                _forEachName(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = _addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) _removeLinkedListItem(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return _createTweenType(1, arguments);
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return _createTweenType(2, arguments);
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return _globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}(Animation);
_setDefaults(Tween.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
_forEachName("staggerTo,staggerFrom,staggerFromTo", function(name) {
    Tween[name] = function() {
        var tl = new Timeline(), params = _slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var _setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, _setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, _setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, _getSetter = function _getSetter(target, property) {
    return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
}, _renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
}, _renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, _renderComplexString = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, _renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, _killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) _removeLinkedListItem(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, _setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var PropTween = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || _renderPlain;
        this.d = data || this;
        this.set = setter || _setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = _setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
    return _reservedProps[name] = 1;
});
_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
    sortChildren: false,
    defaults: _defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
var _media = [], _listeners = {}, _emptyArray = [], _lastMediaTime = 0, _contextID = 0, _dispatch = function _dispatch(type) {
    return (_listeners[type] || _emptyArray).map(function(f) {
        return f();
    });
}, _onMediaChange = function _onMediaChange() {
    var time = Date.now(), matches = [];
    if (time - _lastMediaTime > 2) {
        _dispatch("matchMediaInit");
        _media.forEach(function(c) {
            var queries = c.queries, conditions = c.conditions, match, p, anyMatch, toggled;
            for(p in queries){
                match = _win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
                match && (anyMatch = 1);
                if (match !== conditions[p]) {
                    conditions[p] = match;
                    toggled = 1;
                }
            }
            if (toggled) {
                c.revert();
                anyMatch && matches.push(c);
            }
        });
        _dispatch("matchMediaRevert");
        matches.forEach(function(c) {
            return c.onMatch(c, function(func) {
                return c.add(null, func);
            });
        });
        _lastMediaTime = time;
        _dispatch("matchMedia");
    }
};
var Context = /*#__PURE__*/ function() {
    function Context(func, scope) {
        this.selector = scope && selector(scope);
        this.data = [];
        this._r = []; // returned/cleanup functions
        this.isReverted = false;
        this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
        func && this.add(func);
    }
    var _proto5 = Context.prototype;
    _proto5.add = function add(name, func, scope) {
        // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
        // if (name && _isFunction(name.revert)) {
        // 	this.data.push(name);
        // 	return (name._ctx = this);
        // }
        if (_isFunction(name)) {
            scope = func;
            func = name;
            name = _isFunction;
        }
        var self = this, f = function f() {
            var prev = _context, prevSelector = self.selector, result;
            prev && prev !== self && prev.data.push(self);
            scope && (self.selector = selector(scope));
            _context = self;
            result = func.apply(self, arguments);
            _isFunction(result) && self._r.push(result);
            _context = prev;
            self.selector = prevSelector;
            self.isReverted = false;
            return result;
        };
        self.last = f;
        return name === _isFunction ? f(self, function(func) {
            return self.add(null, func);
        }) : name ? self[name] = f : f;
    };
    _proto5.ignore = function ignore(func) {
        var prev = _context;
        _context = null;
        func(this);
        _context = prev;
    };
    _proto5.getTweens = function getTweens() {
        var a = [];
        this.data.forEach(function(e) {
            return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
        });
        return a;
    };
    _proto5.clear = function clear() {
        this._r.length = this.data.length = 0;
    };
    _proto5.kill = function kill(revert, matchMedia) {
        var _this4 = this;
        if (revert) (function() {
            var tweens = _this4.getTweens(), i = _this4.data.length, t;
            while(i--){
                // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
                t = _this4.data[i];
                if (t.data === "isFlip") {
                    t.revert();
                    t.getChildren(true, true, false).forEach(function(tween) {
                        return tweens.splice(tweens.indexOf(tween), 1);
                    });
                }
            } // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
            tweens.map(function(t) {
                return {
                    g: t._dur || t._delay || t._sat && !t._sat.vars.immediateRender ? t.globalTime(0) : -Infinity,
                    t: t
                };
            }).sort(function(a, b) {
                return b.g - a.g || -Infinity;
            }).forEach(function(o) {
                return o.t.revert(revert);
            }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
            i = _this4.data.length;
            while(i--){
                // make sure we loop backwards so that, for example, SplitTexts that were created later on the same element get reverted first
                t = _this4.data[i];
                if (t instanceof Timeline) {
                    if (t.data !== "nested") {
                        t.scrollTrigger && t.scrollTrigger.revert();
                        t.kill(); // don't revert() the timeline because that's duplicating efforts since we already reverted all the tweens
                    }
                } else !(t instanceof Tween) && t.revert && t.revert(revert);
            }
            _this4._r.forEach(function(f) {
                return f(revert, _this4);
            });
            _this4.isReverted = true;
        })();
        else this.data.forEach(function(e) {
            return e.kill && e.kill();
        });
        this.clear();
        if (matchMedia) {
            var i = _media.length;
            while(i--)// previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
            _media[i].id === this.id && _media.splice(i, 1);
        }
    } // killWithCleanup() {
    ;
    _proto5.revert = function revert(config) {
        this.kill(config || {});
    };
    return Context;
}();
var MatchMedia = /*#__PURE__*/ function() {
    function MatchMedia(scope) {
        this.contexts = [];
        this.scope = scope;
        _context && _context.data.push(this);
    }
    var _proto6 = MatchMedia.prototype;
    _proto6.add = function add(conditions, func, scope) {
        _isObject(conditions) || (conditions = {
            matches: conditions
        });
        var context = new Context(0, scope || this.scope), cond = context.conditions = {}, mq, p, active;
        _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for(p in conditions)if (p === "all") active = 1;
        else {
            mq = _win.matchMedia(conditions[p]);
            if (mq) {
                _media.indexOf(context) < 0 && _media.push(context);
                (cond[p] = mq.matches) && (active = 1);
                mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
            }
        }
        active && func(context, function(f) {
            return context.add(null, f);
        });
        return this;
    } // refresh() {
    ;
    _proto6.revert = function revert(config) {
        this.kill(config || {});
    };
    _proto6.kill = function kill(revert) {
        this.contexts.forEach(function(c) {
            return c.kill(revert, true);
        });
    };
    return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var _gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return _createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new Timeline(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return _globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in
        var getter = _getCache(target || {}).get, format = unit ? _passThrough : _numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
        } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = toArray(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return gsap.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = _plugins[property], cache = _getCache(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function(value) {
            var p = new Plugin();
            _quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, _quickTween, 0, [
                target
            ]);
            p.render(1, p);
            _quickTween._pt && _renderPropTweens(1, _quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    quickTo: function quickTo(target, property, vars) {
        var _setDefaults2;
        var tween = gsap.to(target, _setDefaults((_setDefaults2 = {}, _setDefaults2[property] = "+=0.1", _setDefaults2.paused = true, _setDefaults2.stagger = 0, _setDefaults2), vars || {})), func = function func(value, start, startIsRelative) {
            return tween.resetTo(property, value, start, startIsRelative);
        };
        func.tween = tween;
        return func;
    },
    isTweening: function isTweening(targets) {
        return _globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
        return _mergeDeep(_defaults, value || {});
    },
    config: function config(value) {
        return _mergeDeep(_config, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
        });
        _effects[name] = function(targets, vars, tl) {
            return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
        };
        if (extendTimeline) Timeline.prototype[name] = function(targets, vars, position) {
            return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        _easeMap[name] = _parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
    },
    getById: function getById(id) {
        return _globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new Timeline(vars), child, next;
        tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
        _globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = _globalTimeline._time;
        child = _globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) _addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        _addToTimeline(_globalTimeline, tl, 0);
        return tl;
    },
    context: function context(func, scope) {
        return func ? new Context(func, scope) : _context;
    },
    matchMedia: function matchMedia(scope) {
        return new MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
        return _media.forEach(function(c) {
            var cond = c.conditions, found, p;
            for(p in cond)if (cond[p]) {
                cond[p] = false;
                found = 1;
            }
            found && c.revert();
        }) || _onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
        var a = _listeners[type] || (_listeners[type] = []);
        ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
        var a = _listeners[type], i = a && a.indexOf(callback);
        i >= 0 && a.splice(i, 1);
    },
    utils: {
        wrap: wrap,
        wrapYoyo: wrapYoyo,
        distribute: distribute,
        random: random,
        snap: snap,
        normalize: normalize,
        getUnit: getUnit,
        clamp: clamp,
        splitColor: splitColor,
        toArray: toArray,
        selector: selector,
        mapRange: mapRange,
        pipe: pipe,
        unitize: unitize,
        interpolate: interpolate,
        shuffle: shuffle
    },
    install: _install,
    effects: _effects,
    ticker: _ticker,
    updateRoot: Timeline.updateRoot,
    plugins: _plugins,
    globalTimeline: _globalTimeline,
    core: {
        PropTween: PropTween,
        globals: _addGlobal,
        Tween: Tween,
        Timeline: Timeline,
        Animation: Animation,
        getCache: _getCache,
        _removeLinkedListItem: _removeLinkedListItem,
        reverting: function reverting() {
            return _reverting;
        },
        context: function context(toAdd) {
            if (toAdd && _context) {
                _context.data.push(toAdd);
                toAdd._ctx = _context;
            }
            return _context;
        },
        suppressOverwrites: function suppressOverwrites(value) {
            return _suppressOverwrites = value;
        }
    }
};
_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return _gsap[name] = Tween[name];
});
_ticker.add(Timeline.updateRoot);
_quickTween = _gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, _addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = _getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        headless: 1,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if (_isString(vars)) {
                    temp = {};
                    _forEachName(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                _addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var gsap = _gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt, v;
        this.tween = tween;
        for(p in vars){
            v = target.getAttribute(p) || "";
            pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
            pt.op = p;
            pt.b = v; // record the beginning value so we can revert()
            this._props.push(p);
        }
    },
    render: function render(ratio, data) {
        var pt = data._pt;
        while(pt){
            _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
            pt = pt._next;
        }
    }
}, {
    name: "endArray",
    headless: 1,
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
Tween.version = Timeline.version = gsap.version = "3.14.2";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0, Power1 = _easeMap.Power1, Power2 = _easeMap.Power2, Power3 = _easeMap.Power3, Power4 = _easeMap.Power4, Linear = _easeMap.Linear, Quad = _easeMap.Quad, Cubic = _easeMap.Cubic, Quart = _easeMap.Quart, Quint = _easeMap.Quint, Strong = _easeMap.Strong, Elastic = _easeMap.Elastic, Back = _easeMap.Back, SteppedEase = _easeMap.SteppedEase, Bounce = _easeMap.Bounce, Sine = _easeMap.Sine, Expo = _easeMap.Expo, Circ = _easeMap.Circ;

});

parcelRegister("eaKMK", function(module, exports) {
/**
 * EvEmitter v2.1.1
 * Lil' event emitter
 * MIT License
 */ (function(global, factory) {
    // universal module definition
    if (module.exports) // CommonJS - Browserify, Webpack
    module.exports = factory();
    else // Browser globals
    global.EvEmitter = factory();
})(typeof window != 'undefined' ? window : module.exports, function() {
    function EvEmitter() {}
    let proto = EvEmitter.prototype;
    proto.on = function(eventName, listener) {
        if (!eventName || !listener) return this;
        // set events hash
        let events = this._events = this._events || {};
        // set listeners array
        let listeners = events[eventName] = events[eventName] || [];
        // only add once
        if (!listeners.includes(listener)) listeners.push(listener);
        return this;
    };
    proto.once = function(eventName, listener) {
        if (!eventName || !listener) return this;
        // add event
        this.on(eventName, listener);
        // set once flag
        // set onceEvents hash
        let onceEvents = this._onceEvents = this._onceEvents || {};
        // set onceListeners object
        let onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
        // set flag
        onceListeners[listener] = true;
        return this;
    };
    proto.off = function(eventName, listener) {
        let listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return this;
        let index = listeners.indexOf(listener);
        if (index != -1) listeners.splice(index, 1);
        return this;
    };
    proto.emitEvent = function(eventName, args) {
        let listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return this;
        // copy over to avoid interference if .off() in listener
        listeners = listeners.slice(0);
        args = args || [];
        // once stuff
        let onceListeners = this._onceEvents && this._onceEvents[eventName];
        for (let listener of listeners){
            let isOnce = onceListeners && onceListeners[listener];
            if (isOnce) {
                // remove listener
                // remove before trigger to prevent recursion
                this.off(eventName, listener);
                // unset once flag
                delete onceListeners[listener];
            }
            // trigger listener
            listener.apply(this, args);
        }
        return this;
    };
    proto.allOff = function() {
        delete this._events;
        delete this._onceEvents;
        return this;
    };
    return EvEmitter;
});

});

// [EMERGENCY] Move to top to ensure it runs even if late-init scripts fail
/*!
 * matrix 3.14.2
 * https://gsap.com
 *
 * Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $b760a7c355166707$var$_doc, $b760a7c355166707$var$_win, $b760a7c355166707$var$_docElement, $b760a7c355166707$var$_body, $b760a7c355166707$var$_divContainer, $b760a7c355166707$var$_svgContainer, $b760a7c355166707$var$_identityMatrix, $b760a7c355166707$var$_gEl, $b760a7c355166707$var$_transformProp = "transform", $b760a7c355166707$var$_transformOriginProp = $b760a7c355166707$var$_transformProp + "Origin", $b760a7c355166707$var$_hasOffsetBug, $b760a7c355166707$export$33c547c3e20d49b1 = function _setDoc(element) {
    var doc = element.ownerDocument || element;
    if (!($b760a7c355166707$var$_transformProp in element.style) && "msTransform" in element.style) {
        //to improve compatibility with old Microsoft browsers
        $b760a7c355166707$var$_transformProp = "msTransform";
        $b760a7c355166707$var$_transformOriginProp = $b760a7c355166707$var$_transformProp + "Origin";
    }
    while(doc.parentNode && (doc = doc.parentNode));
    $b760a7c355166707$var$_win = window;
    $b760a7c355166707$var$_identityMatrix = new $b760a7c355166707$export$26e6ecd136a15474();
    if (doc) {
        $b760a7c355166707$var$_doc = doc;
        $b760a7c355166707$var$_docElement = doc.documentElement;
        $b760a7c355166707$var$_body = doc.body;
        $b760a7c355166707$var$_gEl = $b760a7c355166707$var$_doc.createElementNS("http://www.w3.org/2000/svg", "g"); // prevent any existing CSS from transforming it
        $b760a7c355166707$var$_gEl.style.transform = "none"; // now test for the offset reporting bug. Use feature detection instead of browser sniffing to make things more bulletproof and future-proof. Hopefully Safari will fix their bug soon.
        var d1 = doc.createElement("div"), d2 = doc.createElement("div"), root = doc && (doc.body || doc.firstElementChild);
        if (root && root.appendChild) {
            root.appendChild(d1);
            d1.appendChild(d2);
            d1.style.position = "static";
            d1.style.transform = "translate3d(0,0,1px)";
            $b760a7c355166707$var$_hasOffsetBug = d2.offsetParent !== d1;
            root.removeChild(d1);
        }
    }
    return doc;
}, $b760a7c355166707$var$_forceNonZeroScale = function _forceNonZeroScale(e) {
    // walks up the element's ancestors and finds any that had their scale set to 0 via GSAP, and changes them to 0.0001 to ensure that measurements work. Firefox has a bug that causes it to incorrectly report getBoundingClientRect() when scale is 0.
    var a, cache;
    while(e && e !== $b760a7c355166707$var$_body){
        cache = e._gsap;
        cache && cache.uncache && cache.get(e, "x"); // force re-parsing of transforms if necessary
        if (cache && !cache.scaleX && !cache.scaleY && cache.renderTransform) {
            cache.scaleX = cache.scaleY = 1e-4;
            cache.renderTransform(1, cache);
            a ? a.push(cache) : a = [
                cache
            ];
        }
        e = e.parentNode;
    }
    return a;
}, // possible future addition: pass an element to _forceDisplay() and it'll walk up all its ancestors and make sure anything with display: none is set to display: block, and if there's no parentNode, it'll add it to the body. It returns an Array that you can then feed to _revertDisplay() to have it revert all the changes it made.
// _forceDisplay = e => {
// 	let a = [],
// 		parent;
// 	while (e && e !== _body) {
// 		parent = e.parentNode;
// 		(_win.getComputedStyle(e).display === "none" || !parent) && a.push(e, e.style.display, parent) && (e.style.display = "block");
// 		parent || _body.appendChild(e);
// 		e = parent;
// 	}
// 	return a;
// },
// _revertDisplay = a => {
// 	for (let i = 0; i < a.length; i+=3) {
// 		a[i+1] ? (a[i].style.display = a[i+1]) : a[i].style.removeProperty("display");
// 		a[i+2] || a[i].parentNode.removeChild(a[i]);
// 	}
// },
$b760a7c355166707$var$_svgTemps = [], //we create 3 elements for SVG, and 3 for other DOM elements and cache them for performance reasons. They get nested in _divContainer and _svgContainer so that just one element is added to the DOM on each successive attempt. Again, performance is key.
$b760a7c355166707$var$_divTemps = [], $b760a7c355166707$export$ffd2ae2432b6e61c = function _getDocScrollTop() {
    return $b760a7c355166707$var$_win.pageYOffset || $b760a7c355166707$var$_doc.scrollTop || $b760a7c355166707$var$_docElement.scrollTop || $b760a7c355166707$var$_body.scrollTop || 0;
}, $b760a7c355166707$export$cf8963d945186253 = function _getDocScrollLeft() {
    return $b760a7c355166707$var$_win.pageXOffset || $b760a7c355166707$var$_doc.scrollLeft || $b760a7c355166707$var$_docElement.scrollLeft || $b760a7c355166707$var$_body.scrollLeft || 0;
}, $b760a7c355166707$var$_svgOwner = function _svgOwner(element) {
    return element.ownerSVGElement || ((element.tagName + "").toLowerCase() === "svg" ? element : null);
}, $b760a7c355166707$export$72052b0a226e838 = function _isFixed(element) {
    if ($b760a7c355166707$var$_win.getComputedStyle(element).position === "fixed") return true;
    element = element.parentNode;
    if (element && element.nodeType === 1) // avoid document fragments which will throw an error.
    return _isFixed(element);
}, $b760a7c355166707$var$_createSibling = function _createSibling(element, i) {
    if (element.parentNode && ($b760a7c355166707$var$_doc || $b760a7c355166707$export$33c547c3e20d49b1(element))) {
        var svg = $b760a7c355166707$var$_svgOwner(element), ns = svg ? svg.getAttribute("xmlns") || "http://www.w3.org/2000/svg" : "http://www.w3.org/1999/xhtml", type = svg ? i ? "rect" : "g" : "div", x = i !== 2 ? 0 : 100, y = i === 3 ? 100 : 0, css = {
            position: "absolute",
            display: "block",
            pointerEvents: "none",
            margin: "0",
            padding: "0"
        }, e = $b760a7c355166707$var$_doc.createElementNS ? $b760a7c355166707$var$_doc.createElementNS(ns.replace(/^https/, "http"), type) : $b760a7c355166707$var$_doc.createElement(type);
        if (i) {
            if (!svg) {
                if (!$b760a7c355166707$var$_divContainer) {
                    $b760a7c355166707$var$_divContainer = _createSibling(element);
                    Object.assign($b760a7c355166707$var$_divContainer.style, css);
                }
                Object.assign(e.style, css, {
                    width: "0.1px",
                    height: "0.1px",
                    top: y + "px",
                    left: x + "px"
                });
                $b760a7c355166707$var$_divContainer.appendChild(e);
            } else {
                $b760a7c355166707$var$_svgContainer || ($b760a7c355166707$var$_svgContainer = _createSibling(element));
                e.setAttribute("width", 0.01);
                e.setAttribute("height", 0.01);
                e.setAttribute("transform", "translate(" + x + "," + y + ")");
                e.setAttribute("fill", "transparent");
                $b760a7c355166707$var$_svgContainer.appendChild(e);
            }
        }
        return e;
    }
    throw "Need document and parent.";
}, $b760a7c355166707$var$_consolidate = function _consolidate(m) {
    // replaces SVGTransformList.consolidate() because a bug in Firefox causes it to break pointer events. See https://gsap.com/forums/topic/23248-touch-is-not-working-on-draggable-in-firefox-windows-v324/?tab=comments#comment-109800
    var c = new $b760a7c355166707$export$26e6ecd136a15474(), i = 0;
    for(; i < m.numberOfItems; i++)c.multiply(m.getItem(i).matrix);
    return c;
}, $b760a7c355166707$export$a2b87f76ca5ccbd0 = function _getCTM(svg) {
    var m = svg.getCTM(), transform;
    if (!m) {
        // Firefox returns null for getCTM() on root <svg> elements, so this is a workaround using a <g> that we temporarily append.
        transform = svg.style[$b760a7c355166707$var$_transformProp];
        svg.style[$b760a7c355166707$var$_transformProp] = "none"; // a bug in Firefox causes css transforms to contaminate the getCTM()
        svg.appendChild($b760a7c355166707$var$_gEl);
        m = $b760a7c355166707$var$_gEl.getCTM();
        svg.removeChild($b760a7c355166707$var$_gEl);
        transform ? svg.style[$b760a7c355166707$var$_transformProp] = transform : svg.style.removeProperty($b760a7c355166707$var$_transformProp.replace(/([A-Z])/g, "-$1").toLowerCase());
    }
    return m || $b760a7c355166707$var$_identityMatrix.clone(); // Firefox will still return null if the <svg> has a width/height of 0 in the browser.
}, $b760a7c355166707$var$_placeSiblings = function _placeSiblings(element, adjustGOffset) {
    var svg = $b760a7c355166707$var$_svgOwner(element), isRootSVG = element === svg, siblings = svg ? $b760a7c355166707$var$_svgTemps : $b760a7c355166707$var$_divTemps, parent = element.parentNode, appendToEl = parent && !svg && parent.shadowRoot && parent.shadowRoot.appendChild ? parent.shadowRoot : parent, container, m, b, x, y, cs;
    if (element === $b760a7c355166707$var$_win) return element;
    siblings.length || siblings.push($b760a7c355166707$var$_createSibling(element, 1), $b760a7c355166707$var$_createSibling(element, 2), $b760a7c355166707$var$_createSibling(element, 3));
    container = svg ? $b760a7c355166707$var$_svgContainer : $b760a7c355166707$var$_divContainer;
    if (svg) {
        if (isRootSVG) {
            b = $b760a7c355166707$export$a2b87f76ca5ccbd0(element);
            x = -b.e / b.a;
            y = -b.f / b.d;
            m = $b760a7c355166707$var$_identityMatrix;
        } else if (element.getBBox) {
            b = element.getBBox();
            m = element.transform ? element.transform.baseVal : {}; // IE11 doesn't follow the spec.
            m = !m.numberOfItems ? $b760a7c355166707$var$_identityMatrix : m.numberOfItems > 1 ? $b760a7c355166707$var$_consolidate(m) : m.getItem(0).matrix; // don't call m.consolidate().matrix because a bug in Firefox makes pointer events not work when consolidate() is called on the same tick as getBoundingClientRect()! See https://gsap.com/forums/topic/23248-touch-is-not-working-on-draggable-in-firefox-windows-v324/?tab=comments#comment-109800
            x = m.a * b.x + m.c * b.y;
            y = m.b * b.x + m.d * b.y;
        } else {
            // may be a <mask> which has no getBBox() so just use defaults instead of throwing errors.
            m = new $b760a7c355166707$export$26e6ecd136a15474();
            x = y = 0;
        }
        if (adjustGOffset && element.tagName.toLowerCase() === "g") x = y = 0;
        (isRootSVG || !element.getBoundingClientRect().width ? svg : parent).appendChild(container); // check getBoundingClientRect().width because things inside a <mask>, for example, may return 0 in which case we need to move the element to the root SVG to properly measure things. An alternative would be to walk up the DOM and see if any ancestor is a nodeName of "mask" and if so, set parent to svg.
        container.setAttribute("transform", "matrix(" + m.a + "," + m.b + "," + m.c + "," + m.d + "," + (m.e + x) + "," + (m.f + y) + ")");
    } else {
        x = y = 0;
        if ($b760a7c355166707$var$_hasOffsetBug) {
            // some browsers (like Safari) have a bug that causes them to misreport offset values. When an ancestor element has a transform applied, it's supposed to treat it as if it's position: relative (new context). Safari botches this, so we need to find the closest ancestor (between the element and its offsetParent) that has a transform applied and if one is found, grab its offsetTop/Left and subtract them to compensate.
            m = element.offsetParent;
            b = element;
            while(b && (b = b.parentNode) && b !== m && b.parentNode)if (($b760a7c355166707$var$_win.getComputedStyle(b)[$b760a7c355166707$var$_transformProp] + "").length > 4) {
                x = b.offsetLeft;
                y = b.offsetTop;
                b = 0;
            }
        }
        cs = $b760a7c355166707$var$_win.getComputedStyle(element);
        if (cs.position !== "absolute" && cs.position !== "fixed") {
            m = element.offsetParent;
            while(parent && parent !== m){
                // if there's an ancestor element between the element and its offsetParent that's scrolled, we must factor that in.
                x += parent.scrollLeft || 0;
                y += parent.scrollTop || 0;
                parent = parent.parentNode;
            }
        }
        b = container.style;
        b.top = element.offsetTop - y + "px";
        b.left = element.offsetLeft - x + "px";
        b[$b760a7c355166707$var$_transformProp] = cs[$b760a7c355166707$var$_transformProp];
        b[$b760a7c355166707$var$_transformOriginProp] = cs[$b760a7c355166707$var$_transformOriginProp]; // b.border = m.border;
        // b.borderLeftStyle = m.borderLeftStyle;
        // b.borderTopStyle = m.borderTopStyle;
        // b.borderLeftWidth = m.borderLeftWidth;
        // b.borderTopWidth = m.borderTopWidth;
        b.position = cs.position === "fixed" ? "fixed" : "absolute";
        appendToEl.appendChild(container);
    }
    return container;
}, $b760a7c355166707$var$_setMatrix = function _setMatrix(m, a, b, c, d, e, f) {
    m.a = a;
    m.b = b;
    m.c = c;
    m.d = d;
    m.e = e;
    m.f = f;
    return m;
};
var $b760a7c355166707$export$26e6ecd136a15474 = /*#__PURE__*/ function() {
    function Matrix2D(a, b, c, d, e, f) {
        if (a === void 0) a = 1;
        if (b === void 0) b = 0;
        if (c === void 0) c = 0;
        if (d === void 0) d = 1;
        if (e === void 0) e = 0;
        if (f === void 0) f = 0;
        $b760a7c355166707$var$_setMatrix(this, a, b, c, d, e, f);
    }
    var _proto = Matrix2D.prototype;
    _proto.inverse = function inverse() {
        var a = this.a, b = this.b, c = this.c, d = this.d, e = this.e, f = this.f, determinant = a * d - b * c || 1e-10;
        return $b760a7c355166707$var$_setMatrix(this, d / determinant, -b / determinant, -c / determinant, a / determinant, (c * f - d * e) / determinant, -(a * f - b * e) / determinant);
    };
    _proto.multiply = function multiply(matrix) {
        var a = this.a, b = this.b, c = this.c, d = this.d, e = this.e, f = this.f, a2 = matrix.a, b2 = matrix.c, c2 = matrix.b, d2 = matrix.d, e2 = matrix.e, f2 = matrix.f;
        return $b760a7c355166707$var$_setMatrix(this, a2 * a + c2 * c, a2 * b + c2 * d, b2 * a + d2 * c, b2 * b + d2 * d, e + e2 * a + f2 * c, f + e2 * b + f2 * d);
    };
    _proto.clone = function clone() {
        return new Matrix2D(this.a, this.b, this.c, this.d, this.e, this.f);
    };
    _proto.equals = function equals(matrix) {
        var a = this.a, b = this.b, c = this.c, d = this.d, e = this.e, f = this.f;
        return a === matrix.a && b === matrix.b && c === matrix.c && d === matrix.d && e === matrix.e && f === matrix.f;
    };
    _proto.apply = function apply(point, decoratee) {
        if (decoratee === void 0) decoratee = {};
        var x = point.x, y = point.y, a = this.a, b = this.b, c = this.c, d = this.d, e = this.e, f = this.f;
        decoratee.x = x * a + y * c + e || 0;
        decoratee.y = x * b + y * d + f || 0;
        return decoratee;
    };
    return Matrix2D;
}(); // Feed in an element and it'll return a 2D matrix (optionally inverted) so that you can translate between coordinate spaces.
function $b760a7c355166707$export$91a495f99cf781b7(element, inverse, adjustGOffset, includeScrollInFixed) {
    // adjustGOffset is typically used only when grabbing an element's PARENT's global matrix, and it ignores the x/y offset of any SVG <g> elements because they behave in a special way.
    if (!element || !element.parentNode || ($b760a7c355166707$var$_doc || $b760a7c355166707$export$33c547c3e20d49b1(element)).documentElement === element) return new $b760a7c355166707$export$26e6ecd136a15474();
    var zeroScales = $b760a7c355166707$var$_forceNonZeroScale(element), svg = $b760a7c355166707$var$_svgOwner(element), temps = svg ? $b760a7c355166707$var$_svgTemps : $b760a7c355166707$var$_divTemps, container = $b760a7c355166707$var$_placeSiblings(element, adjustGOffset), b1 = temps[0].getBoundingClientRect(), b2 = temps[1].getBoundingClientRect(), b3 = temps[2].getBoundingClientRect(), parent = container.parentNode, isFixed = !includeScrollInFixed && $b760a7c355166707$export$72052b0a226e838(element), m = new $b760a7c355166707$export$26e6ecd136a15474((b2.left - b1.left) / 100, (b2.top - b1.top) / 100, (b3.left - b1.left) / 100, (b3.top - b1.top) / 100, b1.left + (isFixed ? 0 : $b760a7c355166707$export$cf8963d945186253()), b1.top + (isFixed ? 0 : $b760a7c355166707$export$ffd2ae2432b6e61c()));
    parent.removeChild(container);
    if (zeroScales) {
        b1 = zeroScales.length;
        while(b1--){
            b2 = zeroScales[b1];
            b2.scaleX = b2.scaleY = 0;
            b2.renderTransform(1, b2);
        }
    }
    return inverse ? m.inverse() : m;
}
 // export function getMatrix(element) {
 // 	_doc || _setDoc(element);
 // 	let m = (_win.getComputedStyle(element)[_transformProp] + "").substr(7).match(/[-.]*\d+[.e\-+]*\d*[e\-\+]*\d*/g),
 // 		is2D = m && m.length === 6;
 // 	return !m || m.length < 6 ? new Matrix2D() : new Matrix2D(+m[0], +m[1], +m[is2D ? 2 : 4], +m[is2D ? 3 : 5], +m[is2D ? 4 : 12], +m[is2D ? 5 : 13]);
 // }


function $9644ab9b72d1ba35$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $9644ab9b72d1ba35$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $9644ab9b72d1ba35$var$gsap, $9644ab9b72d1ba35$var$_win, $9644ab9b72d1ba35$var$_doc, $9644ab9b72d1ba35$var$_docElement, $9644ab9b72d1ba35$var$_body, $9644ab9b72d1ba35$var$_tempDiv, $9644ab9b72d1ba35$var$_placeholderDiv, $9644ab9b72d1ba35$var$_coreInitted, $9644ab9b72d1ba35$var$_checkPrefix, $9644ab9b72d1ba35$var$_toArray, $9644ab9b72d1ba35$var$_supportsPassive, $9644ab9b72d1ba35$var$_isTouchDevice, $9644ab9b72d1ba35$var$_touchEventLookup, $9644ab9b72d1ba35$var$_isMultiTouching, $9644ab9b72d1ba35$var$_isAndroid, $9644ab9b72d1ba35$var$InertiaPlugin, $9644ab9b72d1ba35$var$_defaultCursor, $9644ab9b72d1ba35$var$_supportsPointer, $9644ab9b72d1ba35$var$_context, $9644ab9b72d1ba35$var$_getStyleSaver, $9644ab9b72d1ba35$var$_dragCount = 0, $9644ab9b72d1ba35$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $9644ab9b72d1ba35$var$_getGSAP = function _getGSAP() {
    return $9644ab9b72d1ba35$var$gsap || $9644ab9b72d1ba35$var$_windowExists() && ($9644ab9b72d1ba35$var$gsap = window.gsap) && $9644ab9b72d1ba35$var$gsap.registerPlugin && $9644ab9b72d1ba35$var$gsap;
}, $9644ab9b72d1ba35$var$_isFunction = function _isFunction(value) {
    return typeof value === "function";
}, $9644ab9b72d1ba35$var$_isObject = function _isObject(value) {
    return typeof value === "object";
}, $9644ab9b72d1ba35$var$_isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, $9644ab9b72d1ba35$var$_emptyFunc = function _emptyFunc() {
    return false;
}, $9644ab9b72d1ba35$var$_transformProp = "transform", $9644ab9b72d1ba35$var$_transformOriginProp = "transformOrigin", $9644ab9b72d1ba35$var$_round = function _round(value) {
    return Math.round(value * 10000) / 10000;
}, $9644ab9b72d1ba35$var$_isArray = Array.isArray, $9644ab9b72d1ba35$var$_createElement = function _createElement(type, ns) {
    var e = $9644ab9b72d1ba35$var$_doc.createElementNS ? $9644ab9b72d1ba35$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $9644ab9b72d1ba35$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e.style ? e : $9644ab9b72d1ba35$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://gsap.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $9644ab9b72d1ba35$var$_RAD2DEG = 180 / Math.PI, $9644ab9b72d1ba35$var$_bigNum = 1e20, $9644ab9b72d1ba35$var$_identityMatrix = new (0, $b760a7c355166707$export$26e6ecd136a15474)(), $9644ab9b72d1ba35$var$_getTime = Date.now || function() {
    return new Date().getTime();
}, $9644ab9b72d1ba35$var$_renderQueue = [], $9644ab9b72d1ba35$var$_lookup = {}, //when a Draggable is created, the target gets a unique _gsDragID property that allows gets associated with the Draggable instance for quick lookups in Draggable.get(). This avoids circular references that could cause gc problems.
$9644ab9b72d1ba35$var$_lookupCount = 0, $9644ab9b72d1ba35$var$_clickableTagExp = /^(?:a|input|textarea|button|select)$/i, $9644ab9b72d1ba35$var$_lastDragTime = 0, $9644ab9b72d1ba35$var$_temp1 = {}, // a simple object we reuse and populate (usually x/y properties) to conserve memory and improve performance.
$9644ab9b72d1ba35$var$_windowProxy = {}, //memory/performance optimization - we reuse this object during autoScroll to store window-related bounds/offsets.
$9644ab9b72d1ba35$var$_copy = function _copy(obj, factor) {
    var copy = {}, p;
    for(p in obj)copy[p] = factor ? obj[p] * factor : obj[p];
    return copy;
}, $9644ab9b72d1ba35$var$_extend = function _extend(obj, defaults) {
    for(var p in defaults)if (!(p in obj)) obj[p] = defaults[p];
    return obj;
}, $9644ab9b72d1ba35$var$_setTouchActionForAllDescendants = function _setTouchActionForAllDescendants(elements, value) {
    var i = elements.length, children;
    while(i--){
        value ? elements[i].style.touchAction = value : elements[i].style.removeProperty("touch-action");
        children = elements[i].children;
        children && children.length && _setTouchActionForAllDescendants(children, value);
    }
}, $9644ab9b72d1ba35$var$_renderQueueTick = function _renderQueueTick() {
    return $9644ab9b72d1ba35$var$_renderQueue.forEach(function(func) {
        return func();
    });
}, $9644ab9b72d1ba35$var$_addToRenderQueue = function _addToRenderQueue(func) {
    $9644ab9b72d1ba35$var$_renderQueue.push(func);
    if ($9644ab9b72d1ba35$var$_renderQueue.length === 1) $9644ab9b72d1ba35$var$gsap.ticker.add($9644ab9b72d1ba35$var$_renderQueueTick);
}, $9644ab9b72d1ba35$var$_renderQueueTimeout = function _renderQueueTimeout() {
    return !$9644ab9b72d1ba35$var$_renderQueue.length && $9644ab9b72d1ba35$var$gsap.ticker.remove($9644ab9b72d1ba35$var$_renderQueueTick);
}, $9644ab9b72d1ba35$var$_removeFromRenderQueue = function _removeFromRenderQueue(func) {
    var i = $9644ab9b72d1ba35$var$_renderQueue.length;
    while(i--)if ($9644ab9b72d1ba35$var$_renderQueue[i] === func) $9644ab9b72d1ba35$var$_renderQueue.splice(i, 1);
    $9644ab9b72d1ba35$var$gsap.to($9644ab9b72d1ba35$var$_renderQueueTimeout, {
        overwrite: true,
        delay: 15,
        duration: 0,
        onComplete: $9644ab9b72d1ba35$var$_renderQueueTimeout,
        data: "_draggable"
    }); //remove the "tick" listener only after the render queue is empty for 15 seconds (to improve performance). Adding/removing it constantly for every click/touch wouldn't deliver optimal speed, and we also don't want the ticker to keep calling the render method when things are idle for long periods of time (we want to improve battery life on mobile devices).
}, $9644ab9b72d1ba35$var$_setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)if (!(p in obj)) obj[p] = defaults[p];
    return obj;
}, $9644ab9b72d1ba35$var$_addListener = function _addListener(element, type, func, capture) {
    if (element.addEventListener) {
        var touchType = $9644ab9b72d1ba35$var$_touchEventLookup[type];
        capture = capture || ($9644ab9b72d1ba35$var$_supportsPassive ? {
            passive: false
        } : null);
        element.addEventListener(touchType || type, func, capture);
        touchType && type !== touchType && element.addEventListener(type, func, capture); //some browsers actually support both, so must we. But pointer events cover all.
    }
}, $9644ab9b72d1ba35$var$_removeListener = function _removeListener(element, type, func, capture) {
    if (element.removeEventListener) {
        var touchType = $9644ab9b72d1ba35$var$_touchEventLookup[type];
        element.removeEventListener(touchType || type, func, capture);
        touchType && type !== touchType && element.removeEventListener(type, func, capture);
    }
}, $9644ab9b72d1ba35$var$_preventDefault = function _preventDefault(event) {
    event.preventDefault && event.preventDefault();
    event.preventManipulation && event.preventManipulation(); //for some Microsoft browsers
}, $9644ab9b72d1ba35$var$_hasTouchID = function _hasTouchID(list, ID) {
    var i = list.length;
    while(i--){
        if (list[i].identifier === ID) return true;
    }
}, $9644ab9b72d1ba35$var$_onMultiTouchDocumentEnd = function _onMultiTouchDocumentEnd(event) {
    $9644ab9b72d1ba35$var$_isMultiTouching = event.touches && $9644ab9b72d1ba35$var$_dragCount < event.touches.length;
    $9644ab9b72d1ba35$var$_removeListener(event.target, "touchend", _onMultiTouchDocumentEnd);
}, $9644ab9b72d1ba35$var$_onMultiTouchDocument = function _onMultiTouchDocument(event) {
    $9644ab9b72d1ba35$var$_isMultiTouching = event.touches && $9644ab9b72d1ba35$var$_dragCount < event.touches.length;
    $9644ab9b72d1ba35$var$_addListener(event.target, "touchend", $9644ab9b72d1ba35$var$_onMultiTouchDocumentEnd);
}, $9644ab9b72d1ba35$var$_getDocScrollTop = function _getDocScrollTop(doc) {
    return $9644ab9b72d1ba35$var$_win.pageYOffset || doc.scrollTop || doc.documentElement.scrollTop || doc.body.scrollTop || 0;
}, $9644ab9b72d1ba35$var$_getDocScrollLeft = function _getDocScrollLeft(doc) {
    return $9644ab9b72d1ba35$var$_win.pageXOffset || doc.scrollLeft || doc.documentElement.scrollLeft || doc.body.scrollLeft || 0;
}, $9644ab9b72d1ba35$var$_addScrollListener = function _addScrollListener(e, callback) {
    $9644ab9b72d1ba35$var$_addListener(e, "scroll", callback);
    if (!$9644ab9b72d1ba35$var$_isRoot(e.parentNode)) _addScrollListener(e.parentNode, callback);
}, $9644ab9b72d1ba35$var$_removeScrollListener = function _removeScrollListener(e, callback) {
    $9644ab9b72d1ba35$var$_removeListener(e, "scroll", callback);
    if (!$9644ab9b72d1ba35$var$_isRoot(e.parentNode)) _removeScrollListener(e.parentNode, callback);
}, $9644ab9b72d1ba35$var$_isRoot = function _isRoot(e) {
    return !!(!e || e === $9644ab9b72d1ba35$var$_docElement || e.nodeType === 9 || e === $9644ab9b72d1ba35$var$_doc.body || e === $9644ab9b72d1ba35$var$_win || !e.nodeType || !e.parentNode);
}, $9644ab9b72d1ba35$var$_getMaxScroll = function _getMaxScroll(element, axis) {
    var dim = axis === "x" ? "Width" : "Height", scroll = "scroll" + dim, client = "client" + dim;
    return Math.max(0, $9644ab9b72d1ba35$var$_isRoot(element) ? Math.max($9644ab9b72d1ba35$var$_docElement[scroll], $9644ab9b72d1ba35$var$_body[scroll]) - ($9644ab9b72d1ba35$var$_win["inner" + dim] || $9644ab9b72d1ba35$var$_docElement[client] || $9644ab9b72d1ba35$var$_body[client]) : element[scroll] - element[client]);
}, $9644ab9b72d1ba35$var$_recordMaxScrolls = function _recordMaxScrolls(e, skipCurrent) {
    //records _gsMaxScrollX and _gsMaxScrollY properties for the element and all ancestors up the chain so that we can cap it, otherwise dragging beyond the edges with autoScroll on can endlessly scroll.
    var x = $9644ab9b72d1ba35$var$_getMaxScroll(e, "x"), y = $9644ab9b72d1ba35$var$_getMaxScroll(e, "y");
    if ($9644ab9b72d1ba35$var$_isRoot(e)) e = $9644ab9b72d1ba35$var$_windowProxy;
    else _recordMaxScrolls(e.parentNode, skipCurrent);
    e._gsMaxScrollX = x;
    e._gsMaxScrollY = y;
    if (!skipCurrent) {
        e._gsScrollX = e.scrollLeft || 0;
        e._gsScrollY = e.scrollTop || 0;
    }
}, $9644ab9b72d1ba35$var$_setStyle = function _setStyle(element, property, value) {
    var style = element.style;
    if (!style) return;
    if ($9644ab9b72d1ba35$var$_isUndefined(style[property])) property = $9644ab9b72d1ba35$var$_checkPrefix(property, element) || property;
    if (value == null) style.removeProperty && style.removeProperty(property.replace(/([A-Z])/g, "-$1").toLowerCase());
    else style[property] = value;
}, $9644ab9b72d1ba35$var$_getComputedStyle = function _getComputedStyle(element) {
    return $9644ab9b72d1ba35$var$_win.getComputedStyle(element instanceof Element ? element : element.host || (element.parentNode || {}).host || element);
}, //the "host" stuff helps to accommodate ShadowDom objects.
$9644ab9b72d1ba35$var$_tempRect = {}, //reuse to reduce garbage collection tasks
$9644ab9b72d1ba35$var$_parseRect = function _parseRect(e) {
    //accepts a DOM element, a mouse event, or a rectangle object and returns the corresponding rectangle with left, right, width, height, top, and bottom properties
    if (e === $9644ab9b72d1ba35$var$_win) {
        $9644ab9b72d1ba35$var$_tempRect.left = $9644ab9b72d1ba35$var$_tempRect.top = 0;
        $9644ab9b72d1ba35$var$_tempRect.width = $9644ab9b72d1ba35$var$_tempRect.right = $9644ab9b72d1ba35$var$_docElement.clientWidth || e.innerWidth || $9644ab9b72d1ba35$var$_body.clientWidth || 0;
        $9644ab9b72d1ba35$var$_tempRect.height = $9644ab9b72d1ba35$var$_tempRect.bottom = (e.innerHeight || 0) - 20 < $9644ab9b72d1ba35$var$_docElement.clientHeight ? $9644ab9b72d1ba35$var$_docElement.clientHeight : e.innerHeight || $9644ab9b72d1ba35$var$_body.clientHeight || 0;
        return $9644ab9b72d1ba35$var$_tempRect;
    }
    var doc = e.ownerDocument || $9644ab9b72d1ba35$var$_doc, r = !$9644ab9b72d1ba35$var$_isUndefined(e.pageX) ? {
        left: e.pageX - $9644ab9b72d1ba35$var$_getDocScrollLeft(doc),
        top: e.pageY - $9644ab9b72d1ba35$var$_getDocScrollTop(doc),
        right: e.pageX - $9644ab9b72d1ba35$var$_getDocScrollLeft(doc) + 1,
        bottom: e.pageY - $9644ab9b72d1ba35$var$_getDocScrollTop(doc) + 1
    } : !e.nodeType && !$9644ab9b72d1ba35$var$_isUndefined(e.left) && !$9644ab9b72d1ba35$var$_isUndefined(e.top) ? e : $9644ab9b72d1ba35$var$_toArray(e)[0].getBoundingClientRect();
    if ($9644ab9b72d1ba35$var$_isUndefined(r.right) && !$9644ab9b72d1ba35$var$_isUndefined(r.width)) {
        r.right = r.left + r.width;
        r.bottom = r.top + r.height;
    } else if ($9644ab9b72d1ba35$var$_isUndefined(r.width)) //some browsers don't include width and height properties. We can't just set them directly on r because some browsers throw errors, so create a new generic object.
    r = {
        width: r.right - r.left,
        height: r.bottom - r.top,
        right: r.right,
        left: r.left,
        bottom: r.bottom,
        top: r.top
    };
    return r;
}, $9644ab9b72d1ba35$var$_dispatchEvent = function _dispatchEvent(target, type, callbackName) {
    var vars = target.vars, callback = vars[callbackName], listeners = target._listeners[type], result;
    if ($9644ab9b72d1ba35$var$_isFunction(callback)) result = callback.apply(vars.callbackScope || target, vars[callbackName + "Params"] || [
        target.pointerEvent
    ]);
    if (listeners && target.dispatchEvent(type) === false) result = false;
    return result;
}, $9644ab9b72d1ba35$var$_getBounds = function _getBounds(target, context) {
    //accepts any of the following: a DOM element, jQuery object, selector text, or an object defining bounds as {top, left, width, height} or {minX, maxX, minY, maxY}. Returns an object with left, top, width, and height properties.
    var e = $9644ab9b72d1ba35$var$_toArray(target)[0], top, left, offset;
    if (!e.nodeType && e !== $9644ab9b72d1ba35$var$_win) {
        if (!$9644ab9b72d1ba35$var$_isUndefined(target.left)) {
            offset = {
                x: 0,
                y: 0
            }; //_getOffsetTransformOrigin(context); //the bounds should be relative to the origin
            return {
                left: target.left - offset.x,
                top: target.top - offset.y,
                width: target.width,
                height: target.height
            };
        }
        left = target.min || target.minX || target.minRotation || 0;
        top = target.min || target.minY || 0;
        return {
            left: left,
            top: top,
            width: (target.max || target.maxX || target.maxRotation || 0) - left,
            height: (target.max || target.maxY || 0) - top
        };
    }
    return $9644ab9b72d1ba35$var$_getElementBounds(e, context);
}, $9644ab9b72d1ba35$var$_point1 = {}, //we reuse to minimize garbage collection tasks.
$9644ab9b72d1ba35$var$_getElementBounds = function _getElementBounds(element, context) {
    context = $9644ab9b72d1ba35$var$_toArray(context)[0];
    var isSVG = element.getBBox && element.ownerSVGElement, doc = element.ownerDocument || $9644ab9b72d1ba35$var$_doc, left, right, top, bottom, matrix, p1, p2, p3, p4, bbox, width, height, cs;
    if (element === $9644ab9b72d1ba35$var$_win) {
        top = $9644ab9b72d1ba35$var$_getDocScrollTop(doc);
        left = $9644ab9b72d1ba35$var$_getDocScrollLeft(doc);
        right = left + (doc.documentElement.clientWidth || element.innerWidth || doc.body.clientWidth || 0);
        bottom = top + ((element.innerHeight || 0) - 20 < doc.documentElement.clientHeight ? doc.documentElement.clientHeight : element.innerHeight || doc.body.clientHeight || 0); //some browsers (like Firefox) ignore absolutely positioned elements, and collapse the height of the documentElement, so it could be 8px, for example, if you have just an absolutely positioned div. In that case, we use the innerHeight to resolve this.
    } else if (context === $9644ab9b72d1ba35$var$_win || $9644ab9b72d1ba35$var$_isUndefined(context)) return element.getBoundingClientRect();
    else {
        left = top = 0;
        if (isSVG) {
            bbox = element.getBBox();
            width = bbox.width;
            height = bbox.height;
        } else {
            if (element.viewBox && (bbox = element.viewBox.baseVal)) {
                left = bbox.x || 0;
                top = bbox.y || 0;
                width = bbox.width;
                height = bbox.height;
            }
            if (!width) {
                cs = $9644ab9b72d1ba35$var$_getComputedStyle(element);
                bbox = cs.boxSizing === "border-box";
                width = (parseFloat(cs.width) || element.clientWidth || 0) + (bbox ? 0 : parseFloat(cs.borderLeftWidth) + parseFloat(cs.borderRightWidth));
                height = (parseFloat(cs.height) || element.clientHeight || 0) + (bbox ? 0 : parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth));
            }
        }
        right = width;
        bottom = height;
    }
    if (element === context) return {
        left: left,
        top: top,
        width: right - left,
        height: bottom - top
    };
    matrix = (0, $b760a7c355166707$export$91a495f99cf781b7)(context, true).multiply((0, $b760a7c355166707$export$91a495f99cf781b7)(element));
    p1 = matrix.apply({
        x: left,
        y: top
    });
    p2 = matrix.apply({
        x: right,
        y: top
    });
    p3 = matrix.apply({
        x: right,
        y: bottom
    });
    p4 = matrix.apply({
        x: left,
        y: bottom
    });
    left = Math.min(p1.x, p2.x, p3.x, p4.x);
    top = Math.min(p1.y, p2.y, p3.y, p4.y);
    return {
        left: left,
        top: top,
        width: Math.max(p1.x, p2.x, p3.x, p4.x) - left,
        height: Math.max(p1.y, p2.y, p3.y, p4.y) - top
    };
}, $9644ab9b72d1ba35$var$_parseInertia = function _parseInertia(draggable, snap, max, min, factor, forceZeroVelocity) {
    var vars = {}, a, i, l;
    if (snap) {
        if (factor !== 1 && snap instanceof Array) {
            //some data must be altered to make sense, like if the user passes in an array of rotational values in degrees, we must convert it to radians. Or for scrollLeft and scrollTop, we invert the values.
            vars.end = a = [];
            l = snap.length;
            if ($9644ab9b72d1ba35$var$_isObject(snap[0])) //if the array is populated with objects, like points ({x:100, y:200}), make copies before multiplying by the factor, otherwise we'll mess up the originals and the user may reuse it elsewhere.
            for(i = 0; i < l; i++)a[i] = $9644ab9b72d1ba35$var$_copy(snap[i], factor);
            else for(i = 0; i < l; i++)a[i] = snap[i] * factor;
            max += 1.1; //allow 1.1 pixels of wiggle room when snapping in order to work around some browser inconsistencies in the way bounds are reported which can make them roughly a pixel off. For example, if "snap:[-$('#menu').width(), 0]" was defined and #menu had a wrapper that was used as the bounds, some browsers would be one pixel off, making the minimum -752 for example when snap was [-753,0], thus instead of snapping to -753, it would snap to 0 since -753 was below the minimum.
            min -= 1.1;
        } else if ($9644ab9b72d1ba35$var$_isFunction(snap)) vars.end = function(value) {
            var result = snap.call(draggable, value), copy, p;
            if (factor !== 1) {
                if ($9644ab9b72d1ba35$var$_isObject(result)) {
                    copy = {};
                    for(p in result)copy[p] = result[p] * factor;
                    result = copy;
                } else result *= factor;
            }
            return result; //we need to ensure that we can scope the function call to the Draggable instance itself so that users can access important values like maxX, minX, maxY, minY, x, and y from within that function.
        };
        else vars.end = snap;
    }
    if (max || max === 0) vars.max = max;
    if (min || min === 0) vars.min = min;
    if (forceZeroVelocity) vars.velocity = 0;
    return vars;
}, $9644ab9b72d1ba35$var$_isClickable = function _isClickable(element) {
    //sometimes it's convenient to mark an element as clickable by adding a data-clickable="true" attribute (in which case we won't preventDefault() the mouse/touch event). This method checks if the element is an <a>, <input>, or <button> or has the data-clickable or contentEditable attribute set to true (or any of its parent elements).
    var data;
    return !element || !element.getAttribute || element === $9644ab9b72d1ba35$var$_body ? false : (data = element.getAttribute("data-clickable")) === "true" || data !== "false" && ($9644ab9b72d1ba35$var$_clickableTagExp.test(element.nodeName + "") || element.getAttribute("contentEditable") === "true") ? true : _isClickable(element.parentNode);
}, $9644ab9b72d1ba35$var$_setSelectable = function _setSelectable(elements, selectable) {
    var i = elements.length, e;
    while(i--){
        e = elements[i];
        e.ondragstart = e.onselectstart = selectable ? null : $9644ab9b72d1ba35$var$_emptyFunc;
        $9644ab9b72d1ba35$var$gsap.set(e, {
            lazy: true,
            userSelect: selectable ? "text" : "none"
        });
    }
}, $9644ab9b72d1ba35$var$_isFixed = function _isFixed(element) {
    if ($9644ab9b72d1ba35$var$_getComputedStyle(element).position === "fixed") return true;
    element = element.parentNode;
    if (element && element.nodeType === 1) // avoid document fragments which will throw an error.
    return _isFixed(element);
}, $9644ab9b72d1ba35$var$_supports3D, $9644ab9b72d1ba35$var$_addPaddingBR, //The ScrollProxy class wraps an element's contents into another div (we call it "content") that we either add padding when necessary or apply a translate3d() transform in order to overscroll (scroll past the boundaries). This allows us to simply set the scrollTop/scrollLeft (or top/left for easier reverse-axis orientation, which is what we do in Draggable) and it'll do all the work for us. For example, if we tried setting scrollTop to -100 on a normal DOM element, it wouldn't work - it'd look the same as setting it to 0, but if we set scrollTop of a ScrollProxy to -100, it'll give the correct appearance by either setting paddingTop of the wrapper to 100 or applying a 100-pixel translateY.
$9644ab9b72d1ba35$var$ScrollProxy = function ScrollProxy(element, vars) {
    element = $9644ab9b72d1ba35$var$gsap.utils.toArray(element)[0];
    vars = vars || {};
    var content = document.createElement("div"), style = content.style, node = element.firstChild, offsetTop = 0, offsetLeft = 0, prevTop = element.scrollTop, prevLeft = element.scrollLeft, scrollWidth = element.scrollWidth, scrollHeight = element.scrollHeight, extraPadRight = 0, maxLeft = 0, maxTop = 0, elementWidth, elementHeight, contentHeight, nextNode, transformStart, transformEnd;
    if ($9644ab9b72d1ba35$var$_supports3D && vars.force3D !== false) {
        transformStart = "translate3d(";
        transformEnd = "px,0px)";
    } else if ($9644ab9b72d1ba35$var$_transformProp) {
        transformStart = "translate(";
        transformEnd = "px)";
    }
    this.scrollTop = function(value, force) {
        if (!arguments.length) return -this.top();
        this.top(-value, force);
    };
    this.scrollLeft = function(value, force) {
        if (!arguments.length) return -this.left();
        this.left(-value, force);
    };
    this.left = function(value, force) {
        if (!arguments.length) return -(element.scrollLeft + offsetLeft);
        var dif = element.scrollLeft - prevLeft, oldOffset = offsetLeft;
        if ((dif > 2 || dif < -2) && !force) {
            //if the user interacts with the scrollbar (or something else scrolls it, like the mouse wheel), we should kill any tweens of the ScrollProxy.
            prevLeft = element.scrollLeft;
            $9644ab9b72d1ba35$var$gsap.killTweensOf(this, {
                left: 1,
                scrollLeft: 1
            });
            this.left(-prevLeft);
            if (vars.onKill) vars.onKill();
            return;
        }
        value = -value; //invert because scrolling works in the opposite direction
        if (value < 0) {
            offsetLeft = value - 0.5 | 0;
            value = 0;
        } else if (value > maxLeft) {
            offsetLeft = value - maxLeft | 0;
            value = maxLeft;
        } else offsetLeft = 0;
        if (offsetLeft || oldOffset) {
            if (!this._skip) style[$9644ab9b72d1ba35$var$_transformProp] = transformStart + -offsetLeft + "px," + -offsetTop + transformEnd;
            if (offsetLeft + extraPadRight >= 0) style.paddingRight = offsetLeft + extraPadRight + "px";
        }
        element.scrollLeft = value | 0;
        prevLeft = element.scrollLeft; //don't merge this with the line above because some browsers adjust the scrollLeft after it's set, so in order to be 100% accurate in tracking it, we need to ask the browser to report it.
    };
    this.top = function(value, force) {
        if (!arguments.length) return -(element.scrollTop + offsetTop);
        var dif = element.scrollTop - prevTop, oldOffset = offsetTop;
        if ((dif > 2 || dif < -2) && !force) {
            //if the user interacts with the scrollbar (or something else scrolls it, like the mouse wheel), we should kill any tweens of the ScrollProxy.
            prevTop = element.scrollTop;
            $9644ab9b72d1ba35$var$gsap.killTweensOf(this, {
                top: 1,
                scrollTop: 1
            });
            this.top(-prevTop);
            if (vars.onKill) vars.onKill();
            return;
        }
        value = -value; //invert because scrolling works in the opposite direction
        if (value < 0) {
            offsetTop = value - 0.5 | 0;
            value = 0;
        } else if (value > maxTop) {
            offsetTop = value - maxTop | 0;
            value = maxTop;
        } else offsetTop = 0;
        if (offsetTop || oldOffset) {
            if (!this._skip) style[$9644ab9b72d1ba35$var$_transformProp] = transformStart + -offsetLeft + "px," + -offsetTop + transformEnd;
        }
        element.scrollTop = value | 0;
        prevTop = element.scrollTop;
    };
    this.maxScrollTop = function() {
        return maxTop;
    };
    this.maxScrollLeft = function() {
        return maxLeft;
    };
    this.disable = function() {
        node = content.firstChild;
        while(node){
            nextNode = node.nextSibling;
            element.appendChild(node);
            node = nextNode;
        }
        if (element === content.parentNode) //in case disable() is called when it's already disabled.
        element.removeChild(content);
    };
    this.enable = function() {
        node = element.firstChild;
        if (node === content) return;
        while(node){
            nextNode = node.nextSibling;
            content.appendChild(node);
            node = nextNode;
        }
        element.appendChild(content);
        this.calibrate();
    };
    this.calibrate = function(force) {
        var widthMatches = element.clientWidth === elementWidth, cs, x, y;
        prevTop = element.scrollTop;
        prevLeft = element.scrollLeft;
        if (widthMatches && element.clientHeight === elementHeight && content.offsetHeight === contentHeight && scrollWidth === element.scrollWidth && scrollHeight === element.scrollHeight && !force) return; //no need to recalculate things if the width and height haven't changed.
        if (offsetTop || offsetLeft) {
            x = this.left();
            y = this.top();
            this.left(-element.scrollLeft);
            this.top(-element.scrollTop);
        }
        cs = $9644ab9b72d1ba35$var$_getComputedStyle(element); //first, we need to remove any width constraints to see how the content naturally flows so that we can see if it's wider than the containing element. If so, we've got to record the amount of overage so that we can apply that as padding in order for browsers to correctly handle things. Then we switch back to a width of 100% (without that, some browsers don't flow the content correctly)
        if (!widthMatches || force) {
            style.display = "block";
            style.width = "auto";
            style.paddingRight = "0px";
            extraPadRight = Math.max(0, element.scrollWidth - element.clientWidth); //if the content is wider than the container, we need to add the paddingLeft and paddingRight in order for things to behave correctly.
            if (extraPadRight) extraPadRight += parseFloat(cs.paddingLeft) + ($9644ab9b72d1ba35$var$_addPaddingBR ? parseFloat(cs.paddingRight) : 0);
        }
        style.display = "inline-block";
        style.position = "relative";
        style.overflow = "visible";
        style.verticalAlign = "top";
        style.boxSizing = "content-box";
        style.width = "100%";
        style.paddingRight = extraPadRight + "px"; //some browsers neglect to factor in the bottom padding when calculating the scrollHeight, so we need to add that padding to the content when that happens. Allow a 2px margin for error
        if ($9644ab9b72d1ba35$var$_addPaddingBR) style.paddingBottom = cs.paddingBottom;
        elementWidth = element.clientWidth;
        elementHeight = element.clientHeight;
        scrollWidth = element.scrollWidth;
        scrollHeight = element.scrollHeight;
        maxLeft = element.scrollWidth - elementWidth;
        maxTop = element.scrollHeight - elementHeight;
        contentHeight = content.offsetHeight;
        style.display = "block";
        if (x || y) {
            this.left(x);
            this.top(y);
        }
    };
    this.content = content;
    this.element = element;
    this._skip = false;
    this.enable();
}, $9644ab9b72d1ba35$var$_initCore = function _initCore(required) {
    if ($9644ab9b72d1ba35$var$_windowExists() && document.body) {
        var nav = window && window.navigator;
        $9644ab9b72d1ba35$var$_win = window;
        $9644ab9b72d1ba35$var$_doc = document;
        $9644ab9b72d1ba35$var$_docElement = $9644ab9b72d1ba35$var$_doc.documentElement;
        $9644ab9b72d1ba35$var$_body = $9644ab9b72d1ba35$var$_doc.body;
        $9644ab9b72d1ba35$var$_tempDiv = $9644ab9b72d1ba35$var$_createElement("div");
        $9644ab9b72d1ba35$var$_supportsPointer = !!window.PointerEvent;
        $9644ab9b72d1ba35$var$_placeholderDiv = $9644ab9b72d1ba35$var$_createElement("div");
        $9644ab9b72d1ba35$var$_placeholderDiv.style.cssText = "visibility:hidden;height:1px;top:-1px;pointer-events:none;position:relative;clear:both;cursor:grab";
        $9644ab9b72d1ba35$var$_defaultCursor = $9644ab9b72d1ba35$var$_placeholderDiv.style.cursor === "grab" ? "grab" : "move";
        $9644ab9b72d1ba35$var$_isAndroid = nav && nav.userAgent.toLowerCase().indexOf("android") !== -1; //Android handles touch events in an odd way and it's virtually impossible to "feature test" so we resort to UA sniffing
        $9644ab9b72d1ba35$var$_isTouchDevice = "ontouchstart" in $9644ab9b72d1ba35$var$_docElement && "orientation" in $9644ab9b72d1ba35$var$_win || nav && (nav.MaxTouchPoints > 0 || nav.msMaxTouchPoints > 0);
        $9644ab9b72d1ba35$var$_addPaddingBR = function() {
            //this function is in charge of analyzing browser behavior related to padding. It sets the _addPaddingBR to true if the browser doesn't normally factor in the bottom or right padding on the element inside the scrolling area, and it sets _addPaddingLeft to true if it's a browser that requires the extra offset (offsetLeft) to be added to the paddingRight (like Opera).
            var div = $9644ab9b72d1ba35$var$_createElement("div"), child = $9644ab9b72d1ba35$var$_createElement("div"), childStyle = child.style, parent = $9644ab9b72d1ba35$var$_body, val;
            childStyle.display = "inline-block";
            childStyle.position = "relative";
            div.style.cssText = "width:90px;height:40px;padding:10px;overflow:auto;visibility:hidden";
            div.appendChild(child);
            parent.appendChild(div);
            val = child.offsetHeight + 18 > div.scrollHeight; //div.scrollHeight should be child.offsetHeight + 20 because of the 10px of padding on each side, but some browsers ignore one side. We allow a 2px margin of error.
            parent.removeChild(div);
            return val;
        }();
        $9644ab9b72d1ba35$var$_touchEventLookup = function(types) {
            //we create an object that makes it easy to translate touch event types into their "pointer" counterparts if we're in a browser that uses those instead. Like IE10 uses "MSPointerDown" instead of "touchstart", for example.
            var standard = types.split(","), converted = ("onpointerdown" in $9644ab9b72d1ba35$var$_tempDiv ? "pointerdown,pointermove,pointerup,pointercancel" : "onmspointerdown" in $9644ab9b72d1ba35$var$_tempDiv ? "MSPointerDown,MSPointerMove,MSPointerUp,MSPointerCancel" : types).split(","), obj = {}, i = 4;
            while(--i > -1){
                obj[standard[i]] = converted[i];
                obj[converted[i]] = standard[i];
            } //to avoid problems in iOS 9, test to see if the browser supports the "passive" option on addEventListener().
            try {
                $9644ab9b72d1ba35$var$_docElement.addEventListener("test", null, Object.defineProperty({}, "passive", {
                    get: function get() {
                        $9644ab9b72d1ba35$var$_supportsPassive = 1;
                    }
                }));
            } catch (e) {}
            return obj;
        }("touchstart,touchmove,touchend,touchcancel");
        $9644ab9b72d1ba35$var$_addListener($9644ab9b72d1ba35$var$_doc, "touchcancel", $9644ab9b72d1ba35$var$_emptyFunc); //some older Android devices intermittently stop dispatching "touchmove" events if we don't listen for "touchcancel" on the document. Very strange indeed.
        $9644ab9b72d1ba35$var$_addListener($9644ab9b72d1ba35$var$_win, "touchmove", $9644ab9b72d1ba35$var$_emptyFunc); //works around Safari bugs that still allow the page to scroll even when we preventDefault() on the touchmove event.
        $9644ab9b72d1ba35$var$_body && $9644ab9b72d1ba35$var$_body.addEventListener("touchstart", $9644ab9b72d1ba35$var$_emptyFunc); //works around Safari bug: https://gsap.com/forums/topic/21450-draggable-in-iframe-on-mobile-is-buggy/
        $9644ab9b72d1ba35$var$_addListener($9644ab9b72d1ba35$var$_doc, "contextmenu", function() {
            for(var p in $9644ab9b72d1ba35$var$_lookup)if ($9644ab9b72d1ba35$var$_lookup[p].isPressed) $9644ab9b72d1ba35$var$_lookup[p].endDrag();
        });
        $9644ab9b72d1ba35$var$gsap = $9644ab9b72d1ba35$var$_coreInitted = $9644ab9b72d1ba35$var$_getGSAP();
    }
    if ($9644ab9b72d1ba35$var$gsap) {
        $9644ab9b72d1ba35$var$InertiaPlugin = $9644ab9b72d1ba35$var$gsap.plugins.inertia;
        $9644ab9b72d1ba35$var$_context = $9644ab9b72d1ba35$var$gsap.core.context || function() {};
        $9644ab9b72d1ba35$var$_checkPrefix = $9644ab9b72d1ba35$var$gsap.utils.checkPrefix;
        $9644ab9b72d1ba35$var$_transformProp = $9644ab9b72d1ba35$var$_checkPrefix($9644ab9b72d1ba35$var$_transformProp);
        $9644ab9b72d1ba35$var$_transformOriginProp = $9644ab9b72d1ba35$var$_checkPrefix($9644ab9b72d1ba35$var$_transformOriginProp);
        $9644ab9b72d1ba35$var$_toArray = $9644ab9b72d1ba35$var$gsap.utils.toArray;
        $9644ab9b72d1ba35$var$_getStyleSaver = $9644ab9b72d1ba35$var$gsap.core.getStyleSaver;
        $9644ab9b72d1ba35$var$_supports3D = !!$9644ab9b72d1ba35$var$_checkPrefix("perspective");
    } else if (required) console.warn("Please gsap.registerPlugin(Draggable)");
};
var $9644ab9b72d1ba35$var$EventDispatcher = /*#__PURE__*/ function() {
    function EventDispatcher(target) {
        this._listeners = {};
        this.target = target || this;
    }
    var _proto = EventDispatcher.prototype;
    _proto.addEventListener = function addEventListener(type, callback) {
        var list = this._listeners[type] || (this._listeners[type] = []);
        if (!~list.indexOf(callback)) list.push(callback);
    };
    _proto.removeEventListener = function removeEventListener(type, callback) {
        var list = this._listeners[type], i = list && list.indexOf(callback);
        i >= 0 && list.splice(i, 1);
    };
    _proto.dispatchEvent = function dispatchEvent(type) {
        var _this = this;
        var result;
        (this._listeners[type] || []).forEach(function(callback) {
            return callback.call(_this, {
                type: type,
                target: _this.target
            }) === false && (result = false);
        });
        return result; //if any of the callbacks return false, pass that along.
    };
    return EventDispatcher;
}();
var $9644ab9b72d1ba35$export$f2a139e5d18b9882 = /*#__PURE__*/ function(_EventDispatcher) {
    $9644ab9b72d1ba35$var$_inheritsLoose(Draggable, _EventDispatcher);
    function Draggable(target, vars) {
        var _this2;
        _this2 = _EventDispatcher.call(this) || this;
        $9644ab9b72d1ba35$var$_coreInitted || $9644ab9b72d1ba35$var$_initCore(1);
        target = $9644ab9b72d1ba35$var$_toArray(target)[0]; //in case the target is a selector object or selector text
        _this2.styles = $9644ab9b72d1ba35$var$_getStyleSaver && $9644ab9b72d1ba35$var$_getStyleSaver(target, "transform,left,top");
        if (!$9644ab9b72d1ba35$var$InertiaPlugin) $9644ab9b72d1ba35$var$InertiaPlugin = $9644ab9b72d1ba35$var$gsap.plugins.inertia;
        _this2.vars = vars = $9644ab9b72d1ba35$var$_copy(vars || {});
        _this2.target = target;
        _this2.x = _this2.y = _this2.rotation = 0;
        _this2.dragResistance = parseFloat(vars.dragResistance) || 0;
        _this2.edgeResistance = isNaN(vars.edgeResistance) ? 1 : parseFloat(vars.edgeResistance) || 0;
        _this2.lockAxis = vars.lockAxis;
        _this2.autoScroll = vars.autoScroll || 0;
        _this2.lockedAxis = null;
        _this2.allowEventDefault = !!vars.allowEventDefault;
        $9644ab9b72d1ba35$var$gsap.getProperty(target, "x"); // to ensure that transforms are instantiated.
        var type = (vars.type || "x,y").toLowerCase(), xyMode = ~type.indexOf("x") || ~type.indexOf("y"), rotationMode = type.indexOf("rotation") !== -1, xProp = rotationMode ? "rotation" : xyMode ? "x" : "left", yProp = xyMode ? "y" : "top", allowX = !!(~type.indexOf("x") || ~type.indexOf("left") || type === "scroll"), allowY = !!(~type.indexOf("y") || ~type.indexOf("top") || type === "scroll"), minimumMovement = vars.minimumMovement || 2, self = $9644ab9b72d1ba35$var$_assertThisInitialized(_this2), triggers = $9644ab9b72d1ba35$var$_toArray(vars.trigger || vars.handle || target), killProps = {}, dragEndTime = 0, checkAutoScrollBounds = false, autoScrollMarginTop = vars.autoScrollMarginTop || 40, autoScrollMarginRight = vars.autoScrollMarginRight || 40, autoScrollMarginBottom = vars.autoScrollMarginBottom || 40, autoScrollMarginLeft = vars.autoScrollMarginLeft || 40, isClickable = vars.clickableTest || $9644ab9b72d1ba35$var$_isClickable, clickTime = 0, gsCache = target._gsap || $9644ab9b72d1ba35$var$gsap.core.getCache(target), isFixed = $9644ab9b72d1ba35$var$_isFixed(target), getPropAsNum = function getPropAsNum(property, unit) {
            return parseFloat(gsCache.get(target, property, unit));
        }, ownerDoc = target.ownerDocument || $9644ab9b72d1ba35$var$_doc, enabled, scrollProxy, startPointerX, startPointerY, startElementX, startElementY, hasBounds, hasDragCallback, hasMoveCallback, maxX, minX, maxY, minY, touch, touchID, rotationOrigin, dirty, old, snapX, snapY, snapXY, isClicking, touchEventTarget, matrix, interrupted, allowNativeTouchScrolling, touchDragAxis, isDispatching, clickDispatch, trustedClickDispatch, isPreventingDefault, innerMatrix, dragged, onContextMenu = function onContextMenu(e) {
            //used to prevent long-touch from triggering a context menu.
            // (self.isPressed && e.which < 2) && self.endDrag() // previously ended drag when context menu was triggered, but instead we should just stop propagation and prevent the default event behavior.
            $9644ab9b72d1ba35$var$_preventDefault(e);
            e.stopImmediatePropagation && e.stopImmediatePropagation();
            return false;
        }, //this method gets called on every tick of TweenLite.ticker which allows us to synchronize the renders to the core engine (which is typically synchronized with the display refresh via requestAnimationFrame). This is an optimization - it's better than applying the values inside the "mousemove" or "touchmove" event handler which may get called many times inbetween refreshes.
        render = function render(suppressEvents) {
            if (self.autoScroll && self.isDragging && (checkAutoScrollBounds || dirty)) {
                var e = target, autoScrollFactor = self.autoScroll * 15, //multiplying by 15 just gives us a better "feel" speed-wise.
                parent, isRoot, rect, pointerX, pointerY, changeX, changeY, gap;
                checkAutoScrollBounds = false;
                $9644ab9b72d1ba35$var$_windowProxy.scrollTop = $9644ab9b72d1ba35$var$_win.pageYOffset != null ? $9644ab9b72d1ba35$var$_win.pageYOffset : ownerDoc.documentElement.scrollTop != null ? ownerDoc.documentElement.scrollTop : ownerDoc.body.scrollTop;
                $9644ab9b72d1ba35$var$_windowProxy.scrollLeft = $9644ab9b72d1ba35$var$_win.pageXOffset != null ? $9644ab9b72d1ba35$var$_win.pageXOffset : ownerDoc.documentElement.scrollLeft != null ? ownerDoc.documentElement.scrollLeft : ownerDoc.body.scrollLeft;
                pointerX = self.pointerX - $9644ab9b72d1ba35$var$_windowProxy.scrollLeft;
                pointerY = self.pointerY - $9644ab9b72d1ba35$var$_windowProxy.scrollTop;
                while(e && !isRoot){
                    //walk up the chain and sense wherever the pointer is within 40px of an edge that's scrollable.
                    isRoot = $9644ab9b72d1ba35$var$_isRoot(e.parentNode);
                    parent = isRoot ? $9644ab9b72d1ba35$var$_windowProxy : e.parentNode;
                    rect = isRoot ? {
                        bottom: Math.max($9644ab9b72d1ba35$var$_docElement.clientHeight, $9644ab9b72d1ba35$var$_win.innerHeight || 0),
                        right: Math.max($9644ab9b72d1ba35$var$_docElement.clientWidth, $9644ab9b72d1ba35$var$_win.innerWidth || 0),
                        left: 0,
                        top: 0
                    } : parent.getBoundingClientRect();
                    changeX = changeY = 0;
                    if (allowY) {
                        gap = parent._gsMaxScrollY - parent.scrollTop;
                        if (gap < 0) changeY = gap;
                        else if (pointerY > rect.bottom - autoScrollMarginBottom && gap) {
                            checkAutoScrollBounds = true;
                            changeY = Math.min(gap, autoScrollFactor * (1 - Math.max(0, rect.bottom - pointerY) / autoScrollMarginBottom) | 0);
                        } else if (pointerY < rect.top + autoScrollMarginTop && parent.scrollTop) {
                            checkAutoScrollBounds = true;
                            changeY = -Math.min(parent.scrollTop, autoScrollFactor * (1 - Math.max(0, pointerY - rect.top) / autoScrollMarginTop) | 0);
                        }
                        if (changeY) parent.scrollTop += changeY;
                    }
                    if (allowX) {
                        gap = parent._gsMaxScrollX - parent.scrollLeft;
                        if (gap < 0) changeX = gap;
                        else if (pointerX > rect.right - autoScrollMarginRight && gap) {
                            checkAutoScrollBounds = true;
                            changeX = Math.min(gap, autoScrollFactor * (1 - Math.max(0, rect.right - pointerX) / autoScrollMarginRight) | 0);
                        } else if (pointerX < rect.left + autoScrollMarginLeft && parent.scrollLeft) {
                            checkAutoScrollBounds = true;
                            changeX = -Math.min(parent.scrollLeft, autoScrollFactor * (1 - Math.max(0, pointerX - rect.left) / autoScrollMarginLeft) | 0);
                        }
                        if (changeX) parent.scrollLeft += changeX;
                    }
                    if (isRoot && (changeX || changeY)) {
                        $9644ab9b72d1ba35$var$_win.scrollTo(parent.scrollLeft, parent.scrollTop);
                        setPointerPosition(self.pointerX + changeX, self.pointerY + changeY);
                    }
                    e = parent;
                }
            }
            if (dirty) {
                var x = self.x, y = self.y;
                if (rotationMode) {
                    self.deltaX = x - parseFloat(gsCache.rotation);
                    self.rotation = x;
                    gsCache.rotation = x + "deg";
                    gsCache.renderTransform(1, gsCache);
                } else {
                    if (scrollProxy) {
                        if (allowY) {
                            self.deltaY = y - scrollProxy.top();
                            scrollProxy.top(y);
                        }
                        if (allowX) {
                            self.deltaX = x - scrollProxy.left();
                            scrollProxy.left(x);
                        }
                    } else if (xyMode) {
                        if (allowY) {
                            self.deltaY = y - parseFloat(gsCache.y);
                            gsCache.y = y + "px";
                        }
                        if (allowX) {
                            self.deltaX = x - parseFloat(gsCache.x);
                            gsCache.x = x + "px";
                        }
                        gsCache.renderTransform(1, gsCache);
                    } else {
                        if (allowY) {
                            self.deltaY = y - parseFloat(target.style.top || 0);
                            target.style.top = y + "px";
                        }
                        if (allowX) {
                            self.deltaX = x - parseFloat(target.style.left || 0);
                            target.style.left = x + "px";
                        }
                    }
                }
                if (hasDragCallback && !suppressEvents && !isDispatching) {
                    isDispatching = true; //in case onDrag has an update() call (avoid endless loop)
                    if ($9644ab9b72d1ba35$var$_dispatchEvent(self, "drag", "onDrag") === false) {
                        if (allowX) self.x -= self.deltaX;
                        if (allowY) self.y -= self.deltaY;
                        render(true);
                    }
                    isDispatching = false;
                }
            }
            dirty = false;
        }, //copies the x/y from the element (whether that be transforms, top/left, or ScrollProxy's top/left) to the Draggable's x and y (and rotation if necessary) properties so that they reflect reality and it also (optionally) applies any snapping necessary. This is used by the InertiaPlugin tween in an onUpdate to ensure things are synced and snapped.
        syncXY = function syncXY(skipOnUpdate, skipSnap) {
            var x = self.x, y = self.y, snappedValue, cs;
            if (!target._gsap) //just in case the _gsap cache got wiped, like if the user called clearProps on the transform or something (very rare).
            gsCache = $9644ab9b72d1ba35$var$gsap.core.getCache(target);
            gsCache.uncache && $9644ab9b72d1ba35$var$gsap.getProperty(target, "x"); // trigger a re-cache
            if (xyMode) {
                self.x = parseFloat(gsCache.x);
                self.y = parseFloat(gsCache.y);
            } else if (rotationMode) self.x = self.rotation = $9644ab9b72d1ba35$var$_round(parseFloat(gsCache.rotation));
            else if (scrollProxy) {
                self.y = scrollProxy.top();
                self.x = scrollProxy.left();
            } else {
                self.y = parseFloat(target.style.top || (cs = $9644ab9b72d1ba35$var$_getComputedStyle(target)) && cs.top) || 0;
                self.x = parseFloat(target.style.left || (cs || {}).left) || 0;
            }
            if ((snapX || snapY || snapXY) && !skipSnap && (self.isDragging || self.isThrowing)) {
                if (snapXY) {
                    $9644ab9b72d1ba35$var$_temp1.x = self.x;
                    $9644ab9b72d1ba35$var$_temp1.y = self.y;
                    snappedValue = snapXY($9644ab9b72d1ba35$var$_temp1);
                    if (snappedValue.x !== self.x) {
                        self.x = snappedValue.x;
                        dirty = true;
                    }
                    if (snappedValue.y !== self.y) {
                        self.y = snappedValue.y;
                        dirty = true;
                    }
                }
                if (snapX) {
                    snappedValue = snapX(self.x);
                    if (snappedValue !== self.x) {
                        self.x = snappedValue;
                        if (rotationMode) self.rotation = snappedValue;
                        dirty = true;
                    }
                }
                if (snapY) {
                    snappedValue = snapY(self.y);
                    if (snappedValue !== self.y) self.y = snappedValue;
                    dirty = true;
                }
            }
            dirty && render(true);
            if (!skipOnUpdate) {
                self.deltaX = self.x - x;
                self.deltaY = self.y - y;
                $9644ab9b72d1ba35$var$_dispatchEvent(self, "throwupdate", "onThrowUpdate");
            }
        }, buildSnapFunc = function buildSnapFunc(snap, min, max, factor) {
            if (min == null) min = -$9644ab9b72d1ba35$var$_bigNum;
            if (max == null) max = $9644ab9b72d1ba35$var$_bigNum;
            if ($9644ab9b72d1ba35$var$_isFunction(snap)) return function(n) {
                var edgeTolerance = !self.isPressed ? 1 : 1 - self.edgeResistance; //if we're tweening, disable the edgeTolerance because it's already factored into the tweening values (we don't want to apply it multiple times)
                return snap.call(self, (n > max ? max + (n - max) * edgeTolerance : n < min ? min + (n - min) * edgeTolerance : n) * factor) * factor;
            };
            if ($9644ab9b72d1ba35$var$_isArray(snap)) return function(n) {
                var i = snap.length, closest = 0, absDif = $9644ab9b72d1ba35$var$_bigNum, val, dif;
                while(--i > -1){
                    val = snap[i];
                    dif = val - n;
                    if (dif < 0) dif = -dif;
                    if (dif < absDif && val >= min && val <= max) {
                        closest = i;
                        absDif = dif;
                    }
                }
                return snap[closest];
            };
            return isNaN(snap) ? function(n) {
                return n;
            } : function() {
                return snap * factor;
            };
        }, buildPointSnapFunc = function buildPointSnapFunc(snap, minX, maxX, minY, maxY, radius, factor) {
            radius = radius && radius < $9644ab9b72d1ba35$var$_bigNum ? radius * radius : $9644ab9b72d1ba35$var$_bigNum; //so we don't have to Math.sqrt() in the functions. Performance optimization.
            if ($9644ab9b72d1ba35$var$_isFunction(snap)) return function(point) {
                var edgeTolerance = !self.isPressed ? 1 : 1 - self.edgeResistance, x = point.x, y = point.y, result, dx, dy; //if we're tweening, disable the edgeTolerance because it's already factored into the tweening values (we don't want to apply it multiple times)
                point.x = x = x > maxX ? maxX + (x - maxX) * edgeTolerance : x < minX ? minX + (x - minX) * edgeTolerance : x;
                point.y = y = y > maxY ? maxY + (y - maxY) * edgeTolerance : y < minY ? minY + (y - minY) * edgeTolerance : y;
                result = snap.call(self, point);
                if (result !== point) {
                    point.x = result.x;
                    point.y = result.y;
                }
                if (factor !== 1) {
                    point.x *= factor;
                    point.y *= factor;
                }
                if (radius < $9644ab9b72d1ba35$var$_bigNum) {
                    dx = point.x - x;
                    dy = point.y - y;
                    if (dx * dx + dy * dy > radius) {
                        point.x = x;
                        point.y = y;
                    }
                }
                return point;
            };
            if ($9644ab9b72d1ba35$var$_isArray(snap)) return function(p) {
                var i = snap.length, closest = 0, minDist = $9644ab9b72d1ba35$var$_bigNum, x, y, point, dist;
                while(--i > -1){
                    point = snap[i];
                    x = point.x - p.x;
                    y = point.y - p.y;
                    dist = x * x + y * y;
                    if (dist < minDist) {
                        closest = i;
                        minDist = dist;
                    }
                }
                return minDist <= radius ? snap[closest] : p;
            };
            return function(n) {
                return n;
            };
        }, calculateBounds = function calculateBounds() {
            var bounds, targetBounds, snap, snapIsRaw;
            hasBounds = false;
            if (scrollProxy) {
                scrollProxy.calibrate();
                self.minX = minX = -scrollProxy.maxScrollLeft();
                self.minY = minY = -scrollProxy.maxScrollTop();
                self.maxX = maxX = self.maxY = maxY = 0;
                hasBounds = true;
            } else if (!!vars.bounds) {
                bounds = $9644ab9b72d1ba35$var$_getBounds(vars.bounds, target.parentNode); //could be a selector/jQuery object or a DOM element or a generic object like {top:0, left:100, width:1000, height:800} or {minX:100, maxX:1100, minY:0, maxY:800}
                if (rotationMode) {
                    self.minX = minX = bounds.left;
                    self.maxX = maxX = bounds.left + bounds.width;
                    self.minY = minY = self.maxY = maxY = 0;
                } else if (!$9644ab9b72d1ba35$var$_isUndefined(vars.bounds.maxX) || !$9644ab9b72d1ba35$var$_isUndefined(vars.bounds.maxY)) {
                    bounds = vars.bounds;
                    self.minX = minX = bounds.minX;
                    self.minY = minY = bounds.minY;
                    self.maxX = maxX = bounds.maxX;
                    self.maxY = maxY = bounds.maxY;
                } else {
                    targetBounds = $9644ab9b72d1ba35$var$_getBounds(target, target.parentNode);
                    self.minX = minX = Math.round(getPropAsNum(xProp, "px") + bounds.left - targetBounds.left);
                    self.minY = minY = Math.round(getPropAsNum(yProp, "px") + bounds.top - targetBounds.top);
                    self.maxX = maxX = Math.round(minX + (bounds.width - targetBounds.width));
                    self.maxY = maxY = Math.round(minY + (bounds.height - targetBounds.height));
                }
                if (minX > maxX) {
                    self.minX = maxX;
                    self.maxX = maxX = minX;
                    minX = self.minX;
                }
                if (minY > maxY) {
                    self.minY = maxY;
                    self.maxY = maxY = minY;
                    minY = self.minY;
                }
                if (rotationMode) {
                    self.minRotation = minX;
                    self.maxRotation = maxX;
                }
                hasBounds = true;
            }
            if (vars.liveSnap) {
                snap = vars.liveSnap === true ? vars.snap || {} : vars.liveSnap;
                snapIsRaw = $9644ab9b72d1ba35$var$_isArray(snap) || $9644ab9b72d1ba35$var$_isFunction(snap);
                if (rotationMode) {
                    snapX = buildSnapFunc(snapIsRaw ? snap : snap.rotation, minX, maxX, 1);
                    snapY = null;
                } else if (snap.points) snapXY = buildPointSnapFunc(snapIsRaw ? snap : snap.points, minX, maxX, minY, maxY, snap.radius, scrollProxy ? -1 : 1);
                else {
                    if (allowX) snapX = buildSnapFunc(snapIsRaw ? snap : snap.x || snap.left || snap.scrollLeft, minX, maxX, scrollProxy ? -1 : 1);
                    if (allowY) snapY = buildSnapFunc(snapIsRaw ? snap : snap.y || snap.top || snap.scrollTop, minY, maxY, scrollProxy ? -1 : 1);
                }
            }
        }, onThrowComplete = function onThrowComplete() {
            self.isThrowing = false;
            $9644ab9b72d1ba35$var$_dispatchEvent(self, "throwcomplete", "onThrowComplete");
        }, onThrowInterrupt = function onThrowInterrupt() {
            self.isThrowing = false;
        }, animate = function animate(inertia, forceZeroVelocity) {
            var snap, snapIsRaw, tween, overshootTolerance;
            if (inertia && $9644ab9b72d1ba35$var$InertiaPlugin) {
                if (inertia === true) {
                    snap = vars.snap || vars.liveSnap || {};
                    snapIsRaw = $9644ab9b72d1ba35$var$_isArray(snap) || $9644ab9b72d1ba35$var$_isFunction(snap);
                    inertia = {
                        resistance: (vars.throwResistance || vars.resistance || 1000) / (rotationMode ? 10 : 1)
                    };
                    if (rotationMode) inertia.rotation = $9644ab9b72d1ba35$var$_parseInertia(self, snapIsRaw ? snap : snap.rotation, maxX, minX, 1, forceZeroVelocity);
                    else {
                        if (allowX) inertia[xProp] = $9644ab9b72d1ba35$var$_parseInertia(self, snapIsRaw ? snap : snap.points || snap.x || snap.left, maxX, minX, scrollProxy ? -1 : 1, forceZeroVelocity || self.lockedAxis === "x");
                        if (allowY) inertia[yProp] = $9644ab9b72d1ba35$var$_parseInertia(self, snapIsRaw ? snap : snap.points || snap.y || snap.top, maxY, minY, scrollProxy ? -1 : 1, forceZeroVelocity || self.lockedAxis === "y");
                        if (snap.points || $9644ab9b72d1ba35$var$_isArray(snap) && $9644ab9b72d1ba35$var$_isObject(snap[0])) {
                            inertia.linkedProps = xProp + "," + yProp;
                            inertia.radius = snap.radius; //note: we also disable liveSnapping while throwing if there's a "radius" defined, otherwise it looks weird to have the item thrown past a snapping point but live-snapping mid-tween. We do this by altering the onUpdateParams so that "skipSnap" parameter is true for syncXY.
                        }
                    }
                }
                self.isThrowing = true;
                overshootTolerance = !isNaN(vars.overshootTolerance) ? vars.overshootTolerance : vars.edgeResistance === 1 ? 0 : 1 - self.edgeResistance + 0.2;
                if (!inertia.duration) inertia.duration = {
                    max: Math.max(vars.minDuration || 0, "maxDuration" in vars ? vars.maxDuration : 2),
                    min: !isNaN(vars.minDuration) ? vars.minDuration : overshootTolerance === 0 || $9644ab9b72d1ba35$var$_isObject(inertia) && inertia.resistance > 1000 ? 0 : 0.5,
                    overshoot: overshootTolerance
                };
                self.tween = tween = $9644ab9b72d1ba35$var$gsap.to(scrollProxy || target, {
                    inertia: inertia,
                    data: "_draggable",
                    inherit: false,
                    onComplete: onThrowComplete,
                    onInterrupt: onThrowInterrupt,
                    onUpdate: vars.fastMode ? $9644ab9b72d1ba35$var$_dispatchEvent : syncXY,
                    onUpdateParams: vars.fastMode ? [
                        self,
                        "onthrowupdate",
                        "onThrowUpdate"
                    ] : snap && snap.radius ? [
                        false,
                        true
                    ] : []
                });
                if (!vars.fastMode) {
                    if (scrollProxy) scrollProxy._skip = true; // Microsoft browsers have a bug that causes them to briefly render the position incorrectly (it flashes to the end state when we seek() the tween even though we jump right back to the current position, and this only seems to happen when we're affecting both top and left), so we set a _suspendTransforms flag to prevent it from actually applying the values in the ScrollProxy.
                    tween.render(1e9, true, true); // force to the end. Remember, the duration will likely change upon initting because that's when InertiaPlugin calculates it.
                    syncXY(true, true);
                    self.endX = self.x;
                    self.endY = self.y;
                    if (rotationMode) self.endRotation = self.x;
                    tween.play(0);
                    syncXY(true, true);
                    if (scrollProxy) scrollProxy._skip = false; //Microsoft browsers have a bug that causes them to briefly render the position incorrectly (it flashes to the end state when we seek() the tween even though we jump right back to the current position, and this only seems to happen when we're affecting both top and left), so we set a _suspendTransforms flag to prevent it from actually applying the values in the ScrollProxy.
                }
            } else if (hasBounds) self.applyBounds();
        }, updateMatrix = function updateMatrix(shiftStart) {
            var start = matrix, p;
            matrix = (0, $b760a7c355166707$export$91a495f99cf781b7)(target.parentNode, true);
            if (shiftStart && self.isPressed && !matrix.equals(start || new (0, $b760a7c355166707$export$26e6ecd136a15474)())) {
                //if the matrix changes WHILE the element is pressed, we must adjust the startPointerX and startPointerY accordingly, so we invert the original matrix and figure out where the pointerX and pointerY were in the global space, then apply the new matrix to get the updated coordinates.
                p = start.inverse().apply({
                    x: startPointerX,
                    y: startPointerY
                });
                matrix.apply(p, p);
                startPointerX = p.x;
                startPointerY = p.y;
            }
            if (matrix.equals($9644ab9b72d1ba35$var$_identityMatrix)) //if there are no transforms, we can optimize performance by not factoring in the matrix
            matrix = null;
        }, recordStartPositions = function recordStartPositions() {
            var edgeTolerance = 1 - self.edgeResistance, offsetX = isFixed ? $9644ab9b72d1ba35$var$_getDocScrollLeft(ownerDoc) : 0, offsetY = isFixed ? $9644ab9b72d1ba35$var$_getDocScrollTop(ownerDoc) : 0, parsedOrigin, x, y;
            if (xyMode) {
                // in case the user set it as a different unit, like animating the x to "100%". We must convert it back to px!
                gsCache.x = getPropAsNum(xProp, "px") + "px";
                gsCache.y = getPropAsNum(yProp, "px") + "px";
                gsCache.renderTransform();
            }
            updateMatrix(false);
            $9644ab9b72d1ba35$var$_point1.x = self.pointerX - offsetX;
            $9644ab9b72d1ba35$var$_point1.y = self.pointerY - offsetY;
            matrix && matrix.apply($9644ab9b72d1ba35$var$_point1, $9644ab9b72d1ba35$var$_point1);
            startPointerX = $9644ab9b72d1ba35$var$_point1.x; //translate to local coordinate system
            startPointerY = $9644ab9b72d1ba35$var$_point1.y;
            if (dirty) {
                setPointerPosition(self.pointerX, self.pointerY);
                render(true);
            }
            innerMatrix = (0, $b760a7c355166707$export$91a495f99cf781b7)(target);
            if (scrollProxy) {
                calculateBounds();
                startElementY = scrollProxy.top();
                startElementX = scrollProxy.left();
            } else {
                //if the element is in the process of tweening, don't force snapping to occur because it could make it jump. Imagine the user throwing, then before it's done, clicking on the element in its inbetween state.
                if (isTweening()) {
                    syncXY(true, true);
                    calculateBounds();
                } else self.applyBounds();
                if (rotationMode) {
                    parsedOrigin = target.ownerSVGElement ? [
                        gsCache.xOrigin - target.getBBox().x,
                        gsCache.yOrigin - target.getBBox().y
                    ] : ($9644ab9b72d1ba35$var$_getComputedStyle(target)[$9644ab9b72d1ba35$var$_transformOriginProp] || "0 0").split(" ");
                    rotationOrigin = self.rotationOrigin = (0, $b760a7c355166707$export$91a495f99cf781b7)(target).apply({
                        x: parseFloat(parsedOrigin[0]) || 0,
                        y: parseFloat(parsedOrigin[1]) || 0
                    });
                    syncXY(true, true);
                    x = self.pointerX - rotationOrigin.x - offsetX;
                    y = rotationOrigin.y - self.pointerY + offsetY;
                    startElementX = self.x; //starting rotation (x always refers to rotation in type:"rotation", measured in degrees)
                    startElementY = self.y = Math.atan2(y, x) * $9644ab9b72d1ba35$var$_RAD2DEG;
                } else {
                    //parent = !isFixed && target.parentNode;
                    //startScrollTop = parent ? parent.scrollTop || 0 : 0;
                    //startScrollLeft = parent ? parent.scrollLeft || 0 : 0;
                    startElementY = getPropAsNum(yProp, "px"); //record the starting top and left values so that we can just add the mouse's movement to them later.
                    startElementX = getPropAsNum(xProp, "px");
                }
            }
            if (hasBounds && edgeTolerance) {
                if (startElementX > maxX) startElementX = maxX + (startElementX - maxX) / edgeTolerance;
                else if (startElementX < minX) startElementX = minX - (minX - startElementX) / edgeTolerance;
                if (!rotationMode) {
                    if (startElementY > maxY) startElementY = maxY + (startElementY - maxY) / edgeTolerance;
                    else if (startElementY < minY) startElementY = minY - (minY - startElementY) / edgeTolerance;
                }
            }
            self.startX = startElementX = $9644ab9b72d1ba35$var$_round(startElementX);
            self.startY = startElementY = $9644ab9b72d1ba35$var$_round(startElementY);
        }, isTweening = function isTweening() {
            return self.tween && self.tween.isActive();
        }, removePlaceholder = function removePlaceholder() {
            if ($9644ab9b72d1ba35$var$_placeholderDiv.parentNode && !isTweening() && !self.isDragging) //_placeholderDiv just props open auto-scrolling containers so they don't collapse as the user drags left/up. We remove it after dragging (and throwing, if necessary) finishes.
            $9644ab9b72d1ba35$var$_placeholderDiv.parentNode.removeChild($9644ab9b72d1ba35$var$_placeholderDiv);
        }, //called when the mouse is pressed (or touch starts)
        onPress = function onPress(e, force) {
            var i;
            if (!enabled || self.isPressed || !e || (e.type === "mousedown" || e.type === "pointerdown") && !force && $9644ab9b72d1ba35$var$_getTime() - clickTime < 30 && $9644ab9b72d1ba35$var$_touchEventLookup[self.pointerEvent.type]) {
                //when we DON'T preventDefault() in order to accommodate touch-scrolling and the user just taps, many browsers also fire a mousedown/mouseup sequence AFTER the touchstart/touchend sequence, thus it'd result in two quick "click" events being dispatched. This line senses that condition and halts it on the subsequent mousedown.
                isPreventingDefault && e && enabled && $9644ab9b72d1ba35$var$_preventDefault(e); // in some browsers, we must listen for multiple event types like touchstart, pointerdown, mousedown. The first time this function is called, we record whether or not we _preventDefault() so that on duplicate calls, we can do the same if necessary.
                return;
            }
            interrupted = isTweening();
            dragged = false; // we need to track whether or not it was dragged in this interaction so that if, for example, the user calls .endDrag() to FORCE it to stop and then they keep the mouse pressed down and eventually release, that would normally cause an onClick but we have to skip it in that case if there was dragging that occurred.
            self.pointerEvent = e;
            if ($9644ab9b72d1ba35$var$_touchEventLookup[e.type]) {
                //note: on iOS, BOTH touchmove and mousemove are dispatched, but the mousemove has pageY and pageX of 0 which would mess up the calculations and needlessly hurt performance.
                touchEventTarget = ~e.type.indexOf("touch") ? e.currentTarget || e.target : ownerDoc; //pointer-based touches (for Microsoft browsers) don't remain locked to the original target like other browsers, so we must use the document instead. The event type would be "MSPointerDown" or "pointerdown".
                $9644ab9b72d1ba35$var$_addListener(touchEventTarget, "touchend", onRelease);
                $9644ab9b72d1ba35$var$_addListener(touchEventTarget, "touchmove", onMove); // possible future change if PointerEvents are more standardized: https://developer.mozilla.org/en-US/docs/Web/API/Element/setPointerCapture
                $9644ab9b72d1ba35$var$_addListener(touchEventTarget, "touchcancel", onRelease);
                $9644ab9b72d1ba35$var$_addListener(ownerDoc, "touchstart", $9644ab9b72d1ba35$var$_onMultiTouchDocument);
            } else {
                touchEventTarget = null;
                $9644ab9b72d1ba35$var$_addListener(ownerDoc, "mousemove", onMove); //attach these to the document instead of the box itself so that if the user's mouse moves too quickly (and off of the box), things still work.
            }
            touchDragAxis = null;
            if (!$9644ab9b72d1ba35$var$_supportsPointer || !touchEventTarget) {
                $9644ab9b72d1ba35$var$_addListener(ownerDoc, "mouseup", onRelease);
                e && e.target && $9644ab9b72d1ba35$var$_addListener(e.target, "mouseup", onRelease); //we also have to listen directly on the element because some browsers don't bubble up the event to the _doc on elements with contentEditable="true"
            }
            isClicking = isClickable.call(self, e.target) && vars.dragClickables === false && !force;
            if (isClicking) {
                $9644ab9b72d1ba35$var$_addListener(e.target, "change", onRelease); //in some browsers, when you mousedown on a <select> element, no mouseup gets dispatched! So we listen for a "change" event instead.
                $9644ab9b72d1ba35$var$_dispatchEvent(self, "pressInit", "onPressInit");
                $9644ab9b72d1ba35$var$_dispatchEvent(self, "press", "onPress");
                $9644ab9b72d1ba35$var$_setSelectable(triggers, true); //accommodates things like inputs and elements with contentEditable="true" (otherwise user couldn't drag to select text)
                isPreventingDefault = false;
                return;
            }
            allowNativeTouchScrolling = !touchEventTarget || allowX === allowY || self.vars.allowNativeTouchScrolling === false || self.vars.allowContextMenu && e && (e.ctrlKey || e.which > 2) ? false : allowX ? "y" : "x"; //note: in Chrome, right-clicking (for a context menu) fires onPress and it doesn't have the event.which set properly, so we must look for event.ctrlKey. If the user wants to allow context menus we should of course sense it here and not allow native touch scrolling.
            isPreventingDefault = !allowNativeTouchScrolling && !self.allowEventDefault;
            if (isPreventingDefault) {
                $9644ab9b72d1ba35$var$_preventDefault(e);
                $9644ab9b72d1ba35$var$_addListener($9644ab9b72d1ba35$var$_win, "touchforcechange", $9644ab9b72d1ba35$var$_preventDefault); //works around safari bug: https://gsap.com/forums/topic/21450-draggable-in-iframe-on-mobile-is-buggy/
            }
            if (e.changedTouches) {
                //touch events store the data slightly differently
                e = touch = e.changedTouches[0];
                touchID = e.identifier;
            } else if (e.pointerId) touchID = e.pointerId; //for some Microsoft browsers
            else touch = touchID = null;
            $9644ab9b72d1ba35$var$_dragCount++;
            $9644ab9b72d1ba35$var$_addToRenderQueue(render); //causes the Draggable to render on each "tick" of gsap.ticker (performance optimization - updating values in a mousemove can cause them to happen too frequently, like multiple times between frame redraws which is wasteful, and it also prevents values from updating properly in IE8)
            startPointerY = self.pointerY = e.pageY; //record the starting x and y so that we can calculate the movement from the original in _onMouseMove
            startPointerX = self.pointerX = e.pageX;
            $9644ab9b72d1ba35$var$_dispatchEvent(self, "pressInit", "onPressInit");
            if (allowNativeTouchScrolling || self.autoScroll) $9644ab9b72d1ba35$var$_recordMaxScrolls(target.parentNode);
            if (target.parentNode && self.autoScroll && !scrollProxy && !rotationMode && target.parentNode._gsMaxScrollX && !$9644ab9b72d1ba35$var$_placeholderDiv.parentNode && !target.getBBox) {
                //add a placeholder div to prevent the parent container from collapsing when the user drags the element left.
                $9644ab9b72d1ba35$var$_placeholderDiv.style.width = target.parentNode.scrollWidth + "px";
                target.parentNode.appendChild($9644ab9b72d1ba35$var$_placeholderDiv);
            }
            recordStartPositions();
            self.tween && self.tween.kill();
            self.isThrowing = false;
            $9644ab9b72d1ba35$var$gsap.killTweensOf(scrollProxy || target, killProps, true); //in case the user tries to drag it before the last tween is done.
            scrollProxy && $9644ab9b72d1ba35$var$gsap.killTweensOf(target, {
                scrollTo: 1
            }, true); //just in case the original target's scroll position is being tweened somewhere else.
            self.tween = self.lockedAxis = null;
            if (vars.zIndexBoost || !rotationMode && !scrollProxy && vars.zIndexBoost !== false) target.style.zIndex = Draggable.zIndex++;
            self.isPressed = true;
            hasDragCallback = !!(vars.onDrag || self._listeners.drag);
            hasMoveCallback = !!(vars.onMove || self._listeners.move);
            if (vars.cursor !== false || vars.activeCursor) {
                i = triggers.length;
                while(--i > -1)$9644ab9b72d1ba35$var$gsap.set(triggers[i], {
                    cursor: vars.activeCursor || vars.cursor || ($9644ab9b72d1ba35$var$_defaultCursor === "grab" ? "grabbing" : $9644ab9b72d1ba35$var$_defaultCursor)
                });
            }
            $9644ab9b72d1ba35$var$_dispatchEvent(self, "press", "onPress"); // reset the velocity tracking because it's relatively common to suddenly change position in an onPress() or onPressInit()
            $9644ab9b72d1ba35$var$InertiaPlugin && $9644ab9b72d1ba35$var$InertiaPlugin.track(scrollProxy || target, xyMode ? "x,y" : rotationMode ? "rotation" : "top,left");
        }, //called every time the mouse/touch moves
        onMove = function onMove(e) {
            var originalEvent = e, touches, pointerX, pointerY, i, dx, dy;
            if (!enabled || $9644ab9b72d1ba35$var$_isMultiTouching || !self.isPressed || !e) {
                isPreventingDefault && e && enabled && $9644ab9b72d1ba35$var$_preventDefault(e); // in some browsers, we must listen for multiple event types like touchmove, pointermove, mousemove. The first time this function is called, we record whether or not we _preventDefault() so that on duplicate calls, we can do the same if necessary.
                return;
            }
            self.pointerEvent = e;
            touches = e.changedTouches;
            if (touches) {
                //touch events store the data slightly differently
                e = touches[0];
                if (e !== touch && e.identifier !== touchID) {
                    //Usually changedTouches[0] will be what we're looking for, but in case it's not, look through the rest of the array...(and Android browsers don't reuse the event like iOS)
                    i = touches.length;
                    while(--i > -1 && (e = touches[i]).identifier !== touchID && e.target !== target); // Some Android devices dispatch a touchstart AND pointerdown initially, and then only pointermove thus the touchID may not match because it was grabbed from the touchstart event whereas the pointer event is the one that the browser dispatches for move, so if the event target matches this Draggable's target, let it through.
                    if (i < 0) return;
                }
            } else if (e.pointerId && touchID && e.pointerId !== touchID) //for some Microsoft browsers, we must attach the listener to the doc rather than the trigger so that when the finger moves outside the bounds of the trigger, things still work. So if the event we're receiving has a pointerId that doesn't match the touchID, ignore it (for multi-touch)
            return;
            if (touchEventTarget && allowNativeTouchScrolling && !touchDragAxis) {
                //Android browsers force us to decide on the first "touchmove" event if we should allow the default (scrolling) behavior or preventDefault(). Otherwise, a "touchcancel" will be fired and then no "touchmove" or "touchend" will fire during the scrolling (no good).
                $9644ab9b72d1ba35$var$_point1.x = e.pageX - (isFixed ? $9644ab9b72d1ba35$var$_getDocScrollLeft(ownerDoc) : 0);
                $9644ab9b72d1ba35$var$_point1.y = e.pageY - (isFixed ? $9644ab9b72d1ba35$var$_getDocScrollTop(ownerDoc) : 0);
                matrix && matrix.apply($9644ab9b72d1ba35$var$_point1, $9644ab9b72d1ba35$var$_point1);
                pointerX = $9644ab9b72d1ba35$var$_point1.x;
                pointerY = $9644ab9b72d1ba35$var$_point1.y;
                dx = Math.abs(pointerX - startPointerX);
                dy = Math.abs(pointerY - startPointerY);
                if (dx !== dy && (dx > minimumMovement || dy > minimumMovement) || $9644ab9b72d1ba35$var$_isAndroid && allowNativeTouchScrolling === touchDragAxis) {
                    touchDragAxis = dx > dy && allowX ? "x" : "y";
                    if (allowNativeTouchScrolling && touchDragAxis !== allowNativeTouchScrolling) $9644ab9b72d1ba35$var$_addListener($9644ab9b72d1ba35$var$_win, "touchforcechange", $9644ab9b72d1ba35$var$_preventDefault); // prevents native touch scrolling from taking over if the user started dragging in the other direction in iOS Safari
                    if (self.vars.lockAxisOnTouchScroll !== false && allowX && allowY) {
                        self.lockedAxis = touchDragAxis === "x" ? "y" : "x";
                        $9644ab9b72d1ba35$var$_isFunction(self.vars.onLockAxis) && self.vars.onLockAxis.call(self, originalEvent);
                    }
                    if ($9644ab9b72d1ba35$var$_isAndroid && allowNativeTouchScrolling === touchDragAxis) {
                        onRelease(originalEvent);
                        return;
                    }
                }
            }
            if (!self.allowEventDefault && (!allowNativeTouchScrolling || touchDragAxis && allowNativeTouchScrolling !== touchDragAxis) && originalEvent.cancelable !== false) {
                $9644ab9b72d1ba35$var$_preventDefault(originalEvent);
                isPreventingDefault = true;
            } else if (isPreventingDefault) isPreventingDefault = false;
            if (self.autoScroll) checkAutoScrollBounds = true;
            setPointerPosition(e.pageX, e.pageY, hasMoveCallback);
        }, setPointerPosition = function setPointerPosition(pointerX, pointerY, invokeOnMove) {
            var dragTolerance = 1 - self.dragResistance, edgeTolerance = 1 - self.edgeResistance, prevPointerX = self.pointerX, prevPointerY = self.pointerY, prevStartElementY = startElementY, prevX = self.x, prevY = self.y, prevEndX = self.endX, prevEndY = self.endY, prevEndRotation = self.endRotation, prevDirty = dirty, xChange, yChange, x, y, dif, temp;
            self.pointerX = pointerX;
            self.pointerY = pointerY;
            if (isFixed) {
                pointerX -= $9644ab9b72d1ba35$var$_getDocScrollLeft(ownerDoc);
                pointerY -= $9644ab9b72d1ba35$var$_getDocScrollTop(ownerDoc);
            }
            if (rotationMode) {
                y = $9644ab9b72d1ba35$var$_round(Math.atan2(rotationOrigin.y - pointerY, pointerX - rotationOrigin.x) * $9644ab9b72d1ba35$var$_RAD2DEG);
                dif = self.y - y;
                if (dif > 180) {
                    startElementY -= 360;
                    self.y = y;
                } else if (dif < -180) {
                    startElementY += 360;
                    self.y = y;
                }
                if (matrix) {
                    temp = pointerX * matrix.a + pointerY * matrix.c + matrix.e;
                    pointerY = pointerX * matrix.b + pointerY * matrix.d + matrix.f;
                    pointerX = temp;
                }
                if (self.x !== startElementX || Math.max(Math.abs(startPointerX - pointerX), Math.abs(startPointerY - pointerY)) > minimumMovement) {
                    self.y = y;
                    x = $9644ab9b72d1ba35$var$_round(startElementX + (startElementY - y) * dragTolerance);
                } else x = startElementX;
            } else {
                if (matrix) {
                    temp = pointerX * matrix.a + pointerY * matrix.c + matrix.e;
                    pointerY = pointerX * matrix.b + pointerY * matrix.d + matrix.f;
                    pointerX = temp;
                }
                yChange = pointerY - startPointerY;
                xChange = pointerX - startPointerX;
                if (yChange < minimumMovement && yChange > -minimumMovement) yChange = 0;
                if (xChange < minimumMovement && xChange > -minimumMovement) xChange = 0;
                if ((self.lockAxis || self.lockedAxis) && (xChange || yChange)) {
                    temp = self.lockedAxis;
                    if (!temp) {
                        self.lockedAxis = temp = allowX && Math.abs(xChange) > Math.abs(yChange) ? "y" : allowY ? "x" : null;
                        if (temp && $9644ab9b72d1ba35$var$_isFunction(self.vars.onLockAxis)) self.vars.onLockAxis.call(self, self.pointerEvent);
                    }
                    if (temp === "y") yChange = 0;
                    else if (temp === "x") xChange = 0;
                }
                x = $9644ab9b72d1ba35$var$_round(startElementX + xChange * dragTolerance);
                y = $9644ab9b72d1ba35$var$_round(startElementY + yChange * dragTolerance);
            }
            if ((snapX || snapY || snapXY) && (self.x !== x || self.y !== y && !rotationMode)) {
                if (snapXY) {
                    $9644ab9b72d1ba35$var$_temp1.x = x;
                    $9644ab9b72d1ba35$var$_temp1.y = y;
                    temp = snapXY($9644ab9b72d1ba35$var$_temp1);
                    x = $9644ab9b72d1ba35$var$_round(temp.x);
                    y = $9644ab9b72d1ba35$var$_round(temp.y);
                }
                if (snapX) x = $9644ab9b72d1ba35$var$_round(snapX(x));
                if (snapY) y = $9644ab9b72d1ba35$var$_round(snapY(y));
            }
            if (hasBounds) {
                if (x > maxX) x = maxX + Math.round((x - maxX) * edgeTolerance);
                else if (x < minX) x = minX + Math.round((x - minX) * edgeTolerance);
                if (!rotationMode) {
                    if (y > maxY) y = Math.round(maxY + (y - maxY) * edgeTolerance);
                    else if (y < minY) y = Math.round(minY + (y - minY) * edgeTolerance);
                }
            }
            if (self.x !== x || self.y !== y && !rotationMode) {
                if (rotationMode) {
                    self.endRotation = self.x = self.endX = $9644ab9b72d1ba35$var$_round(x);
                    dirty = true;
                } else {
                    if (allowY) {
                        self.y = self.endY = y;
                        dirty = true; //a flag that indicates we need to render the target next time the TweenLite.ticker dispatches a "tick" event (typically on a requestAnimationFrame) - this is a performance optimization (we shouldn't render on every move because sometimes many move events can get dispatched between screen refreshes, and that'd be wasteful to render every time)
                    }
                    if (allowX) {
                        self.x = self.endX = x;
                        dirty = true;
                    }
                }
                if (!invokeOnMove || $9644ab9b72d1ba35$var$_dispatchEvent(self, "move", "onMove") !== false) {
                    if (!self.isDragging && self.isPressed) {
                        self.isDragging = dragged = true;
                        $9644ab9b72d1ba35$var$_dispatchEvent(self, "dragstart", "onDragStart");
                    }
                } else {
                    //revert because the onMove returned false!
                    self.pointerX = prevPointerX;
                    self.pointerY = prevPointerY;
                    startElementY = prevStartElementY;
                    self.x = prevX;
                    self.y = prevY;
                    self.endX = prevEndX;
                    self.endY = prevEndY;
                    self.endRotation = prevEndRotation;
                    dirty = prevDirty;
                }
            }
        }, //called when the mouse/touch is released
        onRelease = function onRelease(e, force) {
            if (!enabled || !self.isPressed || e && touchID != null && !force && (e.pointerId && e.pointerId !== touchID && e.target !== target || e.changedTouches && !$9644ab9b72d1ba35$var$_hasTouchID(e.changedTouches, touchID))) {
                //for some Microsoft browsers, we must attach the listener to the doc rather than the trigger so that when the finger moves outside the bounds of the trigger, things still work. So if the event we're receiving has a pointerId that doesn't match the touchID, ignore it (for multi-touch)
                isPreventingDefault && e && enabled && $9644ab9b72d1ba35$var$_preventDefault(e); // in some browsers, we must listen for multiple event types like touchend, pointerup, mouseup. The first time this function is called, we record whether or not we _preventDefault() so that on duplicate calls, we can do the same if necessary.
                return;
            }
            self.isPressed = false;
            var originalEvent = e, wasDragging = self.isDragging, isContextMenuRelease = self.vars.allowContextMenu && e && (e.ctrlKey || e.which > 2), placeholderDelayedCall = $9644ab9b72d1ba35$var$gsap.delayedCall(0.001, removePlaceholder), touches, i, syntheticEvent, eventTarget, syntheticClick;
            if (touchEventTarget) {
                $9644ab9b72d1ba35$var$_removeListener(touchEventTarget, "touchend", onRelease);
                $9644ab9b72d1ba35$var$_removeListener(touchEventTarget, "touchmove", onMove);
                $9644ab9b72d1ba35$var$_removeListener(touchEventTarget, "touchcancel", onRelease);
                $9644ab9b72d1ba35$var$_removeListener(ownerDoc, "touchstart", $9644ab9b72d1ba35$var$_onMultiTouchDocument);
            } else $9644ab9b72d1ba35$var$_removeListener(ownerDoc, "mousemove", onMove);
            $9644ab9b72d1ba35$var$_removeListener($9644ab9b72d1ba35$var$_win, "touchforcechange", $9644ab9b72d1ba35$var$_preventDefault);
            if (!$9644ab9b72d1ba35$var$_supportsPointer || !touchEventTarget) {
                $9644ab9b72d1ba35$var$_removeListener(ownerDoc, "mouseup", onRelease);
                e && e.target && $9644ab9b72d1ba35$var$_removeListener(e.target, "mouseup", onRelease);
            }
            dirty = false;
            if (wasDragging) {
                dragEndTime = $9644ab9b72d1ba35$var$_lastDragTime = $9644ab9b72d1ba35$var$_getTime();
                self.isDragging = false;
            }
            $9644ab9b72d1ba35$var$_removeFromRenderQueue(render);
            if (isClicking && !isContextMenuRelease) {
                if (e) {
                    $9644ab9b72d1ba35$var$_removeListener(e.target, "change", onRelease);
                    self.pointerEvent = originalEvent;
                }
                $9644ab9b72d1ba35$var$_setSelectable(triggers, false);
                $9644ab9b72d1ba35$var$_dispatchEvent(self, "release", "onRelease");
                $9644ab9b72d1ba35$var$_dispatchEvent(self, "click", "onClick");
                isClicking = false;
                return;
            }
            i = triggers.length;
            while(--i > -1)$9644ab9b72d1ba35$var$_setStyle(triggers[i], "cursor", vars.cursor || (vars.cursor !== false ? $9644ab9b72d1ba35$var$_defaultCursor : null));
            $9644ab9b72d1ba35$var$_dragCount--;
            if (e) {
                touches = e.changedTouches;
                if (touches) {
                    //touch events store the data slightly differently
                    e = touches[0];
                    if (e !== touch && e.identifier !== touchID) {
                        //Usually changedTouches[0] will be what we're looking for, but in case it's not, look through the rest of the array...(and Android browsers don't reuse the event like iOS)
                        i = touches.length;
                        while(--i > -1 && (e = touches[i]).identifier !== touchID && e.target !== target);
                        if (i < 0 && !force) return;
                    }
                }
                self.pointerEvent = originalEvent;
                self.pointerX = e.pageX;
                self.pointerY = e.pageY;
            }
            if (isContextMenuRelease && originalEvent) {
                $9644ab9b72d1ba35$var$_preventDefault(originalEvent);
                isPreventingDefault = true;
                $9644ab9b72d1ba35$var$_dispatchEvent(self, "release", "onRelease");
            } else if (originalEvent && !wasDragging) {
                isPreventingDefault = false;
                if (interrupted && (vars.snap || vars.bounds)) //otherwise, if the user clicks on the object while it's animating to a snapped position, and then releases without moving 3 pixels, it will just stay there (it should animate/snap)
                animate(vars.inertia || vars.throwProps);
                $9644ab9b72d1ba35$var$_dispatchEvent(self, "release", "onRelease");
                if ((!$9644ab9b72d1ba35$var$_isAndroid || originalEvent.type !== "touchmove") && originalEvent.type.indexOf("cancel") === -1) {
                    //to accommodate native scrolling on Android devices, we have to immediately call onRelease() on the first touchmove event, but that shouldn't trigger a "click".
                    $9644ab9b72d1ba35$var$_dispatchEvent(self, "click", "onClick");
                    if ($9644ab9b72d1ba35$var$_getTime() - clickTime < 300) $9644ab9b72d1ba35$var$_dispatchEvent(self, "doubleclick", "onDoubleClick");
                    eventTarget = originalEvent.target || target; //old IE uses srcElement
                    clickTime = $9644ab9b72d1ba35$var$_getTime();
                    syntheticClick = function syntheticClick() {
                        // some browsers (like Firefox) won't trust script-generated clicks, so if the user tries to click on a video to play it, for example, it simply won't work. Since a regular "click" event will most likely be generated anyway (one that has its isTrusted flag set to true), we must slightly delay our script-generated click so that the "real"/trusted one is prioritized. Remember, when there are duplicate events in quick succession, we suppress all but the first one. Some browsers don't even trigger the "real" one at all, so our synthetic one is a safety valve that ensures that no matter what, a click event does get dispatched.
                        if (clickTime !== clickDispatch && self.enabled() && !self.isPressed && !originalEvent.defaultPrevented) {
                            if (eventTarget.click) //some browsers (like mobile Safari) don't properly trigger the click event
                            eventTarget.click();
                            else if (ownerDoc.createEvent) {
                                syntheticEvent = ownerDoc.createEvent("MouseEvents");
                                syntheticEvent.initMouseEvent("click", true, true, $9644ab9b72d1ba35$var$_win, 1, self.pointerEvent.screenX, self.pointerEvent.screenY, self.pointerX, self.pointerY, false, false, false, false, 0, null);
                                eventTarget.dispatchEvent(syntheticEvent);
                            }
                        }
                    };
                    if (!$9644ab9b72d1ba35$var$_isAndroid && !originalEvent.defaultPrevented) //iOS Safari requires the synthetic click to happen immediately or else it simply won't work, but Android doesn't play nice.
                    $9644ab9b72d1ba35$var$gsap.delayedCall(0.05, syntheticClick); //in addition to the iOS bug workaround, there's a Firefox issue with clicking on things like a video to play, so we must fake a click event in a slightly delayed fashion. Previously, we listened for the "click" event with "capture" false which solved the video-click-to-play issue, but it would allow the "click" event to be dispatched twice like if you were using a jQuery.click() because that was handled in the capture phase, thus we had to switch to the capture phase to avoid the double-dispatching, but do the delayed synthetic click. Don't fire it too fast (like 0.00001) because we want to give the native event a chance to fire first as it's "trusted".
                }
            } else {
                animate(vars.inertia || vars.throwProps); //will skip if inertia/throwProps isn't defined or InertiaPlugin isn't loaded.
                if (!self.allowEventDefault && originalEvent && (vars.dragClickables !== false || !isClickable.call(self, originalEvent.target)) && wasDragging && (!allowNativeTouchScrolling || touchDragAxis && allowNativeTouchScrolling === touchDragAxis) && originalEvent.cancelable !== false) {
                    isPreventingDefault = true;
                    $9644ab9b72d1ba35$var$_preventDefault(originalEvent);
                } else isPreventingDefault = false;
                $9644ab9b72d1ba35$var$_dispatchEvent(self, "release", "onRelease");
            }
            isTweening() && placeholderDelayedCall.duration(self.tween.duration()); //sync the timing so that the placeholder DIV gets
            wasDragging && $9644ab9b72d1ba35$var$_dispatchEvent(self, "dragend", "onDragEnd");
            return true;
        }, updateScroll = function updateScroll(e) {
            if (e && self.isDragging && !scrollProxy) {
                var parent = e.target || target.parentNode, deltaX = parent.scrollLeft - parent._gsScrollX, deltaY = parent.scrollTop - parent._gsScrollY;
                if (deltaX || deltaY) {
                    if (matrix) {
                        startPointerX -= deltaX * matrix.a + deltaY * matrix.c;
                        startPointerY -= deltaY * matrix.d + deltaX * matrix.b;
                    } else {
                        startPointerX -= deltaX;
                        startPointerY -= deltaY;
                    }
                    parent._gsScrollX += deltaX;
                    parent._gsScrollY += deltaY;
                    setPointerPosition(self.pointerX, self.pointerY);
                }
            }
        }, onClick = function onClick(e) {
            //this was a huge pain in the neck to align all the various browsers and their behaviors. Chrome, Firefox, Safari, Opera, Android, and Microsoft Edge all handle events differently! Some will only trigger native behavior (like checkbox toggling) from trusted events. Others don't even support isTrusted, but require 2 events to flow through before triggering native behavior. Edge treats everything as trusted but also mandates that 2 flow through to trigger the correct native behavior.
            var time = $9644ab9b72d1ba35$var$_getTime(), recentlyClicked = time - clickTime < 100, recentlyDragged = time - dragEndTime < 50, alreadyDispatched = recentlyClicked && clickDispatch === clickTime, defaultPrevented = self.pointerEvent && self.pointerEvent.defaultPrevented, alreadyDispatchedTrusted = recentlyClicked && trustedClickDispatch === clickTime, trusted = e.isTrusted || e.isTrusted == null && recentlyClicked && alreadyDispatched; //note: Safari doesn't support isTrusted, and it won't properly execute native behavior (like toggling checkboxes) on the first synthetic "click" event - we must wait for the 2nd and treat it as trusted (but stop propagation at that point). Confusing, I know. Don't you love cross-browser compatibility challenges?
            if ((alreadyDispatched || recentlyDragged && self.vars.suppressClickOnDrag !== false) && e.stopImmediatePropagation) e.stopImmediatePropagation();
            if (recentlyClicked && !(self.pointerEvent && self.pointerEvent.defaultPrevented) && (!alreadyDispatched || trusted && !alreadyDispatchedTrusted)) {
                //let the first click pass through unhindered. Let the next one only if it's trusted, then no more (stop quick-succession ones)
                if (trusted && alreadyDispatched) trustedClickDispatch = clickTime;
                clickDispatch = clickTime;
                return;
            }
            if (self.isPressed || recentlyDragged || recentlyClicked) {
                if (!trusted || !e.detail || !recentlyClicked || defaultPrevented) $9644ab9b72d1ba35$var$_preventDefault(e);
            }
            if (!recentlyClicked && !recentlyDragged && !dragged) {
                // for script-triggered event dispatches, like element.click()
                e && e.target && (self.pointerEvent = e);
                $9644ab9b72d1ba35$var$_dispatchEvent(self, "click", "onClick");
            }
        }, localizePoint = function localizePoint(p) {
            return matrix ? {
                x: p.x * matrix.a + p.y * matrix.c + matrix.e,
                y: p.x * matrix.b + p.y * matrix.d + matrix.f
            } : {
                x: p.x,
                y: p.y
            };
        };
        old = Draggable.get(target);
        old && old.kill(); // avoids duplicates (an element can only be controlled by one Draggable)
        //give the user access to start/stop dragging...
        _this2.startDrag = function(event, align) {
            var r1, r2, p1, p2;
            onPress(event || self.pointerEvent, true); //if the pointer isn't on top of the element, adjust things accordingly
            if (align && !self.hitTest(event || self.pointerEvent)) {
                r1 = $9644ab9b72d1ba35$var$_parseRect(event || self.pointerEvent);
                r2 = $9644ab9b72d1ba35$var$_parseRect(target);
                p1 = localizePoint({
                    x: r1.left + r1.width / 2,
                    y: r1.top + r1.height / 2
                });
                p2 = localizePoint({
                    x: r2.left + r2.width / 2,
                    y: r2.top + r2.height / 2
                });
                startPointerX -= p1.x - p2.x;
                startPointerY -= p1.y - p2.y;
            }
            if (!self.isDragging) {
                self.isDragging = dragged = true;
                $9644ab9b72d1ba35$var$_dispatchEvent(self, "dragstart", "onDragStart");
            }
        };
        _this2.drag = onMove;
        _this2.endDrag = function(e) {
            return onRelease(e || self.pointerEvent, true);
        };
        _this2.timeSinceDrag = function() {
            return self.isDragging ? 0 : ($9644ab9b72d1ba35$var$_getTime() - dragEndTime) / 1000;
        };
        _this2.timeSinceClick = function() {
            return ($9644ab9b72d1ba35$var$_getTime() - clickTime) / 1000;
        };
        _this2.hitTest = function(target, threshold) {
            return Draggable.hitTest(self.target, target, threshold);
        };
        _this2.getDirection = function(from, diagonalThreshold) {
            //from can be "start" (default), "velocity", or an element
            var mode = from === "velocity" && $9644ab9b72d1ba35$var$InertiaPlugin ? from : $9644ab9b72d1ba35$var$_isObject(from) && !rotationMode ? "element" : "start", xChange, yChange, ratio, direction, r1, r2;
            if (mode === "element") {
                r1 = $9644ab9b72d1ba35$var$_parseRect(self.target);
                r2 = $9644ab9b72d1ba35$var$_parseRect(from);
            }
            xChange = mode === "start" ? self.x - startElementX : mode === "velocity" ? $9644ab9b72d1ba35$var$InertiaPlugin.getVelocity(target, xProp) : r1.left + r1.width / 2 - (r2.left + r2.width / 2);
            if (rotationMode) return xChange < 0 ? "counter-clockwise" : "clockwise";
            else {
                diagonalThreshold = diagonalThreshold || 2;
                yChange = mode === "start" ? self.y - startElementY : mode === "velocity" ? $9644ab9b72d1ba35$var$InertiaPlugin.getVelocity(target, yProp) : r1.top + r1.height / 2 - (r2.top + r2.height / 2);
                ratio = Math.abs(xChange / yChange);
                direction = ratio < 1 / diagonalThreshold ? "" : xChange < 0 ? "left" : "right";
                if (ratio < diagonalThreshold) {
                    if (direction !== "") direction += "-";
                    direction += yChange < 0 ? "up" : "down";
                }
            }
            return direction;
        };
        _this2.applyBounds = function(newBounds, sticky) {
            var x, y, forceZeroVelocity, e, parent, isRoot;
            if (newBounds && vars.bounds !== newBounds) {
                vars.bounds = newBounds;
                return self.update(true, sticky);
            }
            syncXY(true);
            calculateBounds();
            if (hasBounds && !isTweening()) {
                x = self.x;
                y = self.y;
                if (x > maxX) x = maxX;
                else if (x < minX) x = minX;
                if (y > maxY) y = maxY;
                else if (y < minY) y = minY;
                if (self.x !== x || self.y !== y) {
                    forceZeroVelocity = true;
                    self.x = self.endX = x;
                    if (rotationMode) self.endRotation = x;
                    else self.y = self.endY = y;
                    dirty = true;
                    render(true);
                    if (self.autoScroll && !self.isDragging) {
                        $9644ab9b72d1ba35$var$_recordMaxScrolls(target.parentNode);
                        e = target;
                        $9644ab9b72d1ba35$var$_windowProxy.scrollTop = $9644ab9b72d1ba35$var$_win.pageYOffset != null ? $9644ab9b72d1ba35$var$_win.pageYOffset : ownerDoc.documentElement.scrollTop != null ? ownerDoc.documentElement.scrollTop : ownerDoc.body.scrollTop;
                        $9644ab9b72d1ba35$var$_windowProxy.scrollLeft = $9644ab9b72d1ba35$var$_win.pageXOffset != null ? $9644ab9b72d1ba35$var$_win.pageXOffset : ownerDoc.documentElement.scrollLeft != null ? ownerDoc.documentElement.scrollLeft : ownerDoc.body.scrollLeft;
                        while(e && !isRoot){
                            //walk up the chain and sense wherever the scrollTop/scrollLeft exceeds the maximum.
                            isRoot = $9644ab9b72d1ba35$var$_isRoot(e.parentNode);
                            parent = isRoot ? $9644ab9b72d1ba35$var$_windowProxy : e.parentNode;
                            if (allowY && parent.scrollTop > parent._gsMaxScrollY) parent.scrollTop = parent._gsMaxScrollY;
                            if (allowX && parent.scrollLeft > parent._gsMaxScrollX) parent.scrollLeft = parent._gsMaxScrollX;
                            e = parent;
                        }
                    }
                }
                if (self.isThrowing && (forceZeroVelocity || self.endX > maxX || self.endX < minX || self.endY > maxY || self.endY < minY)) animate(vars.inertia || vars.throwProps, forceZeroVelocity);
            }
            return self;
        };
        _this2.update = function(applyBounds, sticky, ignoreExternalChanges) {
            if (sticky && self.isPressed) {
                // in case the element was repositioned in the document flow, thus its x/y may be identical but its position is actually quite different.
                if (rotationMode) self.x = self.y = $9644ab9b72d1ba35$var$_round(parseFloat(gsCache.rotation));
                else {
                    var m = (0, $b760a7c355166707$export$91a495f99cf781b7)(target), p = innerMatrix.apply({
                        x: self.x - startElementX,
                        y: self.y - startElementY
                    }), m2 = (0, $b760a7c355166707$export$91a495f99cf781b7)(target.parentNode, true);
                    m2.apply({
                        x: m.e - p.x,
                        y: m.f - p.y
                    }, p);
                    self.x = $9644ab9b72d1ba35$var$_round(self.x - (p.x - m2.e));
                    self.y = $9644ab9b72d1ba35$var$_round(self.y - (p.y - m2.f));
                }
                render(true);
                recordStartPositions();
            }
            var x = self.x, y = self.y;
            updateMatrix(!sticky);
            if (applyBounds) self.applyBounds();
            else {
                dirty && ignoreExternalChanges && render(true);
                syncXY(true);
            }
            if (sticky) {
                setPointerPosition(self.pointerX, self.pointerY);
                dirty && render(true);
            }
            if (self.isPressed && !sticky && (allowX && Math.abs(x - self.x) > 0.01 || allowY && Math.abs(y - self.y) > 0.01 && !rotationMode)) recordStartPositions();
            if (self.autoScroll) {
                $9644ab9b72d1ba35$var$_recordMaxScrolls(target.parentNode, self.isDragging);
                checkAutoScrollBounds = self.isDragging;
                render(true); //in case reparenting occurred.
                $9644ab9b72d1ba35$var$_removeScrollListener(target, updateScroll);
                $9644ab9b72d1ba35$var$_addScrollListener(target, updateScroll);
            }
            return self;
        };
        _this2.enable = function(type) {
            var setVars = {
                lazy: true
            }, id, i, trigger;
            if (vars.cursor !== false) setVars.cursor = vars.cursor || $9644ab9b72d1ba35$var$_defaultCursor;
            if ($9644ab9b72d1ba35$var$gsap.utils.checkPrefix("touchCallout")) setVars.touchCallout = "none";
            if (type !== "soft") {
                $9644ab9b72d1ba35$var$_setTouchActionForAllDescendants(triggers, allowX === allowY ? "none" : vars.allowNativeTouchScrolling && target.scrollHeight === target.clientHeight === (target.scrollWidth === target.clientHeight) || vars.allowEventDefault ? "manipulation" : allowX ? "pan-y" : "pan-x"); // Some browsers like Internet Explorer will fire a pointercancel event when the user attempts to drag when touchAction is "manipulate" because it's perceived as a pan. If the element has scrollable content in only one direction, we should use pan-x or pan-y accordingly so that the pointercancel doesn't prevent dragging.
                i = triggers.length;
                while(--i > -1){
                    trigger = triggers[i];
                    $9644ab9b72d1ba35$var$_supportsPointer || $9644ab9b72d1ba35$var$_addListener(trigger, "mousedown", onPress);
                    $9644ab9b72d1ba35$var$_addListener(trigger, "touchstart", onPress);
                    $9644ab9b72d1ba35$var$_addListener(trigger, "click", onClick, true); // note: used to pass true for capture but it prevented click-to-play-video functionality in Firefox.
                    $9644ab9b72d1ba35$var$gsap.set(trigger, setVars);
                    if (trigger.getBBox && trigger.ownerSVGElement && allowX !== allowY) // a bug in chrome doesn't respect touch-action on SVG elements - it only works if we set it on the parent SVG.
                    $9644ab9b72d1ba35$var$gsap.set(trigger.ownerSVGElement, {
                        touchAction: vars.allowNativeTouchScrolling || vars.allowEventDefault ? "manipulation" : allowX ? "pan-y" : "pan-x"
                    });
                    vars.allowContextMenu || $9644ab9b72d1ba35$var$_addListener(trigger, "contextmenu", onContextMenu);
                }
                $9644ab9b72d1ba35$var$_setSelectable(triggers, false);
            }
            $9644ab9b72d1ba35$var$_addScrollListener(target, updateScroll);
            enabled = true;
            if ($9644ab9b72d1ba35$var$InertiaPlugin && type !== "soft") $9644ab9b72d1ba35$var$InertiaPlugin.track(scrollProxy || target, xyMode ? "x,y" : rotationMode ? "rotation" : "top,left");
            target._gsDragID = id = target._gsDragID || "d" + $9644ab9b72d1ba35$var$_lookupCount++;
            $9644ab9b72d1ba35$var$_lookup[id] = self;
            if (scrollProxy) {
                scrollProxy.enable();
                scrollProxy.element._gsDragID = id;
            }
            (vars.bounds || rotationMode) && recordStartPositions();
            vars.bounds && self.applyBounds();
            return self;
        };
        _this2.disable = function(type) {
            var dragging = self.isDragging, i = triggers.length, trigger;
            while(--i > -1)$9644ab9b72d1ba35$var$_setStyle(triggers[i], "cursor", null);
            if (type !== "soft") {
                $9644ab9b72d1ba35$var$_setTouchActionForAllDescendants(triggers, null);
                i = triggers.length;
                while(--i > -1){
                    trigger = triggers[i];
                    $9644ab9b72d1ba35$var$_setStyle(trigger, "touchCallout", null);
                    $9644ab9b72d1ba35$var$_removeListener(trigger, "mousedown", onPress);
                    $9644ab9b72d1ba35$var$_removeListener(trigger, "touchstart", onPress);
                    $9644ab9b72d1ba35$var$_removeListener(trigger, "click", onClick, true);
                    $9644ab9b72d1ba35$var$_removeListener(trigger, "contextmenu", onContextMenu);
                }
                $9644ab9b72d1ba35$var$_setSelectable(triggers, true);
                if (touchEventTarget) {
                    $9644ab9b72d1ba35$var$_removeListener(touchEventTarget, "touchcancel", onRelease);
                    $9644ab9b72d1ba35$var$_removeListener(touchEventTarget, "touchend", onRelease);
                    $9644ab9b72d1ba35$var$_removeListener(touchEventTarget, "touchmove", onMove);
                }
                $9644ab9b72d1ba35$var$_removeListener(ownerDoc, "mouseup", onRelease);
                $9644ab9b72d1ba35$var$_removeListener(ownerDoc, "mousemove", onMove);
            }
            $9644ab9b72d1ba35$var$_removeScrollListener(target, updateScroll);
            enabled = false;
            if ($9644ab9b72d1ba35$var$InertiaPlugin && type !== "soft") {
                $9644ab9b72d1ba35$var$InertiaPlugin.untrack(scrollProxy || target, xyMode ? "x,y" : rotationMode ? "rotation" : "top,left");
                self.tween && self.tween.kill();
            }
            scrollProxy && scrollProxy.disable();
            $9644ab9b72d1ba35$var$_removeFromRenderQueue(render);
            self.isDragging = self.isPressed = isClicking = false;
            dragging && $9644ab9b72d1ba35$var$_dispatchEvent(self, "dragend", "onDragEnd");
            return self;
        };
        _this2.enabled = function(value, type) {
            return arguments.length ? value ? self.enable(type) : self.disable(type) : enabled;
        };
        _this2.kill = function() {
            self.isThrowing = false;
            self.tween && self.tween.kill();
            self.disable();
            $9644ab9b72d1ba35$var$gsap.set(triggers, {
                clearProps: "userSelect"
            });
            delete $9644ab9b72d1ba35$var$_lookup[target._gsDragID];
            return self;
        };
        _this2.revert = function() {
            this.kill();
            this.styles && this.styles.revert();
        };
        if (~type.indexOf("scroll")) {
            scrollProxy = _this2.scrollProxy = new $9644ab9b72d1ba35$var$ScrollProxy(target, $9644ab9b72d1ba35$var$_extend({
                onKill: function onKill() {
                    //ScrollProxy's onKill() gets called if/when the ScrollProxy senses that the user interacted with the scroll position manually (like using the scrollbar). IE9 doesn't fire the "mouseup" properly when users drag the scrollbar of an element, so this works around that issue.
                    self.isPressed && onRelease(null);
                }
            }, vars)); //a bug in many Android devices' stock browser causes scrollTop to get forced back to 0 after it is altered via JS, so we set overflow to "hidden" on mobile/touch devices (they hide the scroll bar anyway). That works around the bug. (This bug is discussed at https://code.google.com/p/android/issues/detail?id=19625)
            target.style.overflowY = allowY && !$9644ab9b72d1ba35$var$_isTouchDevice ? "auto" : "hidden";
            target.style.overflowX = allowX && !$9644ab9b72d1ba35$var$_isTouchDevice ? "auto" : "hidden";
            target = scrollProxy.content;
        }
        if (rotationMode) killProps.rotation = 1;
        else {
            if (allowX) killProps[xProp] = 1;
            if (allowY) killProps[yProp] = 1;
        }
        gsCache.force3D = "force3D" in vars ? vars.force3D : true; //otherwise, normal dragging would be in 2D and then as soon as it's released and there's an inertia tween, it'd jump to 3D which can create an initial jump due to the work the browser must to do layerize it.
        $9644ab9b72d1ba35$var$_context($9644ab9b72d1ba35$var$_assertThisInitialized(_this2));
        _this2.enable();
        return _this2;
    }
    Draggable.register = function register(core) {
        $9644ab9b72d1ba35$var$gsap = core;
        $9644ab9b72d1ba35$var$_initCore();
    };
    Draggable.create = function create(targets, vars) {
        $9644ab9b72d1ba35$var$_coreInitted || $9644ab9b72d1ba35$var$_initCore(true);
        return $9644ab9b72d1ba35$var$_toArray(targets).map(function(target) {
            return new Draggable(target, vars);
        });
    };
    Draggable.get = function get(target) {
        return $9644ab9b72d1ba35$var$_lookup[($9644ab9b72d1ba35$var$_toArray(target)[0] || {})._gsDragID];
    };
    Draggable.timeSinceDrag = function timeSinceDrag() {
        return ($9644ab9b72d1ba35$var$_getTime() - $9644ab9b72d1ba35$var$_lastDragTime) / 1000;
    };
    Draggable.hitTest = function hitTest(obj1, obj2, threshold) {
        if (obj1 === obj2) return false;
        var r1 = $9644ab9b72d1ba35$var$_parseRect(obj1), r2 = $9644ab9b72d1ba35$var$_parseRect(obj2), top = r1.top, left = r1.left, right = r1.right, bottom = r1.bottom, width = r1.width, height = r1.height, isOutside = r2.left > right || r2.right < left || r2.top > bottom || r2.bottom < top, overlap, area, isRatio;
        if (isOutside || !threshold) return !isOutside;
        isRatio = (threshold + "").indexOf("%") !== -1;
        threshold = parseFloat(threshold) || 0;
        overlap = {
            left: Math.max(left, r2.left),
            top: Math.max(top, r2.top)
        };
        overlap.width = Math.min(right, r2.right) - overlap.left;
        overlap.height = Math.min(bottom, r2.bottom) - overlap.top;
        if (overlap.width < 0 || overlap.height < 0) return false;
        if (isRatio) {
            threshold *= 0.01;
            area = overlap.width * overlap.height;
            return area >= width * height * threshold || area >= r2.width * r2.height * threshold;
        }
        return overlap.width > threshold && overlap.height > threshold;
    };
    return Draggable;
}($9644ab9b72d1ba35$var$EventDispatcher);
$9644ab9b72d1ba35$var$_setDefaults($9644ab9b72d1ba35$export$f2a139e5d18b9882.prototype, {
    pointerX: 0,
    pointerY: 0,
    startX: 0,
    startY: 0,
    deltaX: 0,
    deltaY: 0,
    isDragging: false,
    isPressed: false
});
$9644ab9b72d1ba35$export$f2a139e5d18b9882.zIndex = 1000;
$9644ab9b72d1ba35$export$f2a139e5d18b9882.version = "3.14.2";
$9644ab9b72d1ba35$var$_getGSAP() && $9644ab9b72d1ba35$var$gsap.registerPlugin($9644ab9b72d1ba35$export$f2a139e5d18b9882);


var $8w6H4 = parcelRequire("8w6H4");
/*!
 * CSSPlugin 3.14.2
 * https://gsap.com
 *
 * Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $8w6H4 = parcelRequire("8w6H4");
var $4ad50e95ed8fc124$var$_win, $4ad50e95ed8fc124$var$_doc, $4ad50e95ed8fc124$var$_docElement, $4ad50e95ed8fc124$var$_pluginInitted, $4ad50e95ed8fc124$var$_tempDiv, $4ad50e95ed8fc124$var$_tempDivStyler, $4ad50e95ed8fc124$var$_recentSetterPlugin, $4ad50e95ed8fc124$var$_reverting, $4ad50e95ed8fc124$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $4ad50e95ed8fc124$var$_transformProps = {}, $4ad50e95ed8fc124$var$_RAD2DEG = 180 / Math.PI, $4ad50e95ed8fc124$var$_DEG2RAD = Math.PI / 180, $4ad50e95ed8fc124$var$_atan2 = Math.atan2, $4ad50e95ed8fc124$var$_bigNum = 1e8, $4ad50e95ed8fc124$var$_capsExp = /([A-Z])/g, $4ad50e95ed8fc124$var$_horizontalExp = /(left|right|width|margin|padding|x)/i, $4ad50e95ed8fc124$var$_complexExp = /[\s,\(]\S/, $4ad50e95ed8fc124$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $4ad50e95ed8fc124$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $4ad50e95ed8fc124$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $4ad50e95ed8fc124$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$4ad50e95ed8fc124$var$_renderCSSPropWithBeginningAndEnd = function _renderCSSPropWithBeginningAndEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$4ad50e95ed8fc124$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $4ad50e95ed8fc124$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $4ad50e95ed8fc124$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $4ad50e95ed8fc124$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $4ad50e95ed8fc124$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $4ad50e95ed8fc124$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $4ad50e95ed8fc124$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $4ad50e95ed8fc124$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $4ad50e95ed8fc124$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $4ad50e95ed8fc124$var$_transformProp = "transform", $4ad50e95ed8fc124$var$_transformOriginProp = $4ad50e95ed8fc124$var$_transformProp + "Origin", $4ad50e95ed8fc124$var$_saveStyle = function _saveStyle(property, isNotCSS) {
    var _this = this;
    var target = this.target, style = target.style, cache = target._gsap;
    if (property in $4ad50e95ed8fc124$var$_transformProps && style) {
        this.tfm = this.tfm || {};
        if (property !== "transform") {
            property = $4ad50e95ed8fc124$var$_propertyAliases[property] || property;
            ~property.indexOf(",") ? property.split(",").forEach(function(a) {
                return _this.tfm[a] = $4ad50e95ed8fc124$var$_get(target, a);
            }) : this.tfm[property] = cache.x ? cache[property] : $4ad50e95ed8fc124$var$_get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.
            property === $4ad50e95ed8fc124$var$_transformOriginProp && (this.tfm.zOrigin = cache.zOrigin);
        } else return $4ad50e95ed8fc124$var$_propertyAliases.transform.split(",").forEach(function(p) {
            return _saveStyle.call(_this, p, isNotCSS);
        });
        if (this.props.indexOf($4ad50e95ed8fc124$var$_transformProp) >= 0) return;
        if (cache.svg) {
            this.svgo = target.getAttribute("data-svg-origin");
            this.props.push($4ad50e95ed8fc124$var$_transformOriginProp, isNotCSS, "");
        }
        property = $4ad50e95ed8fc124$var$_transformProp;
    }
    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
}, $4ad50e95ed8fc124$var$_removeIndependentTransforms = function _removeIndependentTransforms(style) {
    if (style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
    }
}, $4ad50e95ed8fc124$var$_revertStyle = function _revertStyle() {
    var props = this.props, target = this.target, style = target.style, cache = target._gsap, i, p;
    for(i = 0; i < props.length; i += 3){
        // stored like this: property, isNotCSS, value
        if (!props[i + 1]) props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace($4ad50e95ed8fc124$var$_capsExp, "-$1").toLowerCase());
        else if (props[i + 1] === 2) // non-CSS value (function-based)
        target[props[i]](props[i + 2]);
        else // non-CSS value (not function-based)
        target[props[i]] = props[i + 2];
    }
    if (this.tfm) {
        for(p in this.tfm)cache[p] = this.tfm[p];
        if (cache.svg) {
            cache.renderTransform();
            target.setAttribute("data-svg-origin", this.svgo || "");
        }
        i = $4ad50e95ed8fc124$var$_reverting();
        if ((!i || !i.isStart) && !style[$4ad50e95ed8fc124$var$_transformProp]) {
            $4ad50e95ed8fc124$var$_removeIndependentTransforms(style);
            if (cache.zOrigin && style[$4ad50e95ed8fc124$var$_transformOriginProp]) {
                style[$4ad50e95ed8fc124$var$_transformOriginProp] += " " + cache.zOrigin + "px"; // since we're uncaching, we must put the zOrigin back into the transformOrigin so that we can pull it out accurately when we parse again. Otherwise, we'd lose the z portion of the origin since we extract it to protect from Safari bugs.
                cache.zOrigin = 0;
                cache.renderTransform();
            }
            cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
        }
    }
}, $4ad50e95ed8fc124$var$_getStyleSaver = function _getStyleSaver(target, properties) {
    var saver = {
        target: target,
        props: [],
        revert: $4ad50e95ed8fc124$var$_revertStyle,
        save: $4ad50e95ed8fc124$var$_saveStyle
    };
    target._gsap || (0, $8w6H4.gsap).core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.
    properties && target.style && target.nodeType && properties.split(",").forEach(function(p) {
        return saver.save(p);
    }); // make sure it's a DOM node too.
    return saver;
}, $4ad50e95ed8fc124$var$_supports3D, $4ad50e95ed8fc124$export$a232bb0480ae674a = function _createElement(type, ns) {
    var e = $4ad50e95ed8fc124$var$_doc.createElementNS ? $4ad50e95ed8fc124$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $4ad50e95ed8fc124$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e && e.style ? e : $4ad50e95ed8fc124$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://gsap.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $4ad50e95ed8fc124$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($4ad50e95ed8fc124$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $4ad50e95ed8fc124$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $4ad50e95ed8fc124$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $4ad50e95ed8fc124$export$8cbef5dd49a09c8b = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || $4ad50e95ed8fc124$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($4ad50e95ed8fc124$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $4ad50e95ed8fc124$var$_prefixes[i] : "") + property;
}, $4ad50e95ed8fc124$var$_initCore = function _initCore() {
    if ($4ad50e95ed8fc124$var$_windowExists() && window.document) {
        $4ad50e95ed8fc124$var$_win = window;
        $4ad50e95ed8fc124$var$_doc = $4ad50e95ed8fc124$var$_win.document;
        $4ad50e95ed8fc124$var$_docElement = $4ad50e95ed8fc124$var$_doc.documentElement;
        $4ad50e95ed8fc124$var$_tempDiv = $4ad50e95ed8fc124$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $4ad50e95ed8fc124$var$_tempDivStyler = $4ad50e95ed8fc124$export$a232bb0480ae674a("div");
        $4ad50e95ed8fc124$var$_transformProp = $4ad50e95ed8fc124$export$8cbef5dd49a09c8b($4ad50e95ed8fc124$var$_transformProp);
        $4ad50e95ed8fc124$var$_transformOriginProp = $4ad50e95ed8fc124$var$_transformProp + "Origin";
        $4ad50e95ed8fc124$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $4ad50e95ed8fc124$var$_supports3D = !!$4ad50e95ed8fc124$export$8cbef5dd49a09c8b("perspective");
        $4ad50e95ed8fc124$var$_reverting = (0, $8w6H4.gsap).core.reverting;
        $4ad50e95ed8fc124$var$_pluginInitted = 1;
    }
}, $4ad50e95ed8fc124$var$_getReparentedCloneBBox = function _getReparentedCloneBBox(target) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var owner = target.ownerSVGElement, svg = $4ad50e95ed8fc124$export$a232bb0480ae674a("svg", owner && owner.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), clone = target.cloneNode(true), bbox;
    clone.style.display = "block";
    svg.appendChild(clone);
    $4ad50e95ed8fc124$var$_docElement.appendChild(svg);
    try {
        bbox = clone.getBBox();
    } catch (e) {}
    svg.removeChild(clone);
    $4ad50e95ed8fc124$var$_docElement.removeChild(svg);
    return bbox;
}, $4ad50e95ed8fc124$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $4ad50e95ed8fc124$export$41bc7c2d1e04f11b = function _getBBox(target) {
    var bounds, cloned;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $4ad50e95ed8fc124$var$_getReparentedCloneBBox(target);
        cloned = 1;
    }
    bounds && (bounds.width || bounds.height) || cloned || (bounds = $4ad50e95ed8fc124$var$_getReparentedCloneBBox(target)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$4ad50e95ed8fc124$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$4ad50e95ed8fc124$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $4ad50e95ed8fc124$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $4ad50e95ed8fc124$export$41bc7c2d1e04f11b(e));
}, //reports if the element is an SVG on which getBBox() actually works
$4ad50e95ed8fc124$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style, first2Chars;
        if (property in $4ad50e95ed8fc124$var$_transformProps && property !== $4ad50e95ed8fc124$var$_transformOriginProp) property = $4ad50e95ed8fc124$var$_transformProp;
        if (style.removeProperty) {
            first2Chars = property.substr(0, 2);
            if (first2Chars === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(first2Chars === "--" ? property : property.replace($4ad50e95ed8fc124$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $4ad50e95ed8fc124$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, $8w6H4.PropTween)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $4ad50e95ed8fc124$var$_renderNonTweeningValueOnlyAtEnd : $4ad50e95ed8fc124$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $4ad50e95ed8fc124$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, $4ad50e95ed8fc124$var$_nonStandardLayouts = {
    grid: 1,
    flex: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$4ad50e95ed8fc124$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = $4ad50e95ed8fc124$var$_tempDiv.style, horizontal = $4ad50e95ed8fc124$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $4ad50e95ed8fc124$var$_nonConvertibleUnits[unit] || $4ad50e95ed8fc124$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $4ad50e95ed8fc124$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($4ad50e95ed8fc124$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, $8w6H4._round)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = unit !== "rem" && ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $4ad50e95ed8fc124$var$_doc || !parent.appendChild) parent = $4ad50e95ed8fc124$var$_doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, $8w6H4._ticker).time && !cache.uncache) return (0, $8w6H4._round)(curValue / cache.width * amount);
    else {
        if (toPercent && (property === "height" || property === "width")) {
            // if we're dealing with width/height that's inside a container with padding and/or it's a flexbox/grid container, we must apply it to the target itself rather than the _tempDiv in order to ensure complete accuracy, factoring in the parent's padding.
            var v = target.style[property];
            target.style[property] = amount + unit;
            px = target[measureProperty];
            v ? target.style[property] = v : $4ad50e95ed8fc124$var$_removeProperty(target, property);
        } else {
            (toPercent || curUnit === "%") && !$4ad50e95ed8fc124$var$_nonStandardLayouts[$4ad50e95ed8fc124$var$_getComputedProperty(parent, "display")] && (style.position = $4ad50e95ed8fc124$var$_getComputedProperty(target, "position"));
            parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
            parent.appendChild($4ad50e95ed8fc124$var$_tempDiv);
            px = $4ad50e95ed8fc124$var$_tempDiv[measureProperty];
            parent.removeChild($4ad50e95ed8fc124$var$_tempDiv);
            style.position = "absolute";
        }
        if (horizontal && toPercent) {
            cache = (0, $8w6H4._getCache)(parent);
            cache.time = (0, $8w6H4._ticker).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $8w6H4._round)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $4ad50e95ed8fc124$var$_get = function _get(target, property, unit, uncache) {
    var value;
    $4ad50e95ed8fc124$var$_pluginInitted || $4ad50e95ed8fc124$var$_initCore();
    if (property in $4ad50e95ed8fc124$var$_propertyAliases && property !== "transform") {
        property = $4ad50e95ed8fc124$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($4ad50e95ed8fc124$var$_transformProps[property] && property !== "transform") {
        value = $4ad50e95ed8fc124$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : $4ad50e95ed8fc124$var$_firstTwoOnly($4ad50e95ed8fc124$var$_getComputedProperty(target, $4ad50e95ed8fc124$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $4ad50e95ed8fc124$var$_specialProps[property] && $4ad50e95ed8fc124$var$_specialProps[property](target, property, unit) || $4ad50e95ed8fc124$var$_getComputedProperty(target, property) || (0, $8w6H4._getProperty)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $4ad50e95ed8fc124$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $4ad50e95ed8fc124$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://gsap.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = $4ad50e95ed8fc124$export$8cbef5dd49a09c8b(prop, target, 1), s = p && $4ad50e95ed8fc124$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $4ad50e95ed8fc124$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://gsap.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new (0, $8w6H4.PropTween)(this._pt, target.style, prop, 0, 1, (0, $8w6H4._renderComplexString)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; // ensure values are strings
    end += "";
    if (end.substring(0, 6) === "var(--") end = $4ad50e95ed8fc124$var$_getComputedProperty(target, end.substring(4, end.indexOf(")")));
    if (end === "auto") {
        startValue = target.style[prop];
        target.style[prop] = end;
        end = $4ad50e95ed8fc124$var$_getComputedProperty(target, prop) || end;
        startValue ? target.style[prop] = startValue : $4ad50e95ed8fc124$var$_removeProperty(target, prop);
    }
    a = [
        start,
        end
    ];
    (0, $8w6H4._colorStringFilter)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, $8w6H4._numWithUnitExp)) || [];
    endValues = end.match((0, $8w6H4._numWithUnitExp)) || [];
    if (endValues.length) {
        while(result = (0, $8w6H4._numWithUnitExp).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                endValue.charAt(1) === "=" && (endValue = (0, $8w6H4._parseRelative)(startNum, endValue) + startUnit);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, $8w6H4._numWithUnitExp).lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, $8w6H4._config).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $4ad50e95ed8fc124$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $4ad50e95ed8fc124$var$_renderNonTweeningValueOnlyAtEnd : $4ad50e95ed8fc124$var$_renderNonTweeningValue;
    (0, $8w6H4._relExp).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $4ad50e95ed8fc124$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $4ad50e95ed8fc124$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $4ad50e95ed8fc124$var$_keywordToPercent[x] || x;
    split[1] = $4ad50e95ed8fc124$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $4ad50e95ed8fc124$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($4ad50e95ed8fc124$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $4ad50e95ed8fc124$var$_transformOriginProp : $4ad50e95ed8fc124$var$_transformProp;
                }
                $4ad50e95ed8fc124$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $4ad50e95ed8fc124$var$_removeProperty(target, $4ad50e95ed8fc124$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                style.scale = style.rotate = style.translate = "none";
                $4ad50e95ed8fc124$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
                $4ad50e95ed8fc124$var$_removeIndependentTransforms(style);
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$4ad50e95ed8fc124$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, $8w6H4.PropTween)(plugin._pt, target, property, 0, 0, $4ad50e95ed8fc124$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $4ad50e95ed8fc124$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $4ad50e95ed8fc124$var$_rotationalProperties = {}, $4ad50e95ed8fc124$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $4ad50e95ed8fc124$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $4ad50e95ed8fc124$var$_getComputedProperty(target, $4ad50e95ed8fc124$var$_transformProp);
    return $4ad50e95ed8fc124$var$_isNullTransform(matrixString) ? $4ad50e95ed8fc124$var$_identity2DMatrix : matrixString.substr(7).match((0, $8w6H4._numExp)).map((0, $8w6H4._round));
}, $4ad50e95ed8fc124$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || (0, $8w6H4._getCache)(target), style = target.style, matrix = $4ad50e95ed8fc124$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $4ad50e95ed8fc124$var$_identity2DMatrix : matrix;
    } else if (matrix === $4ad50e95ed8fc124$var$_identity2DMatrix && !target.offsetParent && target !== $4ad50e95ed8fc124$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent && !target.getBoundingClientRect().width) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375. Note: position: fixed elements report a null offsetParent but they could also be invisible because they're in an ancestor with display: none, so we check getBoundingClientRect(). We only want to alter the DOM if we absolutely have to because it can cause iframe content to reload, like a Vimeo video.
            addedToDOM = 1; //flag
            nextSibling = target.nextElementSibling;
            $4ad50e95ed8fc124$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $4ad50e95ed8fc124$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $4ad50e95ed8fc124$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $4ad50e95ed8fc124$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $4ad50e95ed8fc124$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $4ad50e95ed8fc124$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $4ad50e95ed8fc124$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin); // if (!("xOrigin" in cache) && (xOrigin || yOrigin)) { // added in 3.12.3, reverted in 3.12.4; requires more exploration
    // 	xOrigin -= bounds.x;
    // 	yOrigin -= bounds.y;
    // }
    } else if (matrix !== $4ad50e95ed8fc124$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y; // theory: we only had to do this for smoothing and it assumes that the previous one was not originIsAbsolute.
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$4ad50e95ed8fc124$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $4ad50e95ed8fc124$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $4ad50e95ed8fc124$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $4ad50e95ed8fc124$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $4ad50e95ed8fc124$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $4ad50e95ed8fc124$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, $8w6H4.GSCache)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", cs = getComputedStyle(target), origin = $4ad50e95ed8fc124$var$_getComputedProperty(target, $4ad50e95ed8fc124$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $4ad50e95ed8fc124$var$_isSVG(target));
    if (cs.translate) {
        // accommodate independent transforms by combining them into normal ones.
        if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") style[$4ad50e95ed8fc124$var$_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[$4ad50e95ed8fc124$var$_transformProp] !== "none" ? cs[$4ad50e95ed8fc124$var$_transformProp] : "");
        style.scale = style.rotate = style.translate = "none";
    }
    matrix = $4ad50e95ed8fc124$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        if (cache.uncache) {
            // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
            t2 = target.getBBox();
            origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
            t1 = "";
        } else t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
        $4ad50e95ed8fc124$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $4ad50e95ed8fc124$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $4ad50e95ed8fc124$var$_atan2(b, a) * $4ad50e95ed8fc124$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $4ad50e95ed8fc124$var$_atan2(c, d) * $4ad50e95ed8fc124$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.abs(Math.cos(skewX * $4ad50e95ed8fc124$var$_DEG2RAD)));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $4ad50e95ed8fc124$var$_atan2(a32, a33);
            rotationX = angle * $4ad50e95ed8fc124$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $4ad50e95ed8fc124$var$_atan2(-c, a33);
            rotationY = angle * $4ad50e95ed8fc124$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $4ad50e95ed8fc124$var$_atan2(b, a);
            rotation = angle * $4ad50e95ed8fc124$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $8w6H4._round)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $8w6H4._round)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $4ad50e95ed8fc124$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $4ad50e95ed8fc124$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$4ad50e95ed8fc124$var$_isNullTransform($4ad50e95ed8fc124$var$_getComputedProperty(target, $4ad50e95ed8fc124$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, $8w6H4._round)(scaleX);
    cache.scaleY = (0, $8w6H4._round)(scaleY);
    cache.rotation = (0, $8w6H4._round)(rotation) + deg;
    cache.rotationX = (0, $8w6H4._round)(rotationX) + deg;
    cache.rotationY = (0, $8w6H4._round)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || !uncache && cache.zOrigin || 0) style[$4ad50e95ed8fc124$var$_transformOriginProp] = $4ad50e95ed8fc124$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $8w6H4._config).force3D;
    cache.renderTransform = cache.svg ? $4ad50e95ed8fc124$var$_renderSVGTransforms : $4ad50e95ed8fc124$var$_supports3D ? $4ad50e95ed8fc124$var$_renderCSSTransforms : $4ad50e95ed8fc124$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $4ad50e95ed8fc124$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$4ad50e95ed8fc124$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, $8w6H4.getUnit)(start);
    return (0, $8w6H4._round)(parseFloat(start) + parseFloat($4ad50e95ed8fc124$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $4ad50e95ed8fc124$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $4ad50e95ed8fc124$var$_renderCSSTransforms(ratio, cache);
}, $4ad50e95ed8fc124$var$_zeroDeg = "0deg", $4ad50e95ed8fc124$var$_zeroPx = "0px", $4ad50e95ed8fc124$var$_endParenthesis = ") ", $4ad50e95ed8fc124$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $4ad50e95ed8fc124$var$_zeroDeg || rotationY !== $4ad50e95ed8fc124$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $4ad50e95ed8fc124$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $4ad50e95ed8fc124$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $4ad50e95ed8fc124$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $4ad50e95ed8fc124$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $4ad50e95ed8fc124$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $4ad50e95ed8fc124$var$_zeroPx) transforms += "perspective(" + transformPerspective + $4ad50e95ed8fc124$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $4ad50e95ed8fc124$var$_zeroPx || y !== $4ad50e95ed8fc124$var$_zeroPx || z !== $4ad50e95ed8fc124$var$_zeroPx) transforms += z !== $4ad50e95ed8fc124$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $4ad50e95ed8fc124$var$_endParenthesis;
    if (rotation !== $4ad50e95ed8fc124$var$_zeroDeg) transforms += "rotate(" + rotation + $4ad50e95ed8fc124$var$_endParenthesis;
    if (rotationY !== $4ad50e95ed8fc124$var$_zeroDeg) transforms += "rotateY(" + rotationY + $4ad50e95ed8fc124$var$_endParenthesis;
    if (rotationX !== $4ad50e95ed8fc124$var$_zeroDeg) transforms += "rotateX(" + rotationX + $4ad50e95ed8fc124$var$_endParenthesis;
    if (skewX !== $4ad50e95ed8fc124$var$_zeroDeg || skewY !== $4ad50e95ed8fc124$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $4ad50e95ed8fc124$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $4ad50e95ed8fc124$var$_endParenthesis;
    target.style[$4ad50e95ed8fc124$var$_transformProp] = transforms || "translate(0, 0)";
}, $4ad50e95ed8fc124$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $4ad50e95ed8fc124$var$_DEG2RAD;
        skewX *= $4ad50e95ed8fc124$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $4ad50e95ed8fc124$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $8w6H4._round)(a11);
        a21 = (0, $8w6H4._round)(a21);
        a12 = (0, $8w6H4._round)(a12);
        a22 = (0, $8w6H4._round)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $4ad50e95ed8fc124$var$_convertToUnit(target, "x", x, "px");
        ty = $4ad50e95ed8fc124$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $8w6H4._round)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $8w6H4._round)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $8w6H4._round)(tx + xPercent / 100 * temp.width);
        ty = (0, $8w6H4._round)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$4ad50e95ed8fc124$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
}, $4ad50e95ed8fc124$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
    var cap = 360, isString = (0, $8w6H4._isString)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $4ad50e95ed8fc124$var$_RAD2DEG : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $4ad50e95ed8fc124$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $4ad50e95ed8fc124$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $8w6H4.PropTween)(plugin._pt, target, property, startNum, change, $4ad50e95ed8fc124$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $4ad50e95ed8fc124$var$_assign = function _assign(target, source) {
    // Internet Explorer doesn't have Object.assign(), so we recreate it here.
    for(var p in source)target[p] = source[p];
    return target;
}, $4ad50e95ed8fc124$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var startCache = $4ad50e95ed8fc124$var$_assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[$4ad50e95ed8fc124$var$_transformProp] = transforms;
        endCache = $4ad50e95ed8fc124$var$_parseTransform(target, 1);
        $4ad50e95ed8fc124$var$_removeProperty(target, $4ad50e95ed8fc124$var$_transformProp);
        target.setAttribute("transform", startValue);
    } else {
        startValue = getComputedStyle(target)[$4ad50e95ed8fc124$var$_transformProp];
        style[$4ad50e95ed8fc124$var$_transformProp] = transforms;
        endCache = $4ad50e95ed8fc124$var$_parseTransform(target, 1);
        style[$4ad50e95ed8fc124$var$_transformProp] = startValue;
    }
    for(p in $4ad50e95ed8fc124$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, $8w6H4.getUnit)(startValue);
            endUnit = (0, $8w6H4.getUnit)(endValue);
            startNum = startUnit !== endUnit ? $4ad50e95ed8fc124$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $8w6H4.PropTween)(plugin._pt, endCache, p, startNum, endNum - startNum, $4ad50e95ed8fc124$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $4ad50e95ed8fc124$var$_assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, $8w6H4._forEachName)("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    $4ad50e95ed8fc124$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return $4ad50e95ed8fc124$var$_get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var $4ad50e95ed8fc124$export$855822f522f18eef = {
    name: "css",
    register: $4ad50e95ed8fc124$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps, finalTransformValue;
        $4ad50e95ed8fc124$var$_pluginInitted || $4ad50e95ed8fc124$var$_initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps
        this.styles = this.styles || $4ad50e95ed8fc124$var$_getStyleSaver(target);
        inlineProps = this.styles.props;
        this.tween = tween;
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $8w6H4._plugins)[p] && (0, $8w6H4._checkPlugin)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = $4ad50e95ed8fc124$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $8w6H4._replaceRandom)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                (0, $8w6H4._colorExp).lastIndex = 0;
                if (!(0, $8w6H4._colorExp).test(startValue)) {
                    // colors don't have units
                    startUnit = (0, $8w6H4.getUnit)(startValue);
                    endUnit = (0, $8w6H4.getUnit)(endValue);
                    endUnit ? startUnit !== endUnit && (startValue = $4ad50e95ed8fc124$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                }
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
                props.push(p);
                inlineProps.push(p, 0, style[p]);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    (0, $8w6H4._isString)(startValue) && ~startValue.indexOf("random(") && (startValue = (0, $8w6H4._replaceRandom)(startValue));
                    (0, $8w6H4.getUnit)(startValue + "") || startValue === "auto" || (startValue += (0, $8w6H4._config).units[p] || (0, $8w6H4.getUnit)($4ad50e95ed8fc124$var$_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $4ad50e95ed8fc124$var$_get(target, p)); // can't work with relative values
                } else startValue = $4ad50e95ed8fc124$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $4ad50e95ed8fc124$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $4ad50e95ed8fc124$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        inlineProps.push("visibility", 0, style.visibility);
                        $4ad50e95ed8fc124$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $4ad50e95ed8fc124$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $4ad50e95ed8fc124$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    this.styles.save(p);
                    finalTransformValue = endValue; // this is always the same as endValue except when it's a var(--) value, in which case we need to calculate the end value.
                    if (type === "string" && endValue.substring(0, 6) === "var(--") {
                        endValue = $4ad50e95ed8fc124$var$_getComputedProperty(target, endValue.substring(4, endValue.indexOf(")")));
                        if (endValue.substring(0, 5) === "calc(") {
                            var origPerspective = target.style.perspective;
                            target.style.perspective = endValue;
                            endValue = $4ad50e95ed8fc124$var$_getComputedProperty(target, "perspective");
                            origPerspective ? target.style.perspective = origPerspective : $4ad50e95ed8fc124$var$_removeProperty(target, "perspective");
                        }
                        endNum = parseFloat(endValue);
                    }
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $4ad50e95ed8fc124$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $8w6H4.PropTween)(this._pt, style, $4ad50e95ed8fc124$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $8w6H4.PropTween)(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0, $8w6H4._parseRelative)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, $4ad50e95ed8fc124$var$_renderCSSProp);
                        this._pt.u = 0;
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        inlineProps.push($4ad50e95ed8fc124$var$_transformOriginProp, 0, style[$4ad50e95ed8fc124$var$_transformOriginProp]);
                        endValue = $4ad50e95ed8fc124$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $4ad50e95ed8fc124$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $4ad50e95ed8fc124$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $4ad50e95ed8fc124$var$_addNonTweeningPT(this, style, p, $4ad50e95ed8fc124$var$_firstTwoOnly(startValue), $4ad50e95ed8fc124$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $4ad50e95ed8fc124$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $4ad50e95ed8fc124$var$_rotationalProperties) {
                        $4ad50e95ed8fc124$var$_addRotationalPropTween(this, cache, p, startNum, relative ? (0, $8w6H4._parseRelative)(startNum, relative + endValue) : endValue);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $4ad50e95ed8fc124$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $4ad50e95ed8fc124$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $4ad50e95ed8fc124$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$4ad50e95ed8fc124$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, $8w6H4.getUnit)(endValue) || (p in (0, $8w6H4._config).units ? (0, $8w6H4._config).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $4ad50e95ed8fc124$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, $8w6H4.PropTween)(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0, $8w6H4._parseRelative)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $4ad50e95ed8fc124$var$_renderRoundedCSSProp : $4ad50e95ed8fc124$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (isTransformRelated && finalTransformValue !== endValue) {
                        this._pt.b = startValue;
                        this._pt.e = finalTransformValue;
                        this._pt.r = $4ad50e95ed8fc124$var$_renderCSSPropWithBeginningAndEnd;
                    } else if (startUnit !== endUnit && endUnit !== "%") {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $4ad50e95ed8fc124$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
                    else if (p !== "parseTransform") {
                        (0, $8w6H4._missingPlugin)(p, endValue);
                        continue;
                    }
                } else $4ad50e95ed8fc124$var$_tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
                isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : typeof target[p] === "function" ? inlineProps.push(p, 2, target[p]()) : inlineProps.push(p, 1, startValue || target[p]));
                props.push(p);
            }
        }
        hasPriority && (0, $8w6H4._sortPropTweensByPriority)(this);
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$4ad50e95ed8fc124$var$_reverting()) {
            var pt = data._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
        } else data.styles.revert();
    },
    get: $4ad50e95ed8fc124$var$_get,
    aliases: $4ad50e95ed8fc124$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = $4ad50e95ed8fc124$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $4ad50e95ed8fc124$var$_transformProps && property !== $4ad50e95ed8fc124$var$_transformOriginProp && (target._gsap.x || $4ad50e95ed8fc124$var$_get(target, "x")) ? plugin && $4ad50e95ed8fc124$var$_recentSetterPlugin === plugin ? property === "scale" ? $4ad50e95ed8fc124$var$_setterScale : $4ad50e95ed8fc124$var$_setterTransform : ($4ad50e95ed8fc124$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $4ad50e95ed8fc124$var$_setterScaleWithRender : $4ad50e95ed8fc124$var$_setterTransformWithRender) : target.style && !(0, $8w6H4._isUndefined)(target.style[property]) ? $4ad50e95ed8fc124$var$_setterCSSStyle : ~property.indexOf("-") ? $4ad50e95ed8fc124$var$_setterCSSProp : (0, $8w6H4._getSetter)(target, property);
    },
    core: {
        _removeProperty: $4ad50e95ed8fc124$var$_removeProperty,
        _getMatrix: $4ad50e95ed8fc124$var$_getMatrix
    }
};
(0, $8w6H4.gsap).utils.checkPrefix = $4ad50e95ed8fc124$export$8cbef5dd49a09c8b;
(0, $8w6H4.gsap).core.getStyleSaver = $4ad50e95ed8fc124$var$_getStyleSaver;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, $8w6H4._forEachName)(positionAndScale + "," + rotation + "," + others, function(name) {
        $4ad50e95ed8fc124$var$_transformProps[name] = 1;
    });
    (0, $8w6H4._forEachName)(rotation, function(name) {
        (0, $8w6H4._config).units[name] = "deg";
        $4ad50e95ed8fc124$var$_rotationalProperties[name] = 1;
    });
    $4ad50e95ed8fc124$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $8w6H4._forEachName)(aliases, function(name) {
        var split = name.split(":");
        $4ad50e95ed8fc124$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, $8w6H4._forEachName)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, $8w6H4._config).units[name] = "px";
});
(0, $8w6H4.gsap).registerPlugin($4ad50e95ed8fc124$export$855822f522f18eef);








/*!
 * MotionPathPlugin 3.14.2
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ /*!
 * paths 3.14.2
 * https://gsap.com
 *
 * Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $aa28be8644bac4a8$var$_svgPathExp = /[achlmqstvz]|(-?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig, $aa28be8644bac4a8$var$_numbersExp = /(?:(-)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig, $aa28be8644bac4a8$var$_scientific = /[\+\-]?\d*\.?\d+e[\+\-]?\d+/ig, $aa28be8644bac4a8$var$_selectorExp = /(^[#\.][a-z]|[a-y][a-z])/i, $aa28be8644bac4a8$var$_DEG2RAD = Math.PI / 180, $aa28be8644bac4a8$var$_RAD2DEG = 180 / Math.PI, $aa28be8644bac4a8$var$_sin = Math.sin, $aa28be8644bac4a8$var$_cos = Math.cos, $aa28be8644bac4a8$var$_abs = Math.abs, $aa28be8644bac4a8$var$_sqrt = Math.sqrt, $aa28be8644bac4a8$var$_atan2 = Math.atan2, $aa28be8644bac4a8$var$_largeNum = 1e8, $aa28be8644bac4a8$var$_isString = function _isString(value) {
    return typeof value === "string";
}, $aa28be8644bac4a8$var$_isNumber = function _isNumber(value) {
    return typeof value === "number";
}, $aa28be8644bac4a8$var$_isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, $aa28be8644bac4a8$var$_temp = {}, $aa28be8644bac4a8$var$_temp2 = {}, $aa28be8644bac4a8$var$_roundingNum = 1e5, $aa28be8644bac4a8$var$_wrapProgress = function _wrapProgress(progress) {
    return Math.round((progress + $aa28be8644bac4a8$var$_largeNum) % 1 * $aa28be8644bac4a8$var$_roundingNum) / $aa28be8644bac4a8$var$_roundingNum || (progress < 0 ? 0 : 1);
}, //if progress lands on 1, the % will make it 0 which is why we || 1, but not if it's negative because it makes more sense for motion to end at 0 in that case.
$aa28be8644bac4a8$var$_round = function _round(value) {
    return Math.round(value * $aa28be8644bac4a8$var$_roundingNum) / $aa28be8644bac4a8$var$_roundingNum || 0;
}, $aa28be8644bac4a8$var$_roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 1e10) / 1e10 || 0;
}, $aa28be8644bac4a8$var$_segmentIsClosed = function _segmentIsClosed(segment) {
    return segment.closed = Math.abs(segment[0] - segment[segment.length - 2]) < 0.001 && Math.abs(segment[1] - segment[segment.length - 1]) < 0.001;
}, $aa28be8644bac4a8$var$_splitSegment = function _splitSegment(rawPath, segIndex, i, t) {
    var segment = rawPath[segIndex], shift = t === 1 ? 6 : $aa28be8644bac4a8$export$bd9f14de8998b2c6(segment, i, t);
    if ((shift || !t) && shift + i + 2 < segment.length) {
        rawPath.splice(segIndex, 0, segment.slice(0, i + shift + 2));
        segment.splice(0, i + shift);
        return 1;
    }
}, $aa28be8644bac4a8$var$_getSampleIndex = function _getSampleIndex(samples, length, progress) {
    // slightly slower way than doing this (when there's no lookup): segment.lookup[progress < 1 ? ~~(length / segment.minLength) : segment.lookup.length - 1] || 0;
    var l = samples.length, i = ~~(progress * l);
    if (samples[i] > length) {
        while(--i && samples[i] > length);
        i < 0 && (i = 0);
    } else {
        while(samples[++i] < length && i < l);
    }
    return i < l ? i : l - 1;
}, $aa28be8644bac4a8$var$_reverseRawPath = function _reverseRawPath(rawPath, skipOuter) {
    var i = rawPath.length;
    skipOuter || rawPath.reverse();
    while(i--)rawPath[i].reversed || $aa28be8644bac4a8$export$1c1e155a66a9b65a(rawPath[i]);
}, $aa28be8644bac4a8$var$_copyMetaData = function _copyMetaData(source, copy) {
    copy.totalLength = source.totalLength;
    if (source.samples) {
        //segment
        copy.samples = source.samples.slice(0);
        copy.lookup = source.lookup.slice(0);
        copy.minLength = source.minLength;
        copy.resolution = source.resolution;
    } else if (source.totalPoints) //rawPath
    copy.totalPoints = source.totalPoints;
    return copy;
}, //pushes a new segment into a rawPath, but if its starting values match the ending values of the last segment, it'll merge it into that same segment (to reduce the number of segments)
$aa28be8644bac4a8$var$_appendOrMerge = function _appendOrMerge(rawPath, segment) {
    var index = rawPath.length, prevSeg = rawPath[index - 1] || [], l = prevSeg.length;
    if (index && segment[0] === prevSeg[l - 2] && segment[1] === prevSeg[l - 1]) {
        segment = prevSeg.concat(segment.slice(2));
        index--;
    }
    rawPath[index] = segment;
}, $aa28be8644bac4a8$var$_bestDistance;
function $aa28be8644bac4a8$export$a7de45090ab95fc7(value) {
    value = $aa28be8644bac4a8$var$_isString(value) && $aa28be8644bac4a8$var$_selectorExp.test(value) ? document.querySelector(value) || value : value;
    var e = value.getAttribute ? value : 0, rawPath;
    if (e && (value = value.getAttribute("d"))) {
        //implements caching
        if (!e._gsPath) e._gsPath = {};
        rawPath = e._gsPath[value];
        return rawPath && !rawPath._dirty ? rawPath : e._gsPath[value] = $aa28be8644bac4a8$export$a9a6ab89eb1c2191(value);
    }
    return !value ? console.warn("Expecting a <path> element or an SVG path data string") : $aa28be8644bac4a8$var$_isString(value) ? $aa28be8644bac4a8$export$a9a6ab89eb1c2191(value) : $aa28be8644bac4a8$var$_isNumber(value[0]) ? [
        value
    ] : value;
} //copies a RawPath WITHOUT the length meta data (for speed)
function $aa28be8644bac4a8$export$e358367bf79edde2(rawPath) {
    var a = [], i = 0;
    for(; i < rawPath.length; i++)a[i] = $aa28be8644bac4a8$var$_copyMetaData(rawPath[i], rawPath[i].slice(0));
    return $aa28be8644bac4a8$var$_copyMetaData(rawPath, a);
}
function $aa28be8644bac4a8$export$1c1e155a66a9b65a(segment) {
    var i = 0, y;
    segment.reverse(); //this will invert the order y, x, y, x so we must flip it back.
    for(; i < segment.length; i += 2){
        y = segment[i];
        segment[i] = segment[i + 1];
        segment[i + 1] = y;
    }
    segment.reversed = !segment.reversed;
}
var $aa28be8644bac4a8$var$_createPath = function _createPath(e, ignore) {
    var path = document.createElementNS("http://www.w3.org/2000/svg", "path"), attr = [].slice.call(e.attributes), i = attr.length, name;
    ignore = "," + ignore + ",";
    while(--i > -1){
        name = attr[i].nodeName.toLowerCase(); //in Microsoft Edge, if you don't set the attribute with a lowercase name, it doesn't render correctly! Super weird.
        if (ignore.indexOf("," + name + ",") < 0) path.setAttributeNS(null, name, attr[i].nodeValue);
    }
    return path;
}, $aa28be8644bac4a8$var$_typeAttrs = {
    rect: "rx,ry,x,y,width,height",
    circle: "r,cx,cy",
    ellipse: "rx,ry,cx,cy",
    line: "x1,x2,y1,y2"
}, $aa28be8644bac4a8$var$_attrToObj = function _attrToObj(e, attrs) {
    var props = attrs ? attrs.split(",") : [], obj = {}, i = props.length;
    while(--i > -1)obj[props[i]] = +e.getAttribute(props[i]) || 0;
    return obj;
}; //converts an SVG shape like <circle>, <rect>, <polygon>, <polyline>, <ellipse>, etc. to a <path>, swapping it in and copying the attributes to match.
function $aa28be8644bac4a8$export$1a6b6149d6272140(element, swap) {
    var type = element.tagName.toLowerCase(), circ = 0.552284749831, data, x, y, r, ry, path, rcirc, rycirc, points, w, h, x2, x3, x4, x5, x6, y2, y3, y4, y5, y6, attr;
    if (type === "path" || !element.getBBox) return element;
    path = $aa28be8644bac4a8$var$_createPath(element, "x,y,width,height,cx,cy,rx,ry,r,x1,x2,y1,y2,points");
    attr = $aa28be8644bac4a8$var$_attrToObj(element, $aa28be8644bac4a8$var$_typeAttrs[type]);
    if (type === "rect") {
        r = attr.rx;
        ry = attr.ry || r;
        x = attr.x;
        y = attr.y;
        w = attr.width - r * 2;
        h = attr.height - ry * 2;
        if (r || ry) {
            //if there are rounded corners, render cubic beziers
            x2 = x + r * (1 - circ);
            x3 = x + r;
            x4 = x3 + w;
            x5 = x4 + r * circ;
            x6 = x4 + r;
            y2 = y + ry * (1 - circ);
            y3 = y + ry;
            y4 = y3 + h;
            y5 = y4 + ry * circ;
            y6 = y4 + ry;
            data = "M" + x6 + "," + y3 + " V" + y4 + " C" + [
                x6,
                y5,
                x5,
                y6,
                x4,
                y6,
                x4 - (x4 - x3) / 3,
                y6,
                x3 + (x4 - x3) / 3,
                y6,
                x3,
                y6,
                x2,
                y6,
                x,
                y5,
                x,
                y4,
                x,
                y4 - (y4 - y3) / 3,
                x,
                y3 + (y4 - y3) / 3,
                x,
                y3,
                x,
                y2,
                x2,
                y,
                x3,
                y,
                x3 + (x4 - x3) / 3,
                y,
                x4 - (x4 - x3) / 3,
                y,
                x4,
                y,
                x5,
                y,
                x6,
                y2,
                x6,
                y3
            ].join(",") + "z";
        } else data = "M" + (x + w) + "," + y + " v" + h + " h" + -w + " v" + -h + " h" + w + "z";
    } else if (type === "circle" || type === "ellipse") {
        if (type === "circle") {
            r = ry = attr.r;
            rycirc = r * circ;
        } else {
            r = attr.rx;
            ry = attr.ry;
            rycirc = ry * circ;
        }
        x = attr.cx;
        y = attr.cy;
        rcirc = r * circ;
        data = "M" + (x + r) + "," + y + " C" + [
            x + r,
            y + rycirc,
            x + rcirc,
            y + ry,
            x,
            y + ry,
            x - rcirc,
            y + ry,
            x - r,
            y + rycirc,
            x - r,
            y,
            x - r,
            y - rycirc,
            x - rcirc,
            y - ry,
            x,
            y - ry,
            x + rcirc,
            y - ry,
            x + r,
            y - rycirc,
            x + r,
            y
        ].join(",") + "z";
    } else if (type === "line") data = "M" + attr.x1 + "," + attr.y1 + " L" + attr.x2 + "," + attr.y2; //previously, we just converted to "Mx,y Lx,y" but Safari has bugs that cause that not to render properly when using a stroke-dasharray that's not fully visible! Using a cubic bezier fixes that issue.
    else if (type === "polyline" || type === "polygon") {
        points = (element.getAttribute("points") + "").match($aa28be8644bac4a8$var$_numbersExp) || [];
        x = points.shift();
        y = points.shift();
        data = "M" + x + "," + y + " L" + points.join(",");
        if (type === "polygon") data += "," + x + "," + y + "z";
    }
    path.setAttribute("d", $aa28be8644bac4a8$export$ced9e1d9be30c397(path._gsRawPath = $aa28be8644bac4a8$export$a9a6ab89eb1c2191(data)));
    if (swap && element.parentNode) {
        element.parentNode.insertBefore(path, element);
        element.parentNode.removeChild(element);
    }
    return path;
} //returns the rotation (in degrees) at a particular progress on a rawPath (the slope of the tangent)
function $aa28be8644bac4a8$export$d03e55696b4d7894(rawPath, progress) {
    var d = $aa28be8644bac4a8$var$getProgressData(rawPath, progress >= 1 ? 1 - 1e-9 : progress ? progress : 1e-9);
    return $aa28be8644bac4a8$var$getRotationAtBezierT(d.segment, d.i, d.t);
}
function $aa28be8644bac4a8$var$getRotationAtBezierT(segment, i, t) {
    var a = segment[i], b = segment[i + 2], c = segment[i + 4], x;
    a += (b - a) * t;
    b += (c - b) * t;
    a += (b - a) * t;
    x = b + (c + (segment[i + 6] - c) * t - b) * t - a;
    a = segment[i + 1];
    b = segment[i + 3];
    c = segment[i + 5];
    a += (b - a) * t;
    b += (c - b) * t;
    a += (b - a) * t;
    return $aa28be8644bac4a8$var$_round($aa28be8644bac4a8$var$_atan2(b + (c + (segment[i + 7] - c) * t - b) * t - a, x) * $aa28be8644bac4a8$var$_RAD2DEG);
}
function $aa28be8644bac4a8$export$510a529ffd67482a(rawPath, start, end) {
    end = $aa28be8644bac4a8$var$_isUndefined(end) ? 1 : $aa28be8644bac4a8$var$_roundPrecise(end) || 0; // we must round to avoid issues like 4.15 / 8 = 0.8300000000000001 instead of 0.83 or 2.8 / 5 = 0.5599999999999999 instead of 0.56 and if someone is doing a loop like start: 2.8 / 0.5, end: 2.8 / 0.5 + 1.
    start = $aa28be8644bac4a8$var$_roundPrecise(start) || 0;
    var loops = Math.max(0, ~~($aa28be8644bac4a8$var$_abs(end - start) - 1e-8)), path = $aa28be8644bac4a8$export$e358367bf79edde2(rawPath);
    if (start > end) {
        start = 1 - start;
        end = 1 - end;
        $aa28be8644bac4a8$var$_reverseRawPath(path);
        path.totalLength = 0;
    }
    if (start < 0 || end < 0) {
        var offset = Math.abs(~~Math.min(start, end)) + 1;
        start += offset;
        end += offset;
    }
    path.totalLength || $aa28be8644bac4a8$export$cd44c6d3aa5b1098(path);
    var wrap = end > 1, s = $aa28be8644bac4a8$var$getProgressData(path, start, $aa28be8644bac4a8$var$_temp, true), e = $aa28be8644bac4a8$var$getProgressData(path, end, $aa28be8644bac4a8$var$_temp2), eSeg = e.segment, sSeg = s.segment, eSegIndex = e.segIndex, sSegIndex = s.segIndex, ei = e.i, si = s.i, sameSegment = sSegIndex === eSegIndex, sameBezier = ei === si && sameSegment, wrapsBehind, sShift, eShift, i, copy, totalSegments, l, j;
    if (wrap || loops) {
        wrapsBehind = eSegIndex < sSegIndex || sameSegment && ei < si || sameBezier && e.t < s.t;
        if ($aa28be8644bac4a8$var$_splitSegment(path, sSegIndex, si, s.t)) {
            sSegIndex++;
            if (!wrapsBehind) {
                eSegIndex++;
                if (sameBezier) {
                    e.t = (e.t - s.t) / (1 - s.t);
                    ei = 0;
                } else if (sameSegment) ei -= si;
            }
        }
        if (Math.abs(1 - (end - start)) < 1e-5) eSegIndex = sSegIndex - 1;
        else if (!e.t && eSegIndex) eSegIndex--;
        else if ($aa28be8644bac4a8$var$_splitSegment(path, eSegIndex, ei, e.t) && wrapsBehind) sSegIndex++;
        if (s.t === 1) sSegIndex = (sSegIndex + 1) % path.length;
        copy = [];
        totalSegments = path.length;
        l = 1 + totalSegments * loops;
        j = sSegIndex;
        l += (totalSegments - sSegIndex + eSegIndex) % totalSegments;
        for(i = 0; i < l; i++)$aa28be8644bac4a8$var$_appendOrMerge(copy, path[j++ % totalSegments]);
        path = copy;
    } else {
        eShift = e.t === 1 ? 6 : $aa28be8644bac4a8$export$bd9f14de8998b2c6(eSeg, ei, e.t);
        if (start !== end) {
            sShift = $aa28be8644bac4a8$export$bd9f14de8998b2c6(sSeg, si, sameBezier ? s.t / e.t : s.t);
            sameSegment && (eShift += sShift);
            eSeg.splice(ei + eShift + 2);
            (sShift || si) && sSeg.splice(0, si + sShift);
            i = path.length;
            while(i--)//chop off any extra segments
            (i < sSegIndex || i > eSegIndex) && path.splice(i, 1);
        } else {
            eSeg.angle = $aa28be8644bac4a8$var$getRotationAtBezierT(eSeg, ei + eShift, 0); //record the value before we chop because it'll be impossible to determine the angle after its length is 0!
            ei += eShift;
            s = eSeg[ei];
            e = eSeg[ei + 1];
            eSeg.length = eSeg.totalLength = 0;
            eSeg.totalPoints = path.totalPoints = 8;
            eSeg.push(s, e, s, e, s, e, s, e);
        }
    }
    path.totalLength = 0;
    return path;
} //measures a Segment according to its resolution (so if segment.resolution is 6, for example, it'll take 6 samples equally across each Bezier) and create/populate a "samples" Array that has the length up to each of those sample points (always increasing from the start) as well as a "lookup" array that's broken up according to the smallest distance between 2 samples. This gives us a very fast way of looking up a progress position rather than looping through all the points/Beziers. You can optionally have it only measure a subset, starting at startIndex and going for a specific number of beziers (remember, there are 3 x/y pairs each, for a total of 6 elements for each Bezier). It will also populate a "totalLength" property, but that's not generally super accurate because by default it'll only take 6 samples per Bezier. But for performance reasons, it's perfectly adequate for measuring progress values along the path. If you need a more accurate totalLength, either increase the resolution or use the more advanced bezierToPoints() method which keeps adding points until they don't deviate by more than a certain precision value.
function $aa28be8644bac4a8$var$measureSegment(segment, startIndex, bezierQty) {
    startIndex = startIndex || 0;
    if (!segment.samples) {
        segment.samples = [];
        segment.lookup = [];
    }
    var resolution = ~~segment.resolution || 12, inc = 1 / resolution, endIndex = bezierQty ? startIndex + bezierQty * 6 + 1 : segment.length, x1 = segment[startIndex], y1 = segment[startIndex + 1], samplesIndex = startIndex ? startIndex / 6 * resolution : 0, samples = segment.samples, lookup = segment.lookup, min = (startIndex ? segment.minLength : $aa28be8644bac4a8$var$_largeNum) || $aa28be8644bac4a8$var$_largeNum, prevLength = samples[samplesIndex + bezierQty * resolution - 1], length = startIndex ? samples[samplesIndex - 1] : 0, i, j, x4, x3, x2, xd, xd1, y4, y3, y2, yd, yd1, inv, t, lengthIndex, l, segLength;
    samples.length = lookup.length = 0;
    for(j = startIndex + 2; j < endIndex; j += 6){
        x4 = segment[j + 4] - x1;
        x3 = segment[j + 2] - x1;
        x2 = segment[j] - x1;
        y4 = segment[j + 5] - y1;
        y3 = segment[j + 3] - y1;
        y2 = segment[j + 1] - y1;
        xd = xd1 = yd = yd1 = 0;
        if ($aa28be8644bac4a8$var$_abs(x4) < .01 && $aa28be8644bac4a8$var$_abs(y4) < .01 && $aa28be8644bac4a8$var$_abs(x2) + $aa28be8644bac4a8$var$_abs(y2) < .01) // dump points that are close enough (basically right on top of each other, making a bezier super tiny or 0 length)
        {
            if (segment.length > 8) {
                segment.splice(j, 6);
                j -= 6;
                endIndex -= 6;
            }
        } else for(i = 1; i <= resolution; i++){
            t = inc * i;
            inv = 1 - t;
            xd = xd1 - (xd1 = (t * t * x4 + 3 * inv * (t * x3 + inv * x2)) * t);
            yd = yd1 - (yd1 = (t * t * y4 + 3 * inv * (t * y3 + inv * y2)) * t);
            l = $aa28be8644bac4a8$var$_sqrt(yd * yd + xd * xd);
            if (l < min) min = l;
            length += l;
            samples[samplesIndex++] = length;
        }
        x1 += x4;
        y1 += y4;
    }
    if (prevLength) {
        prevLength -= length;
        for(; samplesIndex < samples.length; samplesIndex++)samples[samplesIndex] += prevLength;
    }
    if (samples.length && min) {
        segment.totalLength = segLength = samples[samples.length - 1] || 0;
        segment.minLength = min;
        if (segLength / min < 9999) {
            // if the lookup would require too many values (memory problem), we skip this and instead we use a loop to lookup values directly in the samples Array
            l = lengthIndex = 0;
            for(i = 0; i < segLength; i += min)lookup[l++] = samples[lengthIndex] < i ? ++lengthIndex : lengthIndex;
        }
    } else segment.totalLength = samples[0] = 0;
    return startIndex ? length - samples[startIndex / 2 - 1] : length;
}
function $aa28be8644bac4a8$export$cd44c6d3aa5b1098(rawPath, resolution) {
    var pathLength, points, i;
    for(i = pathLength = points = 0; i < rawPath.length; i++){
        rawPath[i].resolution = ~~resolution || 12; //steps per Bezier curve (anchor, 2 control points, to anchor)
        pathLength += $aa28be8644bac4a8$var$measureSegment(rawPath[i]); // note: measureSegment() also removes points that are basically on top of each other, so the segment.length may change!
        points += rawPath[i].length;
    }
    rawPath.totalPoints = points;
    rawPath.totalLength = pathLength;
    return rawPath;
} //divide segment[i] at position t (value between 0 and 1, progress along that particular cubic bezier segment that starts at segment[i]). Returns how many elements were spliced into the segment array (either 0 or 6)
function $aa28be8644bac4a8$export$bd9f14de8998b2c6(segment, i, t) {
    if (t <= 0 || t >= 1) return 0;
    var ax = segment[i], ay = segment[i + 1], cp1x = segment[i + 2], cp1y = segment[i + 3], cp2x = segment[i + 4], cp2y = segment[i + 5], bx = segment[i + 6], by = segment[i + 7], x1a = ax + (cp1x - ax) * t, x2 = cp1x + (cp2x - cp1x) * t, y1a = ay + (cp1y - ay) * t, y2 = cp1y + (cp2y - cp1y) * t, x1 = x1a + (x2 - x1a) * t, y1 = y1a + (y2 - y1a) * t, x2a = cp2x + (bx - cp2x) * t, y2a = cp2y + (by - cp2y) * t;
    x2 += (x2a - x2) * t;
    y2 += (y2a - y2) * t;
    segment.splice(i + 2, 4, $aa28be8644bac4a8$var$_round(x1a), $aa28be8644bac4a8$var$_round(y1a), $aa28be8644bac4a8$var$_round(x1), $aa28be8644bac4a8$var$_round(y1), $aa28be8644bac4a8$var$_round(x1 + (x2 - x1) * t), $aa28be8644bac4a8$var$_round(y1 + (y2 - y1) * t), $aa28be8644bac4a8$var$_round(x2), $aa28be8644bac4a8$var$_round(y2), $aa28be8644bac4a8$var$_round(x2a), $aa28be8644bac4a8$var$_round(y2a));
    segment.samples && segment.samples.splice(i / 6 * segment.resolution | 0, 0, 0, 0, 0, 0, 0, 0);
    return 6;
} // returns an object {path, segment, segIndex, i, t}
function $aa28be8644bac4a8$var$getProgressData(rawPath, progress, decoratee, pushToNextIfAtEnd) {
    decoratee = decoratee || {};
    rawPath.totalLength || $aa28be8644bac4a8$export$cd44c6d3aa5b1098(rawPath);
    if (progress < 0 || progress > 1) progress = $aa28be8644bac4a8$var$_wrapProgress(progress);
    var segIndex = 0, segment = rawPath[0], samples, resolution, length, min, max, i, t;
    if (!progress) {
        t = i = segIndex = 0;
        segment = rawPath[0];
    } else if (progress === 1) {
        t = 1;
        segIndex = rawPath.length - 1;
        segment = rawPath[segIndex];
        i = segment.length - 8;
    } else {
        if (rawPath.length > 1) {
            //speed optimization: most of the time, there's only one segment so skip the recursion.
            length = rawPath.totalLength * progress;
            max = i = 0;
            while((max += rawPath[i++].totalLength) < length)segIndex = i;
            segment = rawPath[segIndex];
            min = max - segment.totalLength;
            progress = (length - min) / (max - min) || 0;
        }
        samples = segment.samples;
        resolution = segment.resolution; //how many samples per cubic bezier chunk
        length = segment.totalLength * progress;
        i = segment.lookup.length ? segment.lookup[~~(length / segment.minLength)] || 0 : $aa28be8644bac4a8$var$_getSampleIndex(samples, length, progress);
        min = i ? samples[i - 1] : 0;
        max = samples[i];
        if (max < length) {
            min = max;
            max = samples[++i];
        }
        t = 1 / resolution * ((length - min) / (max - min) + i % resolution);
        i = ~~(i / resolution) * 6;
        if (pushToNextIfAtEnd && t === 1) {
            if (i + 6 < segment.length) {
                i += 6;
                t = 0;
            } else if (segIndex + 1 < rawPath.length) {
                i = t = 0;
                segment = rawPath[++segIndex];
            }
        }
    }
    decoratee.t = t;
    decoratee.i = i;
    decoratee.path = rawPath;
    decoratee.segment = segment;
    decoratee.segIndex = segIndex;
    return decoratee;
}
function $aa28be8644bac4a8$export$5fcb25b7d1608b70(rawPath, progress, includeAngle, point) {
    var segment = rawPath[0], result = point || {}, samples, resolution, length, min, max, i, t, a, inv;
    if (progress < 0 || progress > 1) progress = $aa28be8644bac4a8$var$_wrapProgress(progress);
    segment.lookup || $aa28be8644bac4a8$export$cd44c6d3aa5b1098(rawPath);
    if (rawPath.length > 1) {
        //speed optimization: most of the time, there's only one segment so skip the recursion.
        length = rawPath.totalLength * progress;
        max = i = 0;
        while((max += rawPath[i++].totalLength) < length)segment = rawPath[i];
        min = max - segment.totalLength;
        progress = (length - min) / (max - min) || 0;
    }
    samples = segment.samples;
    resolution = segment.resolution;
    length = segment.totalLength * progress;
    i = segment.lookup.length ? segment.lookup[progress < 1 ? ~~(length / segment.minLength) : segment.lookup.length - 1] || 0 : $aa28be8644bac4a8$var$_getSampleIndex(samples, length, progress);
    min = i ? samples[i - 1] : 0;
    max = samples[i];
    if (max < length) {
        min = max;
        max = samples[++i];
    }
    t = 1 / resolution * ((length - min) / (max - min) + i % resolution) || 0;
    inv = 1 - t;
    i = ~~(i / resolution) * 6;
    a = segment[i];
    result.x = $aa28be8644bac4a8$var$_round((t * t * (segment[i + 6] - a) + 3 * inv * (t * (segment[i + 4] - a) + inv * (segment[i + 2] - a))) * t + a);
    result.y = $aa28be8644bac4a8$var$_round((t * t * (segment[i + 7] - (a = segment[i + 1])) + 3 * inv * (t * (segment[i + 5] - a) + inv * (segment[i + 3] - a))) * t + a);
    if (includeAngle) result.angle = segment.totalLength ? $aa28be8644bac4a8$var$getRotationAtBezierT(segment, i, t >= 1 ? 1 - 1e-9 : t ? t : 1e-9) : segment.angle || 0;
    return result;
} //applies a matrix transform to RawPath (or a segment in a RawPath) and returns whatever was passed in (it transforms the values in the array(s), not a copy).
function $aa28be8644bac4a8$export$9210b538875bfe33(rawPath, a, b, c, d, tx, ty) {
    var j = rawPath.length, segment, l, i, x, y;
    while(--j > -1){
        segment = rawPath[j];
        l = segment.length;
        for(i = 0; i < l; i += 2){
            x = segment[i];
            y = segment[i + 1];
            segment[i] = x * a + y * c + tx;
            segment[i + 1] = x * b + y * d + ty;
        }
    }
    rawPath._dirty = 1;
    return rawPath;
} // translates SVG arc data into a segment (cubic beziers). Angle is in degrees.
function $aa28be8644bac4a8$var$arcToSegment(lastX, lastY, rx, ry, angle, largeArcFlag, sweepFlag, x, y) {
    if (lastX === x && lastY === y) return;
    rx = $aa28be8644bac4a8$var$_abs(rx);
    ry = $aa28be8644bac4a8$var$_abs(ry);
    var angleRad = angle % 360 * $aa28be8644bac4a8$var$_DEG2RAD, cosAngle = $aa28be8644bac4a8$var$_cos(angleRad), sinAngle = $aa28be8644bac4a8$var$_sin(angleRad), PI = Math.PI, TWOPI = PI * 2, dx2 = (lastX - x) / 2, dy2 = (lastY - y) / 2, x1 = cosAngle * dx2 + sinAngle * dy2, y1 = -sinAngle * dx2 + cosAngle * dy2, x1_sq = x1 * x1, y1_sq = y1 * y1, radiiCheck = x1_sq / (rx * rx) + y1_sq / (ry * ry);
    if (radiiCheck > 1) {
        rx = $aa28be8644bac4a8$var$_sqrt(radiiCheck) * rx;
        ry = $aa28be8644bac4a8$var$_sqrt(radiiCheck) * ry;
    }
    var rx_sq = rx * rx, ry_sq = ry * ry, sq = (rx_sq * ry_sq - rx_sq * y1_sq - ry_sq * x1_sq) / (rx_sq * y1_sq + ry_sq * x1_sq);
    if (sq < 0) sq = 0;
    var coef = (largeArcFlag === sweepFlag ? -1 : 1) * $aa28be8644bac4a8$var$_sqrt(sq), cx1 = coef * (rx * y1 / ry), cy1 = coef * -(ry * x1 / rx), sx2 = (lastX + x) / 2, sy2 = (lastY + y) / 2, cx = sx2 + (cosAngle * cx1 - sinAngle * cy1), cy = sy2 + (sinAngle * cx1 + cosAngle * cy1), ux = (x1 - cx1) / rx, uy = (y1 - cy1) / ry, vx = (-x1 - cx1) / rx, vy = (-y1 - cy1) / ry, temp = ux * ux + uy * uy, angleStart = (uy < 0 ? -1 : 1) * Math.acos(ux / $aa28be8644bac4a8$var$_sqrt(temp)), angleExtent = (ux * vy - uy * vx < 0 ? -1 : 1) * Math.acos((ux * vx + uy * vy) / $aa28be8644bac4a8$var$_sqrt(temp * (vx * vx + vy * vy)));
    isNaN(angleExtent) && (angleExtent = PI); //rare edge case. Math.cos(-1) is NaN.
    if (!sweepFlag && angleExtent > 0) angleExtent -= TWOPI;
    else if (sweepFlag && angleExtent < 0) angleExtent += TWOPI;
    angleStart %= TWOPI;
    angleExtent %= TWOPI;
    var segments = Math.ceil($aa28be8644bac4a8$var$_abs(angleExtent) / (TWOPI / 4)), rawPath = [], angleIncrement = angleExtent / segments, controlLength = 4 / 3 * $aa28be8644bac4a8$var$_sin(angleIncrement / 2) / (1 + $aa28be8644bac4a8$var$_cos(angleIncrement / 2)), ma = cosAngle * rx, mb = sinAngle * rx, mc = sinAngle * -ry, md = cosAngle * ry, i;
    for(i = 0; i < segments; i++){
        angle = angleStart + i * angleIncrement;
        x1 = $aa28be8644bac4a8$var$_cos(angle);
        y1 = $aa28be8644bac4a8$var$_sin(angle);
        ux = $aa28be8644bac4a8$var$_cos(angle += angleIncrement);
        uy = $aa28be8644bac4a8$var$_sin(angle);
        rawPath.push(x1 - controlLength * y1, y1 + controlLength * x1, ux + controlLength * uy, uy - controlLength * ux, ux, uy);
    } //now transform according to the actual size of the ellipse/arc (the beziers were noramlized, between 0 and 1 on a circle).
    for(i = 0; i < rawPath.length; i += 2){
        x1 = rawPath[i];
        y1 = rawPath[i + 1];
        rawPath[i] = x1 * ma + y1 * mc + cx;
        rawPath[i + 1] = x1 * mb + y1 * md + cy;
    }
    rawPath[i - 2] = x; //always set the end to exactly where it's supposed to be
    rawPath[i - 1] = y;
    return rawPath;
} //Spits back a RawPath with absolute coordinates. Each segment starts with a "moveTo" command (x coordinate, then y) and then 2 control points (x, y, x, y), then anchor. The goal is to minimize memory and maximize speed.
function $aa28be8644bac4a8$export$a9a6ab89eb1c2191(d) {
    var a = (d + "").replace($aa28be8644bac4a8$var$_scientific, function(m) {
        var n = +m;
        return n < 0.0001 && n > -0.0001 ? 0 : n;
    }).match($aa28be8644bac4a8$var$_svgPathExp) || [], //some authoring programs spit out very small numbers in scientific notation like "1e-5", so make sure we round that down to 0 first.
    path = [], relativeX = 0, relativeY = 0, twoThirds = 2 / 3, elements = a.length, points = 0, errorMessage = "ERROR: malformed path: " + d, i, j, x, y, command, isRelative, segment, startX, startY, difX, difY, beziers, prevCommand, flag1, flag2, line = function line(sx, sy, ex, ey) {
        difX = (ex - sx) / 3;
        difY = (ey - sy) / 3;
        segment.push(sx + difX, sy + difY, ex - difX, ey - difY, ex, ey);
    };
    if (!d || !isNaN(a[0]) || isNaN(a[1])) {
        console.log(errorMessage);
        return path;
    }
    for(i = 0; i < elements; i++){
        prevCommand = command;
        if (isNaN(a[i])) {
            command = a[i].toUpperCase();
            isRelative = command !== a[i]; //lower case means relative
        } else //commands like "C" can be strung together without any new command characters between.
        i--;
        x = +a[i + 1];
        y = +a[i + 2];
        if (isRelative) {
            x += relativeX;
            y += relativeY;
        }
        if (!i) {
            startX = x;
            startY = y;
        } // "M" (move)
        if (command === "M") {
            if (segment) {
                if (segment.length < 8) //if the path data was funky and just had a M with no actual drawing anywhere, skip it.
                path.length -= 1;
                else points += segment.length;
                $aa28be8644bac4a8$var$_segmentIsClosed(segment);
            }
            relativeX = startX = x;
            relativeY = startY = y;
            segment = [
                x,
                y
            ];
            path.push(segment);
            i += 2;
            command = "L"; //an "M" with more than 2 values gets interpreted as "lineTo" commands ("L").
        // "C" (cubic bezier)
        } else if (command === "C") {
            if (!segment) segment = [
                0,
                0
            ];
            if (!isRelative) relativeX = relativeY = 0;
             //note: "*1" is just a fast/short way to cast the value as a Number. WAAAY faster in Chrome, slightly slower in Firefox.
            segment.push(x, y, relativeX + a[i + 3] * 1, relativeY + a[i + 4] * 1, relativeX += a[i + 5] * 1, relativeY += a[i + 6] * 1);
            i += 6; // "S" (continuation of cubic bezier)
        } else if (command === "S") {
            difX = relativeX;
            difY = relativeY;
            if (prevCommand === "C" || prevCommand === "S") {
                difX += relativeX - segment[segment.length - 4];
                difY += relativeY - segment[segment.length - 3];
            }
            if (!isRelative) relativeX = relativeY = 0;
            segment.push(difX, difY, x, y, relativeX += a[i + 3] * 1, relativeY += a[i + 4] * 1);
            i += 4; // "Q" (quadratic bezier)
        } else if (command === "Q") {
            difX = relativeX + (x - relativeX) * twoThirds;
            difY = relativeY + (y - relativeY) * twoThirds;
            if (!isRelative) relativeX = relativeY = 0;
            relativeX += a[i + 3] * 1;
            relativeY += a[i + 4] * 1;
            segment.push(difX, difY, relativeX + (x - relativeX) * twoThirds, relativeY + (y - relativeY) * twoThirds, relativeX, relativeY);
            i += 4; // "T" (continuation of quadratic bezier)
        } else if (command === "T") {
            difX = relativeX - segment[segment.length - 4];
            difY = relativeY - segment[segment.length - 3];
            segment.push(relativeX + difX, relativeY + difY, x + (relativeX + difX * 1.5 - x) * twoThirds, y + (relativeY + difY * 1.5 - y) * twoThirds, relativeX = x, relativeY = y);
            i += 2; // "H" (horizontal line)
        } else if (command === "H") {
            line(relativeX, relativeY, relativeX = x, relativeY);
            i += 1; // "V" (vertical line)
        } else if (command === "V") {
            //adjust values because the first (and only one) isn't x in this case, it's y.
            line(relativeX, relativeY, relativeX, relativeY = x + (isRelative ? relativeY - relativeX : 0));
            i += 1; // "L" (line) or "Z" (close)
        } else if (command === "L" || command === "Z") {
            if (command === "Z") {
                x = startX;
                y = startY;
                segment.closed = true;
            }
            if (command === "L" || $aa28be8644bac4a8$var$_abs(relativeX - x) > 0.5 || $aa28be8644bac4a8$var$_abs(relativeY - y) > 0.5) {
                line(relativeX, relativeY, x, y);
                if (command === "L") i += 2;
            }
            relativeX = x;
            relativeY = y; // "A" (arc)
        } else if (command === "A") {
            flag1 = a[i + 4];
            flag2 = a[i + 5];
            difX = a[i + 6];
            difY = a[i + 7];
            j = 7;
            if (flag1.length > 1) {
                // for cases when the flags are merged, like "a8 8 0 018 8" (the 0 and 1 flags are WITH the x value of 8, but it could also be "a8 8 0 01-8 8" so it may include x or not)
                if (flag1.length < 3) {
                    difY = difX;
                    difX = flag2;
                    j--;
                } else {
                    difY = flag2;
                    difX = flag1.substr(2);
                    j -= 2;
                }
                flag2 = flag1.charAt(1);
                flag1 = flag1.charAt(0);
            }
            beziers = $aa28be8644bac4a8$var$arcToSegment(relativeX, relativeY, +a[i + 1], +a[i + 2], +a[i + 3], +flag1, +flag2, (isRelative ? relativeX : 0) + difX * 1, (isRelative ? relativeY : 0) + difY * 1);
            i += j;
            if (beziers) for(j = 0; j < beziers.length; j++)segment.push(beziers[j]);
            relativeX = segment[segment.length - 2];
            relativeY = segment[segment.length - 1];
        } else console.log(errorMessage);
    }
    i = segment.length;
    if (i < 6) {
        //in case there's odd SVG like a M0,0 command at the very end.
        path.pop();
        i = 0;
    } else $aa28be8644bac4a8$var$_segmentIsClosed(segment);
    path.totalPoints = points + i;
    return path;
} //populates the points array in alternating x/y values (like [x, y, x, y...] instead of individual point objects [{x, y}, {x, y}...] to conserve memory and stay in line with how we're handling segment arrays
function $aa28be8644bac4a8$export$f86e11e84068dc85(x1, y1, x2, y2, x3, y3, x4, y4, threshold, points, index) {
    var x12 = (x1 + x2) / 2, y12 = (y1 + y2) / 2, x23 = (x2 + x3) / 2, y23 = (y2 + y3) / 2, x34 = (x3 + x4) / 2, y34 = (y3 + y4) / 2, x123 = (x12 + x23) / 2, y123 = (y12 + y23) / 2, x234 = (x23 + x34) / 2, y234 = (y23 + y34) / 2, x1234 = (x123 + x234) / 2, y1234 = (y123 + y234) / 2, dx = x4 - x1, dy = y4 - y1, d2 = $aa28be8644bac4a8$var$_abs((x2 - x4) * dy - (y2 - y4) * dx), d3 = $aa28be8644bac4a8$var$_abs((x3 - x4) * dy - (y3 - y4) * dx), length;
    if (!points) {
        points = [
            x1,
            y1,
            x4,
            y4
        ];
        index = 2;
    }
    points.splice(index || points.length - 2, 0, x1234, y1234);
    if ((d2 + d3) * (d2 + d3) > threshold * (dx * dx + dy * dy)) {
        length = points.length;
        $aa28be8644bac4a8$export$f86e11e84068dc85(x1, y1, x12, y12, x123, y123, x1234, y1234, threshold, points, index);
        $aa28be8644bac4a8$export$f86e11e84068dc85(x1234, y1234, x234, y234, x34, y34, x4, y4, threshold, points, index + 2 + (points.length - length));
    }
    return points;
}
function $aa28be8644bac4a8$export$e3b964ae0940782f(points, curviness) {
    if (curviness === void 0) curviness = 1;
    var x = points[0], y = 0, segment = [
        x,
        y
    ], i = 2;
    for(; i < points.length; i += 2)segment.push(x, y, points[i], y = (points[i] - x) * curviness / 2, x = points[i], -y);
    return segment;
} // plots a number of points along the segment as evenly as possible while retaining non-smooth (angled) anchors.
function $aa28be8644bac4a8$export$78ff4b90a80a9821(segment, totalPoints) {
    segment.samples || $aa28be8644bac4a8$var$measureSegment(segment);
    var samples = segment.samples, lookup = segment.lookup, resolution = segment.resolution, totalLength = segment.totalLength, points = segment.slice(0, 2), curveStoppingPoints = [], l = segment.length - 4, i = 6, limit = 0.2, startLength = 0, curvePointsCumulative = 0, t, curvePoints, min, max, ci, ratioInc, j, inv, curveLength, length, a, nonSmooth, curveStoppingPointIndex, sampleIndex; // first, loop through each anchor and find out if it's smooth (curve) or not by comparing the angle to each control point (if they're within a certain range, it's smooth). We want to keep pivot points (non-smooth) anchors but allow curved/smooth ones to be subject to simplification.
    for(; i < l; i += 6)if (Math.abs($aa28be8644bac4a8$var$_atan2(segment[i + 1] - segment[i - 1], segment[i] - segment[i - 2]) - $aa28be8644bac4a8$var$_atan2(segment[i + 3] - segment[i + 1], segment[i + 2] - segment[i])) > limit) curveStoppingPoints.push(i);
    curveStoppingPoints.push(segment.length - 2); // the last anchor is always a curve stopping point.
    l = curveStoppingPoints.length;
    points.nonSmooth = nonSmooth = [
        1
    ]; // keep track of which points are non-smooth so that when we call pointsToSegment() we can maintain their angle.
    if (totalPoints > l) {
        totalPoints -= l;
        for(ci = 0; ci < l; ci++){
            curveStoppingPointIndex = curveStoppingPoints[ci];
            sampleIndex = Math.round(curveStoppingPointIndex / 6 * resolution);
            curveLength = samples[sampleIndex - 1] - startLength;
            curvePoints = Math.round(samples[sampleIndex - 1] / totalLength * totalPoints) - curvePointsCumulative;
            curvePointsCumulative += curvePoints;
            ratioInc = 1 / (curvePoints + 1);
            for(j = 1; j <= curvePoints; j++){
                length = startLength + curveLength * j * ratioInc;
                i = lookup.length ? lookup[length < totalLength ? ~~(length / segment.minLength) : lookup.length - 1] || 0 : $aa28be8644bac4a8$var$_getSampleIndex(samples, length, length / totalLength);
                min = i ? samples[i - 1] : 0;
                max = samples[i];
                if (max < length) {
                    min = max;
                    max = samples[++i];
                }
                t = 1 / resolution * ((length - min) / (max - min) + i % resolution) || 0;
                inv = 1 - t;
                i = ~~(i / resolution) * 6;
                a = segment[i];
                points.push($aa28be8644bac4a8$var$_round((t * t * (segment[i + 6] - a) + 3 * inv * (t * (segment[i + 4] - a) + inv * (segment[i + 2] - a))) * t + a), $aa28be8644bac4a8$var$_round((t * t * (segment[i + 7] - (a = segment[i + 1])) + 3 * inv * (t * (segment[i + 5] - a) + inv * (segment[i + 3] - a))) * t + a) // y
                );
            }
            nonSmooth[points.length] = 1;
            points.push(segment[curveStoppingPointIndex], segment[curveStoppingPointIndex + 1]);
            startLength += curveLength;
        }
    } // if the path is closed (the last anchor is the same as the first), check to see if it's a smooth joint. If so, update the nonSmooth Array accordingly.
    i = segment.length - 2;
    if (segment.closed && Math.abs($aa28be8644bac4a8$var$_atan2(segment[i + 1] - segment[i - 1], segment[i] - segment[i - 2]) - $aa28be8644bac4a8$var$_atan2(segment[3] - segment[1], segment[2] - segment[0])) <= limit) nonSmooth[0] = nonSmooth[nonSmooth.length - 1] = 0;
    return points;
} //points is an array of x/y points, like [x, y, x, y, x, y]
function $aa28be8644bac4a8$export$ae6dd21671b80694(points, curviness) {
    //points = simplifyPoints(points, tolerance);
    $aa28be8644bac4a8$var$_abs(points[0] - points[2]) < 1e-4 && $aa28be8644bac4a8$var$_abs(points[1] - points[3]) < 1e-4 && (points = points.slice(2)); // if the first two points are super close, dump the first one.
    var l = points.length - 2, x = +points[0], y = +points[1], nextX = +points[2], nextY = +points[3], segment = [
        x,
        y,
        x,
        y
    ], dx2 = nextX - x, dy2 = nextY - y, nonSmooth = points.nonSmooth || [], // populated by segmentToDistributedPoints(). The x slot will have 1 if it's a non-smooth point, in which case we should skip the smoothing here, obviously.
    closed = Math.abs(points[l] - x) < 0.001 && Math.abs(points[l + 1] - y) < 0.001, prevX, prevY, i, dx1, dy1, r1, r2, r3, tl, mx1, mx2, mxm, my1, my2, mym;
    if (!l) return [
        x,
        y,
        x,
        y,
        x,
        y,
        x,
        y
    ];
    if (closed) {
        // if the start and end points are basically on top of each other, close the segment by adding the 2nd point to the end, and the 2nd-to-last point to the beginning (we'll remove them at the end, but this allows the curvature to look perfect)
        points.push(nextX, nextY);
        nextX = x;
        nextY = y;
        x = points[l - 2];
        y = points[l - 1];
        points.unshift(x, y);
        l += 4;
        nonSmooth = [
            0,
            0
        ].concat(nonSmooth);
    }
    curviness = curviness || curviness === 0 ? +curviness : 1;
    for(i = 2; i < l; i += 2){
        prevX = x;
        prevY = y;
        x = nextX;
        y = nextY;
        nextX = +points[i + 2];
        nextY = +points[i + 3];
        if (x === nextX && y === nextY) continue;
        dx1 = dx2;
        dy1 = dy2;
        dx2 = nextX - x;
        dy2 = nextY - y;
        if (nonSmooth[i]) {
            segment.push(x - (x - prevX) / 4, y - (y - prevY) / 4, x, y, x + (nextX - x) / 4, y + (nextY - y) / 4);
            continue;
        }
        r1 = $aa28be8644bac4a8$var$_sqrt(dx1 * dx1 + dy1 * dy1); // r1, r2, and r3 correlate x and y (and z in the future). Basically 2D or 3D hypotenuse
        r2 = $aa28be8644bac4a8$var$_sqrt(dx2 * dx2 + dy2 * dy2);
        r3 = $aa28be8644bac4a8$var$_sqrt(Math.pow(dx2 / r2 + dx1 / r1, 2) + Math.pow(dy2 / r2 + dy1 / r1, 2));
        tl = (r1 + r2) * curviness * 0.25 / r3;
        mx1 = x - (x - prevX) * (r1 ? tl / r1 : 0);
        mx2 = x + (nextX - x) * (r2 ? tl / r2 : 0);
        mxm = x - (mx1 + ((mx2 - mx1) * (r1 * 3 / (r1 + r2) + 0.5) / 4 || 0));
        my1 = y - (y - prevY) * (r1 ? tl / r1 : 0);
        my2 = y + (nextY - y) * (r2 ? tl / r2 : 0);
        mym = y - (my1 + ((my2 - my1) * (r1 * 3 / (r1 + r2) + 0.5) / 4 || 0));
        segment.push($aa28be8644bac4a8$var$_round(mx1 + mxm), $aa28be8644bac4a8$var$_round(my1 + mym), $aa28be8644bac4a8$var$_round(x), $aa28be8644bac4a8$var$_round(y), $aa28be8644bac4a8$var$_round(mx2 + mxm), $aa28be8644bac4a8$var$_round(my2 + mym));
    }
    x !== nextX || y !== nextY || segment.length < 4 ? segment.push($aa28be8644bac4a8$var$_round(nextX), $aa28be8644bac4a8$var$_round(nextY), $aa28be8644bac4a8$var$_round(nextX), $aa28be8644bac4a8$var$_round(nextY)) : segment.length -= 2;
    if (segment.length === 2) // only one point!
    segment.push(x, y, x, y, x, y);
    else if (closed) {
        segment.splice(0, 6);
        segment.length -= 6;
    }
    segment.closed = closed;
    return segment;
} //returns the squared distance between an x/y coordinate and a segment between x1/y1 and x2/y2
function $aa28be8644bac4a8$var$pointToSegDist(x, y, x1, y1, x2, y2) {
    var dx = x2 - x1, dy = y2 - y1, t;
    if (dx || dy) {
        t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) {
            x1 = x2;
            y1 = y2;
        } else if (t > 0) {
            x1 += dx * t;
            y1 += dy * t;
        }
    }
    return Math.pow(x - x1, 2) + Math.pow(y - y1, 2);
}
function $aa28be8644bac4a8$var$simplifyStep(points, first, last, tolerance, simplified) {
    var maxSqDist = tolerance, firstX = points[first], firstY = points[first + 1], lastX = points[last], lastY = points[last + 1], index, i, d;
    for(i = first + 2; i < last; i += 2){
        d = $aa28be8644bac4a8$var$pointToSegDist(points[i], points[i + 1], firstX, firstY, lastX, lastY);
        if (d > maxSqDist) {
            index = i;
            maxSqDist = d;
        }
    }
    if (maxSqDist > tolerance) {
        index - first > 2 && $aa28be8644bac4a8$var$simplifyStep(points, first, index, tolerance, simplified);
        simplified.push(points[index], points[index + 1]);
        last - index > 2 && $aa28be8644bac4a8$var$simplifyStep(points, index, last, tolerance, simplified);
    }
} //points is an array of x/y values like [x, y, x, y, x, y]
function $aa28be8644bac4a8$export$59627e036caae5e0(points, tolerance) {
    var prevX = parseFloat(points[0]), prevY = parseFloat(points[1]), temp = [
        prevX,
        prevY
    ], l = points.length - 2, i, x, y, dx, dy, result, last;
    tolerance = Math.pow(tolerance || 1, 2);
    for(i = 2; i < l; i += 2){
        x = parseFloat(points[i]);
        y = parseFloat(points[i + 1]);
        dx = prevX - x;
        dy = prevY - y;
        if (dx * dx + dy * dy > tolerance) {
            temp.push(x, y);
            prevX = x;
            prevY = y;
        }
    }
    temp.push(parseFloat(points[l]), parseFloat(points[l + 1]));
    last = temp.length - 2;
    result = [
        temp[0],
        temp[1]
    ];
    $aa28be8644bac4a8$var$simplifyStep(temp, 0, last, tolerance, result);
    result.push(temp[last], temp[last + 1]);
    return result;
}
function $aa28be8644bac4a8$var$getClosestProgressOnBezier(iterations, px, py, start, end, slices, x0, y0, x1, y1, x2, y2, x3, y3) {
    var inc = (end - start) / slices, best = 0, t = start, x, y, d, dx, dy, inv;
    $aa28be8644bac4a8$var$_bestDistance = $aa28be8644bac4a8$var$_largeNum;
    while(t <= end){
        inv = 1 - t;
        x = inv * inv * inv * x0 + 3 * inv * inv * t * x1 + 3 * inv * t * t * x2 + t * t * t * x3;
        y = inv * inv * inv * y0 + 3 * inv * inv * t * y1 + 3 * inv * t * t * y2 + t * t * t * y3;
        dx = x - px;
        dy = y - py;
        d = dx * dx + dy * dy;
        if (d < $aa28be8644bac4a8$var$_bestDistance) {
            $aa28be8644bac4a8$var$_bestDistance = d;
            best = t;
        }
        t += inc;
    }
    return iterations > 1 ? $aa28be8644bac4a8$var$getClosestProgressOnBezier(iterations - 1, px, py, Math.max(best - inc, 0), Math.min(best + inc, 1), slices, x0, y0, x1, y1, x2, y2, x3, y3) : best;
}
function $aa28be8644bac4a8$export$c7551252c2f97fc2(rawPath, x, y, slices) {
    //returns an object with the closest j, i, and t (j is the segment index, i is the index of the point in that segment, and t is the time/progress along that bezier)
    var closest = {
        j: 0,
        i: 0,
        t: 0
    }, bestDistance = $aa28be8644bac4a8$var$_largeNum, i, j, t, segment;
    for(j = 0; j < rawPath.length; j++){
        segment = rawPath[j];
        for(i = 0; i < segment.length; i += 6){
            t = $aa28be8644bac4a8$var$getClosestProgressOnBezier(1, x, y, 0, 1, slices || 20, segment[i], segment[i + 1], segment[i + 2], segment[i + 3], segment[i + 4], segment[i + 5], segment[i + 6], segment[i + 7]);
            if (bestDistance > $aa28be8644bac4a8$var$_bestDistance) {
                bestDistance = $aa28be8644bac4a8$var$_bestDistance;
                closest.j = j;
                closest.i = i;
                closest.t = t;
            }
        }
    }
    return closest;
} //subdivide a Segment closest to a specific x,y coordinate
function $aa28be8644bac4a8$export$179b6e586855bec6(x, y, segment, slices, iterations) {
    var l = segment.length, bestDistance = $aa28be8644bac4a8$var$_largeNum, bestT = 0, bestSegmentIndex = 0, t, i;
    slices = slices || 20;
    iterations = iterations || 3;
    for(i = 0; i < l; i += 6){
        t = $aa28be8644bac4a8$var$getClosestProgressOnBezier(1, x, y, 0, 1, slices, segment[i], segment[i + 1], segment[i + 2], segment[i + 3], segment[i + 4], segment[i + 5], segment[i + 6], segment[i + 7]);
        if (bestDistance > $aa28be8644bac4a8$var$_bestDistance) {
            bestDistance = $aa28be8644bac4a8$var$_bestDistance;
            bestT = t;
            bestSegmentIndex = i;
        }
    }
    t = $aa28be8644bac4a8$var$getClosestProgressOnBezier(iterations, x, y, bestT - 0.05, bestT + 0.05, slices, segment[bestSegmentIndex], segment[bestSegmentIndex + 1], segment[bestSegmentIndex + 2], segment[bestSegmentIndex + 3], segment[bestSegmentIndex + 4], segment[bestSegmentIndex + 5], segment[bestSegmentIndex + 6], segment[bestSegmentIndex + 7]);
    $aa28be8644bac4a8$export$bd9f14de8998b2c6(segment, bestSegmentIndex, t);
    return bestSegmentIndex + 6;
}
function $aa28be8644bac4a8$export$ced9e1d9be30c397(rawPath) {
    if ($aa28be8644bac4a8$var$_isNumber(rawPath[0])) //in case a segment is passed in instead
    rawPath = [
        rawPath
    ];
    var result = "", l = rawPath.length, sl, s, i, segment;
    for(s = 0; s < l; s++){
        segment = rawPath[s];
        result += "M" + $aa28be8644bac4a8$var$_round(segment[0]) + "," + $aa28be8644bac4a8$var$_round(segment[1]) + " C";
        sl = segment.length;
        for(i = 2; i < sl; i++)result += $aa28be8644bac4a8$var$_round(segment[i++]) + "," + $aa28be8644bac4a8$var$_round(segment[i++]) + " " + $aa28be8644bac4a8$var$_round(segment[i++]) + "," + $aa28be8644bac4a8$var$_round(segment[i++]) + " " + $aa28be8644bac4a8$var$_round(segment[i++]) + "," + $aa28be8644bac4a8$var$_round(segment[i]) + " ";
        if (segment.closed) result += "z";
    }
    return result;
} /*
// takes a segment with coordinates [x, y, x, y, ...] and converts the control points into angles and lengths [x, y, angle, length, angle, length, x, y, angle, length, ...] so that it animates more cleanly and avoids odd breaks/kinks. For example, if you animate from 1 o'clock to 6 o'clock, it'd just go directly/linearly rather than around. So the length would be very short in the middle of the tween.
export function cpCoordsToAngles(segment, copy) {
	var result = copy ? segment.slice(0) : segment,
		x, y, i;
	for (i = 0; i < segment.length; i+=6) {
		x = segment[i+2] - segment[i];
		y = segment[i+3] - segment[i+1];
		result[i+2] = Math.atan2(y, x);
		result[i+3] = Math.sqrt(x * x + y * y);
		x = segment[i+6] - segment[i+4];
		y = segment[i+7] - segment[i+5];
		result[i+4] = Math.atan2(y, x);
		result[i+5] = Math.sqrt(x * x + y * y);
	}
	return result;
}

// takes a segment that was converted with cpCoordsToAngles() to have angles and lengths instead of coordinates for the control points, and converts it BACK into coordinates.
export function cpAnglesToCoords(segment, copy) {
	var result = copy ? segment.slice(0) : segment,
		length = segment.length,
		rnd = 1000,
		angle, l, i, j;
	for (i = 0; i < length; i+=6) {
		angle = segment[i+2];
		l = segment[i+3]; //length
		result[i+2] = (((segment[i] + Math.cos(angle) * l) * rnd) | 0) / rnd;
		result[i+3] = (((segment[i+1] + Math.sin(angle) * l) * rnd) | 0) / rnd;
		angle = segment[i+4];
		l = segment[i+5]; //length
		result[i+4] = (((segment[i+6] - Math.cos(angle) * l) * rnd) | 0) / rnd;
		result[i+5] = (((segment[i+7] - Math.sin(angle) * l) * rnd) | 0) / rnd;
	}
	return result;
}

//adds an "isSmooth" array to each segment and populates it with a boolean value indicating whether or not it's smooth (the control points have basically the same slope). For any smooth control points, it converts the coordinates into angle (x, in radians) and length (y) and puts them into the same index value in a smoothData array.
export function populateSmoothData(rawPath) {
	let j = rawPath.length,
		smooth, segment, x, y, x2, y2, i, l, a, a2, isSmooth, smoothData;
	while (--j > -1) {
		segment = rawPath[j];
		isSmooth = segment.isSmooth = segment.isSmooth || [0, 0, 0, 0];
		smoothData = segment.smoothData = segment.smoothData || [0, 0, 0, 0];
		isSmooth.length = 4;
		l = segment.length - 2;
		for (i = 6; i < l; i += 6) {
			x = segment[i] - segment[i - 2];
			y = segment[i + 1] - segment[i - 1];
			x2 = segment[i + 2] - segment[i];
			y2 = segment[i + 3] - segment[i + 1];
			a = _atan2(y, x);
			a2 = _atan2(y2, x2);
			smooth = (Math.abs(a - a2) < 0.09);
			if (smooth) {
				smoothData[i - 2] = a;
				smoothData[i + 2] = a2;
				smoothData[i - 1] = _sqrt(x * x + y * y);
				smoothData[i + 3] = _sqrt(x2 * x2 + y2 * y2);
			}
			isSmooth.push(smooth, smooth, 0, 0, smooth, smooth);
		}
		//if the first and last points are identical, check to see if there's a smooth transition. We must handle this a bit differently due to their positions in the array.
		if (segment[l] === segment[0] && segment[l+1] === segment[1]) {
			x = segment[0] - segment[l-2];
			y = segment[1] - segment[l-1];
			x2 = segment[2] - segment[0];
			y2 = segment[3] - segment[1];
			a = _atan2(y, x);
			a2 = _atan2(y2, x2);
			if (Math.abs(a - a2) < 0.09) {
				smoothData[l-2] = a;
				smoothData[2] = a2;
				smoothData[l-1] = _sqrt(x * x + y * y);
				smoothData[3] = _sqrt(x2 * x2 + y2 * y2);
				isSmooth[l-2] = isSmooth[l-1] = true; //don't change indexes 2 and 3 because we'll trigger everything from the END, and this will optimize file size a bit.
			}
		}
	}
	return rawPath;
}
export function pointToScreen(svgElement, point) {
	if (arguments.length < 2) { //by default, take the first set of coordinates in the path as the point
		let rawPath = getRawPath(svgElement);
		point = svgElement.ownerSVGElement.createSVGPoint();
		point.x = rawPath[0][0];
		point.y = rawPath[0][1];
	}
	return point.matrixTransform(svgElement.getScreenCTM());
}
// takes a <path> and normalizes all of its coordinates to values between 0 and 1
export function normalizePath(path) {
  path = gsap.utils.toArray(path);
  if (!path[0].hasAttribute("d")) {
    path = gsap.utils.toArray(path[0].children);
  }
  if (path.length > 1) {
    path.forEach(normalizePath);
    return path;
  }
  let _svgPathExp = /[achlmqstvz]|(-?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig,
      _scientific = /[\+\-]?\d*\.?\d+e[\+\-]?\d+/ig,
      d = path[0].getAttribute("d"),
      a = d.replace(_scientific, m => { let n = +m; return (n < 0.0001 && n > -0.0001) ? 0 : n; }).match(_svgPathExp),
      nums = a.filter(n => !isNaN(n)).map(n => +n),
      normalize = gsap.utils.normalize(Math.min(...nums), Math.max(...nums)),
      finals = a.map(val => isNaN(val) ? val : normalize(+val)),
      s = "",
      prevWasCommand;
  finals.forEach((value, i) => {
    let isCommand = isNaN(value)
    s += (isCommand && i ? " " : prevWasCommand || !i ? "" : ",") + value;
    prevWasCommand = isCommand;
  });
  path[0].setAttribute("d", s);
}
*/ 



var $1ab54fb6e8a09792$var$_xProps = "x,translateX,left,marginLeft,xPercent".split(","), $1ab54fb6e8a09792$var$_yProps = "y,translateY,top,marginTop,yPercent".split(","), $1ab54fb6e8a09792$var$_DEG2RAD = Math.PI / 180, $1ab54fb6e8a09792$var$gsap, $1ab54fb6e8a09792$var$PropTween, $1ab54fb6e8a09792$var$_getUnit, $1ab54fb6e8a09792$var$_toArray, $1ab54fb6e8a09792$var$_getStyleSaver, $1ab54fb6e8a09792$var$_reverting, $1ab54fb6e8a09792$var$_getGSAP = function _getGSAP() {
    return $1ab54fb6e8a09792$var$gsap || typeof window !== "undefined" && ($1ab54fb6e8a09792$var$gsap = window.gsap) && $1ab54fb6e8a09792$var$gsap.registerPlugin && $1ab54fb6e8a09792$var$gsap;
}, $1ab54fb6e8a09792$var$_populateSegmentFromArray = function _populateSegmentFromArray(segment, values, property, mode) {
    //mode: 0 = x but don't fill y yet, 1 = y, 2 = x and fill y with 0.
    var l = values.length, si = mode === 2 ? 0 : mode, i = 0, v;
    for(; i < l; i++){
        segment[si] = v = parseFloat(values[i][property]);
        mode === 2 && (segment[si + 1] = 0);
        si += 2;
    }
    return segment;
}, $1ab54fb6e8a09792$var$_getPropNum = function _getPropNum(target, prop, unit) {
    return parseFloat(target._gsap.get(target, prop, unit || "px")) || 0;
}, $1ab54fb6e8a09792$var$_relativize = function _relativize(segment) {
    var x = segment[0], y = segment[1], i;
    for(i = 2; i < segment.length; i += 2){
        x = segment[i] += x;
        y = segment[i + 1] += y;
    }
}, // feed in an array of quadratic bezier points like [{x: 0, y: 0}, ...] and it'll convert it to cubic bezier
// _quadToCubic = points => {
// 	let cubic = [],
// 		l = points.length - 1,
// 		i = 1,
// 		a, b, c;
// 	for (; i < l; i+=2) {
// 		a = points[i-1];
// 		b = points[i];
// 		c = points[i+1];
// 		cubic.push(a, {x: (2 * b.x + a.x) / 3, y: (2 * b.y + a.y) / 3}, {x: (2 * b.x + c.x) / 3, y: (2 * b.y + c.y) / 3});
// 	}
// 	cubic.push(points[l]);
// 	return cubic;
// },
$1ab54fb6e8a09792$var$_segmentToRawPath = function _segmentToRawPath(plugin, segment, target, x, y, slicer, vars, unitX, unitY) {
    if (vars.type === "cubic") segment = [
        segment
    ];
    else {
        vars.fromCurrent !== false && segment.unshift($1ab54fb6e8a09792$var$_getPropNum(target, x, unitX), y ? $1ab54fb6e8a09792$var$_getPropNum(target, y, unitY) : 0);
        vars.relative && $1ab54fb6e8a09792$var$_relativize(segment);
        var pointFunc = y ? (0, $aa28be8644bac4a8$export$ae6dd21671b80694) : (0, $aa28be8644bac4a8$export$e3b964ae0940782f);
        segment = [
            pointFunc(segment, vars.curviness)
        ];
    }
    segment = slicer($1ab54fb6e8a09792$var$_align(segment, target, vars));
    $1ab54fb6e8a09792$var$_addDimensionalPropTween(plugin, target, x, segment, "x", unitX);
    y && $1ab54fb6e8a09792$var$_addDimensionalPropTween(plugin, target, y, segment, "y", unitY);
    return (0, $aa28be8644bac4a8$export$cd44c6d3aa5b1098)(segment, vars.resolution || (vars.curviness === 0 ? 20 : 12)); //when curviness is 0, it creates control points right on top of the anchors which makes it more sensitive to resolution, thus we change the default accordingly.
}, $1ab54fb6e8a09792$var$_emptyFunc = function _emptyFunc(v) {
    return v;
}, $1ab54fb6e8a09792$var$_numExp = /[-+\.]*\d+\.?(?:e-|e\+)?\d*/g, $1ab54fb6e8a09792$var$_originToPoint = function _originToPoint(element, origin, parentMatrix) {
    // origin is an array of normalized values (0-1) in relation to the width/height, so [0.5, 0.5] would be the center. It can also be "auto" in which case it will be the top left unless it's a <path>, when it will start at the beginning of the path itself.
    var m = (0, $b760a7c355166707$export$91a495f99cf781b7)(element), x = 0, y = 0, svg;
    if ((element.tagName + "").toLowerCase() === "svg") {
        svg = element.viewBox.baseVal;
        svg.width || (svg = {
            width: +element.getAttribute("width"),
            height: +element.getAttribute("height")
        });
    } else svg = origin && element.getBBox && element.getBBox();
    if (origin && origin !== "auto") {
        x = origin.push ? origin[0] * (svg ? svg.width : element.offsetWidth || 0) : origin.x;
        y = origin.push ? origin[1] * (svg ? svg.height : element.offsetHeight || 0) : origin.y;
    }
    return parentMatrix.apply(x || y ? m.apply({
        x: x,
        y: y
    }) : {
        x: m.e,
        y: m.f
    });
}, $1ab54fb6e8a09792$var$_getAlignMatrix = function _getAlignMatrix(fromElement, toElement, fromOrigin, toOrigin) {
    var parentMatrix = (0, $b760a7c355166707$export$91a495f99cf781b7)(fromElement.parentNode, true, true), m = parentMatrix.clone().multiply((0, $b760a7c355166707$export$91a495f99cf781b7)(toElement)), fromPoint = $1ab54fb6e8a09792$var$_originToPoint(fromElement, fromOrigin, parentMatrix), _originToPoint2 = $1ab54fb6e8a09792$var$_originToPoint(toElement, toOrigin, parentMatrix), x = _originToPoint2.x, y = _originToPoint2.y, p;
    m.e = m.f = 0;
    if (toOrigin === "auto" && toElement.getTotalLength && toElement.tagName.toLowerCase() === "path") {
        p = toElement.getAttribute("d").match($1ab54fb6e8a09792$var$_numExp) || [];
        p = m.apply({
            x: +p[0],
            y: +p[1]
        });
        x += p.x;
        y += p.y;
    } //if (p || (toElement.getBBox && fromElement.getBBox && toElement.ownerSVGElement === fromElement.ownerSVGElement)) {
    if (p) {
        p = m.apply(toElement.getBBox());
        x -= p.x;
        y -= p.y;
    }
    m.e = x - fromPoint.x;
    m.f = y - fromPoint.y;
    return m;
}, $1ab54fb6e8a09792$var$_align = function _align(rawPath, target, _ref) {
    var align = _ref.align, matrix = _ref.matrix, offsetX = _ref.offsetX, offsetY = _ref.offsetY, alignOrigin = _ref.alignOrigin;
    var x = rawPath[0][0], y = rawPath[0][1], curX = $1ab54fb6e8a09792$var$_getPropNum(target, "x"), curY = $1ab54fb6e8a09792$var$_getPropNum(target, "y"), alignTarget, m, p;
    if (!rawPath || !rawPath.length) return (0, $aa28be8644bac4a8$export$a7de45090ab95fc7)("M0,0L0,0");
    if (align) {
        if (align === "self" || (alignTarget = $1ab54fb6e8a09792$var$_toArray(align)[0] || target) === target) (0, $aa28be8644bac4a8$export$9210b538875bfe33)(rawPath, 1, 0, 0, 1, curX - x, curY - y);
        else {
            if (alignOrigin && alignOrigin[2] !== false) $1ab54fb6e8a09792$var$gsap.set(target, {
                transformOrigin: alignOrigin[0] * 100 + "% " + alignOrigin[1] * 100 + "%"
            });
            else alignOrigin = [
                $1ab54fb6e8a09792$var$_getPropNum(target, "xPercent") / -100,
                $1ab54fb6e8a09792$var$_getPropNum(target, "yPercent") / -100
            ];
            m = $1ab54fb6e8a09792$var$_getAlignMatrix(target, alignTarget, alignOrigin, "auto");
            p = m.apply({
                x: x,
                y: y
            });
            (0, $aa28be8644bac4a8$export$9210b538875bfe33)(rawPath, m.a, m.b, m.c, m.d, curX + m.e - (p.x - m.e), curY + m.f - (p.y - m.f));
        }
    }
    if (matrix) (0, $aa28be8644bac4a8$export$9210b538875bfe33)(rawPath, matrix.a, matrix.b, matrix.c, matrix.d, matrix.e, matrix.f);
    else if (offsetX || offsetY) (0, $aa28be8644bac4a8$export$9210b538875bfe33)(rawPath, 1, 0, 0, 1, offsetX || 0, offsetY || 0);
    return rawPath;
}, $1ab54fb6e8a09792$var$_addDimensionalPropTween = function _addDimensionalPropTween(plugin, target, property, rawPath, pathProperty, forceUnit) {
    var cache = target._gsap, harness = cache.harness, alias = harness && harness.aliases && harness.aliases[property], prop = alias && alias.indexOf(",") < 0 ? alias : property, pt = plugin._pt = new $1ab54fb6e8a09792$var$PropTween(plugin._pt, target, prop, 0, 0, $1ab54fb6e8a09792$var$_emptyFunc, 0, cache.set(target, prop, plugin));
    pt.u = $1ab54fb6e8a09792$var$_getUnit(cache.get(target, prop, forceUnit)) || 0;
    pt.path = rawPath;
    pt.pp = pathProperty;
    plugin._props.push(prop);
}, $1ab54fb6e8a09792$var$_sliceModifier = function _sliceModifier(start, end) {
    return function(rawPath) {
        return start || end !== 1 ? (0, $aa28be8644bac4a8$export$510a529ffd67482a)(rawPath, start, end) : rawPath;
    };
};
var $1ab54fb6e8a09792$export$231c7d2ff66229c3 = {
    version: "3.14.2",
    name: "motionPath",
    register: function register(core, Plugin, propTween) {
        $1ab54fb6e8a09792$var$gsap = core;
        $1ab54fb6e8a09792$var$_getUnit = $1ab54fb6e8a09792$var$gsap.utils.getUnit;
        $1ab54fb6e8a09792$var$_toArray = $1ab54fb6e8a09792$var$gsap.utils.toArray;
        $1ab54fb6e8a09792$var$_getStyleSaver = $1ab54fb6e8a09792$var$gsap.core.getStyleSaver;
        $1ab54fb6e8a09792$var$_reverting = $1ab54fb6e8a09792$var$gsap.core.reverting || function() {};
        $1ab54fb6e8a09792$var$PropTween = propTween;
    },
    init: function init(target, vars, tween) {
        if (!$1ab54fb6e8a09792$var$gsap) {
            console.warn("Please gsap.registerPlugin(MotionPathPlugin)");
            return false;
        }
        if (!(typeof vars === "object" && !vars.style) || !vars.path) vars = {
            path: vars
        };
        var rawPaths = [], _vars = vars, path = _vars.path, autoRotate = _vars.autoRotate, unitX = _vars.unitX, unitY = _vars.unitY, x = _vars.x, y = _vars.y, firstObj = path[0], slicer = $1ab54fb6e8a09792$var$_sliceModifier(vars.start, "end" in vars ? vars.end : 1), rawPath, p;
        this.rawPaths = rawPaths;
        this.target = target;
        this.tween = tween;
        this.styles = $1ab54fb6e8a09792$var$_getStyleSaver && $1ab54fb6e8a09792$var$_getStyleSaver(target, "transform");
        if (this.rotate = autoRotate || autoRotate === 0) {
            //get the rotational data FIRST so that the setTransform() method is called in the correct order in the render() loop - rotation gets set last.
            this.rOffset = parseFloat(autoRotate) || 0;
            this.radians = !!vars.useRadians;
            this.rProp = vars.rotation || "rotation"; // rotation property
            this.rSet = target._gsap.set(target, this.rProp, this); // rotation setter
            this.ru = $1ab54fb6e8a09792$var$_getUnit(target._gsap.get(target, this.rProp)) || 0; // rotation units
        }
        if (Array.isArray(path) && !("closed" in path) && typeof firstObj !== "number") {
            for(p in firstObj){
                if (!x && ~$1ab54fb6e8a09792$var$_xProps.indexOf(p)) x = p;
                else if (!y && ~$1ab54fb6e8a09792$var$_yProps.indexOf(p)) y = p;
            }
            if (x && y) //correlated values
            rawPaths.push($1ab54fb6e8a09792$var$_segmentToRawPath(this, $1ab54fb6e8a09792$var$_populateSegmentFromArray($1ab54fb6e8a09792$var$_populateSegmentFromArray([], path, x, 0), path, y, 1), target, x, y, slicer, vars, unitX || $1ab54fb6e8a09792$var$_getUnit(path[0][x]), unitY || $1ab54fb6e8a09792$var$_getUnit(path[0][y])));
            else x = y = 0;
            for(p in firstObj)p !== x && p !== y && rawPaths.push($1ab54fb6e8a09792$var$_segmentToRawPath(this, $1ab54fb6e8a09792$var$_populateSegmentFromArray([], path, p, 2), target, p, 0, slicer, vars, $1ab54fb6e8a09792$var$_getUnit(path[0][p])));
        } else {
            rawPath = slicer($1ab54fb6e8a09792$var$_align((0, $aa28be8644bac4a8$export$a7de45090ab95fc7)(vars.path), target, vars));
            (0, $aa28be8644bac4a8$export$cd44c6d3aa5b1098)(rawPath, vars.resolution);
            rawPaths.push(rawPath);
            $1ab54fb6e8a09792$var$_addDimensionalPropTween(this, target, vars.x || "x", rawPath, "x", vars.unitX || "px");
            $1ab54fb6e8a09792$var$_addDimensionalPropTween(this, target, vars.y || "y", rawPath, "y", vars.unitY || "px");
        }
        tween.vars.immediateRender && this.render(tween.progress(), this);
    },
    render: function render(ratio, data) {
        var rawPaths = data.rawPaths, i = rawPaths.length, pt = data._pt;
        if (data.tween._time || !$1ab54fb6e8a09792$var$_reverting()) {
            if (ratio > 1) ratio = 1;
            else if (ratio < 0) ratio = 0;
            while(i--)(0, $aa28be8644bac4a8$export$5fcb25b7d1608b70)(rawPaths[i], ratio, !i && data.rotate, rawPaths[i]);
            while(pt){
                pt.set(pt.t, pt.p, pt.path[pt.pp] + pt.u, pt.d, ratio);
                pt = pt._next;
            }
            data.rotate && data.rSet(data.target, data.rProp, rawPaths[0].angle * (data.radians ? $1ab54fb6e8a09792$var$_DEG2RAD : 1) + data.rOffset + data.ru, data, ratio);
        } else data.styles.revert();
    },
    getLength: function getLength(path) {
        return (0, $aa28be8644bac4a8$export$cd44c6d3aa5b1098)((0, $aa28be8644bac4a8$export$a7de45090ab95fc7)(path)).totalLength;
    },
    sliceRawPath: (0, $aa28be8644bac4a8$export$510a529ffd67482a),
    getRawPath: (0, $aa28be8644bac4a8$export$a7de45090ab95fc7),
    pointsToSegment: (0, $aa28be8644bac4a8$export$ae6dd21671b80694),
    stringToRawPath: (0, $aa28be8644bac4a8$export$a9a6ab89eb1c2191),
    rawPathToString: (0, $aa28be8644bac4a8$export$ced9e1d9be30c397),
    transformRawPath: (0, $aa28be8644bac4a8$export$9210b538875bfe33),
    getGlobalMatrix: (0, $b760a7c355166707$export$91a495f99cf781b7),
    getPositionOnPath: (0, $aa28be8644bac4a8$export$5fcb25b7d1608b70),
    cacheRawPathMeasurements: (0, $aa28be8644bac4a8$export$cd44c6d3aa5b1098),
    convertToPath: function convertToPath(targets, swap) {
        return $1ab54fb6e8a09792$var$_toArray(targets).map(function(target) {
            return (0, $aa28be8644bac4a8$export$1a6b6149d6272140)(target, swap !== false);
        });
    },
    convertCoordinates: function convertCoordinates(fromElement, toElement, point) {
        var m = (0, $b760a7c355166707$export$91a495f99cf781b7)(toElement, true, true).multiply((0, $b760a7c355166707$export$91a495f99cf781b7)(fromElement));
        return point ? m.apply(point) : m;
    },
    getAlignMatrix: $1ab54fb6e8a09792$var$_getAlignMatrix,
    getRelativePosition: function getRelativePosition(fromElement, toElement, fromOrigin, toOrigin) {
        var m = $1ab54fb6e8a09792$var$_getAlignMatrix(fromElement, toElement, fromOrigin, toOrigin);
        return {
            x: m.e,
            y: m.f
        };
    },
    arrayToRawPath: function arrayToRawPath(value, vars) {
        vars = vars || {};
        var segment = $1ab54fb6e8a09792$var$_populateSegmentFromArray($1ab54fb6e8a09792$var$_populateSegmentFromArray([], value, vars.x || "x", 0), value, vars.y || "y", 1);
        vars.relative && $1ab54fb6e8a09792$var$_relativize(segment);
        return [
            vars.type === "cubic" ? segment : (0, $aa28be8644bac4a8$export$ae6dd21671b80694)(segment, vars.curviness)
        ];
    }
};
$1ab54fb6e8a09792$var$_getGSAP() && $1ab54fb6e8a09792$var$gsap.registerPlugin($1ab54fb6e8a09792$export$231c7d2ff66229c3);





/*!
 * ScrollTrigger 3.14.2
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ function $2796a7dcea5802d4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $2796a7dcea5802d4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2796a7dcea5802d4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2796a7dcea5802d4$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/*!
 * Observer 3.14.2
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $2796a7dcea5802d4$var$gsap, $2796a7dcea5802d4$var$_coreInitted, $2796a7dcea5802d4$var$_clamp, $2796a7dcea5802d4$var$_win, $2796a7dcea5802d4$var$_doc, $2796a7dcea5802d4$var$_docEl, $2796a7dcea5802d4$var$_body, $2796a7dcea5802d4$var$_isTouch, $2796a7dcea5802d4$var$_pointerType, $2796a7dcea5802d4$var$ScrollTrigger, $2796a7dcea5802d4$var$_root, $2796a7dcea5802d4$var$_normalizer, $2796a7dcea5802d4$var$_eventTypes, $2796a7dcea5802d4$var$_context, $2796a7dcea5802d4$var$_getGSAP = function _getGSAP() {
    return $2796a7dcea5802d4$var$gsap || typeof window !== "undefined" && ($2796a7dcea5802d4$var$gsap = window.gsap) && $2796a7dcea5802d4$var$gsap.registerPlugin && $2796a7dcea5802d4$var$gsap;
}, $2796a7dcea5802d4$var$_startup = 1, $2796a7dcea5802d4$var$_observers = [], $2796a7dcea5802d4$export$3cd1cee43d19b683 = [], $2796a7dcea5802d4$export$d8e56d510a804d0a = [], $2796a7dcea5802d4$var$_getTime = Date.now, $2796a7dcea5802d4$var$_bridge = function _bridge(name, value) {
    return value;
}, $2796a7dcea5802d4$var$_integrate = function _integrate() {
    var core = $2796a7dcea5802d4$var$ScrollTrigger.core, data = core.bridge || {}, scrollers = core._scrollers, proxies = core._proxies;
    scrollers.push.apply(scrollers, $2796a7dcea5802d4$export$3cd1cee43d19b683);
    proxies.push.apply(proxies, $2796a7dcea5802d4$export$d8e56d510a804d0a);
    $2796a7dcea5802d4$export$3cd1cee43d19b683 = scrollers;
    $2796a7dcea5802d4$export$d8e56d510a804d0a = proxies;
    $2796a7dcea5802d4$var$_bridge = function _bridge(name, value) {
        return data[name](value);
    };
}, $2796a7dcea5802d4$export$6078f1ef08b38af9 = function _getProxyProp(element, property) {
    return ~$2796a7dcea5802d4$export$d8e56d510a804d0a.indexOf(element) && $2796a7dcea5802d4$export$d8e56d510a804d0a[$2796a7dcea5802d4$export$d8e56d510a804d0a.indexOf(element) + 1][property];
}, $2796a7dcea5802d4$export$4330f3a92e5d2e94 = function _isViewport(el) {
    return !!~$2796a7dcea5802d4$var$_root.indexOf(el);
}, $2796a7dcea5802d4$var$_addListener = function _addListener(element, type, func, passive, capture) {
    return element.addEventListener(type, func, {
        passive: passive !== false,
        capture: !!capture
    });
}, $2796a7dcea5802d4$var$_removeListener = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
}, $2796a7dcea5802d4$var$_scrollLeft = "scrollLeft", $2796a7dcea5802d4$var$_scrollTop = "scrollTop", $2796a7dcea5802d4$var$_onScroll = function _onScroll() {
    return $2796a7dcea5802d4$var$_normalizer && $2796a7dcea5802d4$var$_normalizer.isPressed || $2796a7dcea5802d4$export$3cd1cee43d19b683.cache++;
}, $2796a7dcea5802d4$var$_scrollCacheFunc = function _scrollCacheFunc(f, doNotCache) {
    var cachingFunc = function cachingFunc(value) {
        // since reading the scrollTop/scrollLeft/pageOffsetY/pageOffsetX can trigger a layout, this function allows us to cache the value so it only gets read fresh after a "scroll" event fires (or while we're refreshing because that can lengthen the page and alter the scroll position). when "soft" is true, that means don't actually set the scroll, but cache the new value instead (useful in ScrollSmoother)
        if (value || value === 0) {
            $2796a7dcea5802d4$var$_startup && ($2796a7dcea5802d4$var$_win.history.scrollRestoration = "manual"); // otherwise the new position will get overwritten by the browser onload.
            var isNormalizing = $2796a7dcea5802d4$var$_normalizer && $2796a7dcea5802d4$var$_normalizer.isPressed;
            value = cachingFunc.v = Math.round(value) || ($2796a7dcea5802d4$var$_normalizer && $2796a7dcea5802d4$var$_normalizer.iOS ? 1 : 0); //TODO: iOS Bug: if you allow it to go to 0, Safari can start to report super strange (wildly inaccurate) touch positions!
            f(value);
            cachingFunc.cacheID = $2796a7dcea5802d4$export$3cd1cee43d19b683.cache;
            isNormalizing && $2796a7dcea5802d4$var$_bridge("ss", value); // set scroll (notify ScrollTrigger so it can dispatch a "scrollStart" event if necessary
        } else if (doNotCache || $2796a7dcea5802d4$export$3cd1cee43d19b683.cache !== cachingFunc.cacheID || $2796a7dcea5802d4$var$_bridge("ref")) {
            cachingFunc.cacheID = $2796a7dcea5802d4$export$3cd1cee43d19b683.cache;
            cachingFunc.v = f();
        }
        return cachingFunc.v + cachingFunc.offset;
    };
    cachingFunc.offset = 0;
    return f && cachingFunc;
}, $2796a7dcea5802d4$export$b2cabb342cb0ebe1 = {
    s: $2796a7dcea5802d4$var$_scrollLeft,
    p: "left",
    p2: "Left",
    os: "right",
    os2: "Right",
    d: "width",
    d2: "Width",
    a: "x",
    sc: $2796a7dcea5802d4$var$_scrollCacheFunc(function(value) {
        return arguments.length ? $2796a7dcea5802d4$var$_win.scrollTo(value, $2796a7dcea5802d4$export$8e40fc98ff518e9d.sc()) : $2796a7dcea5802d4$var$_win.pageXOffset || $2796a7dcea5802d4$var$_doc[$2796a7dcea5802d4$var$_scrollLeft] || $2796a7dcea5802d4$var$_docEl[$2796a7dcea5802d4$var$_scrollLeft] || $2796a7dcea5802d4$var$_body[$2796a7dcea5802d4$var$_scrollLeft] || 0;
    })
}, $2796a7dcea5802d4$export$8e40fc98ff518e9d = {
    s: $2796a7dcea5802d4$var$_scrollTop,
    p: "top",
    p2: "Top",
    os: "bottom",
    os2: "Bottom",
    d: "height",
    d2: "Height",
    a: "y",
    op: $2796a7dcea5802d4$export$b2cabb342cb0ebe1,
    sc: $2796a7dcea5802d4$var$_scrollCacheFunc(function(value) {
        return arguments.length ? $2796a7dcea5802d4$var$_win.scrollTo($2796a7dcea5802d4$export$b2cabb342cb0ebe1.sc(), value) : $2796a7dcea5802d4$var$_win.pageYOffset || $2796a7dcea5802d4$var$_doc[$2796a7dcea5802d4$var$_scrollTop] || $2796a7dcea5802d4$var$_docEl[$2796a7dcea5802d4$var$_scrollTop] || $2796a7dcea5802d4$var$_body[$2796a7dcea5802d4$var$_scrollTop] || 0;
    })
}, $2796a7dcea5802d4$export$937374fea3f88711 = function _getTarget(t, self) {
    return (self && self._ctx && self._ctx.selector || $2796a7dcea5802d4$var$gsap.utils.toArray)(t)[0] || (typeof t === "string" && $2796a7dcea5802d4$var$gsap.config().nullTargetWarn !== false ? console.warn("Element not found:", t) : null);
}, $2796a7dcea5802d4$var$_isWithin = function _isWithin(element, list) {
    // check if the element is in the list or is a descendant of an element in the list.
    var i = list.length;
    while(i--){
        if (list[i] === element || list[i].contains(element)) return true;
    }
    return false;
}, $2796a7dcea5802d4$export$8665aac53dad5647 = function _getScrollFunc(element, _ref) {
    var s = _ref.s, sc = _ref.sc;
    // we store the scroller functions in an alternating sequenced Array like [element, verticalScrollFunc, horizontalScrollFunc, ...] so that we can minimize memory, maximize performance, and we also record the last position as a ".rec" property in order to revert to that after refreshing to ensure things don't shift around.
    $2796a7dcea5802d4$export$4330f3a92e5d2e94(element) && (element = $2796a7dcea5802d4$var$_doc.scrollingElement || $2796a7dcea5802d4$var$_docEl);
    var i = $2796a7dcea5802d4$export$3cd1cee43d19b683.indexOf(element), offset = sc === $2796a7dcea5802d4$export$8e40fc98ff518e9d.sc ? 1 : 2;
    !~i && (i = $2796a7dcea5802d4$export$3cd1cee43d19b683.push(element) - 1);
    $2796a7dcea5802d4$export$3cd1cee43d19b683[i + offset] || $2796a7dcea5802d4$var$_addListener(element, "scroll", $2796a7dcea5802d4$var$_onScroll); // clear the cache when a scroll occurs
    var prev = $2796a7dcea5802d4$export$3cd1cee43d19b683[i + offset], func = prev || ($2796a7dcea5802d4$export$3cd1cee43d19b683[i + offset] = $2796a7dcea5802d4$var$_scrollCacheFunc($2796a7dcea5802d4$export$6078f1ef08b38af9(element, s), true) || ($2796a7dcea5802d4$export$4330f3a92e5d2e94(element) ? sc : $2796a7dcea5802d4$var$_scrollCacheFunc(function(value) {
        return arguments.length ? element[s] = value : element[s];
    })));
    func.target = element;
    prev || (func.smooth = $2796a7dcea5802d4$var$gsap.getProperty(element, "scrollBehavior") === "smooth"); // only set it the first time (don't reset every time a scrollFunc is requested because perhaps it happens during a refresh() when it's disabled in ScrollTrigger.
    return func;
}, $2796a7dcea5802d4$export$5de019f4480f0f8d = function _getVelocityProp(value, minTimeRefresh, useDelta) {
    var v1 = value, v2 = value, t1 = $2796a7dcea5802d4$var$_getTime(), t2 = t1, min = minTimeRefresh || 50, dropToZeroTime = Math.max(500, min * 3), update = function update(value, force) {
        var t = $2796a7dcea5802d4$var$_getTime();
        if (force || t - t1 > min) {
            v2 = v1;
            v1 = value;
            t2 = t1;
            t1 = t;
        } else if (useDelta) v1 += value;
        else // not totally necessary, but makes it a bit more accurate by adjusting the v1 value according to the new slope. This way we're not just ignoring the incoming data. Removing for now because it doesn't seem to make much practical difference and it's probably not worth the kb.
        v1 = v2 + (value - v2) / (t - t2) * (t1 - t2);
    }, reset = function reset() {
        v2 = v1 = useDelta ? 0 : v1;
        t2 = t1 = 0;
    }, getVelocity = function getVelocity(latestValue) {
        var tOld = t2, vOld = v2, t = $2796a7dcea5802d4$var$_getTime();
        (latestValue || latestValue === 0) && latestValue !== v1 && update(latestValue);
        return t1 === t2 || t - t2 > dropToZeroTime ? 0 : (v1 + (useDelta ? vOld : -vOld)) / ((useDelta ? t : t1) - tOld) * 1000;
    };
    return {
        update: update,
        reset: reset,
        getVelocity: getVelocity
    };
}, $2796a7dcea5802d4$var$_getEvent = function _getEvent(e, preventDefault) {
    preventDefault && !e._gsapAllow && e.preventDefault();
    return e.changedTouches ? e.changedTouches[0] : e;
}, $2796a7dcea5802d4$var$_getAbsoluteMax = function _getAbsoluteMax(a) {
    var max = Math.max.apply(Math, a), min = Math.min.apply(Math, a);
    return Math.abs(max) >= Math.abs(min) ? max : min;
}, $2796a7dcea5802d4$var$_setScrollTrigger = function _setScrollTrigger() {
    $2796a7dcea5802d4$var$ScrollTrigger = $2796a7dcea5802d4$var$gsap.core.globals().ScrollTrigger;
    $2796a7dcea5802d4$var$ScrollTrigger && $2796a7dcea5802d4$var$ScrollTrigger.core && $2796a7dcea5802d4$var$_integrate();
}, $2796a7dcea5802d4$var$_initCore = function _initCore(core) {
    $2796a7dcea5802d4$var$gsap = core || $2796a7dcea5802d4$var$_getGSAP();
    if (!$2796a7dcea5802d4$var$_coreInitted && $2796a7dcea5802d4$var$gsap && typeof document !== "undefined" && document.body) {
        $2796a7dcea5802d4$var$_win = window;
        $2796a7dcea5802d4$var$_doc = document;
        $2796a7dcea5802d4$var$_docEl = $2796a7dcea5802d4$var$_doc.documentElement;
        $2796a7dcea5802d4$var$_body = $2796a7dcea5802d4$var$_doc.body;
        $2796a7dcea5802d4$var$_root = [
            $2796a7dcea5802d4$var$_win,
            $2796a7dcea5802d4$var$_doc,
            $2796a7dcea5802d4$var$_docEl,
            $2796a7dcea5802d4$var$_body
        ];
        $2796a7dcea5802d4$var$_clamp = $2796a7dcea5802d4$var$gsap.utils.clamp;
        $2796a7dcea5802d4$var$_context = $2796a7dcea5802d4$var$gsap.core.context || function() {};
        $2796a7dcea5802d4$var$_pointerType = "onpointerenter" in $2796a7dcea5802d4$var$_body ? "pointer" : "mouse"; // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
        $2796a7dcea5802d4$var$_isTouch = $2796a7dcea5802d4$export$c1cbdee04e18ea8b.isTouch = $2796a7dcea5802d4$var$_win.matchMedia && $2796a7dcea5802d4$var$_win.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in $2796a7dcea5802d4$var$_win || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? 2 : 0;
        $2796a7dcea5802d4$var$_eventTypes = $2796a7dcea5802d4$export$c1cbdee04e18ea8b.eventTypes = ("ontouchstart" in $2796a7dcea5802d4$var$_docEl ? "touchstart,touchmove,touchcancel,touchend" : !("onpointerdown" in $2796a7dcea5802d4$var$_docEl) ? "mousedown,mousemove,mouseup,mouseup" : "pointerdown,pointermove,pointercancel,pointerup").split(",");
        setTimeout(function() {
            return $2796a7dcea5802d4$var$_startup = 0;
        }, 500);
        $2796a7dcea5802d4$var$_setScrollTrigger();
        $2796a7dcea5802d4$var$_coreInitted = 1;
    }
    return $2796a7dcea5802d4$var$_coreInitted;
};
$2796a7dcea5802d4$export$b2cabb342cb0ebe1.op = $2796a7dcea5802d4$export$8e40fc98ff518e9d;
$2796a7dcea5802d4$export$3cd1cee43d19b683.cache = 0;
var $2796a7dcea5802d4$export$c1cbdee04e18ea8b = /*#__PURE__*/ function() {
    function Observer(vars) {
        this.init(vars);
    }
    var _proto = Observer.prototype;
    _proto.init = function init(vars) {
        $2796a7dcea5802d4$var$_coreInitted || $2796a7dcea5802d4$var$_initCore($2796a7dcea5802d4$var$gsap) || console.warn("Please gsap.registerPlugin(Observer)");
        $2796a7dcea5802d4$var$ScrollTrigger || $2796a7dcea5802d4$var$_setScrollTrigger();
        var tolerance = vars.tolerance, dragMinimum = vars.dragMinimum, type = vars.type, target = vars.target, lineHeight = vars.lineHeight, debounce = vars.debounce, preventDefault = vars.preventDefault, onStop = vars.onStop, onStopDelay = vars.onStopDelay, ignore = vars.ignore, wheelSpeed = vars.wheelSpeed, event = vars.event, onDragStart = vars.onDragStart, onDragEnd = vars.onDragEnd, onDrag = vars.onDrag, onPress = vars.onPress, onRelease = vars.onRelease, onRight = vars.onRight, onLeft = vars.onLeft, onUp = vars.onUp, onDown = vars.onDown, onChangeX = vars.onChangeX, onChangeY = vars.onChangeY, onChange = vars.onChange, onToggleX = vars.onToggleX, onToggleY = vars.onToggleY, onHover = vars.onHover, onHoverEnd = vars.onHoverEnd, onMove = vars.onMove, ignoreCheck = vars.ignoreCheck, isNormalizer = vars.isNormalizer, onGestureStart = vars.onGestureStart, onGestureEnd = vars.onGestureEnd, onWheel = vars.onWheel, onEnable = vars.onEnable, onDisable = vars.onDisable, onClick = vars.onClick, scrollSpeed = vars.scrollSpeed, capture = vars.capture, allowClicks = vars.allowClicks, lockAxis = vars.lockAxis, onLockAxis = vars.onLockAxis;
        this.target = target = $2796a7dcea5802d4$export$937374fea3f88711(target) || $2796a7dcea5802d4$var$_docEl;
        this.vars = vars;
        ignore && (ignore = $2796a7dcea5802d4$var$gsap.utils.toArray(ignore));
        tolerance = tolerance || 1e-9;
        dragMinimum = dragMinimum || 0;
        wheelSpeed = wheelSpeed || 1;
        scrollSpeed = scrollSpeed || 1;
        type = type || "wheel,touch,pointer";
        debounce = debounce !== false;
        lineHeight || (lineHeight = parseFloat($2796a7dcea5802d4$var$_win.getComputedStyle($2796a7dcea5802d4$var$_body).lineHeight) || 22); // note: browser may report "normal", so default to 22.
        var id, onStopDelayedCall, dragged, moved, wheeled, locked, axis, self = this, prevDeltaX = 0, prevDeltaY = 0, passive = vars.passive || !preventDefault && vars.passive !== false, scrollFuncX = $2796a7dcea5802d4$export$8665aac53dad5647(target, $2796a7dcea5802d4$export$b2cabb342cb0ebe1), scrollFuncY = $2796a7dcea5802d4$export$8665aac53dad5647(target, $2796a7dcea5802d4$export$8e40fc98ff518e9d), scrollX = scrollFuncX(), scrollY = scrollFuncY(), limitToTouch = ~type.indexOf("touch") && !~type.indexOf("pointer") && $2796a7dcea5802d4$var$_eventTypes[0] === "pointerdown", // for devices that accommodate mouse events and touch events, we need to distinguish.
        isViewport = $2796a7dcea5802d4$export$4330f3a92e5d2e94(target), ownerDoc = target.ownerDocument || $2796a7dcea5802d4$var$_doc, deltaX = [
            0,
            0,
            0
        ], // wheel, scroll, pointer/touch
        deltaY = [
            0,
            0,
            0
        ], onClickTime = 0, clickCapture = function clickCapture() {
            return onClickTime = $2796a7dcea5802d4$var$_getTime();
        }, _ignoreCheck = function _ignoreCheck(e, isPointerOrTouch) {
            return (self.event = e) && ignore && $2796a7dcea5802d4$var$_isWithin(e.target, ignore) || isPointerOrTouch && limitToTouch && e.pointerType !== "touch" || ignoreCheck && ignoreCheck(e, isPointerOrTouch);
        }, onStopFunc = function onStopFunc() {
            self._vx.reset();
            self._vy.reset();
            onStopDelayedCall.pause();
            onStop && onStop(self);
        }, update = function update() {
            var dx = self.deltaX = $2796a7dcea5802d4$var$_getAbsoluteMax(deltaX), dy = self.deltaY = $2796a7dcea5802d4$var$_getAbsoluteMax(deltaY), changedX = Math.abs(dx) >= tolerance, changedY = Math.abs(dy) >= tolerance;
            onChange && (changedX || changedY) && onChange(self, dx, dy, deltaX, deltaY); // in ScrollTrigger.normalizeScroll(), we need to know if it was touch/pointer so we need access to the deltaX/deltaY Arrays before we clear them out.
            if (changedX) {
                onRight && self.deltaX > 0 && onRight(self);
                onLeft && self.deltaX < 0 && onLeft(self);
                onChangeX && onChangeX(self);
                onToggleX && self.deltaX < 0 !== prevDeltaX < 0 && onToggleX(self);
                prevDeltaX = self.deltaX;
                deltaX[0] = deltaX[1] = deltaX[2] = 0;
            }
            if (changedY) {
                onDown && self.deltaY > 0 && onDown(self);
                onUp && self.deltaY < 0 && onUp(self);
                onChangeY && onChangeY(self);
                onToggleY && self.deltaY < 0 !== prevDeltaY < 0 && onToggleY(self);
                prevDeltaY = self.deltaY;
                deltaY[0] = deltaY[1] = deltaY[2] = 0;
            }
            if (moved || dragged) {
                onMove && onMove(self);
                if (dragged) {
                    onDragStart && dragged === 1 && onDragStart(self);
                    onDrag && onDrag(self);
                    dragged = 0;
                }
                moved = false;
            }
            locked && (locked = false, true) && onLockAxis && onLockAxis(self);
            if (wheeled) {
                onWheel(self);
                wheeled = false;
            }
            id = 0;
        }, onDelta = function onDelta(x, y, index) {
            deltaX[index] += x;
            deltaY[index] += y;
            self._vx.update(x);
            self._vy.update(y);
            debounce ? id || (id = requestAnimationFrame(update)) : update();
        }, onTouchOrPointerDelta = function onTouchOrPointerDelta(x, y) {
            if (lockAxis && !axis) {
                self.axis = axis = Math.abs(x) > Math.abs(y) ? "x" : "y";
                locked = true;
            }
            if (axis !== "y") {
                deltaX[2] += x;
                self._vx.update(x, true); // update the velocity as frequently as possible instead of in the debounced function so that very quick touch-scrolls (flicks) feel natural. If it's the mouse/touch/pointer, force it so that we get snappy/accurate momentum scroll.
            }
            if (axis !== "x") {
                deltaY[2] += y;
                self._vy.update(y, true);
            }
            debounce ? id || (id = requestAnimationFrame(update)) : update();
        }, _onDrag = function _onDrag(e) {
            if (_ignoreCheck(e, 1)) return;
            e = $2796a7dcea5802d4$var$_getEvent(e, preventDefault);
            var x = e.clientX, y = e.clientY, dx = x - self.x, dy = y - self.y, isDragging = self.isDragging;
            self.x = x;
            self.y = y;
            if (isDragging || (dx || dy) && (Math.abs(self.startX - x) >= dragMinimum || Math.abs(self.startY - y) >= dragMinimum)) {
                dragged || (dragged = isDragging ? 2 : 1); // dragged: 0 = not dragging, 1 = first drag, 2 = normal drag
                isDragging || (self.isDragging = true);
                onTouchOrPointerDelta(dx, dy);
            }
        }, _onPress = self.onPress = function(e) {
            if (_ignoreCheck(e, 1) || e && e.button) return;
            self.axis = axis = null;
            onStopDelayedCall.pause();
            self.isPressed = true;
            e = $2796a7dcea5802d4$var$_getEvent(e); // note: may need to preventDefault(?) Won't side-scroll on iOS Safari if we do, though.
            prevDeltaX = prevDeltaY = 0;
            self.startX = self.x = e.clientX;
            self.startY = self.y = e.clientY;
            self._vx.reset(); // otherwise the t2 may be stale if the user touches and flicks super fast and releases in less than 2 requestAnimationFrame ticks, causing velocity to be 0.
            self._vy.reset();
            $2796a7dcea5802d4$var$_addListener(isNormalizer ? target : ownerDoc, $2796a7dcea5802d4$var$_eventTypes[1], _onDrag, passive, true);
            self.deltaX = self.deltaY = 0;
            onPress && onPress(self);
        }, _onRelease = self.onRelease = function(e) {
            if (_ignoreCheck(e, 1)) return;
            $2796a7dcea5802d4$var$_removeListener(isNormalizer ? target : ownerDoc, $2796a7dcea5802d4$var$_eventTypes[1], _onDrag, true);
            var isTrackingDrag = !isNaN(self.y - self.startY), wasDragging = self.isDragging, isDragNotClick = wasDragging && (Math.abs(self.x - self.startX) > 3 || Math.abs(self.y - self.startY) > 3), // some touch devices need some wiggle room in terms of sensing clicks - the finger may move a few pixels.
            eventData = $2796a7dcea5802d4$var$_getEvent(e);
            if (!isDragNotClick && isTrackingDrag) {
                self._vx.reset();
                self._vy.reset(); //if (preventDefault && allowClicks && self.isPressed) { // check isPressed because in a rare edge case, the inputObserver in ScrollTrigger may stopPropagation() on the press/drag, so the onRelease may get fired without the onPress/onDrag ever getting called, thus it could trigger a click to occur on a link after scroll-dragging it.
                if (preventDefault && allowClicks) $2796a7dcea5802d4$var$gsap.delayedCall(0.08, function() {
                    // some browsers (like Firefox) won't trust script-generated clicks, so if the user tries to click on a video to play it, for example, it simply won't work. Since a regular "click" event will most likely be generated anyway (one that has its isTrusted flag set to true), we must slightly delay our script-generated click so that the "real"/trusted one is prioritized. Remember, when there are duplicate events in quick succession, we suppress all but the first one. Some browsers don't even trigger the "real" one at all, so our synthetic one is a safety valve that ensures that no matter what, a click event does get dispatched.
                    if ($2796a7dcea5802d4$var$_getTime() - onClickTime > 300 && !e.defaultPrevented) {
                        if (e.target.click) //some browsers (like mobile Safari) don't properly trigger the click event
                        e.target.click();
                        else if (ownerDoc.createEvent) {
                            var syntheticEvent = ownerDoc.createEvent("MouseEvents");
                            syntheticEvent.initMouseEvent("click", true, true, $2796a7dcea5802d4$var$_win, 1, eventData.screenX, eventData.screenY, eventData.clientX, eventData.clientY, false, false, false, false, 0, null);
                            e.target.dispatchEvent(syntheticEvent);
                        }
                    }
                });
            }
            self.isDragging = self.isGesturing = self.isPressed = false;
            onStop && wasDragging && !isNormalizer && onStopDelayedCall.restart(true);
            dragged && update(); // in case debouncing, we don't want onDrag to fire AFTER onDragEnd().
            onDragEnd && wasDragging && onDragEnd(self);
            onRelease && onRelease(self, isDragNotClick);
        }, _onGestureStart = function _onGestureStart(e) {
            return e.touches && e.touches.length > 1 && (self.isGesturing = true) && onGestureStart(e, self.isDragging);
        }, _onGestureEnd = function _onGestureEnd() {
            return self.isGesturing = false, onGestureEnd(self);
        }, onScroll = function onScroll(e) {
            if (_ignoreCheck(e)) return;
            var x = scrollFuncX(), y = scrollFuncY();
            onDelta((x - scrollX) * scrollSpeed, (y - scrollY) * scrollSpeed, 1);
            scrollX = x;
            scrollY = y;
            onStop && onStopDelayedCall.restart(true);
        }, _onWheel = function _onWheel(e) {
            if (_ignoreCheck(e)) return;
            e = $2796a7dcea5802d4$var$_getEvent(e, preventDefault);
            onWheel && (wheeled = true);
            var multiplier = (e.deltaMode === 1 ? lineHeight : e.deltaMode === 2 ? $2796a7dcea5802d4$var$_win.innerHeight : 1) * wheelSpeed;
            onDelta(e.deltaX * multiplier, e.deltaY * multiplier, 0);
            onStop && !isNormalizer && onStopDelayedCall.restart(true);
        }, _onMove = function _onMove(e) {
            if (_ignoreCheck(e)) return;
            var x = e.clientX, y = e.clientY, dx = x - self.x, dy = y - self.y;
            self.x = x;
            self.y = y;
            moved = true;
            onStop && onStopDelayedCall.restart(true);
            (dx || dy) && onTouchOrPointerDelta(dx, dy);
        }, _onHover = function _onHover(e) {
            self.event = e;
            onHover(self);
        }, _onHoverEnd = function _onHoverEnd(e) {
            self.event = e;
            onHoverEnd(self);
        }, _onClick = function _onClick(e) {
            return _ignoreCheck(e) || $2796a7dcea5802d4$var$_getEvent(e, preventDefault) && onClick(self);
        };
        onStopDelayedCall = self._dc = $2796a7dcea5802d4$var$gsap.delayedCall(onStopDelay || 0.25, onStopFunc).pause();
        self.deltaX = self.deltaY = 0;
        self._vx = $2796a7dcea5802d4$export$5de019f4480f0f8d(0, 50, true);
        self._vy = $2796a7dcea5802d4$export$5de019f4480f0f8d(0, 50, true);
        self.scrollX = scrollFuncX;
        self.scrollY = scrollFuncY;
        self.isDragging = self.isGesturing = self.isPressed = false;
        $2796a7dcea5802d4$var$_context(this);
        self.enable = function(e) {
            if (!self.isEnabled) {
                $2796a7dcea5802d4$var$_addListener(isViewport ? ownerDoc : target, "scroll", $2796a7dcea5802d4$var$_onScroll);
                type.indexOf("scroll") >= 0 && $2796a7dcea5802d4$var$_addListener(isViewport ? ownerDoc : target, "scroll", onScroll, passive, capture);
                type.indexOf("wheel") >= 0 && $2796a7dcea5802d4$var$_addListener(target, "wheel", _onWheel, passive, capture);
                if (type.indexOf("touch") >= 0 && $2796a7dcea5802d4$var$_isTouch || type.indexOf("pointer") >= 0) {
                    $2796a7dcea5802d4$var$_addListener(target, $2796a7dcea5802d4$var$_eventTypes[0], _onPress, passive, capture);
                    $2796a7dcea5802d4$var$_addListener(ownerDoc, $2796a7dcea5802d4$var$_eventTypes[2], _onRelease);
                    $2796a7dcea5802d4$var$_addListener(ownerDoc, $2796a7dcea5802d4$var$_eventTypes[3], _onRelease);
                    allowClicks && $2796a7dcea5802d4$var$_addListener(target, "click", clickCapture, true, true);
                    onClick && $2796a7dcea5802d4$var$_addListener(target, "click", _onClick);
                    onGestureStart && $2796a7dcea5802d4$var$_addListener(ownerDoc, "gesturestart", _onGestureStart);
                    onGestureEnd && $2796a7dcea5802d4$var$_addListener(ownerDoc, "gestureend", _onGestureEnd);
                    onHover && $2796a7dcea5802d4$var$_addListener(target, $2796a7dcea5802d4$var$_pointerType + "enter", _onHover);
                    onHoverEnd && $2796a7dcea5802d4$var$_addListener(target, $2796a7dcea5802d4$var$_pointerType + "leave", _onHoverEnd);
                    onMove && $2796a7dcea5802d4$var$_addListener(target, $2796a7dcea5802d4$var$_pointerType + "move", _onMove);
                }
                self.isEnabled = true;
                self.isDragging = self.isGesturing = self.isPressed = moved = dragged = false;
                self._vx.reset();
                self._vy.reset();
                scrollX = scrollFuncX();
                scrollY = scrollFuncY();
                e && e.type && _onPress(e);
                onEnable && onEnable(self);
            }
            return self;
        };
        self.disable = function() {
            if (self.isEnabled) {
                // only remove the _onScroll listener if there aren't any others that rely on the functionality.
                $2796a7dcea5802d4$var$_observers.filter(function(o) {
                    return o !== self && $2796a7dcea5802d4$export$4330f3a92e5d2e94(o.target);
                }).length || $2796a7dcea5802d4$var$_removeListener(isViewport ? ownerDoc : target, "scroll", $2796a7dcea5802d4$var$_onScroll);
                if (self.isPressed) {
                    self._vx.reset();
                    self._vy.reset();
                    $2796a7dcea5802d4$var$_removeListener(isNormalizer ? target : ownerDoc, $2796a7dcea5802d4$var$_eventTypes[1], _onDrag, true);
                }
                $2796a7dcea5802d4$var$_removeListener(isViewport ? ownerDoc : target, "scroll", onScroll, capture);
                $2796a7dcea5802d4$var$_removeListener(target, "wheel", _onWheel, capture);
                $2796a7dcea5802d4$var$_removeListener(target, $2796a7dcea5802d4$var$_eventTypes[0], _onPress, capture);
                $2796a7dcea5802d4$var$_removeListener(ownerDoc, $2796a7dcea5802d4$var$_eventTypes[2], _onRelease);
                $2796a7dcea5802d4$var$_removeListener(ownerDoc, $2796a7dcea5802d4$var$_eventTypes[3], _onRelease);
                $2796a7dcea5802d4$var$_removeListener(target, "click", clickCapture, true);
                $2796a7dcea5802d4$var$_removeListener(target, "click", _onClick);
                $2796a7dcea5802d4$var$_removeListener(ownerDoc, "gesturestart", _onGestureStart);
                $2796a7dcea5802d4$var$_removeListener(ownerDoc, "gestureend", _onGestureEnd);
                $2796a7dcea5802d4$var$_removeListener(target, $2796a7dcea5802d4$var$_pointerType + "enter", _onHover);
                $2796a7dcea5802d4$var$_removeListener(target, $2796a7dcea5802d4$var$_pointerType + "leave", _onHoverEnd);
                $2796a7dcea5802d4$var$_removeListener(target, $2796a7dcea5802d4$var$_pointerType + "move", _onMove);
                self.isEnabled = self.isPressed = self.isDragging = false;
                onDisable && onDisable(self);
            }
        };
        self.kill = self.revert = function() {
            self.disable();
            var i = $2796a7dcea5802d4$var$_observers.indexOf(self);
            i >= 0 && $2796a7dcea5802d4$var$_observers.splice(i, 1);
            $2796a7dcea5802d4$var$_normalizer === self && ($2796a7dcea5802d4$var$_normalizer = 0);
        };
        $2796a7dcea5802d4$var$_observers.push(self);
        isNormalizer && $2796a7dcea5802d4$export$4330f3a92e5d2e94(target) && ($2796a7dcea5802d4$var$_normalizer = self);
        self.enable(event);
    };
    $2796a7dcea5802d4$var$_createClass(Observer, [
        {
            key: "velocityX",
            get: function get() {
                return this._vx.getVelocity();
            }
        },
        {
            key: "velocityY",
            get: function get() {
                return this._vy.getVelocity();
            }
        }
    ]);
    return Observer;
}();
$2796a7dcea5802d4$export$c1cbdee04e18ea8b.version = "3.14.2";
$2796a7dcea5802d4$export$c1cbdee04e18ea8b.create = function(vars) {
    return new $2796a7dcea5802d4$export$c1cbdee04e18ea8b(vars);
};
$2796a7dcea5802d4$export$c1cbdee04e18ea8b.register = $2796a7dcea5802d4$var$_initCore;
$2796a7dcea5802d4$export$c1cbdee04e18ea8b.getAll = function() {
    return $2796a7dcea5802d4$var$_observers.slice();
};
$2796a7dcea5802d4$export$c1cbdee04e18ea8b.getById = function(id) {
    return $2796a7dcea5802d4$var$_observers.filter(function(o) {
        return o.vars.id === id;
    })[0];
};
$2796a7dcea5802d4$var$_getGSAP() && $2796a7dcea5802d4$var$gsap.registerPlugin($2796a7dcea5802d4$export$c1cbdee04e18ea8b);


var $82ba1e40433c64f0$var$gsap, $82ba1e40433c64f0$var$_coreInitted, $82ba1e40433c64f0$var$_win, $82ba1e40433c64f0$var$_doc, $82ba1e40433c64f0$var$_docEl, $82ba1e40433c64f0$var$_body, $82ba1e40433c64f0$var$_root, $82ba1e40433c64f0$var$_resizeDelay, $82ba1e40433c64f0$var$_toArray, $82ba1e40433c64f0$var$_clamp, $82ba1e40433c64f0$var$_time2, $82ba1e40433c64f0$var$_syncInterval, $82ba1e40433c64f0$var$_refreshing, $82ba1e40433c64f0$var$_pointerIsDown, $82ba1e40433c64f0$var$_transformProp, $82ba1e40433c64f0$var$_i, $82ba1e40433c64f0$var$_prevWidth, $82ba1e40433c64f0$var$_prevHeight, $82ba1e40433c64f0$var$_autoRefresh, $82ba1e40433c64f0$var$_sort, $82ba1e40433c64f0$var$_suppressOverwrites, $82ba1e40433c64f0$var$_ignoreResize, $82ba1e40433c64f0$var$_normalizer, $82ba1e40433c64f0$var$_ignoreMobileResize, $82ba1e40433c64f0$var$_baseScreenHeight, $82ba1e40433c64f0$var$_baseScreenWidth, $82ba1e40433c64f0$var$_fixIOSBug, $82ba1e40433c64f0$var$_context, $82ba1e40433c64f0$var$_scrollRestoration, $82ba1e40433c64f0$var$_div100vh, $82ba1e40433c64f0$var$_100vh, $82ba1e40433c64f0$var$_isReverted, $82ba1e40433c64f0$var$_clampingMax, $82ba1e40433c64f0$var$_limitCallbacks, // if true, we'll only trigger callbacks if the active state toggles, so if you scroll immediately past both the start and end positions of a ScrollTrigger (thus inactive to inactive), neither its onEnter nor onLeave will be called. This is useful during startup.
$82ba1e40433c64f0$var$_startup = 1, $82ba1e40433c64f0$var$_getTime = Date.now, $82ba1e40433c64f0$var$_time1 = $82ba1e40433c64f0$var$_getTime(), $82ba1e40433c64f0$var$_lastScrollTime = 0, $82ba1e40433c64f0$var$_enabled = 0, $82ba1e40433c64f0$var$_parseClamp = function _parseClamp(value, type, self) {
    var clamp = $82ba1e40433c64f0$var$_isString(value) && (value.substr(0, 6) === "clamp(" || value.indexOf("max") > -1);
    self["_" + type + "Clamp"] = clamp;
    return clamp ? value.substr(6, value.length - 7) : value;
}, $82ba1e40433c64f0$var$_keepClamp = function _keepClamp(value, clamp) {
    return clamp && (!$82ba1e40433c64f0$var$_isString(value) || value.substr(0, 6) !== "clamp(") ? "clamp(" + value + ")" : value;
}, $82ba1e40433c64f0$var$_rafBugFix = function _rafBugFix() {
    return $82ba1e40433c64f0$var$_enabled && requestAnimationFrame(_rafBugFix);
}, // in some browsers (like Firefox), screen repaints weren't consistent unless we had SOMETHING queued up in requestAnimationFrame()! So this just creates a super simple loop to keep it alive and smooth out repaints.
$82ba1e40433c64f0$var$_pointerDownHandler = function _pointerDownHandler() {
    return $82ba1e40433c64f0$var$_pointerIsDown = 1;
}, $82ba1e40433c64f0$var$_pointerUpHandler = function _pointerUpHandler() {
    return $82ba1e40433c64f0$var$_pointerIsDown = 0;
}, $82ba1e40433c64f0$var$_passThrough = function _passThrough(v) {
    return v;
}, $82ba1e40433c64f0$var$_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, $82ba1e40433c64f0$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $82ba1e40433c64f0$var$_getGSAP = function _getGSAP() {
    return $82ba1e40433c64f0$var$gsap || $82ba1e40433c64f0$var$_windowExists() && ($82ba1e40433c64f0$var$gsap = window.gsap) && $82ba1e40433c64f0$var$gsap.registerPlugin && $82ba1e40433c64f0$var$gsap;
}, $82ba1e40433c64f0$var$_isViewport = function _isViewport(e) {
    return !!~$82ba1e40433c64f0$var$_root.indexOf(e);
}, $82ba1e40433c64f0$var$_getViewportDimension = function _getViewportDimension(dimensionProperty) {
    return (dimensionProperty === "Height" ? $82ba1e40433c64f0$var$_100vh : $82ba1e40433c64f0$var$_win["inner" + dimensionProperty]) || $82ba1e40433c64f0$var$_docEl["client" + dimensionProperty] || $82ba1e40433c64f0$var$_body["client" + dimensionProperty];
}, $82ba1e40433c64f0$var$_getBoundsFunc = function _getBoundsFunc(element) {
    return (0, $2796a7dcea5802d4$export$6078f1ef08b38af9)(element, "getBoundingClientRect") || ($82ba1e40433c64f0$var$_isViewport(element) ? function() {
        $82ba1e40433c64f0$var$_winOffsets.width = $82ba1e40433c64f0$var$_win.innerWidth;
        $82ba1e40433c64f0$var$_winOffsets.height = $82ba1e40433c64f0$var$_100vh;
        return $82ba1e40433c64f0$var$_winOffsets;
    } : function() {
        return $82ba1e40433c64f0$var$_getBounds(element);
    });
}, $82ba1e40433c64f0$var$_getSizeFunc = function _getSizeFunc(scroller, isViewport, _ref) {
    var d = _ref.d, d2 = _ref.d2, a = _ref.a;
    return (a = (0, $2796a7dcea5802d4$export$6078f1ef08b38af9)(scroller, "getBoundingClientRect")) ? function() {
        return a()[d];
    } : function() {
        return (isViewport ? $82ba1e40433c64f0$var$_getViewportDimension(d2) : scroller["client" + d2]) || 0;
    };
}, $82ba1e40433c64f0$var$_getOffsetsFunc = function _getOffsetsFunc(element, isViewport) {
    return !isViewport || ~(0, $2796a7dcea5802d4$export$d8e56d510a804d0a).indexOf(element) ? $82ba1e40433c64f0$var$_getBoundsFunc(element) : function() {
        return $82ba1e40433c64f0$var$_winOffsets;
    };
}, $82ba1e40433c64f0$var$_maxScroll = function _maxScroll(element, _ref2) {
    var s = _ref2.s, d2 = _ref2.d2, d = _ref2.d, a = _ref2.a;
    return Math.max(0, (s = "scroll" + d2, a = (0, $2796a7dcea5802d4$export$6078f1ef08b38af9)(element, s)) ? a() - $82ba1e40433c64f0$var$_getBoundsFunc(element)()[d] : $82ba1e40433c64f0$var$_isViewport(element) ? ($82ba1e40433c64f0$var$_docEl[s] || $82ba1e40433c64f0$var$_body[s]) - $82ba1e40433c64f0$var$_getViewportDimension(d2) : element[s] - element["offset" + d2]);
}, $82ba1e40433c64f0$var$_iterateAutoRefresh = function _iterateAutoRefresh(func, events) {
    for(var i = 0; i < $82ba1e40433c64f0$var$_autoRefresh.length; i += 3)(!events || ~events.indexOf($82ba1e40433c64f0$var$_autoRefresh[i + 1])) && func($82ba1e40433c64f0$var$_autoRefresh[i], $82ba1e40433c64f0$var$_autoRefresh[i + 1], $82ba1e40433c64f0$var$_autoRefresh[i + 2]);
}, $82ba1e40433c64f0$var$_isString = function _isString(value) {
    return typeof value === "string";
}, $82ba1e40433c64f0$var$_isFunction = function _isFunction(value) {
    return typeof value === "function";
}, $82ba1e40433c64f0$var$_isNumber = function _isNumber(value) {
    return typeof value === "number";
}, $82ba1e40433c64f0$var$_isObject = function _isObject(value) {
    return typeof value === "object";
}, $82ba1e40433c64f0$var$_endAnimation = function _endAnimation(animation, reversed, pause) {
    return animation && animation.progress(reversed ? 0 : 1) && pause && animation.pause();
}, $82ba1e40433c64f0$var$_callback = function _callback(self, func) {
    if (self.enabled) {
        var result = self._ctx ? self._ctx.add(function() {
            return func(self);
        }) : func(self);
        result && result.totalTime && (self.callbackAnimation = result);
    }
}, $82ba1e40433c64f0$var$_abs = Math.abs, $82ba1e40433c64f0$var$_left = "left", $82ba1e40433c64f0$var$_top = "top", $82ba1e40433c64f0$var$_right = "right", $82ba1e40433c64f0$var$_bottom = "bottom", $82ba1e40433c64f0$var$_width = "width", $82ba1e40433c64f0$var$_height = "height", $82ba1e40433c64f0$var$_Right = "Right", $82ba1e40433c64f0$var$_Left = "Left", $82ba1e40433c64f0$var$_Top = "Top", $82ba1e40433c64f0$var$_Bottom = "Bottom", $82ba1e40433c64f0$var$_padding = "padding", $82ba1e40433c64f0$var$_margin = "margin", $82ba1e40433c64f0$var$_Width = "Width", $82ba1e40433c64f0$var$_Height = "Height", $82ba1e40433c64f0$var$_px = "px", $82ba1e40433c64f0$var$_getComputedStyle = function _getComputedStyle(element) {
    return $82ba1e40433c64f0$var$_win.getComputedStyle(element);
}, $82ba1e40433c64f0$var$_makePositionable = function _makePositionable(element) {
    // if the element already has position: absolute or fixed, leave that, otherwise make it position: relative
    var position = $82ba1e40433c64f0$var$_getComputedStyle(element).position;
    element.style.position = position === "absolute" || position === "fixed" ? position : "relative";
}, $82ba1e40433c64f0$var$_setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, $82ba1e40433c64f0$var$_getBounds = function _getBounds(element, withoutTransforms) {
    var tween = withoutTransforms && $82ba1e40433c64f0$var$_getComputedStyle(element)[$82ba1e40433c64f0$var$_transformProp] !== "matrix(1, 0, 0, 1, 0, 0)" && $82ba1e40433c64f0$var$gsap.to(element, {
        x: 0,
        y: 0,
        xPercent: 0,
        yPercent: 0,
        rotation: 0,
        rotationX: 0,
        rotationY: 0,
        scale: 1,
        skewX: 0,
        skewY: 0
    }).progress(1), bounds = element.getBoundingClientRect();
    tween && tween.progress(0).kill();
    return bounds;
}, $82ba1e40433c64f0$var$_getSize = function _getSize(element, _ref3) {
    var d2 = _ref3.d2;
    return element["offset" + d2] || element["client" + d2] || 0;
}, $82ba1e40433c64f0$var$_getLabelRatioArray = function _getLabelRatioArray(timeline) {
    var a = [], labels = timeline.labels, duration = timeline.duration(), p;
    for(p in labels)a.push(labels[p] / duration);
    return a;
}, $82ba1e40433c64f0$var$_getClosestLabel = function _getClosestLabel(animation) {
    return function(value) {
        return $82ba1e40433c64f0$var$gsap.utils.snap($82ba1e40433c64f0$var$_getLabelRatioArray(animation), value);
    };
}, $82ba1e40433c64f0$var$_snapDirectional = function _snapDirectional(snapIncrementOrArray) {
    var snap = $82ba1e40433c64f0$var$gsap.utils.snap(snapIncrementOrArray), a = Array.isArray(snapIncrementOrArray) && snapIncrementOrArray.slice(0).sort(function(a, b) {
        return a - b;
    });
    return a ? function(value, direction, threshold) {
        if (threshold === void 0) threshold = 1e-3;
        var i;
        if (!direction) return snap(value);
        if (direction > 0) {
            value -= threshold; // to avoid rounding errors. If we're too strict, it might snap forward, then immediately again, and again.
            for(i = 0; i < a.length; i++){
                if (a[i] >= value) return a[i];
            }
            return a[i - 1];
        } else {
            i = a.length;
            value += threshold;
            while(i--){
                if (a[i] <= value) return a[i];
            }
        }
        return a[0];
    } : function(value, direction, threshold) {
        if (threshold === void 0) threshold = 1e-3;
        var snapped = snap(value);
        return !direction || Math.abs(snapped - value) < threshold || snapped - value < 0 === direction < 0 ? snapped : snap(direction < 0 ? value - snapIncrementOrArray : value + snapIncrementOrArray);
    };
}, $82ba1e40433c64f0$var$_getLabelAtDirection = function _getLabelAtDirection(timeline) {
    return function(value, st) {
        return $82ba1e40433c64f0$var$_snapDirectional($82ba1e40433c64f0$var$_getLabelRatioArray(timeline))(value, st.direction);
    };
}, $82ba1e40433c64f0$var$_multiListener = function _multiListener(func, element, types, callback) {
    return types.split(",").forEach(function(type) {
        return func(element, type, callback);
    });
}, $82ba1e40433c64f0$var$_addListener = function _addListener(element, type, func, nonPassive, capture) {
    return element.addEventListener(type, func, {
        passive: !nonPassive,
        capture: !!capture
    });
}, $82ba1e40433c64f0$var$_removeListener = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
}, $82ba1e40433c64f0$var$_wheelListener = function _wheelListener(func, el, scrollFunc) {
    scrollFunc = scrollFunc && scrollFunc.wheelHandler;
    if (scrollFunc) {
        func(el, "wheel", scrollFunc);
        func(el, "touchmove", scrollFunc);
    }
}, $82ba1e40433c64f0$var$_markerDefaults = {
    startColor: "green",
    endColor: "red",
    indent: 0,
    fontSize: "16px",
    fontWeight: "normal"
}, $82ba1e40433c64f0$var$_defaults = {
    toggleActions: "play",
    anticipatePin: 0
}, $82ba1e40433c64f0$var$_keywords = {
    top: 0,
    left: 0,
    center: 0.5,
    bottom: 1,
    right: 1
}, $82ba1e40433c64f0$var$_offsetToPx = function _offsetToPx(value, size) {
    if ($82ba1e40433c64f0$var$_isString(value)) {
        var eqIndex = value.indexOf("="), relative = ~eqIndex ? +(value.charAt(eqIndex - 1) + 1) * parseFloat(value.substr(eqIndex + 1)) : 0;
        if (~eqIndex) {
            value.indexOf("%") > eqIndex && (relative *= size / 100);
            value = value.substr(0, eqIndex - 1);
        }
        value = relative + (value in $82ba1e40433c64f0$var$_keywords ? $82ba1e40433c64f0$var$_keywords[value] * size : ~value.indexOf("%") ? parseFloat(value) * size / 100 : parseFloat(value) || 0);
    }
    return value;
}, $82ba1e40433c64f0$var$_createMarker = function _createMarker(type, name, container, direction, _ref4, offset, matchWidthEl, containerAnimation) {
    var startColor = _ref4.startColor, endColor = _ref4.endColor, fontSize = _ref4.fontSize, indent = _ref4.indent, fontWeight = _ref4.fontWeight;
    var e = $82ba1e40433c64f0$var$_doc.createElement("div"), useFixedPosition = $82ba1e40433c64f0$var$_isViewport(container) || (0, $2796a7dcea5802d4$export$6078f1ef08b38af9)(container, "pinType") === "fixed", isScroller = type.indexOf("scroller") !== -1, parent = useFixedPosition ? $82ba1e40433c64f0$var$_body : container, isStart = type.indexOf("start") !== -1, color = isStart ? startColor : endColor, css = "border-color:" + color + ";font-size:" + fontSize + ";color:" + color + ";font-weight:" + fontWeight + ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
    css += "position:" + ((isScroller || containerAnimation) && useFixedPosition ? "fixed;" : "absolute;");
    (isScroller || containerAnimation || !useFixedPosition) && (css += (direction === (0, $2796a7dcea5802d4$export$8e40fc98ff518e9d) ? $82ba1e40433c64f0$var$_right : $82ba1e40433c64f0$var$_bottom) + ":" + (offset + parseFloat(indent)) + "px;");
    matchWidthEl && (css += "box-sizing:border-box;text-align:left;width:" + matchWidthEl.offsetWidth + "px;");
    e._isStart = isStart;
    e.setAttribute("class", "gsap-marker-" + type + (name ? " marker-" + name : ""));
    e.style.cssText = css;
    e.innerText = name || name === 0 ? type + "-" + name : type;
    parent.children[0] ? parent.insertBefore(e, parent.children[0]) : parent.appendChild(e);
    e._offset = e["offset" + direction.op.d2];
    $82ba1e40433c64f0$var$_positionMarker(e, 0, direction, isStart);
    return e;
}, $82ba1e40433c64f0$var$_positionMarker = function _positionMarker(marker, start, direction, flipped) {
    var vars = {
        display: "block"
    }, side = direction[flipped ? "os2" : "p2"], oppositeSide = direction[flipped ? "p2" : "os2"];
    marker._isFlipped = flipped;
    vars[direction.a + "Percent"] = flipped ? -100 : 0;
    vars[direction.a] = flipped ? "1px" : 0;
    vars["border" + side + $82ba1e40433c64f0$var$_Width] = 1;
    vars["border" + oppositeSide + $82ba1e40433c64f0$var$_Width] = 0;
    vars[direction.p] = start + "px";
    $82ba1e40433c64f0$var$gsap.set(marker, vars);
}, $82ba1e40433c64f0$var$_triggers = [], $82ba1e40433c64f0$var$_ids = {}, $82ba1e40433c64f0$var$_rafID, $82ba1e40433c64f0$var$_sync = function _sync() {
    return $82ba1e40433c64f0$var$_getTime() - $82ba1e40433c64f0$var$_lastScrollTime > 34 && ($82ba1e40433c64f0$var$_rafID || ($82ba1e40433c64f0$var$_rafID = requestAnimationFrame($82ba1e40433c64f0$var$_updateAll)));
}, $82ba1e40433c64f0$var$_onScroll = function _onScroll() {
    // previously, we tried to optimize performance by batching/deferring to the next requestAnimationFrame(), but discovered that Safari has a few bugs that make this unworkable (especially on iOS). See https://codepen.io/GreenSock/pen/16c435b12ef09c38125204818e7b45fc?editors=0010 and https://codepen.io/GreenSock/pen/JjOxYpQ/3dd65ccec5a60f1d862c355d84d14562?editors=0010 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503?editors=0010
    if (!$82ba1e40433c64f0$var$_normalizer || !$82ba1e40433c64f0$var$_normalizer.isPressed || $82ba1e40433c64f0$var$_normalizer.startX > $82ba1e40433c64f0$var$_body.clientWidth) {
        // if the user is dragging the scrollbar, allow it.
        (0, $2796a7dcea5802d4$export$3cd1cee43d19b683).cache++;
        if ($82ba1e40433c64f0$var$_normalizer) $82ba1e40433c64f0$var$_rafID || ($82ba1e40433c64f0$var$_rafID = requestAnimationFrame($82ba1e40433c64f0$var$_updateAll));
        else $82ba1e40433c64f0$var$_updateAll(); // Safari in particular (on desktop) NEEDS the immediate update rather than waiting for a requestAnimationFrame() whereas iOS seems to benefit from waiting for the requestAnimationFrame() tick, at least when normalizing. See https://codepen.io/GreenSock/pen/qBYozqO?editors=0110
        $82ba1e40433c64f0$var$_lastScrollTime || $82ba1e40433c64f0$var$_dispatch("scrollStart");
        $82ba1e40433c64f0$var$_lastScrollTime = $82ba1e40433c64f0$var$_getTime();
    }
}, $82ba1e40433c64f0$var$_setBaseDimensions = function _setBaseDimensions() {
    $82ba1e40433c64f0$var$_baseScreenWidth = $82ba1e40433c64f0$var$_win.innerWidth;
    $82ba1e40433c64f0$var$_baseScreenHeight = $82ba1e40433c64f0$var$_win.innerHeight;
}, $82ba1e40433c64f0$var$_onResize = function _onResize(force) {
    (0, $2796a7dcea5802d4$export$3cd1cee43d19b683).cache++;
    (force === true || !$82ba1e40433c64f0$var$_refreshing && !$82ba1e40433c64f0$var$_ignoreResize && !$82ba1e40433c64f0$var$_doc.fullscreenElement && !$82ba1e40433c64f0$var$_doc.webkitFullscreenElement && (!$82ba1e40433c64f0$var$_ignoreMobileResize || $82ba1e40433c64f0$var$_baseScreenWidth !== $82ba1e40433c64f0$var$_win.innerWidth || Math.abs($82ba1e40433c64f0$var$_win.innerHeight - $82ba1e40433c64f0$var$_baseScreenHeight) > $82ba1e40433c64f0$var$_win.innerHeight * 0.25)) && $82ba1e40433c64f0$var$_resizeDelay.restart(true);
}, // ignore resizes triggered by refresh()
$82ba1e40433c64f0$var$_listeners = {}, $82ba1e40433c64f0$var$_emptyArray = [], $82ba1e40433c64f0$var$_softRefresh = function _softRefresh() {
    return $82ba1e40433c64f0$var$_removeListener($82ba1e40433c64f0$export$875bcbe48555930, "scrollEnd", _softRefresh) || $82ba1e40433c64f0$var$_refreshAll(true);
}, $82ba1e40433c64f0$var$_dispatch = function _dispatch(type) {
    return $82ba1e40433c64f0$var$_listeners[type] && $82ba1e40433c64f0$var$_listeners[type].map(function(f) {
        return f();
    }) || $82ba1e40433c64f0$var$_emptyArray;
}, $82ba1e40433c64f0$var$_savedStyles = [], // when ScrollTrigger.saveStyles() is called, the inline styles are recorded in this Array in a sequential format like [element, cssText, gsCache, media]. This keeps it very memory-efficient and fast to iterate through.
$82ba1e40433c64f0$var$_revertRecorded = function _revertRecorded(media) {
    for(var i = 0; i < $82ba1e40433c64f0$var$_savedStyles.length; i += 5)if (!media || $82ba1e40433c64f0$var$_savedStyles[i + 4] && $82ba1e40433c64f0$var$_savedStyles[i + 4].query === media) {
        $82ba1e40433c64f0$var$_savedStyles[i].style.cssText = $82ba1e40433c64f0$var$_savedStyles[i + 1];
        $82ba1e40433c64f0$var$_savedStyles[i].getBBox && $82ba1e40433c64f0$var$_savedStyles[i].setAttribute("transform", $82ba1e40433c64f0$var$_savedStyles[i + 2] || "");
        $82ba1e40433c64f0$var$_savedStyles[i + 3].uncache = 1;
    }
}, $82ba1e40433c64f0$var$_recordScrollPositions = function _recordScrollPositions() {
    return (0, $2796a7dcea5802d4$export$3cd1cee43d19b683).forEach(function(obj) {
        return $82ba1e40433c64f0$var$_isFunction(obj) && ++obj.cacheID && (obj.rec = obj());
    });
}, // record the current scroll position. Also force the clearing of the cache because some browsers take a little while to dispatch the "scroll" event and the user may have changed the scroll position and then called ScrollTrigger.refresh() right away
$82ba1e40433c64f0$var$_revertAll = function _revertAll(kill, media) {
    var trigger;
    for($82ba1e40433c64f0$var$_i = 0; $82ba1e40433c64f0$var$_i < $82ba1e40433c64f0$var$_triggers.length; $82ba1e40433c64f0$var$_i++){
        trigger = $82ba1e40433c64f0$var$_triggers[$82ba1e40433c64f0$var$_i];
        if (trigger && (!media || trigger._ctx === media)) {
            if (kill) trigger.kill(1);
            else trigger.revert(true, true);
        }
    }
    $82ba1e40433c64f0$var$_isReverted = true;
    media && $82ba1e40433c64f0$var$_revertRecorded(media);
    media || $82ba1e40433c64f0$var$_dispatch("revert");
}, $82ba1e40433c64f0$var$_clearScrollMemory = function _clearScrollMemory(scrollRestoration, force) {
    // zero-out all the recorded scroll positions. Don't use _triggers because if, for example, .matchMedia() is used to create some ScrollTriggers and then the user resizes and it removes ALL ScrollTriggers, and then go back to a size where there are ScrollTriggers, it would have kept the position(s) saved from the initial state.
    (0, $2796a7dcea5802d4$export$3cd1cee43d19b683).cache++;
    (force || !$82ba1e40433c64f0$var$_refreshingAll) && (0, $2796a7dcea5802d4$export$3cd1cee43d19b683).forEach(function(obj) {
        return $82ba1e40433c64f0$var$_isFunction(obj) && obj.cacheID++ && (obj.rec = 0);
    });
    $82ba1e40433c64f0$var$_isString(scrollRestoration) && ($82ba1e40433c64f0$var$_win.history.scrollRestoration = $82ba1e40433c64f0$var$_scrollRestoration = scrollRestoration);
}, $82ba1e40433c64f0$var$_refreshingAll, $82ba1e40433c64f0$var$_refreshID = 0, $82ba1e40433c64f0$var$_queueRefreshID, $82ba1e40433c64f0$var$_queueRefreshAll = function _queueRefreshAll() {
    // we don't want to call _refreshAll() every time we create a new ScrollTrigger (for performance reasons) - it's better to batch them. Some frameworks dynamically load content and we can't rely on the window's "load" or "DOMContentLoaded" events to trigger it.
    if ($82ba1e40433c64f0$var$_queueRefreshID !== $82ba1e40433c64f0$var$_refreshID) {
        var id = $82ba1e40433c64f0$var$_queueRefreshID = $82ba1e40433c64f0$var$_refreshID;
        requestAnimationFrame(function() {
            return id === $82ba1e40433c64f0$var$_refreshID && $82ba1e40433c64f0$var$_refreshAll(true);
        });
    }
}, $82ba1e40433c64f0$var$_refresh100vh = function _refresh100vh() {
    $82ba1e40433c64f0$var$_body.appendChild($82ba1e40433c64f0$var$_div100vh);
    $82ba1e40433c64f0$var$_100vh = !$82ba1e40433c64f0$var$_normalizer && $82ba1e40433c64f0$var$_div100vh.offsetHeight || $82ba1e40433c64f0$var$_win.innerHeight;
    $82ba1e40433c64f0$var$_body.removeChild($82ba1e40433c64f0$var$_div100vh);
}, $82ba1e40433c64f0$var$_hideAllMarkers = function _hideAllMarkers(hide) {
    return $82ba1e40433c64f0$var$_toArray(".gsap-marker-start, .gsap-marker-end, .gsap-marker-scroller-start, .gsap-marker-scroller-end").forEach(function(el) {
        return el.style.display = hide ? "none" : "block";
    });
}, $82ba1e40433c64f0$var$_refreshAll = function _refreshAll(force, skipRevert) {
    $82ba1e40433c64f0$var$_docEl = $82ba1e40433c64f0$var$_doc.documentElement; // some frameworks like Astro may cache the <body> and replace it during routing, so we'll just re-record the _docEl and _body for safety (otherwise, the markers may not get added properly).
    $82ba1e40433c64f0$var$_body = $82ba1e40433c64f0$var$_doc.body;
    $82ba1e40433c64f0$var$_root = [
        $82ba1e40433c64f0$var$_win,
        $82ba1e40433c64f0$var$_doc,
        $82ba1e40433c64f0$var$_docEl,
        $82ba1e40433c64f0$var$_body
    ];
    if ($82ba1e40433c64f0$var$_lastScrollTime && !force && !$82ba1e40433c64f0$var$_isReverted) {
        $82ba1e40433c64f0$var$_addListener($82ba1e40433c64f0$export$875bcbe48555930, "scrollEnd", $82ba1e40433c64f0$var$_softRefresh);
        return;
    }
    $82ba1e40433c64f0$var$_refresh100vh();
    $82ba1e40433c64f0$var$_refreshingAll = $82ba1e40433c64f0$export$875bcbe48555930.isRefreshing = true;
    $82ba1e40433c64f0$var$_isReverted || $82ba1e40433c64f0$var$_recordScrollPositions();
    var refreshInits = $82ba1e40433c64f0$var$_dispatch("refreshInit");
    $82ba1e40433c64f0$var$_sort && $82ba1e40433c64f0$export$875bcbe48555930.sort();
    skipRevert || $82ba1e40433c64f0$var$_revertAll();
    (0, $2796a7dcea5802d4$export$3cd1cee43d19b683).forEach(function(obj) {
        if ($82ba1e40433c64f0$var$_isFunction(obj)) {
            obj.smooth && (obj.target.style.scrollBehavior = "auto"); // smooth scrolling interferes
            obj(0);
        }
    });
    $82ba1e40433c64f0$var$_triggers.slice(0).forEach(function(t) {
        return t.refresh();
    }); // don't loop with _i because during a refresh() someone could call ScrollTrigger.update() which would iterate through _i resulting in a skip.
    $82ba1e40433c64f0$var$_isReverted = false;
    $82ba1e40433c64f0$var$_triggers.forEach(function(t) {
        // nested pins (pinnedContainer) with pinSpacing may expand the container, so we must accommodate that here.
        if (t._subPinOffset && t.pin) {
            var prop = t.vars.horizontal ? "offsetWidth" : "offsetHeight", original = t.pin[prop];
            t.revert(true, 1);
            t.adjustPinSpacing(t.pin[prop] - original);
            t.refresh();
        }
    });
    $82ba1e40433c64f0$var$_clampingMax = 1; // pinSpacing might be propping a page open, thus when we .setPositions() to clamp a ScrollTrigger's end we should leave the pinSpacing alone. That's what this flag is for.
    $82ba1e40433c64f0$var$_hideAllMarkers(true);
    $82ba1e40433c64f0$var$_triggers.forEach(function(t) {
        // the scroller's max scroll position may change after all the ScrollTriggers refreshed (like pinning could push it down), so we need to loop back and correct any with end: "max". Same for anything with a clamped end
        var max = $82ba1e40433c64f0$var$_maxScroll(t.scroller, t._dir), endClamp = t.vars.end === "max" || t._endClamp && t.end > max, startClamp = t._startClamp && t.start >= max;
        (endClamp || startClamp) && t.setPositions(startClamp ? max - 1 : t.start, endClamp ? Math.max(startClamp ? max : t.start + 1, max) : t.end, true);
    });
    $82ba1e40433c64f0$var$_hideAllMarkers(false);
    $82ba1e40433c64f0$var$_clampingMax = 0;
    refreshInits.forEach(function(result) {
        return result && result.render && result.render(-1);
    }); // if the onRefreshInit() returns an animation (typically a gsap.set()), revert it. This makes it easy to put things in a certain spot before refreshing for measurement purposes, and then put things back.
    (0, $2796a7dcea5802d4$export$3cd1cee43d19b683).forEach(function(obj) {
        if ($82ba1e40433c64f0$var$_isFunction(obj)) {
            obj.smooth && requestAnimationFrame(function() {
                return obj.target.style.scrollBehavior = "smooth";
            });
            obj.rec && obj(obj.rec);
        }
    });
    $82ba1e40433c64f0$var$_clearScrollMemory($82ba1e40433c64f0$var$_scrollRestoration, 1);
    $82ba1e40433c64f0$var$_resizeDelay.pause();
    $82ba1e40433c64f0$var$_refreshID++;
    $82ba1e40433c64f0$var$_refreshingAll = 2;
    $82ba1e40433c64f0$var$_updateAll(2);
    $82ba1e40433c64f0$var$_triggers.forEach(function(t) {
        return $82ba1e40433c64f0$var$_isFunction(t.vars.onRefresh) && t.vars.onRefresh(t);
    });
    $82ba1e40433c64f0$var$_refreshingAll = $82ba1e40433c64f0$export$875bcbe48555930.isRefreshing = false;
    $82ba1e40433c64f0$var$_dispatch("refresh");
}, $82ba1e40433c64f0$var$_lastScroll = 0, $82ba1e40433c64f0$var$_direction = 1, $82ba1e40433c64f0$var$_primary, $82ba1e40433c64f0$var$_updateAll = function _updateAll(force) {
    if (force === 2 || !$82ba1e40433c64f0$var$_refreshingAll && !$82ba1e40433c64f0$var$_isReverted) {
        // _isReverted could be true if, for example, a matchMedia() is in the process of executing. We don't want to update during the time everything is reverted.
        $82ba1e40433c64f0$export$875bcbe48555930.isUpdating = true;
        $82ba1e40433c64f0$var$_primary && $82ba1e40433c64f0$var$_primary.update(0); // ScrollSmoother uses refreshPriority -9999 to become the primary that gets updated before all others because it affects the scroll position.
        var l = $82ba1e40433c64f0$var$_triggers.length, time = $82ba1e40433c64f0$var$_getTime(), recordVelocity = time - $82ba1e40433c64f0$var$_time1 >= 50, scroll = l && $82ba1e40433c64f0$var$_triggers[0].scroll();
        $82ba1e40433c64f0$var$_direction = $82ba1e40433c64f0$var$_lastScroll > scroll ? -1 : 1;
        $82ba1e40433c64f0$var$_refreshingAll || ($82ba1e40433c64f0$var$_lastScroll = scroll);
        if (recordVelocity) {
            if ($82ba1e40433c64f0$var$_lastScrollTime && !$82ba1e40433c64f0$var$_pointerIsDown && time - $82ba1e40433c64f0$var$_lastScrollTime > 200) {
                $82ba1e40433c64f0$var$_lastScrollTime = 0;
                $82ba1e40433c64f0$var$_dispatch("scrollEnd");
            }
            $82ba1e40433c64f0$var$_time2 = $82ba1e40433c64f0$var$_time1;
            $82ba1e40433c64f0$var$_time1 = time;
        }
        if ($82ba1e40433c64f0$var$_direction < 0) {
            $82ba1e40433c64f0$var$_i = l;
            while($82ba1e40433c64f0$var$_i-- > 0)$82ba1e40433c64f0$var$_triggers[$82ba1e40433c64f0$var$_i] && $82ba1e40433c64f0$var$_triggers[$82ba1e40433c64f0$var$_i].update(0, recordVelocity);
            $82ba1e40433c64f0$var$_direction = 1;
        } else for($82ba1e40433c64f0$var$_i = 0; $82ba1e40433c64f0$var$_i < l; $82ba1e40433c64f0$var$_i++)$82ba1e40433c64f0$var$_triggers[$82ba1e40433c64f0$var$_i] && $82ba1e40433c64f0$var$_triggers[$82ba1e40433c64f0$var$_i].update(0, recordVelocity);
        $82ba1e40433c64f0$export$875bcbe48555930.isUpdating = false;
    }
    $82ba1e40433c64f0$var$_rafID = 0;
}, $82ba1e40433c64f0$var$_propNamesToCopy = [
    $82ba1e40433c64f0$var$_left,
    $82ba1e40433c64f0$var$_top,
    $82ba1e40433c64f0$var$_bottom,
    $82ba1e40433c64f0$var$_right,
    $82ba1e40433c64f0$var$_margin + $82ba1e40433c64f0$var$_Bottom,
    $82ba1e40433c64f0$var$_margin + $82ba1e40433c64f0$var$_Right,
    $82ba1e40433c64f0$var$_margin + $82ba1e40433c64f0$var$_Top,
    $82ba1e40433c64f0$var$_margin + $82ba1e40433c64f0$var$_Left,
    "display",
    "flexShrink",
    "float",
    "zIndex",
    "gridColumnStart",
    "gridColumnEnd",
    "gridRowStart",
    "gridRowEnd",
    "gridArea",
    "justifySelf",
    "alignSelf",
    "placeSelf",
    "order"
], $82ba1e40433c64f0$var$_stateProps = $82ba1e40433c64f0$var$_propNamesToCopy.concat([
    $82ba1e40433c64f0$var$_width,
    $82ba1e40433c64f0$var$_height,
    "boxSizing",
    "max" + $82ba1e40433c64f0$var$_Width,
    "max" + $82ba1e40433c64f0$var$_Height,
    "position",
    $82ba1e40433c64f0$var$_margin,
    $82ba1e40433c64f0$var$_padding,
    $82ba1e40433c64f0$var$_padding + $82ba1e40433c64f0$var$_Top,
    $82ba1e40433c64f0$var$_padding + $82ba1e40433c64f0$var$_Right,
    $82ba1e40433c64f0$var$_padding + $82ba1e40433c64f0$var$_Bottom,
    $82ba1e40433c64f0$var$_padding + $82ba1e40433c64f0$var$_Left
]), $82ba1e40433c64f0$var$_swapPinOut = function _swapPinOut(pin, spacer, state) {
    $82ba1e40433c64f0$var$_setState(state);
    var cache = pin._gsap;
    if (cache.spacerIsNative) $82ba1e40433c64f0$var$_setState(cache.spacerState);
    else if (pin._gsap.swappedIn) {
        var parent = spacer.parentNode;
        if (parent) {
            parent.insertBefore(pin, spacer);
            parent.removeChild(spacer);
        }
    }
    pin._gsap.swappedIn = false;
}, $82ba1e40433c64f0$var$_swapPinIn = function _swapPinIn(pin, spacer, cs, spacerState) {
    if (!pin._gsap.swappedIn) {
        var i = $82ba1e40433c64f0$var$_propNamesToCopy.length, spacerStyle = spacer.style, pinStyle = pin.style, p;
        while(i--){
            p = $82ba1e40433c64f0$var$_propNamesToCopy[i];
            spacerStyle[p] = cs[p];
        }
        spacerStyle.position = cs.position === "absolute" ? "absolute" : "relative";
        cs.display === "inline" && (spacerStyle.display = "inline-block");
        pinStyle[$82ba1e40433c64f0$var$_bottom] = pinStyle[$82ba1e40433c64f0$var$_right] = "auto";
        spacerStyle.flexBasis = cs.flexBasis || "auto";
        spacerStyle.overflow = "visible";
        spacerStyle.boxSizing = "border-box";
        spacerStyle[$82ba1e40433c64f0$var$_width] = $82ba1e40433c64f0$var$_getSize(pin, (0, $2796a7dcea5802d4$export$b2cabb342cb0ebe1)) + $82ba1e40433c64f0$var$_px;
        spacerStyle[$82ba1e40433c64f0$var$_height] = $82ba1e40433c64f0$var$_getSize(pin, (0, $2796a7dcea5802d4$export$8e40fc98ff518e9d)) + $82ba1e40433c64f0$var$_px;
        spacerStyle[$82ba1e40433c64f0$var$_padding] = pinStyle[$82ba1e40433c64f0$var$_margin] = pinStyle[$82ba1e40433c64f0$var$_top] = pinStyle[$82ba1e40433c64f0$var$_left] = "0";
        $82ba1e40433c64f0$var$_setState(spacerState);
        pinStyle[$82ba1e40433c64f0$var$_width] = pinStyle["max" + $82ba1e40433c64f0$var$_Width] = cs[$82ba1e40433c64f0$var$_width];
        pinStyle[$82ba1e40433c64f0$var$_height] = pinStyle["max" + $82ba1e40433c64f0$var$_Height] = cs[$82ba1e40433c64f0$var$_height];
        pinStyle[$82ba1e40433c64f0$var$_padding] = cs[$82ba1e40433c64f0$var$_padding];
        if (pin.parentNode !== spacer) {
            pin.parentNode.insertBefore(spacer, pin);
            spacer.appendChild(pin);
        }
        pin._gsap.swappedIn = true;
    }
}, $82ba1e40433c64f0$var$_capsExp = /([A-Z])/g, $82ba1e40433c64f0$var$_setState = function _setState(state) {
    if (state) {
        var style = state.t.style, l = state.length, i = 0, p, value;
        (state.t._gsap || $82ba1e40433c64f0$var$gsap.core.getCache(state.t)).uncache = 1; // otherwise transforms may be off
        for(; i < l; i += 2){
            value = state[i + 1];
            p = state[i];
            if (value) style[p] = value;
            else if (style[p]) style.removeProperty(p.replace($82ba1e40433c64f0$var$_capsExp, "-$1").toLowerCase());
        }
    }
}, $82ba1e40433c64f0$var$_getState = function _getState(element) {
    // returns an Array with alternating values like [property, value, property, value] and a "t" property pointing to the target (element). Makes it fast and cheap.
    var l = $82ba1e40433c64f0$var$_stateProps.length, style = element.style, state = [], i = 0;
    for(; i < l; i++)state.push($82ba1e40433c64f0$var$_stateProps[i], style[$82ba1e40433c64f0$var$_stateProps[i]]);
    state.t = element;
    return state;
}, $82ba1e40433c64f0$var$_copyState = function _copyState(state, override, omitOffsets) {
    var result = [], l = state.length, i = omitOffsets ? 8 : 0, // skip top, left, right, bottom if omitOffsets is true
    p;
    for(; i < l; i += 2){
        p = state[i];
        result.push(p, p in override ? override[p] : state[i + 1]);
    }
    result.t = state.t;
    return result;
}, $82ba1e40433c64f0$var$_winOffsets = {
    left: 0,
    top: 0
}, // // potential future feature (?) Allow users to calculate where a trigger hits (scroll position) like getScrollPosition("#id", "top bottom")
// _getScrollPosition = (trigger, position, {scroller, containerAnimation, horizontal}) => {
// 	scroller = _getTarget(scroller || _win);
// 	let direction = horizontal ? _horizontal : _vertical,
// 		isViewport = _isViewport(scroller);
// 	_getSizeFunc(scroller, isViewport, direction);
// 	return _parsePosition(position, _getTarget(trigger), _getSizeFunc(scroller, isViewport, direction)(), direction, _getScrollFunc(scroller, direction)(), 0, 0, 0, _getOffsetsFunc(scroller, isViewport)(), isViewport ? 0 : parseFloat(_getComputedStyle(scroller)["border" + direction.p2 + _Width]) || 0, 0, containerAnimation ? containerAnimation.duration() : _maxScroll(scroller), containerAnimation);
// },
$82ba1e40433c64f0$var$_parsePosition = function _parsePosition(value, trigger, scrollerSize, direction, scroll, marker, markerScroller, self, scrollerBounds, borderWidth, useFixedPosition, scrollerMax, containerAnimation, clampZeroProp) {
    $82ba1e40433c64f0$var$_isFunction(value) && (value = value(self));
    if ($82ba1e40433c64f0$var$_isString(value) && value.substr(0, 3) === "max") value = scrollerMax + (value.charAt(4) === "=" ? $82ba1e40433c64f0$var$_offsetToPx("0" + value.substr(3), scrollerSize) : 0);
    var time = containerAnimation ? containerAnimation.time() : 0, p1, p2, element;
    containerAnimation && containerAnimation.seek(0);
    isNaN(value) || (value = +value); // convert a string number like "45" to an actual number
    if (!$82ba1e40433c64f0$var$_isNumber(value)) {
        $82ba1e40433c64f0$var$_isFunction(trigger) && (trigger = trigger(self));
        var offsets = (value || "0").split(" "), bounds, localOffset, globalOffset, display;
        element = (0, $2796a7dcea5802d4$export$937374fea3f88711)(trigger, self) || $82ba1e40433c64f0$var$_body;
        bounds = $82ba1e40433c64f0$var$_getBounds(element) || {};
        if ((!bounds || !bounds.left && !bounds.top) && $82ba1e40433c64f0$var$_getComputedStyle(element).display === "none") {
            // if display is "none", it won't report getBoundingClientRect() properly
            display = element.style.display;
            element.style.display = "block";
            bounds = $82ba1e40433c64f0$var$_getBounds(element);
            display ? element.style.display = display : element.style.removeProperty("display");
        }
        localOffset = $82ba1e40433c64f0$var$_offsetToPx(offsets[0], bounds[direction.d]);
        globalOffset = $82ba1e40433c64f0$var$_offsetToPx(offsets[1] || "0", scrollerSize);
        value = bounds[direction.p] - scrollerBounds[direction.p] - borderWidth + localOffset + scroll - globalOffset;
        markerScroller && $82ba1e40433c64f0$var$_positionMarker(markerScroller, globalOffset, direction, scrollerSize - globalOffset < 20 || markerScroller._isStart && globalOffset > 20);
        scrollerSize -= scrollerSize - globalOffset; // adjust for the marker
    } else {
        containerAnimation && (value = $82ba1e40433c64f0$var$gsap.utils.mapRange(containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, 0, scrollerMax, value));
        markerScroller && $82ba1e40433c64f0$var$_positionMarker(markerScroller, scrollerSize, direction, true);
    }
    if (clampZeroProp) {
        self[clampZeroProp] = value || -0.001;
        value < 0 && (value = 0);
    }
    if (marker) {
        var position = value + scrollerSize, isStart = marker._isStart;
        p1 = "scroll" + direction.d2;
        $82ba1e40433c64f0$var$_positionMarker(marker, position, direction, isStart && position > 20 || !isStart && (useFixedPosition ? Math.max($82ba1e40433c64f0$var$_body[p1], $82ba1e40433c64f0$var$_docEl[p1]) : marker.parentNode[p1]) <= position + 1);
        if (useFixedPosition) {
            scrollerBounds = $82ba1e40433c64f0$var$_getBounds(markerScroller);
            useFixedPosition && (marker.style[direction.op.p] = scrollerBounds[direction.op.p] - direction.op.m - marker._offset + $82ba1e40433c64f0$var$_px);
        }
    }
    if (containerAnimation && element) {
        p1 = $82ba1e40433c64f0$var$_getBounds(element);
        containerAnimation.seek(scrollerMax);
        p2 = $82ba1e40433c64f0$var$_getBounds(element);
        containerAnimation._caScrollDist = p1[direction.p] - p2[direction.p];
        value = value / containerAnimation._caScrollDist * scrollerMax;
    }
    containerAnimation && containerAnimation.seek(time);
    return containerAnimation ? value : Math.round(value);
}, $82ba1e40433c64f0$var$_prefixExp = /(webkit|moz|length|cssText|inset)/i, $82ba1e40433c64f0$var$_reparent = function _reparent(element, parent, top, left) {
    if (element.parentNode !== parent) {
        var style = element.style, p, cs;
        if (parent === $82ba1e40433c64f0$var$_body) {
            element._stOrig = style.cssText; // record original inline styles so we can revert them later
            cs = $82ba1e40433c64f0$var$_getComputedStyle(element);
            for(p in cs)// must copy all relevant styles to ensure that nothing changes visually when we reparent to the <body>. Skip the vendor prefixed ones.
            if (!+p && !$82ba1e40433c64f0$var$_prefixExp.test(p) && cs[p] && typeof style[p] === "string" && p !== "0") style[p] = cs[p];
            style.top = top;
            style.left = left;
        } else style.cssText = element._stOrig;
        $82ba1e40433c64f0$var$gsap.core.getCache(element).uncache = 1;
        parent.appendChild(element);
    }
}, $82ba1e40433c64f0$var$_interruptionTracker = function _interruptionTracker(getValueFunc, initialValue, onInterrupt) {
    var last1 = initialValue, last2 = last1;
    return function(value) {
        var current = Math.round(getValueFunc()); // round because in some [very uncommon] Windows environments, scroll can get reported with decimals even though it was set without.
        if (current !== last1 && current !== last2 && Math.abs(current - last1) > 3 && Math.abs(current - last2) > 3) {
            // if the user scrolls, kill the tween. iOS Safari intermittently misreports the scroll position, it may be the most recently-set one or the one before that! When Safari is zoomed (CMD-+), it often misreports as 1 pixel off too! So if we set the scroll position to 125, for example, it'll actually report it as 124.
            value = current;
            onInterrupt && onInterrupt();
        }
        last2 = last1;
        last1 = Math.round(value);
        return last1;
    };
}, $82ba1e40433c64f0$var$_shiftMarker = function _shiftMarker(marker, direction, value) {
    var vars = {};
    vars[direction.p] = "+=" + value;
    $82ba1e40433c64f0$var$gsap.set(marker, vars);
}, // _mergeAnimations = animations => {
// 	let tl = gsap.timeline({smoothChildTiming: true}).startTime(Math.min(...animations.map(a => a.globalTime(0))));
// 	animations.forEach(a => {let time = a.totalTime(); tl.add(a); a.totalTime(time); });
// 	tl.smoothChildTiming = false;
// 	return tl;
// },
// returns a function that can be used to tween the scroll position in the direction provided, and when doing so it'll add a .tween property to the FUNCTION itself, and remove it when the tween completes or gets killed. This gives us a way to have multiple ScrollTriggers use a central function for any given scroller and see if there's a scroll tween running (which would affect if/how things get updated)
$82ba1e40433c64f0$var$_getTweenCreator = function _getTweenCreator(scroller, direction) {
    var getScroll = (0, $2796a7dcea5802d4$export$8665aac53dad5647)(scroller, direction), prop = "_scroll" + direction.p2, // add a tweenable property to the scroller that's a getter/setter function, like _scrollTop or _scrollLeft. This way, if someone does gsap.killTweensOf(scroller) it'll kill the scroll tween.
    getTween = function getTween(scrollTo, vars, initialValue, change1, change2) {
        var tween = getTween.tween, onComplete = vars.onComplete, modifiers = {};
        initialValue = initialValue || getScroll();
        var checkForInterruption = $82ba1e40433c64f0$var$_interruptionTracker(getScroll, initialValue, function() {
            tween.kill();
            getTween.tween = 0;
        });
        change2 = change1 && change2 || 0; // if change1 is 0, we set that to the difference and ignore change2. Otherwise, there would be a compound effect.
        change1 = change1 || scrollTo - initialValue;
        tween && tween.kill();
        vars[prop] = scrollTo;
        vars.inherit = false;
        vars.modifiers = modifiers;
        modifiers[prop] = function() {
            return checkForInterruption(initialValue + change1 * tween.ratio + change2 * tween.ratio * tween.ratio);
        };
        vars.onUpdate = function() {
            (0, $2796a7dcea5802d4$export$3cd1cee43d19b683).cache++;
            getTween.tween && $82ba1e40433c64f0$var$_updateAll(); // if it was interrupted/killed, like in a context.revert(), don't force an updateAll()
        };
        vars.onComplete = function() {
            getTween.tween = 0;
            onComplete && onComplete.call(tween);
        };
        tween = getTween.tween = $82ba1e40433c64f0$var$gsap.to(scroller, vars);
        return tween;
    };
    scroller[prop] = getScroll;
    getScroll.wheelHandler = function() {
        return getTween.tween && getTween.tween.kill() && (getTween.tween = 0);
    };
    $82ba1e40433c64f0$var$_addListener(scroller, "wheel", getScroll.wheelHandler); // Windows machines handle mousewheel scrolling in chunks (like "3 lines per scroll") meaning the typical strategy for cancelling the scroll isn't as sensitive. It's much more likely to match one of the previous 2 scroll event positions. So we kill any snapping as soon as there's a wheel event.
    $82ba1e40433c64f0$export$875bcbe48555930.isTouch && $82ba1e40433c64f0$var$_addListener(scroller, "touchmove", getScroll.wheelHandler);
    return getTween;
};
var $82ba1e40433c64f0$export$875bcbe48555930 = /*#__PURE__*/ function() {
    function ScrollTrigger(vars, animation) {
        $82ba1e40433c64f0$var$_coreInitted || ScrollTrigger.register($82ba1e40433c64f0$var$gsap) || console.warn("Please gsap.registerPlugin(ScrollTrigger)");
        $82ba1e40433c64f0$var$_context(this);
        this.init(vars, animation);
    }
    var _proto = ScrollTrigger.prototype;
    _proto.init = function init(vars, animation) {
        this.progress = this.start = 0;
        this.vars && this.kill(true, true); // in case it's being initted again
        if (!$82ba1e40433c64f0$var$_enabled) {
            this.update = this.refresh = this.kill = $82ba1e40433c64f0$var$_passThrough;
            return;
        }
        vars = $82ba1e40433c64f0$var$_setDefaults($82ba1e40433c64f0$var$_isString(vars) || $82ba1e40433c64f0$var$_isNumber(vars) || vars.nodeType ? {
            trigger: vars
        } : vars, $82ba1e40433c64f0$var$_defaults);
        var _vars = vars, onUpdate = _vars.onUpdate, toggleClass = _vars.toggleClass, id = _vars.id, onToggle = _vars.onToggle, onRefresh = _vars.onRefresh, scrub = _vars.scrub, trigger = _vars.trigger, pin = _vars.pin, pinSpacing = _vars.pinSpacing, invalidateOnRefresh = _vars.invalidateOnRefresh, anticipatePin = _vars.anticipatePin, onScrubComplete = _vars.onScrubComplete, onSnapComplete = _vars.onSnapComplete, once = _vars.once, snap = _vars.snap, pinReparent = _vars.pinReparent, pinSpacer = _vars.pinSpacer, containerAnimation = _vars.containerAnimation, fastScrollEnd = _vars.fastScrollEnd, preventOverlaps = _vars.preventOverlaps, direction = vars.horizontal || vars.containerAnimation && vars.horizontal !== false ? (0, $2796a7dcea5802d4$export$b2cabb342cb0ebe1) : (0, $2796a7dcea5802d4$export$8e40fc98ff518e9d), isToggle = !scrub && scrub !== 0, scroller = (0, $2796a7dcea5802d4$export$937374fea3f88711)(vars.scroller || $82ba1e40433c64f0$var$_win), scrollerCache = $82ba1e40433c64f0$var$gsap.core.getCache(scroller), isViewport = $82ba1e40433c64f0$var$_isViewport(scroller), useFixedPosition = ("pinType" in vars ? vars.pinType : (0, $2796a7dcea5802d4$export$6078f1ef08b38af9)(scroller, "pinType") || isViewport && "fixed") === "fixed", callbacks = [
            vars.onEnter,
            vars.onLeave,
            vars.onEnterBack,
            vars.onLeaveBack
        ], toggleActions = isToggle && vars.toggleActions.split(" "), markers = "markers" in vars ? vars.markers : $82ba1e40433c64f0$var$_defaults.markers, borderWidth = isViewport ? 0 : parseFloat($82ba1e40433c64f0$var$_getComputedStyle(scroller)["border" + direction.p2 + $82ba1e40433c64f0$var$_Width]) || 0, self = this, onRefreshInit = vars.onRefreshInit && function() {
            return vars.onRefreshInit(self);
        }, getScrollerSize = $82ba1e40433c64f0$var$_getSizeFunc(scroller, isViewport, direction), getScrollerOffsets = $82ba1e40433c64f0$var$_getOffsetsFunc(scroller, isViewport), lastSnap = 0, lastRefresh = 0, prevProgress = 0, scrollFunc = (0, $2796a7dcea5802d4$export$8665aac53dad5647)(scroller, direction), tweenTo, pinCache, snapFunc, scroll1, scroll2, start, end, markerStart, markerEnd, markerStartTrigger, markerEndTrigger, markerVars, executingOnRefresh, change, pinOriginalState, pinActiveState, pinState, spacer, offset, pinGetter, pinSetter, pinStart, pinChange, spacingStart, spacerState, markerStartSetter, pinMoves, markerEndSetter, cs, snap1, snap2, scrubTween, scrubSmooth, snapDurClamp, snapDelayedCall, prevScroll, prevAnimProgress, caMarkerSetter, customRevertReturn; // for the sake of efficiency, _startClamp/_endClamp serve like a truthy value indicating that clamping was enabled on the start/end, and ALSO store the actual pre-clamped numeric value. We tap into that in ScrollSmoother for speed effects. So for example, if start="clamp(top bottom)" results in a start of -100 naturally, it would get clamped to 0 but -100 would be stored in _startClamp.
        self._startClamp = self._endClamp = false;
        self._dir = direction;
        anticipatePin *= 45;
        self.scroller = scroller;
        self.scroll = containerAnimation ? containerAnimation.time.bind(containerAnimation) : scrollFunc;
        scroll1 = scrollFunc();
        self.vars = vars;
        animation = animation || vars.animation;
        if ("refreshPriority" in vars) {
            $82ba1e40433c64f0$var$_sort = 1;
            vars.refreshPriority === -9999 && ($82ba1e40433c64f0$var$_primary = self); // used by ScrollSmoother
        }
        scrollerCache.tweenScroll = scrollerCache.tweenScroll || {
            top: $82ba1e40433c64f0$var$_getTweenCreator(scroller, (0, $2796a7dcea5802d4$export$8e40fc98ff518e9d)),
            left: $82ba1e40433c64f0$var$_getTweenCreator(scroller, (0, $2796a7dcea5802d4$export$b2cabb342cb0ebe1))
        };
        self.tweenTo = tweenTo = scrollerCache.tweenScroll[direction.p];
        self.scrubDuration = function(value) {
            scrubSmooth = $82ba1e40433c64f0$var$_isNumber(value) && value;
            if (!scrubSmooth) {
                scrubTween && scrubTween.progress(1).kill();
                scrubTween = 0;
            } else scrubTween ? scrubTween.duration(value) : scrubTween = $82ba1e40433c64f0$var$gsap.to(animation, {
                ease: "expo",
                totalProgress: "+=0",
                inherit: false,
                duration: scrubSmooth,
                paused: true,
                onComplete: function onComplete() {
                    return onScrubComplete && onScrubComplete(self);
                }
            });
        };
        if (animation) {
            animation.vars.lazy = false;
            animation._initted && !self.isReverted || animation.vars.immediateRender !== false && vars.immediateRender !== false && animation.duration() && animation.render(0, true, true); // special case: if this ScrollTrigger gets re-initted, a from() tween with a stagger could get initted initially and then reverted on the re-init which means it'll need to get rendered again here to properly display things. Otherwise, See https://gsap.com/forums/topic/36777-scrollsmoother-splittext-nextjs/ and https://codepen.io/GreenSock/pen/eYPyPpd?editors=0010
            self.animation = animation.pause();
            animation.scrollTrigger = self;
            self.scrubDuration(scrub);
            snap1 = 0;
            id || (id = animation.vars.id);
        }
        if (snap) {
            // TODO: potential idea: use legitimate CSS scroll snapping by pushing invisible elements into the DOM that serve as snap positions, and toggle the document.scrollingElement.style.scrollSnapType onToggle. See https://codepen.io/GreenSock/pen/JjLrgWM for a quick proof of concept.
            if (!$82ba1e40433c64f0$var$_isObject(snap) || snap.push) snap = {
                snapTo: snap
            };
            "scrollBehavior" in $82ba1e40433c64f0$var$_body.style && $82ba1e40433c64f0$var$gsap.set(isViewport ? [
                $82ba1e40433c64f0$var$_body,
                $82ba1e40433c64f0$var$_docEl
            ] : scroller, {
                scrollBehavior: "auto"
            }); // smooth scrolling doesn't work with snap.
            (0, $2796a7dcea5802d4$export$3cd1cee43d19b683).forEach(function(o) {
                return $82ba1e40433c64f0$var$_isFunction(o) && o.target === (isViewport ? $82ba1e40433c64f0$var$_doc.scrollingElement || $82ba1e40433c64f0$var$_docEl : scroller) && (o.smooth = false);
            }); // note: set smooth to false on both the vertical and horizontal scroll getters/setters
            snapFunc = $82ba1e40433c64f0$var$_isFunction(snap.snapTo) ? snap.snapTo : snap.snapTo === "labels" ? $82ba1e40433c64f0$var$_getClosestLabel(animation) : snap.snapTo === "labelsDirectional" ? $82ba1e40433c64f0$var$_getLabelAtDirection(animation) : snap.directional !== false ? function(value, st) {
                return $82ba1e40433c64f0$var$_snapDirectional(snap.snapTo)(value, $82ba1e40433c64f0$var$_getTime() - lastRefresh < 500 ? 0 : st.direction);
            } : $82ba1e40433c64f0$var$gsap.utils.snap(snap.snapTo);
            snapDurClamp = snap.duration || {
                min: 0.1,
                max: 2
            };
            snapDurClamp = $82ba1e40433c64f0$var$_isObject(snapDurClamp) ? $82ba1e40433c64f0$var$_clamp(snapDurClamp.min, snapDurClamp.max) : $82ba1e40433c64f0$var$_clamp(snapDurClamp, snapDurClamp);
            snapDelayedCall = $82ba1e40433c64f0$var$gsap.delayedCall(snap.delay || scrubSmooth / 2 || 0.1, function() {
                var scroll = scrollFunc(), refreshedRecently = $82ba1e40433c64f0$var$_getTime() - lastRefresh < 500, tween = tweenTo.tween;
                if ((refreshedRecently || Math.abs(self.getVelocity()) < 10) && !tween && !$82ba1e40433c64f0$var$_pointerIsDown && lastSnap !== scroll) {
                    var progress = (scroll - start) / change, totalProgress = animation && !isToggle ? animation.totalProgress() : progress, velocity = refreshedRecently ? 0 : (totalProgress - snap2) / ($82ba1e40433c64f0$var$_getTime() - $82ba1e40433c64f0$var$_time2) * 1000 || 0, change1 = $82ba1e40433c64f0$var$gsap.utils.clamp(-progress, 1 - progress, $82ba1e40433c64f0$var$_abs(velocity / 2) * velocity / 0.185), naturalEnd = progress + (snap.inertia === false ? 0 : change1), endValue, endScroll, _snap = snap, onStart = _snap.onStart, _onInterrupt = _snap.onInterrupt, _onComplete = _snap.onComplete;
                    endValue = snapFunc(naturalEnd, self);
                    $82ba1e40433c64f0$var$_isNumber(endValue) || (endValue = naturalEnd); // in case the function didn't return a number, fall back to using the naturalEnd
                    endScroll = Math.max(0, Math.round(start + endValue * change));
                    if (scroll <= end && scroll >= start && endScroll !== scroll) {
                        if (tween && !tween._initted && tween.data <= $82ba1e40433c64f0$var$_abs(endScroll - scroll)) // there's an overlapping snap! So we must figure out which one is closer and let that tween live.
                        return;
                        if (snap.inertia === false) change1 = endValue - progress;
                        tweenTo(endScroll, {
                            duration: snapDurClamp($82ba1e40433c64f0$var$_abs(Math.max($82ba1e40433c64f0$var$_abs(naturalEnd - totalProgress), $82ba1e40433c64f0$var$_abs(endValue - totalProgress)) * 0.185 / velocity / 0.05 || 0)),
                            ease: snap.ease || "power3",
                            data: $82ba1e40433c64f0$var$_abs(endScroll - scroll),
                            // record the distance so that if another snap tween occurs (conflict) we can prioritize the closest snap.
                            onInterrupt: function onInterrupt() {
                                return snapDelayedCall.restart(true) && _onInterrupt && _onInterrupt(self);
                            },
                            onComplete: function onComplete() {
                                self.update();
                                lastSnap = scrollFunc();
                                if (animation && !isToggle) // the resolution of the scrollbar is limited, so we should correct the scrubbed animation's playhead at the end to match EXACTLY where it was supposed to snap
                                scrubTween ? scrubTween.resetTo("totalProgress", endValue, animation._tTime / animation._tDur) : animation.progress(endValue);
                                snap1 = snap2 = animation && !isToggle ? animation.totalProgress() : self.progress;
                                onSnapComplete && onSnapComplete(self);
                                _onComplete && _onComplete(self);
                            }
                        }, scroll, change1 * change, endScroll - scroll - change1 * change);
                        onStart && onStart(self, tweenTo.tween);
                    }
                } else if (self.isActive && lastSnap !== scroll) snapDelayedCall.restart(true);
            }).pause();
        }
        id && ($82ba1e40433c64f0$var$_ids[id] = self);
        trigger = self.trigger = (0, $2796a7dcea5802d4$export$937374fea3f88711)(trigger || pin !== true && pin); // if a trigger has some kind of scroll-related effect applied that could contaminate the "y" or "x" position (like a ScrollSmoother effect), we needed a way to temporarily revert it, so we use the stRevert property of the gsCache. It can return another function that we'll call at the end so it can return to its normal state.
        customRevertReturn = trigger && trigger._gsap && trigger._gsap.stRevert;
        customRevertReturn && (customRevertReturn = customRevertReturn(self));
        pin = pin === true ? trigger : (0, $2796a7dcea5802d4$export$937374fea3f88711)(pin);
        $82ba1e40433c64f0$var$_isString(toggleClass) && (toggleClass = {
            targets: trigger,
            className: toggleClass
        });
        if (pin) {
            pinSpacing === false || pinSpacing === $82ba1e40433c64f0$var$_margin || (pinSpacing = !pinSpacing && pin.parentNode && pin.parentNode.style && $82ba1e40433c64f0$var$_getComputedStyle(pin.parentNode).display === "flex" ? false : $82ba1e40433c64f0$var$_padding); // if the parent is display: flex, don't apply pinSpacing by default. We should check that pin.parentNode is an element (not shadow dom window)
            self.pin = pin;
            pinCache = $82ba1e40433c64f0$var$gsap.core.getCache(pin);
            if (!pinCache.spacer) {
                // record the spacer and pinOriginalState on the cache in case someone tries pinning the same element with MULTIPLE ScrollTriggers - we don't want to have multiple spacers or record the "original" pin state after it has already been affected by another ScrollTrigger.
                if (pinSpacer) {
                    pinSpacer = (0, $2796a7dcea5802d4$export$937374fea3f88711)(pinSpacer);
                    pinSpacer && !pinSpacer.nodeType && (pinSpacer = pinSpacer.current || pinSpacer.nativeElement); // for React & Angular
                    pinCache.spacerIsNative = !!pinSpacer;
                    pinSpacer && (pinCache.spacerState = $82ba1e40433c64f0$var$_getState(pinSpacer));
                }
                pinCache.spacer = spacer = pinSpacer || $82ba1e40433c64f0$var$_doc.createElement("div");
                spacer.classList.add("pin-spacer");
                id && spacer.classList.add("pin-spacer-" + id);
                pinCache.pinState = pinOriginalState = $82ba1e40433c64f0$var$_getState(pin);
            } else pinOriginalState = pinCache.pinState;
            vars.force3D !== false && $82ba1e40433c64f0$var$gsap.set(pin, {
                force3D: true
            });
            self.spacer = spacer = pinCache.spacer;
            cs = $82ba1e40433c64f0$var$_getComputedStyle(pin);
            spacingStart = cs[pinSpacing + direction.os2];
            pinGetter = $82ba1e40433c64f0$var$gsap.getProperty(pin);
            pinSetter = $82ba1e40433c64f0$var$gsap.quickSetter(pin, direction.a, $82ba1e40433c64f0$var$_px); // pin.firstChild && !_maxScroll(pin, direction) && (pin.style.overflow = "hidden"); // protects from collapsing margins, but can have unintended consequences as demonstrated here: https://codepen.io/GreenSock/pen/1e42c7a73bfa409d2cf1e184e7a4248d so it was removed in favor of just telling people to set up their CSS to avoid the collapsing margins (overflow: hidden | auto is just one option. Another is border-top: 1px solid transparent).
            $82ba1e40433c64f0$var$_swapPinIn(pin, spacer, cs);
            pinState = $82ba1e40433c64f0$var$_getState(pin);
        }
        if (markers) {
            markerVars = $82ba1e40433c64f0$var$_isObject(markers) ? $82ba1e40433c64f0$var$_setDefaults(markers, $82ba1e40433c64f0$var$_markerDefaults) : $82ba1e40433c64f0$var$_markerDefaults;
            markerStartTrigger = $82ba1e40433c64f0$var$_createMarker("scroller-start", id, scroller, direction, markerVars, 0);
            markerEndTrigger = $82ba1e40433c64f0$var$_createMarker("scroller-end", id, scroller, direction, markerVars, 0, markerStartTrigger);
            offset = markerStartTrigger["offset" + direction.op.d2];
            var content = (0, $2796a7dcea5802d4$export$937374fea3f88711)((0, $2796a7dcea5802d4$export$6078f1ef08b38af9)(scroller, "content") || scroller);
            markerStart = this.markerStart = $82ba1e40433c64f0$var$_createMarker("start", id, content, direction, markerVars, offset, 0, containerAnimation);
            markerEnd = this.markerEnd = $82ba1e40433c64f0$var$_createMarker("end", id, content, direction, markerVars, offset, 0, containerAnimation);
            containerAnimation && (caMarkerSetter = $82ba1e40433c64f0$var$gsap.quickSetter([
                markerStart,
                markerEnd
            ], direction.a, $82ba1e40433c64f0$var$_px));
            if (!useFixedPosition && !((0, $2796a7dcea5802d4$export$d8e56d510a804d0a).length && (0, $2796a7dcea5802d4$export$6078f1ef08b38af9)(scroller, "fixedMarkers") === true)) {
                $82ba1e40433c64f0$var$_makePositionable(isViewport ? $82ba1e40433c64f0$var$_body : scroller);
                $82ba1e40433c64f0$var$gsap.set([
                    markerStartTrigger,
                    markerEndTrigger
                ], {
                    force3D: true
                });
                markerStartSetter = $82ba1e40433c64f0$var$gsap.quickSetter(markerStartTrigger, direction.a, $82ba1e40433c64f0$var$_px);
                markerEndSetter = $82ba1e40433c64f0$var$gsap.quickSetter(markerEndTrigger, direction.a, $82ba1e40433c64f0$var$_px);
            }
        }
        if (containerAnimation) {
            var oldOnUpdate = containerAnimation.vars.onUpdate, oldParams = containerAnimation.vars.onUpdateParams;
            containerAnimation.eventCallback("onUpdate", function() {
                self.update(0, 0, 1);
                oldOnUpdate && oldOnUpdate.apply(containerAnimation, oldParams || []);
            });
        }
        self.previous = function() {
            return $82ba1e40433c64f0$var$_triggers[$82ba1e40433c64f0$var$_triggers.indexOf(self) - 1];
        };
        self.next = function() {
            return $82ba1e40433c64f0$var$_triggers[$82ba1e40433c64f0$var$_triggers.indexOf(self) + 1];
        };
        self.revert = function(revert, temp) {
            if (!temp) return self.kill(true);
             // for compatibility with gsap.context() and gsap.matchMedia() which call revert()
            var r = revert !== false || !self.enabled, prevRefreshing = $82ba1e40433c64f0$var$_refreshing;
            if (r !== self.isReverted) {
                if (r) {
                    prevScroll = Math.max(scrollFunc(), self.scroll.rec || 0); // record the scroll so we can revert later (repositioning/pinning things can affect scroll position). In the static refresh() method, we first record all the scroll positions as a reference.
                    prevProgress = self.progress;
                    prevAnimProgress = animation && animation.progress();
                }
                markerStart && [
                    markerStart,
                    markerEnd,
                    markerStartTrigger,
                    markerEndTrigger
                ].forEach(function(m) {
                    return m.style.display = r ? "none" : "block";
                });
                if (r) {
                    $82ba1e40433c64f0$var$_refreshing = self;
                    self.update(r); // make sure the pin is back in its original position so that all the measurements are correct. do this BEFORE swapping the pin out
                }
                if (pin && (!pinReparent || !self.isActive)) {
                    if (r) $82ba1e40433c64f0$var$_swapPinOut(pin, spacer, pinOriginalState);
                    else $82ba1e40433c64f0$var$_swapPinIn(pin, spacer, $82ba1e40433c64f0$var$_getComputedStyle(pin), spacerState);
                }
                r || self.update(r); // when we're restoring, the update should run AFTER swapping the pin into its pin-spacer.
                $82ba1e40433c64f0$var$_refreshing = prevRefreshing; // restore. We set it to true during the update() so that things fire properly in there.
                self.isReverted = r;
            }
        };
        self.refresh = function(soft, force, position, pinOffset) {
            // position is typically only defined if it's coming from setPositions() - it's a way to skip the normal parsing. pinOffset is also only from setPositions() and is mostly related to fancy stuff we need to do in ScrollSmoother with effects
            if (($82ba1e40433c64f0$var$_refreshing || !self.enabled) && !force) return;
            if (pin && soft && $82ba1e40433c64f0$var$_lastScrollTime) {
                $82ba1e40433c64f0$var$_addListener(ScrollTrigger, "scrollEnd", $82ba1e40433c64f0$var$_softRefresh);
                return;
            }
            !$82ba1e40433c64f0$var$_refreshingAll && onRefreshInit && onRefreshInit(self);
            $82ba1e40433c64f0$var$_refreshing = self;
            if (tweenTo.tween && !position) {
                // we skip this if a position is passed in because typically that's from .setPositions() and it's best to allow in-progress snapping to continue.
                tweenTo.tween.kill();
                tweenTo.tween = 0;
            }
            scrubTween && scrubTween.pause();
            if (invalidateOnRefresh && animation) {
                animation.revert({
                    kill: false
                }).invalidate();
                animation.getChildren ? animation.getChildren(true, true, false).forEach(function(t) {
                    return t.vars.immediateRender && t.render(0, true, true);
                }) : animation.vars.immediateRender && animation.render(0, true, true); // any from() or fromTo() tweens should render immediately (well, unless they have immediateRender: false)
            }
            self.isReverted || self.revert(true, true);
            self._subPinOffset = false; // we'll set this to true in the sub-pins if we find any
            var size = getScrollerSize(), scrollerBounds = getScrollerOffsets(), max = containerAnimation ? containerAnimation.duration() : $82ba1e40433c64f0$var$_maxScroll(scroller, direction), isFirstRefresh = change <= 0.01 || !change, offset = 0, otherPinOffset = pinOffset || 0, parsedEnd = $82ba1e40433c64f0$var$_isObject(position) ? position.end : vars.end, parsedEndTrigger = vars.endTrigger || trigger, parsedStart = $82ba1e40433c64f0$var$_isObject(position) ? position.start : vars.start || (vars.start === 0 || !trigger ? 0 : pin ? "0 0" : "0 100%"), pinnedContainer = self.pinnedContainer = vars.pinnedContainer && (0, $2796a7dcea5802d4$export$937374fea3f88711)(vars.pinnedContainer, self), triggerIndex = trigger && Math.max(0, $82ba1e40433c64f0$var$_triggers.indexOf(self)) || 0, i = triggerIndex, cs, bounds, scroll, isVertical, override, curTrigger, curPin, oppositeScroll, initted, revertedPins, forcedOverflow, markerStartOffset, markerEndOffset;
            if (markers && $82ba1e40433c64f0$var$_isObject(position)) {
                // if we alter the start/end positions with .setPositions(), it generally feeds in absolute NUMBERS which don't convey information about where to line up the markers, so to keep it intuitive, we record how far the trigger positions shift after applying the new numbers and then offset by that much in the opposite direction. We do the same to the associated trigger markers too of course.
                markerStartOffset = $82ba1e40433c64f0$var$gsap.getProperty(markerStartTrigger, direction.p);
                markerEndOffset = $82ba1e40433c64f0$var$gsap.getProperty(markerEndTrigger, direction.p);
            }
            while(i-- > 0){
                // user might try to pin the same element more than once, so we must find any prior triggers with the same pin, revert them, and determine how long they're pinning so that we can offset things appropriately. Make sure we revert from last to first so that things "rewind" properly.
                curTrigger = $82ba1e40433c64f0$var$_triggers[i];
                curTrigger.end || curTrigger.refresh(0, 1) || ($82ba1e40433c64f0$var$_refreshing = self); // if it's a timeline-based trigger that hasn't been fully initialized yet because it's waiting for 1 tick, just force the refresh() here, otherwise if it contains a pin that's supposed to affect other ScrollTriggers further down the page, they won't be adjusted properly.
                curPin = curTrigger.pin;
                if (curPin && (curPin === trigger || curPin === pin || curPin === pinnedContainer) && !curTrigger.isReverted) {
                    revertedPins || (revertedPins = []);
                    revertedPins.unshift(curTrigger); // we'll revert from first to last to make sure things reach their end state properly
                    curTrigger.revert(true, true);
                }
                if (curTrigger !== $82ba1e40433c64f0$var$_triggers[i]) {
                    // in case it got removed.
                    triggerIndex--;
                    i--;
                }
            }
            $82ba1e40433c64f0$var$_isFunction(parsedStart) && (parsedStart = parsedStart(self));
            parsedStart = $82ba1e40433c64f0$var$_parseClamp(parsedStart, "start", self);
            start = $82ba1e40433c64f0$var$_parsePosition(parsedStart, trigger, size, direction, scrollFunc(), markerStart, markerStartTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._startClamp && "_startClamp") || (pin ? -0.001 : 0);
            $82ba1e40433c64f0$var$_isFunction(parsedEnd) && (parsedEnd = parsedEnd(self));
            if ($82ba1e40433c64f0$var$_isString(parsedEnd) && !parsedEnd.indexOf("+=")) {
                if (~parsedEnd.indexOf(" ")) parsedEnd = ($82ba1e40433c64f0$var$_isString(parsedStart) ? parsedStart.split(" ")[0] : "") + parsedEnd;
                else {
                    offset = $82ba1e40433c64f0$var$_offsetToPx(parsedEnd.substr(2), size);
                    parsedEnd = $82ba1e40433c64f0$var$_isString(parsedStart) ? parsedStart : (containerAnimation ? $82ba1e40433c64f0$var$gsap.utils.mapRange(0, containerAnimation.duration(), containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, start) : start) + offset; // _parsePosition won't factor in the offset if the start is a number, so do it here.
                    parsedEndTrigger = trigger;
                }
            }
            parsedEnd = $82ba1e40433c64f0$var$_parseClamp(parsedEnd, "end", self);
            end = Math.max(start, $82ba1e40433c64f0$var$_parsePosition(parsedEnd || (parsedEndTrigger ? "100% 0" : max), parsedEndTrigger, size, direction, scrollFunc() + offset, markerEnd, markerEndTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._endClamp && "_endClamp")) || -0.001;
            offset = 0;
            i = triggerIndex;
            while(i--){
                curTrigger = $82ba1e40433c64f0$var$_triggers[i] || {};
                curPin = curTrigger.pin;
                if (curPin && curTrigger.start - curTrigger._pinPush <= start && !containerAnimation && curTrigger.end > 0) {
                    cs = curTrigger.end - (self._startClamp ? Math.max(0, curTrigger.start) : curTrigger.start);
                    if ((curPin === trigger && curTrigger.start - curTrigger._pinPush < start || curPin === pinnedContainer) && isNaN(parsedStart)) // numeric start values shouldn't be offset at all - treat them as absolute
                    offset += cs * (1 - curTrigger.progress);
                    curPin === pin && (otherPinOffset += cs);
                }
            }
            start += offset;
            end += offset;
            self._startClamp && (self._startClamp += offset);
            if (self._endClamp && !$82ba1e40433c64f0$var$_refreshingAll) {
                self._endClamp = end || -0.001;
                end = Math.min(end, $82ba1e40433c64f0$var$_maxScroll(scroller, direction));
            }
            change = end - start || (start -= 0.01) && 0.001;
            if (isFirstRefresh) // on the very first refresh(), the prevProgress couldn't have been accurate yet because the start/end were never calculated, so we set it here. Before 3.11.5, it could lead to an inaccurate scroll position restoration with snapping.
            prevProgress = $82ba1e40433c64f0$var$gsap.utils.clamp(0, 1, $82ba1e40433c64f0$var$gsap.utils.normalize(start, end, prevScroll));
            self._pinPush = otherPinOffset;
            if (markerStart && offset) {
                // offset the markers if necessary
                cs = {};
                cs[direction.a] = "+=" + offset;
                pinnedContainer && (cs[direction.p] = "-=" + scrollFunc());
                $82ba1e40433c64f0$var$gsap.set([
                    markerStart,
                    markerEnd
                ], cs);
            }
            if (pin && !($82ba1e40433c64f0$var$_clampingMax && self.end >= $82ba1e40433c64f0$var$_maxScroll(scroller, direction))) {
                cs = $82ba1e40433c64f0$var$_getComputedStyle(pin);
                isVertical = direction === (0, $2796a7dcea5802d4$export$8e40fc98ff518e9d);
                scroll = scrollFunc(); // recalculate because the triggers can affect the scroll
                pinStart = parseFloat(pinGetter(direction.a)) + otherPinOffset;
                if (!max && end > 1) {
                    // makes sure the scroller has a scrollbar, otherwise if something has width: 100%, for example, it would be too big (exclude the scrollbar). See https://gsap.com/forums/topic/25182-scrolltrigger-width-of-page-increase-where-markers-are-set-to-false/
                    forcedOverflow = (isViewport ? $82ba1e40433c64f0$var$_doc.scrollingElement || $82ba1e40433c64f0$var$_docEl : scroller).style;
                    forcedOverflow = {
                        style: forcedOverflow,
                        value: forcedOverflow["overflow" + direction.a.toUpperCase()]
                    };
                    if (isViewport && $82ba1e40433c64f0$var$_getComputedStyle($82ba1e40433c64f0$var$_body)["overflow" + direction.a.toUpperCase()] !== "scroll") // avoid an extra scrollbar if BOTH <html> and <body> have overflow set to "scroll"
                    forcedOverflow.style["overflow" + direction.a.toUpperCase()] = "scroll";
                }
                $82ba1e40433c64f0$var$_swapPinIn(pin, spacer, cs);
                pinState = $82ba1e40433c64f0$var$_getState(pin); // transforms will interfere with the top/left/right/bottom placement, so remove them temporarily. getBoundingClientRect() factors in transforms.
                bounds = $82ba1e40433c64f0$var$_getBounds(pin, true);
                oppositeScroll = useFixedPosition && (0, $2796a7dcea5802d4$export$8665aac53dad5647)(scroller, isVertical ? (0, $2796a7dcea5802d4$export$b2cabb342cb0ebe1) : (0, $2796a7dcea5802d4$export$8e40fc98ff518e9d))();
                if (pinSpacing) {
                    spacerState = [
                        pinSpacing + direction.os2,
                        change + otherPinOffset + $82ba1e40433c64f0$var$_px
                    ];
                    spacerState.t = spacer;
                    i = pinSpacing === $82ba1e40433c64f0$var$_padding ? $82ba1e40433c64f0$var$_getSize(pin, direction) + change + otherPinOffset : 0;
                    if (i) {
                        spacerState.push(direction.d, i + $82ba1e40433c64f0$var$_px); // for box-sizing: border-box (must include padding).
                        spacer.style.flexBasis !== "auto" && (spacer.style.flexBasis = i + $82ba1e40433c64f0$var$_px);
                    }
                    $82ba1e40433c64f0$var$_setState(spacerState);
                    if (pinnedContainer) // in ScrollTrigger.refresh(), we need to re-evaluate the pinContainer's size because this pinSpacing may stretch it out, but we can't just add the exact distance because depending on layout, it may not push things down or it may only do so partially.
                    $82ba1e40433c64f0$var$_triggers.forEach(function(t) {
                        if (t.pin === pinnedContainer && t.vars.pinSpacing !== false) t._subPinOffset = true;
                    });
                    useFixedPosition && scrollFunc(prevScroll);
                } else {
                    i = $82ba1e40433c64f0$var$_getSize(pin, direction);
                    i && spacer.style.flexBasis !== "auto" && (spacer.style.flexBasis = i + $82ba1e40433c64f0$var$_px);
                }
                if (useFixedPosition) {
                    override = {
                        top: bounds.top + (isVertical ? scroll - start : oppositeScroll) + $82ba1e40433c64f0$var$_px,
                        left: bounds.left + (isVertical ? oppositeScroll : scroll - start) + $82ba1e40433c64f0$var$_px,
                        boxSizing: "border-box",
                        position: "fixed"
                    };
                    override[$82ba1e40433c64f0$var$_width] = override["max" + $82ba1e40433c64f0$var$_Width] = Math.ceil(bounds.width) + $82ba1e40433c64f0$var$_px;
                    override[$82ba1e40433c64f0$var$_height] = override["max" + $82ba1e40433c64f0$var$_Height] = Math.ceil(bounds.height) + $82ba1e40433c64f0$var$_px;
                    override[$82ba1e40433c64f0$var$_margin] = override[$82ba1e40433c64f0$var$_margin + $82ba1e40433c64f0$var$_Top] = override[$82ba1e40433c64f0$var$_margin + $82ba1e40433c64f0$var$_Right] = override[$82ba1e40433c64f0$var$_margin + $82ba1e40433c64f0$var$_Bottom] = override[$82ba1e40433c64f0$var$_margin + $82ba1e40433c64f0$var$_Left] = "0";
                    override[$82ba1e40433c64f0$var$_padding] = cs[$82ba1e40433c64f0$var$_padding];
                    override[$82ba1e40433c64f0$var$_padding + $82ba1e40433c64f0$var$_Top] = cs[$82ba1e40433c64f0$var$_padding + $82ba1e40433c64f0$var$_Top];
                    override[$82ba1e40433c64f0$var$_padding + $82ba1e40433c64f0$var$_Right] = cs[$82ba1e40433c64f0$var$_padding + $82ba1e40433c64f0$var$_Right];
                    override[$82ba1e40433c64f0$var$_padding + $82ba1e40433c64f0$var$_Bottom] = cs[$82ba1e40433c64f0$var$_padding + $82ba1e40433c64f0$var$_Bottom];
                    override[$82ba1e40433c64f0$var$_padding + $82ba1e40433c64f0$var$_Left] = cs[$82ba1e40433c64f0$var$_padding + $82ba1e40433c64f0$var$_Left];
                    pinActiveState = $82ba1e40433c64f0$var$_copyState(pinOriginalState, override, pinReparent);
                    $82ba1e40433c64f0$var$_refreshingAll && scrollFunc(0);
                }
                if (animation) {
                    // the animation might be affecting the transform, so we must jump to the end, check the value, and compensate accordingly. Otherwise, when it becomes unpinned, the pinSetter() will get set to a value that doesn't include whatever the animation did.
                    initted = animation._initted; // if not, we must invalidate() after this step, otherwise it could lock in starting values prematurely.
                    $82ba1e40433c64f0$var$_suppressOverwrites(1);
                    animation.render(animation.duration(), true, true);
                    pinChange = pinGetter(direction.a) - pinStart + change + otherPinOffset;
                    pinMoves = Math.abs(change - pinChange) > 1;
                    useFixedPosition && pinMoves && pinActiveState.splice(pinActiveState.length - 2, 2); // transform is the last property/value set in the state Array. Since the animation is controlling that, we should omit it.
                    animation.render(0, true, true);
                    initted || animation.invalidate(true);
                    animation.parent || animation.totalTime(animation.totalTime()); // if, for example, a toggleAction called play() and then refresh() happens and when we render(1) above, it would cause the animation to complete and get removed from its parent, so this makes sure it gets put back in.
                    $82ba1e40433c64f0$var$_suppressOverwrites(0);
                } else pinChange = change;
                forcedOverflow && (forcedOverflow.value ? forcedOverflow.style["overflow" + direction.a.toUpperCase()] = forcedOverflow.value : forcedOverflow.style.removeProperty("overflow-" + direction.a));
            } else if (trigger && scrollFunc() && !containerAnimation) {
                // it may be INSIDE a pinned element, so walk up the tree and look for any elements with _pinOffset to compensate because anything with pinSpacing that's already scrolled would throw off the measurements in getBoundingClientRect()
                bounds = trigger.parentNode;
                while(bounds && bounds !== $82ba1e40433c64f0$var$_body){
                    if (bounds._pinOffset) {
                        start -= bounds._pinOffset;
                        end -= bounds._pinOffset;
                    }
                    bounds = bounds.parentNode;
                }
            }
            revertedPins && revertedPins.forEach(function(t) {
                return t.revert(false, true);
            });
            self.start = start;
            self.end = end;
            scroll1 = scroll2 = $82ba1e40433c64f0$var$_refreshingAll ? prevScroll : scrollFunc(); // reset velocity
            if (!containerAnimation && !$82ba1e40433c64f0$var$_refreshingAll) {
                scroll1 < prevScroll && scrollFunc(prevScroll);
                self.scroll.rec = 0;
            }
            self.revert(false, true);
            lastRefresh = $82ba1e40433c64f0$var$_getTime();
            if (snapDelayedCall) {
                lastSnap = -1; // just so snapping gets re-enabled, clear out any recorded last value
                // self.isActive && scrollFunc(start + change * prevProgress); // previously this line was here to ensure that when snapping kicks in, it's from the previous progress but in some cases that's not desirable, like an all-page ScrollTrigger when new content gets added to the page, that'd totally change the progress.
                snapDelayedCall.restart(true);
            }
            $82ba1e40433c64f0$var$_refreshing = 0;
            animation && isToggle && (animation._initted || prevAnimProgress) && animation.progress() !== prevAnimProgress && animation.progress(prevAnimProgress || 0, true).render(animation.time(), true, true); // must force a re-render because if saveStyles() was used on the target(s), the styles could have been wiped out during the refresh().
            if (isFirstRefresh || prevProgress !== self.progress || containerAnimation || invalidateOnRefresh || animation && !animation._initted) {
                // ensures that the direction is set properly (when refreshing, progress is set back to 0 initially, then back again to wherever it needs to be) and that callbacks are triggered.
                animation && !isToggle && (animation._initted || prevProgress || animation.vars.immediateRender !== false) && animation.totalProgress(containerAnimation && start < -0.001 && !prevProgress ? $82ba1e40433c64f0$var$gsap.utils.normalize(start, end, 0) : prevProgress, true); // to avoid issues where animation callbacks like onStart aren't triggered.
                self.progress = isFirstRefresh || (scroll1 - start) / change === prevProgress ? 0 : prevProgress;
            }
            pin && pinSpacing && (spacer._pinOffset = Math.round(self.progress * pinChange));
            scrubTween && scrubTween.invalidate();
            if (!isNaN(markerStartOffset)) {
                // numbers were passed in for the position which are absolute, so instead of just putting the markers at the very bottom of the viewport, we figure out how far they shifted down (it's safe to assume they were originally positioned in closer relation to the trigger element with values like "top", "center", a percentage or whatever, so we offset that much in the opposite direction to basically revert them to the relative position thy were at previously.
                markerStartOffset -= $82ba1e40433c64f0$var$gsap.getProperty(markerStartTrigger, direction.p);
                markerEndOffset -= $82ba1e40433c64f0$var$gsap.getProperty(markerEndTrigger, direction.p);
                $82ba1e40433c64f0$var$_shiftMarker(markerStartTrigger, direction, markerStartOffset);
                $82ba1e40433c64f0$var$_shiftMarker(markerStart, direction, markerStartOffset - (pinOffset || 0));
                $82ba1e40433c64f0$var$_shiftMarker(markerEndTrigger, direction, markerEndOffset);
                $82ba1e40433c64f0$var$_shiftMarker(markerEnd, direction, markerEndOffset - (pinOffset || 0));
            }
            isFirstRefresh && !$82ba1e40433c64f0$var$_refreshingAll && self.update(); // edge case - when you reload a page when it's already scrolled down, some browsers fire a "scroll" event before DOMContentLoaded, triggering an updateAll(). If we don't update the self.progress as part of refresh(), then when it happens next, it may record prevProgress as 0 when it really shouldn't, potentially causing a callback in an animation to fire again.
            if (onRefresh && !$82ba1e40433c64f0$var$_refreshingAll && !executingOnRefresh) {
                // when refreshing all, we do extra work to correct pinnedContainer sizes and ensure things don't exceed the maxScroll, so we should do all the refreshes at the end after all that work so that the start/end values are corrected.
                executingOnRefresh = true;
                onRefresh(self);
                executingOnRefresh = false;
            }
        };
        self.getVelocity = function() {
            return (scrollFunc() - scroll2) / ($82ba1e40433c64f0$var$_getTime() - $82ba1e40433c64f0$var$_time2) * 1000 || 0;
        };
        self.endAnimation = function() {
            $82ba1e40433c64f0$var$_endAnimation(self.callbackAnimation);
            if (animation) scrubTween ? scrubTween.progress(1) : !animation.paused() ? $82ba1e40433c64f0$var$_endAnimation(animation, animation.reversed()) : isToggle || $82ba1e40433c64f0$var$_endAnimation(animation, self.direction < 0, 1);
        };
        self.labelToScroll = function(label) {
            return animation && animation.labels && (start || self.refresh() || start) + animation.labels[label] / animation.duration() * change || 0;
        };
        self.getTrailing = function(name) {
            var i = $82ba1e40433c64f0$var$_triggers.indexOf(self), a = self.direction > 0 ? $82ba1e40433c64f0$var$_triggers.slice(0, i).reverse() : $82ba1e40433c64f0$var$_triggers.slice(i + 1);
            return ($82ba1e40433c64f0$var$_isString(name) ? a.filter(function(t) {
                return t.vars.preventOverlaps === name;
            }) : a).filter(function(t) {
                return self.direction > 0 ? t.end <= start : t.start >= end;
            });
        };
        self.update = function(reset, recordVelocity, forceFake) {
            if (containerAnimation && !forceFake && !reset) return;
            var scroll = $82ba1e40433c64f0$var$_refreshingAll === true ? prevScroll : self.scroll(), p = reset ? 0 : (scroll - start) / change, clipped = p < 0 ? 0 : p > 1 ? 1 : p || 0, prevProgress = self.progress, isActive, wasActive, toggleState, action, stateChanged, toggled, isAtMax, isTakingAction;
            if (recordVelocity) {
                scroll2 = scroll1;
                scroll1 = containerAnimation ? scrollFunc() : scroll;
                if (snap) {
                    snap2 = snap1;
                    snap1 = animation && !isToggle ? animation.totalProgress() : clipped;
                }
            } // anticipate the pinning a few ticks ahead of time based on velocity to avoid a visual glitch due to the fact that most browsers do scrolling on a separate thread (not synced with requestAnimationFrame).
            if (anticipatePin && pin && !$82ba1e40433c64f0$var$_refreshing && !$82ba1e40433c64f0$var$_startup && $82ba1e40433c64f0$var$_lastScrollTime) {
                if (!clipped && start < scroll + (scroll - scroll2) / ($82ba1e40433c64f0$var$_getTime() - $82ba1e40433c64f0$var$_time2) * anticipatePin) clipped = 0.0001;
                else if (clipped === 1 && end > scroll + (scroll - scroll2) / ($82ba1e40433c64f0$var$_getTime() - $82ba1e40433c64f0$var$_time2) * anticipatePin) clipped = 0.9999;
            }
            if (clipped !== prevProgress && self.enabled) {
                isActive = self.isActive = !!clipped && clipped < 1;
                wasActive = !!prevProgress && prevProgress < 1;
                toggled = isActive !== wasActive;
                stateChanged = toggled || !!clipped !== !!prevProgress; // could go from start all the way to end, thus it didn't toggle but it did change state in a sense (may need to fire a callback)
                self.direction = clipped > prevProgress ? 1 : -1;
                self.progress = clipped;
                if (stateChanged && !$82ba1e40433c64f0$var$_refreshing) {
                    toggleState = clipped && !prevProgress ? 0 : clipped === 1 ? 1 : prevProgress === 1 ? 2 : 3; // 0 = enter, 1 = leave, 2 = enterBack, 3 = leaveBack (we prioritize the FIRST encounter, thus if you scroll really fast past the onEnter and onLeave in one tick, it'd prioritize onEnter.
                    if (isToggle) {
                        action = !toggled && toggleActions[toggleState + 1] !== "none" && toggleActions[toggleState + 1] || toggleActions[toggleState]; // if it didn't toggle, that means it shot right past and since we prioritize the "enter" action, we should switch to the "leave" in this case (but only if one is defined)
                        isTakingAction = animation && (action === "complete" || action === "reset" || action in animation);
                    }
                }
                preventOverlaps && (toggled || isTakingAction) && (isTakingAction || scrub || !animation) && ($82ba1e40433c64f0$var$_isFunction(preventOverlaps) ? preventOverlaps(self) : self.getTrailing(preventOverlaps).forEach(function(t) {
                    return t.endAnimation();
                }));
                if (!isToggle) {
                    if (scrubTween && !$82ba1e40433c64f0$var$_refreshing && !$82ba1e40433c64f0$var$_startup) {
                        scrubTween._dp._time - scrubTween._start !== scrubTween._time && scrubTween.render(scrubTween._dp._time - scrubTween._start); // if there's a scrub on both the container animation and this one (or a ScrollSmoother), the update order would cause this one not to have rendered yet, so it wouldn't make any progress before we .restart() it heading toward the new progress so it'd appear stuck thus we force a render here.
                        if (scrubTween.resetTo) scrubTween.resetTo("totalProgress", clipped, animation._tTime / animation._tDur);
                        else {
                            // legacy support (courtesy), before 3.10.0
                            scrubTween.vars.totalProgress = clipped;
                            scrubTween.invalidate().restart();
                        }
                    } else if (animation) animation.totalProgress(clipped, !!($82ba1e40433c64f0$var$_refreshing && (lastRefresh || reset)));
                }
                if (pin) {
                    reset && pinSpacing && (spacer.style[pinSpacing + direction.os2] = spacingStart);
                    if (!useFixedPosition) pinSetter($82ba1e40433c64f0$var$_round(pinStart + pinChange * clipped));
                    else if (stateChanged) {
                        isAtMax = !reset && clipped > prevProgress && end + 1 > scroll && scroll + 1 >= $82ba1e40433c64f0$var$_maxScroll(scroller, direction); // if it's at the VERY end of the page, don't switch away from position: fixed because it's pointless and it could cause a brief flash when the user scrolls back up (when it gets pinned again)
                        if (pinReparent) {
                            if (!reset && (isActive || isAtMax)) {
                                var bounds = $82ba1e40433c64f0$var$_getBounds(pin, true), _offset = scroll - start;
                                $82ba1e40433c64f0$var$_reparent(pin, $82ba1e40433c64f0$var$_body, bounds.top + (direction === (0, $2796a7dcea5802d4$export$8e40fc98ff518e9d) ? _offset : 0) + $82ba1e40433c64f0$var$_px, bounds.left + (direction === (0, $2796a7dcea5802d4$export$8e40fc98ff518e9d) ? 0 : _offset) + $82ba1e40433c64f0$var$_px);
                            } else $82ba1e40433c64f0$var$_reparent(pin, spacer);
                        }
                        $82ba1e40433c64f0$var$_setState(isActive || isAtMax ? pinActiveState : pinState);
                        pinMoves && clipped < 1 && isActive || pinSetter(pinStart + (clipped === 1 && !isAtMax ? pinChange : 0));
                    }
                }
                snap && !tweenTo.tween && !$82ba1e40433c64f0$var$_refreshing && !$82ba1e40433c64f0$var$_startup && snapDelayedCall.restart(true);
                toggleClass && (toggled || once && clipped && (clipped < 1 || !$82ba1e40433c64f0$var$_limitCallbacks)) && $82ba1e40433c64f0$var$_toArray(toggleClass.targets).forEach(function(el) {
                    return el.classList[isActive || once ? "add" : "remove"](toggleClass.className);
                }); // classes could affect positioning, so do it even if reset or refreshing is true.
                onUpdate && !isToggle && !reset && onUpdate(self);
                if (stateChanged && !$82ba1e40433c64f0$var$_refreshing) {
                    if (isToggle) {
                        if (isTakingAction) {
                            if (action === "complete") animation.pause().totalProgress(1);
                            else if (action === "reset") animation.restart(true).pause();
                            else if (action === "restart") animation.restart(true);
                            else animation[action]();
                        }
                        onUpdate && onUpdate(self);
                    }
                    if (toggled || !$82ba1e40433c64f0$var$_limitCallbacks) {
                        // on startup, the page could be scrolled and we don't want to fire callbacks that didn't toggle. For example onEnter shouldn't fire if the ScrollTrigger isn't actually entered.
                        onToggle && toggled && $82ba1e40433c64f0$var$_callback(self, onToggle);
                        callbacks[toggleState] && $82ba1e40433c64f0$var$_callback(self, callbacks[toggleState]);
                        once && (clipped === 1 ? self.kill(false, 1) : callbacks[toggleState] = 0); // a callback shouldn't be called again if once is true.
                        if (!toggled) {
                            // it's possible to go completely past, like from before the start to after the end (or vice-versa) in which case BOTH callbacks should be fired in that order
                            toggleState = clipped === 1 ? 1 : 3;
                            callbacks[toggleState] && $82ba1e40433c64f0$var$_callback(self, callbacks[toggleState]);
                        }
                    }
                    if (fastScrollEnd && !isActive && Math.abs(self.getVelocity()) > ($82ba1e40433c64f0$var$_isNumber(fastScrollEnd) ? fastScrollEnd : 2500)) {
                        $82ba1e40433c64f0$var$_endAnimation(self.callbackAnimation);
                        scrubTween ? scrubTween.progress(1) : $82ba1e40433c64f0$var$_endAnimation(animation, action === "reverse" ? 1 : !clipped, 1);
                    }
                } else if (isToggle && onUpdate && !$82ba1e40433c64f0$var$_refreshing) onUpdate(self);
            } // update absolutely-positioned markers (only if the scroller isn't the viewport)
            if (markerEndSetter) {
                var n = containerAnimation ? scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0) : scroll;
                markerStartSetter(n + (markerStartTrigger._isFlipped ? 1 : 0));
                markerEndSetter(n);
            }
            caMarkerSetter && caMarkerSetter(-scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0));
        };
        self.enable = function(reset, refresh) {
            if (!self.enabled) {
                self.enabled = true;
                $82ba1e40433c64f0$var$_addListener(scroller, "resize", $82ba1e40433c64f0$var$_onResize);
                isViewport || $82ba1e40433c64f0$var$_addListener(scroller, "scroll", $82ba1e40433c64f0$var$_onScroll);
                onRefreshInit && $82ba1e40433c64f0$var$_addListener(ScrollTrigger, "refreshInit", onRefreshInit);
                if (reset !== false) {
                    self.progress = prevProgress = 0;
                    scroll1 = scroll2 = lastSnap = scrollFunc();
                }
                refresh !== false && self.refresh();
            }
        };
        self.getTween = function(snap) {
            return snap && tweenTo ? tweenTo.tween : scrubTween;
        };
        self.setPositions = function(newStart, newEnd, keepClamp, pinOffset) {
            // doesn't persist after refresh()! Intended to be a way to override values that were set during refresh(), like you could set it in onRefresh()
            if (containerAnimation) {
                // convert ratios into scroll positions. Remember, start/end values on ScrollTriggers that have a containerAnimation refer to the time (in seconds), NOT scroll positions.
                var st = containerAnimation.scrollTrigger, duration = containerAnimation.duration(), _change = st.end - st.start;
                newStart = st.start + _change * newStart / duration;
                newEnd = st.start + _change * newEnd / duration;
            }
            self.refresh(false, false, {
                start: $82ba1e40433c64f0$var$_keepClamp(newStart, keepClamp && !!self._startClamp),
                end: $82ba1e40433c64f0$var$_keepClamp(newEnd, keepClamp && !!self._endClamp)
            }, pinOffset);
            self.update();
        };
        self.adjustPinSpacing = function(amount) {
            if (spacerState && amount) {
                var i = spacerState.indexOf(direction.d) + 1;
                spacerState[i] = parseFloat(spacerState[i]) + amount + $82ba1e40433c64f0$var$_px;
                spacerState[1] = parseFloat(spacerState[1]) + amount + $82ba1e40433c64f0$var$_px;
                $82ba1e40433c64f0$var$_setState(spacerState);
            }
        };
        self.disable = function(reset, allowAnimation) {
            reset !== false && self.revert(true, true);
            if (self.enabled) {
                self.enabled = self.isActive = false;
                allowAnimation || scrubTween && scrubTween.pause();
                prevScroll = 0;
                pinCache && (pinCache.uncache = 1);
                onRefreshInit && $82ba1e40433c64f0$var$_removeListener(ScrollTrigger, "refreshInit", onRefreshInit);
                if (snapDelayedCall) {
                    snapDelayedCall.pause();
                    tweenTo.tween && tweenTo.tween.kill() && (tweenTo.tween = 0);
                }
                if (!isViewport) {
                    var i = $82ba1e40433c64f0$var$_triggers.length;
                    while(i--){
                        if ($82ba1e40433c64f0$var$_triggers[i].scroller === scroller && $82ba1e40433c64f0$var$_triggers[i] !== self) return; //don't remove the listeners if there are still other triggers referencing it.
                    }
                    $82ba1e40433c64f0$var$_removeListener(scroller, "resize", $82ba1e40433c64f0$var$_onResize);
                    isViewport || $82ba1e40433c64f0$var$_removeListener(scroller, "scroll", $82ba1e40433c64f0$var$_onScroll);
                }
            }
        };
        self.kill = function(revert, allowAnimation) {
            self.disable(revert, allowAnimation);
            scrubTween && !allowAnimation && scrubTween.kill();
            id && delete $82ba1e40433c64f0$var$_ids[id];
            var i = $82ba1e40433c64f0$var$_triggers.indexOf(self);
            i >= 0 && $82ba1e40433c64f0$var$_triggers.splice(i, 1);
            i === $82ba1e40433c64f0$var$_i && $82ba1e40433c64f0$var$_direction > 0 && $82ba1e40433c64f0$var$_i--; // if we're in the middle of a refresh() or update(), splicing would cause skips in the index, so adjust...
            // if no other ScrollTrigger instances of the same scroller are found, wipe out any recorded scroll position. Otherwise, in a single page application, for example, it could maintain scroll position when it really shouldn't.
            i = 0;
            $82ba1e40433c64f0$var$_triggers.forEach(function(t) {
                return t.scroller === self.scroller && (i = 1);
            });
            i || $82ba1e40433c64f0$var$_refreshingAll || (self.scroll.rec = 0);
            if (animation) {
                animation.scrollTrigger = null;
                revert && animation.revert({
                    kill: false
                });
                allowAnimation || animation.kill();
            }
            markerStart && [
                markerStart,
                markerEnd,
                markerStartTrigger,
                markerEndTrigger
            ].forEach(function(m) {
                return m.parentNode && m.parentNode.removeChild(m);
            });
            $82ba1e40433c64f0$var$_primary === self && ($82ba1e40433c64f0$var$_primary = 0);
            if (pin) {
                pinCache && (pinCache.uncache = 1);
                i = 0;
                $82ba1e40433c64f0$var$_triggers.forEach(function(t) {
                    return t.pin === pin && i++;
                });
                i || (pinCache.spacer = 0); // if there aren't any more ScrollTriggers with the same pin, remove the spacer, otherwise it could be contaminated with old/stale values if the user re-creates a ScrollTrigger for the same element.
            }
            vars.onKill && vars.onKill(self);
        };
        $82ba1e40433c64f0$var$_triggers.push(self);
        self.enable(false, false);
        customRevertReturn && customRevertReturn(self);
        if (animation && animation.add && !change) {
            // if the animation is a timeline, it may not have been populated yet, so it wouldn't render at the proper place on the first refresh(), thus we should schedule one for the next tick. If "change" is defined, we know it must be re-enabling, thus we can refresh() right away.
            var updateFunc = self.update; // some browsers may fire a scroll event BEFORE a tick elapses and/or the DOMContentLoaded fires. So there's a chance update() will be called BEFORE a refresh() has happened on a Timeline-attached ScrollTrigger which means the start/end won't be calculated yet. We don't want to add conditional logic inside the update() method (like check to see if end is defined and if not, force a refresh()) because that's a function that gets hit a LOT (performance). So we swap out the real update() method for this one that'll re-attach it the first time it gets called and of course forces a refresh().
            self.update = function() {
                self.update = updateFunc;
                (0, $2796a7dcea5802d4$export$3cd1cee43d19b683).cache++; // otherwise a cached scroll position may get used in the refresh() in a very rare scenario, like if ScrollTriggers are created inside a DOMContentLoaded event and the queued requestAnimationFrame() fires beforehand. See https://gsap.com/community/forums/topic/41267-scrolltrigger-breaks-on-refresh-when-using-domcontentloaded/
                start || end || self.refresh();
            };
            $82ba1e40433c64f0$var$gsap.delayedCall(0.01, self.update);
            change = 0.01;
            start = end = 0;
        } else self.refresh();
        pin && $82ba1e40433c64f0$var$_queueRefreshAll(); // pinning could affect the positions of other things, so make sure we queue a full refresh()
    };
    ScrollTrigger.register = function register(core) {
        if (!$82ba1e40433c64f0$var$_coreInitted) {
            $82ba1e40433c64f0$var$gsap = core || $82ba1e40433c64f0$var$_getGSAP();
            $82ba1e40433c64f0$var$_windowExists() && window.document && ScrollTrigger.enable();
            $82ba1e40433c64f0$var$_coreInitted = $82ba1e40433c64f0$var$_enabled;
        }
        return $82ba1e40433c64f0$var$_coreInitted;
    };
    ScrollTrigger.defaults = function defaults(config) {
        if (config) for(var p in config)$82ba1e40433c64f0$var$_defaults[p] = config[p];
        return $82ba1e40433c64f0$var$_defaults;
    };
    ScrollTrigger.disable = function disable(reset, kill) {
        $82ba1e40433c64f0$var$_enabled = 0;
        $82ba1e40433c64f0$var$_triggers.forEach(function(trigger) {
            return trigger[kill ? "kill" : "disable"](reset);
        });
        $82ba1e40433c64f0$var$_removeListener($82ba1e40433c64f0$var$_win, "wheel", $82ba1e40433c64f0$var$_onScroll);
        $82ba1e40433c64f0$var$_removeListener($82ba1e40433c64f0$var$_doc, "scroll", $82ba1e40433c64f0$var$_onScroll);
        clearInterval($82ba1e40433c64f0$var$_syncInterval);
        $82ba1e40433c64f0$var$_removeListener($82ba1e40433c64f0$var$_doc, "touchcancel", $82ba1e40433c64f0$var$_passThrough);
        $82ba1e40433c64f0$var$_removeListener($82ba1e40433c64f0$var$_body, "touchstart", $82ba1e40433c64f0$var$_passThrough);
        $82ba1e40433c64f0$var$_multiListener($82ba1e40433c64f0$var$_removeListener, $82ba1e40433c64f0$var$_doc, "pointerdown,touchstart,mousedown", $82ba1e40433c64f0$var$_pointerDownHandler);
        $82ba1e40433c64f0$var$_multiListener($82ba1e40433c64f0$var$_removeListener, $82ba1e40433c64f0$var$_doc, "pointerup,touchend,mouseup", $82ba1e40433c64f0$var$_pointerUpHandler);
        $82ba1e40433c64f0$var$_resizeDelay.kill();
        $82ba1e40433c64f0$var$_iterateAutoRefresh($82ba1e40433c64f0$var$_removeListener);
        for(var i = 0; i < (0, $2796a7dcea5802d4$export$3cd1cee43d19b683).length; i += 3){
            $82ba1e40433c64f0$var$_wheelListener($82ba1e40433c64f0$var$_removeListener, (0, $2796a7dcea5802d4$export$3cd1cee43d19b683)[i], (0, $2796a7dcea5802d4$export$3cd1cee43d19b683)[i + 1]);
            $82ba1e40433c64f0$var$_wheelListener($82ba1e40433c64f0$var$_removeListener, (0, $2796a7dcea5802d4$export$3cd1cee43d19b683)[i], (0, $2796a7dcea5802d4$export$3cd1cee43d19b683)[i + 2]);
        }
    };
    ScrollTrigger.enable = function enable() {
        $82ba1e40433c64f0$var$_win = window;
        $82ba1e40433c64f0$var$_doc = document;
        $82ba1e40433c64f0$var$_docEl = $82ba1e40433c64f0$var$_doc.documentElement;
        $82ba1e40433c64f0$var$_body = $82ba1e40433c64f0$var$_doc.body;
        if ($82ba1e40433c64f0$var$gsap) {
            $82ba1e40433c64f0$var$_toArray = $82ba1e40433c64f0$var$gsap.utils.toArray;
            $82ba1e40433c64f0$var$_clamp = $82ba1e40433c64f0$var$gsap.utils.clamp;
            $82ba1e40433c64f0$var$_context = $82ba1e40433c64f0$var$gsap.core.context || $82ba1e40433c64f0$var$_passThrough;
            $82ba1e40433c64f0$var$_suppressOverwrites = $82ba1e40433c64f0$var$gsap.core.suppressOverwrites || $82ba1e40433c64f0$var$_passThrough;
            $82ba1e40433c64f0$var$_scrollRestoration = $82ba1e40433c64f0$var$_win.history.scrollRestoration || "auto";
            $82ba1e40433c64f0$var$_lastScroll = $82ba1e40433c64f0$var$_win.pageYOffset || 0;
            $82ba1e40433c64f0$var$gsap.core.globals("ScrollTrigger", ScrollTrigger); // must register the global manually because in Internet Explorer, functions (classes) don't have a "name" property.
            if ($82ba1e40433c64f0$var$_body) {
                $82ba1e40433c64f0$var$_enabled = 1;
                $82ba1e40433c64f0$var$_div100vh = document.createElement("div"); // to solve mobile browser address bar show/hide resizing, we shouldn't rely on window.innerHeight. Instead, use a <div> with its height set to 100vh and measure that since that's what the scrolling is based on anyway and it's not affected by address bar showing/hiding.
                $82ba1e40433c64f0$var$_div100vh.style.height = "100vh";
                $82ba1e40433c64f0$var$_div100vh.style.position = "absolute";
                $82ba1e40433c64f0$var$_refresh100vh();
                $82ba1e40433c64f0$var$_rafBugFix();
                (0, $2796a7dcea5802d4$export$c1cbdee04e18ea8b).register($82ba1e40433c64f0$var$gsap); // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
                ScrollTrigger.isTouch = (0, $2796a7dcea5802d4$export$c1cbdee04e18ea8b).isTouch;
                $82ba1e40433c64f0$var$_fixIOSBug = (0, $2796a7dcea5802d4$export$c1cbdee04e18ea8b).isTouch && /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent); // since 2017, iOS has had a bug that causes event.clientX/Y to be inaccurate when a scroll occurs, thus we must alternate ignoring every other touchmove event to work around it. See https://bugs.webkit.org/show_bug.cgi?id=181954 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503
                $82ba1e40433c64f0$var$_ignoreMobileResize = (0, $2796a7dcea5802d4$export$c1cbdee04e18ea8b).isTouch === 1;
                $82ba1e40433c64f0$var$_addListener($82ba1e40433c64f0$var$_win, "wheel", $82ba1e40433c64f0$var$_onScroll); // mostly for 3rd party smooth scrolling libraries.
                $82ba1e40433c64f0$var$_root = [
                    $82ba1e40433c64f0$var$_win,
                    $82ba1e40433c64f0$var$_doc,
                    $82ba1e40433c64f0$var$_docEl,
                    $82ba1e40433c64f0$var$_body
                ];
                if ($82ba1e40433c64f0$var$gsap.matchMedia) {
                    ScrollTrigger.matchMedia = function(vars) {
                        var mm = $82ba1e40433c64f0$var$gsap.matchMedia(), p;
                        for(p in vars)mm.add(p, vars[p]);
                        return mm;
                    };
                    $82ba1e40433c64f0$var$gsap.addEventListener("matchMediaInit", function() {
                        $82ba1e40433c64f0$var$_recordScrollPositions();
                        $82ba1e40433c64f0$var$_revertAll();
                    });
                    $82ba1e40433c64f0$var$gsap.addEventListener("matchMediaRevert", function() {
                        return $82ba1e40433c64f0$var$_revertRecorded();
                    });
                    $82ba1e40433c64f0$var$gsap.addEventListener("matchMedia", function() {
                        $82ba1e40433c64f0$var$_refreshAll(0, 1);
                        $82ba1e40433c64f0$var$_dispatch("matchMedia");
                    });
                    $82ba1e40433c64f0$var$gsap.matchMedia().add("(orientation: portrait)", function() {
                        // when orientation changes, we should take new base measurements for the ignoreMobileResize feature.
                        $82ba1e40433c64f0$var$_setBaseDimensions();
                        return $82ba1e40433c64f0$var$_setBaseDimensions;
                    });
                } else console.warn("Requires GSAP 3.11.0 or later");
                $82ba1e40433c64f0$var$_setBaseDimensions();
                $82ba1e40433c64f0$var$_addListener($82ba1e40433c64f0$var$_doc, "scroll", $82ba1e40433c64f0$var$_onScroll); // some browsers (like Chrome), the window stops dispatching scroll events on the window if you scroll really fast, but it's consistent on the document!
                var bodyHasStyle = $82ba1e40433c64f0$var$_body.hasAttribute("style"), bodyStyle = $82ba1e40433c64f0$var$_body.style, border = bodyStyle.borderTopStyle, AnimationProto = $82ba1e40433c64f0$var$gsap.core.Animation.prototype, bounds, i;
                AnimationProto.revert || Object.defineProperty(AnimationProto, "revert", {
                    value: function value() {
                        return this.time(-0.01, true);
                    }
                }); // only for backwards compatibility (Animation.revert() was added after 3.10.4)
                bodyStyle.borderTopStyle = "solid"; // works around an issue where a margin of a child element could throw off the bounds of the _body, making it seem like there's a margin when there actually isn't. The border ensures that the bounds are accurate.
                bounds = $82ba1e40433c64f0$var$_getBounds($82ba1e40433c64f0$var$_body);
                (0, $2796a7dcea5802d4$export$8e40fc98ff518e9d).m = Math.round(bounds.top + (0, $2796a7dcea5802d4$export$8e40fc98ff518e9d).sc()) || 0; // accommodate the offset of the <body> caused by margins and/or padding
                (0, $2796a7dcea5802d4$export$b2cabb342cb0ebe1).m = Math.round(bounds.left + (0, $2796a7dcea5802d4$export$b2cabb342cb0ebe1).sc()) || 0;
                border ? bodyStyle.borderTopStyle = border : bodyStyle.removeProperty("border-top-style");
                if (!bodyHasStyle) {
                    // SSR frameworks like Next.js complain if this attribute gets added.
                    $82ba1e40433c64f0$var$_body.setAttribute("style", ""); // it's not enough to just removeAttribute() - we must first set it to empty, otherwise Next.js complains.
                    $82ba1e40433c64f0$var$_body.removeAttribute("style");
                } // TODO: (?) maybe move to leveraging the velocity mechanism in Observer and skip intervals.
                $82ba1e40433c64f0$var$_syncInterval = setInterval($82ba1e40433c64f0$var$_sync, 250);
                $82ba1e40433c64f0$var$gsap.delayedCall(0.5, function() {
                    return $82ba1e40433c64f0$var$_startup = 0;
                });
                $82ba1e40433c64f0$var$_addListener($82ba1e40433c64f0$var$_doc, "touchcancel", $82ba1e40433c64f0$var$_passThrough); // some older Android devices intermittently stop dispatching "touchmove" events if we don't listen for "touchcancel" on the document.
                $82ba1e40433c64f0$var$_addListener($82ba1e40433c64f0$var$_body, "touchstart", $82ba1e40433c64f0$var$_passThrough); //works around Safari bug: https://gsap.com/forums/topic/21450-draggable-in-iframe-on-mobile-is-buggy/
                $82ba1e40433c64f0$var$_multiListener($82ba1e40433c64f0$var$_addListener, $82ba1e40433c64f0$var$_doc, "pointerdown,touchstart,mousedown", $82ba1e40433c64f0$var$_pointerDownHandler);
                $82ba1e40433c64f0$var$_multiListener($82ba1e40433c64f0$var$_addListener, $82ba1e40433c64f0$var$_doc, "pointerup,touchend,mouseup", $82ba1e40433c64f0$var$_pointerUpHandler);
                $82ba1e40433c64f0$var$_transformProp = $82ba1e40433c64f0$var$gsap.utils.checkPrefix("transform");
                $82ba1e40433c64f0$var$_stateProps.push($82ba1e40433c64f0$var$_transformProp);
                $82ba1e40433c64f0$var$_coreInitted = $82ba1e40433c64f0$var$_getTime();
                $82ba1e40433c64f0$var$_resizeDelay = $82ba1e40433c64f0$var$gsap.delayedCall(0.2, $82ba1e40433c64f0$var$_refreshAll).pause();
                $82ba1e40433c64f0$var$_autoRefresh = [
                    $82ba1e40433c64f0$var$_doc,
                    "visibilitychange",
                    function() {
                        var w = $82ba1e40433c64f0$var$_win.innerWidth, h = $82ba1e40433c64f0$var$_win.innerHeight;
                        if ($82ba1e40433c64f0$var$_doc.hidden) {
                            $82ba1e40433c64f0$var$_prevWidth = w;
                            $82ba1e40433c64f0$var$_prevHeight = h;
                        } else if ($82ba1e40433c64f0$var$_prevWidth !== w || $82ba1e40433c64f0$var$_prevHeight !== h) $82ba1e40433c64f0$var$_onResize();
                    },
                    $82ba1e40433c64f0$var$_doc,
                    "DOMContentLoaded",
                    $82ba1e40433c64f0$var$_refreshAll,
                    $82ba1e40433c64f0$var$_win,
                    "load",
                    $82ba1e40433c64f0$var$_refreshAll,
                    $82ba1e40433c64f0$var$_win,
                    "resize",
                    $82ba1e40433c64f0$var$_onResize
                ];
                $82ba1e40433c64f0$var$_iterateAutoRefresh($82ba1e40433c64f0$var$_addListener);
                $82ba1e40433c64f0$var$_triggers.forEach(function(trigger) {
                    return trigger.enable(0, 1);
                });
                for(i = 0; i < (0, $2796a7dcea5802d4$export$3cd1cee43d19b683).length; i += 3){
                    $82ba1e40433c64f0$var$_wheelListener($82ba1e40433c64f0$var$_removeListener, (0, $2796a7dcea5802d4$export$3cd1cee43d19b683)[i], (0, $2796a7dcea5802d4$export$3cd1cee43d19b683)[i + 1]);
                    $82ba1e40433c64f0$var$_wheelListener($82ba1e40433c64f0$var$_removeListener, (0, $2796a7dcea5802d4$export$3cd1cee43d19b683)[i], (0, $2796a7dcea5802d4$export$3cd1cee43d19b683)[i + 2]);
                }
            }
        }
    };
    ScrollTrigger.config = function config(vars) {
        "limitCallbacks" in vars && ($82ba1e40433c64f0$var$_limitCallbacks = !!vars.limitCallbacks);
        var ms = vars.syncInterval;
        ms && clearInterval($82ba1e40433c64f0$var$_syncInterval) || ($82ba1e40433c64f0$var$_syncInterval = ms) && setInterval($82ba1e40433c64f0$var$_sync, ms);
        "ignoreMobileResize" in vars && ($82ba1e40433c64f0$var$_ignoreMobileResize = ScrollTrigger.isTouch === 1 && vars.ignoreMobileResize);
        if ("autoRefreshEvents" in vars) {
            $82ba1e40433c64f0$var$_iterateAutoRefresh($82ba1e40433c64f0$var$_removeListener) || $82ba1e40433c64f0$var$_iterateAutoRefresh($82ba1e40433c64f0$var$_addListener, vars.autoRefreshEvents || "none");
            $82ba1e40433c64f0$var$_ignoreResize = (vars.autoRefreshEvents + "").indexOf("resize") === -1;
        }
    };
    ScrollTrigger.scrollerProxy = function scrollerProxy(target, vars) {
        var t = (0, $2796a7dcea5802d4$export$937374fea3f88711)(target), i = (0, $2796a7dcea5802d4$export$3cd1cee43d19b683).indexOf(t), isViewport = $82ba1e40433c64f0$var$_isViewport(t);
        if (~i) (0, $2796a7dcea5802d4$export$3cd1cee43d19b683).splice(i, isViewport ? 6 : 2);
        if (vars) isViewport ? (0, $2796a7dcea5802d4$export$d8e56d510a804d0a).unshift($82ba1e40433c64f0$var$_win, vars, $82ba1e40433c64f0$var$_body, vars, $82ba1e40433c64f0$var$_docEl, vars) : (0, $2796a7dcea5802d4$export$d8e56d510a804d0a).unshift(t, vars);
    };
    ScrollTrigger.clearMatchMedia = function clearMatchMedia(query) {
        $82ba1e40433c64f0$var$_triggers.forEach(function(t) {
            return t._ctx && t._ctx.query === query && t._ctx.kill(true, true);
        });
    };
    ScrollTrigger.isInViewport = function isInViewport(element, ratio, horizontal) {
        var bounds = ($82ba1e40433c64f0$var$_isString(element) ? (0, $2796a7dcea5802d4$export$937374fea3f88711)(element) : element).getBoundingClientRect(), offset = bounds[horizontal ? $82ba1e40433c64f0$var$_width : $82ba1e40433c64f0$var$_height] * ratio || 0;
        return horizontal ? bounds.right - offset > 0 && bounds.left + offset < $82ba1e40433c64f0$var$_win.innerWidth : bounds.bottom - offset > 0 && bounds.top + offset < $82ba1e40433c64f0$var$_win.innerHeight;
    };
    ScrollTrigger.positionInViewport = function positionInViewport(element, referencePoint, horizontal) {
        $82ba1e40433c64f0$var$_isString(element) && (element = (0, $2796a7dcea5802d4$export$937374fea3f88711)(element));
        var bounds = element.getBoundingClientRect(), size = bounds[horizontal ? $82ba1e40433c64f0$var$_width : $82ba1e40433c64f0$var$_height], offset = referencePoint == null ? size / 2 : referencePoint in $82ba1e40433c64f0$var$_keywords ? $82ba1e40433c64f0$var$_keywords[referencePoint] * size : ~referencePoint.indexOf("%") ? parseFloat(referencePoint) * size / 100 : parseFloat(referencePoint) || 0;
        return horizontal ? (bounds.left + offset) / $82ba1e40433c64f0$var$_win.innerWidth : (bounds.top + offset) / $82ba1e40433c64f0$var$_win.innerHeight;
    };
    ScrollTrigger.killAll = function killAll(allowListeners) {
        $82ba1e40433c64f0$var$_triggers.slice(0).forEach(function(t) {
            return t.vars.id !== "ScrollSmoother" && t.kill();
        });
        if (allowListeners !== true) {
            var listeners = $82ba1e40433c64f0$var$_listeners.killAll || [];
            $82ba1e40433c64f0$var$_listeners = {};
            listeners.forEach(function(f) {
                return f();
            });
        }
    };
    return ScrollTrigger;
}();
$82ba1e40433c64f0$export$875bcbe48555930.version = "3.14.2";
$82ba1e40433c64f0$export$875bcbe48555930.saveStyles = function(targets) {
    return targets ? $82ba1e40433c64f0$var$_toArray(targets).forEach(function(target) {
        // saved styles are recorded in a consecutive alternating Array, like [element, cssText, transform attribute, cache, matchMedia, ...]
        if (target && target.style) {
            var i = $82ba1e40433c64f0$var$_savedStyles.indexOf(target);
            i >= 0 && $82ba1e40433c64f0$var$_savedStyles.splice(i, 5);
            $82ba1e40433c64f0$var$_savedStyles.push(target, target.style.cssText, target.getBBox && target.getAttribute("transform"), $82ba1e40433c64f0$var$gsap.core.getCache(target), $82ba1e40433c64f0$var$_context());
        }
    }) : $82ba1e40433c64f0$var$_savedStyles;
};
$82ba1e40433c64f0$export$875bcbe48555930.revert = function(soft, media) {
    return $82ba1e40433c64f0$var$_revertAll(!soft, media);
};
$82ba1e40433c64f0$export$875bcbe48555930.create = function(vars, animation) {
    return new $82ba1e40433c64f0$export$875bcbe48555930(vars, animation);
};
$82ba1e40433c64f0$export$875bcbe48555930.refresh = function(safe) {
    return safe ? $82ba1e40433c64f0$var$_onResize(true) : ($82ba1e40433c64f0$var$_coreInitted || $82ba1e40433c64f0$export$875bcbe48555930.register()) && $82ba1e40433c64f0$var$_refreshAll(true);
};
$82ba1e40433c64f0$export$875bcbe48555930.update = function(force) {
    return ++(0, $2796a7dcea5802d4$export$3cd1cee43d19b683).cache && $82ba1e40433c64f0$var$_updateAll(force === true ? 2 : 0);
};
$82ba1e40433c64f0$export$875bcbe48555930.clearScrollMemory = $82ba1e40433c64f0$var$_clearScrollMemory;
$82ba1e40433c64f0$export$875bcbe48555930.maxScroll = function(element, horizontal) {
    return $82ba1e40433c64f0$var$_maxScroll(element, horizontal ? (0, $2796a7dcea5802d4$export$b2cabb342cb0ebe1) : (0, $2796a7dcea5802d4$export$8e40fc98ff518e9d));
};
$82ba1e40433c64f0$export$875bcbe48555930.getScrollFunc = function(element, horizontal) {
    return (0, $2796a7dcea5802d4$export$8665aac53dad5647)((0, $2796a7dcea5802d4$export$937374fea3f88711)(element), horizontal ? (0, $2796a7dcea5802d4$export$b2cabb342cb0ebe1) : (0, $2796a7dcea5802d4$export$8e40fc98ff518e9d));
};
$82ba1e40433c64f0$export$875bcbe48555930.getById = function(id) {
    return $82ba1e40433c64f0$var$_ids[id];
};
$82ba1e40433c64f0$export$875bcbe48555930.getAll = function() {
    return $82ba1e40433c64f0$var$_triggers.filter(function(t) {
        return t.vars.id !== "ScrollSmoother";
    });
}; // it's common for people to ScrollTrigger.getAll(t => t.kill()) on page routes, for example, and we don't want it to ruin smooth scrolling by killing the main ScrollSmoother one.
$82ba1e40433c64f0$export$875bcbe48555930.isScrolling = function() {
    return !!$82ba1e40433c64f0$var$_lastScrollTime;
};
$82ba1e40433c64f0$export$875bcbe48555930.snapDirectional = $82ba1e40433c64f0$var$_snapDirectional;
$82ba1e40433c64f0$export$875bcbe48555930.addEventListener = function(type, callback) {
    var a = $82ba1e40433c64f0$var$_listeners[type] || ($82ba1e40433c64f0$var$_listeners[type] = []);
    ~a.indexOf(callback) || a.push(callback);
};
$82ba1e40433c64f0$export$875bcbe48555930.removeEventListener = function(type, callback) {
    var a = $82ba1e40433c64f0$var$_listeners[type], i = a && a.indexOf(callback);
    i >= 0 && a.splice(i, 1);
};
$82ba1e40433c64f0$export$875bcbe48555930.batch = function(targets, vars) {
    var result = [], varsCopy = {}, interval = vars.interval || 0.016, batchMax = vars.batchMax || 1e9, proxyCallback = function proxyCallback(type, callback) {
        var elements = [], triggers = [], delay = $82ba1e40433c64f0$var$gsap.delayedCall(interval, function() {
            callback(elements, triggers);
            elements = [];
            triggers = [];
        }).pause();
        return function(self) {
            elements.length || delay.restart(true);
            elements.push(self.trigger);
            triggers.push(self);
            batchMax <= elements.length && delay.progress(1);
        };
    }, p;
    for(p in vars)varsCopy[p] = p.substr(0, 2) === "on" && $82ba1e40433c64f0$var$_isFunction(vars[p]) && p !== "onRefreshInit" ? proxyCallback(p, vars[p]) : vars[p];
    if ($82ba1e40433c64f0$var$_isFunction(batchMax)) {
        batchMax = batchMax();
        $82ba1e40433c64f0$var$_addListener($82ba1e40433c64f0$export$875bcbe48555930, "refresh", function() {
            return batchMax = vars.batchMax();
        });
    }
    $82ba1e40433c64f0$var$_toArray(targets).forEach(function(target) {
        var config = {};
        for(p in varsCopy)config[p] = varsCopy[p];
        config.trigger = target;
        result.push($82ba1e40433c64f0$export$875bcbe48555930.create(config));
    });
    return result;
}; // to reduce file size. clamps the scroll and also returns a duration multiplier so that if the scroll gets chopped shorter, the duration gets curtailed as well (otherwise if you're very close to the top of the page, for example, and swipe up really fast, it'll suddenly slow down and take a long time to reach the top).
var $82ba1e40433c64f0$var$_clampScrollAndGetDurationMultiplier = function _clampScrollAndGetDurationMultiplier(scrollFunc, current, end, max) {
    current > max ? scrollFunc(max) : current < 0 && scrollFunc(0);
    return end > max ? (max - current) / (end - current) : end < 0 ? current / (current - end) : 1;
}, $82ba1e40433c64f0$var$_allowNativePanning = function _allowNativePanning(target, direction) {
    if (direction === true) target.style.removeProperty("touch-action");
    else target.style.touchAction = direction === true ? "auto" : direction ? "pan-" + direction + ((0, $2796a7dcea5802d4$export$c1cbdee04e18ea8b).isTouch ? " pinch-zoom" : "") : "none"; // note: Firefox doesn't support it pinch-zoom properly, at least in addition to a pan-x or pan-y.
    target === $82ba1e40433c64f0$var$_docEl && _allowNativePanning($82ba1e40433c64f0$var$_body, direction);
}, $82ba1e40433c64f0$var$_overflow = {
    auto: 1,
    scroll: 1
}, $82ba1e40433c64f0$var$_nestedScroll = function _nestedScroll(_ref5) {
    var event = _ref5.event, target = _ref5.target, axis = _ref5.axis;
    var node = (event.changedTouches ? event.changedTouches[0] : event).target, cache = node._gsap || $82ba1e40433c64f0$var$gsap.core.getCache(node), time = $82ba1e40433c64f0$var$_getTime(), cs;
    if (!cache._isScrollT || time - cache._isScrollT > 2000) {
        // cache for 2 seconds to improve performance.
        while(node && node !== $82ba1e40433c64f0$var$_body && (node.scrollHeight <= node.clientHeight && node.scrollWidth <= node.clientWidth || !($82ba1e40433c64f0$var$_overflow[(cs = $82ba1e40433c64f0$var$_getComputedStyle(node)).overflowY] || $82ba1e40433c64f0$var$_overflow[cs.overflowX])))node = node.parentNode;
        cache._isScroll = node && node !== target && !$82ba1e40433c64f0$var$_isViewport(node) && ($82ba1e40433c64f0$var$_overflow[(cs = $82ba1e40433c64f0$var$_getComputedStyle(node)).overflowY] || $82ba1e40433c64f0$var$_overflow[cs.overflowX]);
        cache._isScrollT = time;
    }
    if (cache._isScroll || axis === "x") {
        event.stopPropagation();
        event._gsapAllow = true;
    }
}, // capture events on scrollable elements INSIDE the <body> and allow those by calling stopPropagation() when we find a scrollable ancestor
$82ba1e40433c64f0$var$_inputObserver = function _inputObserver(target, type, inputs, nested) {
    return (0, $2796a7dcea5802d4$export$c1cbdee04e18ea8b).create({
        target: target,
        capture: true,
        debounce: false,
        lockAxis: true,
        type: type,
        onWheel: nested = nested && $82ba1e40433c64f0$var$_nestedScroll,
        onPress: nested,
        onDrag: nested,
        onScroll: nested,
        onEnable: function onEnable() {
            return inputs && $82ba1e40433c64f0$var$_addListener($82ba1e40433c64f0$var$_doc, (0, $2796a7dcea5802d4$export$c1cbdee04e18ea8b).eventTypes[0], $82ba1e40433c64f0$var$_captureInputs, false, true);
        },
        onDisable: function onDisable() {
            return $82ba1e40433c64f0$var$_removeListener($82ba1e40433c64f0$var$_doc, (0, $2796a7dcea5802d4$export$c1cbdee04e18ea8b).eventTypes[0], $82ba1e40433c64f0$var$_captureInputs, true);
        }
    });
}, $82ba1e40433c64f0$var$_inputExp = /(input|label|select|textarea)/i, $82ba1e40433c64f0$var$_inputIsFocused, $82ba1e40433c64f0$var$_captureInputs = function _captureInputs(e) {
    var isInput = $82ba1e40433c64f0$var$_inputExp.test(e.target.tagName);
    if (isInput || $82ba1e40433c64f0$var$_inputIsFocused) {
        e._gsapAllow = true;
        $82ba1e40433c64f0$var$_inputIsFocused = isInput;
    }
}, $82ba1e40433c64f0$var$_getScrollNormalizer = function _getScrollNormalizer(vars) {
    $82ba1e40433c64f0$var$_isObject(vars) || (vars = {});
    vars.preventDefault = vars.isNormalizer = vars.allowClicks = true;
    vars.type || (vars.type = "wheel,touch");
    vars.debounce = !!vars.debounce;
    vars.id = vars.id || "normalizer";
    var _vars2 = vars, normalizeScrollX = _vars2.normalizeScrollX, momentum = _vars2.momentum, allowNestedScroll = _vars2.allowNestedScroll, onRelease = _vars2.onRelease, self, maxY, target = (0, $2796a7dcea5802d4$export$937374fea3f88711)(vars.target) || $82ba1e40433c64f0$var$_docEl, smoother = $82ba1e40433c64f0$var$gsap.core.globals().ScrollSmoother, smootherInstance = smoother && smoother.get(), content = $82ba1e40433c64f0$var$_fixIOSBug && (vars.content && (0, $2796a7dcea5802d4$export$937374fea3f88711)(vars.content) || smootherInstance && vars.content !== false && !smootherInstance.smooth() && smootherInstance.content()), scrollFuncY = (0, $2796a7dcea5802d4$export$8665aac53dad5647)(target, (0, $2796a7dcea5802d4$export$8e40fc98ff518e9d)), scrollFuncX = (0, $2796a7dcea5802d4$export$8665aac53dad5647)(target, (0, $2796a7dcea5802d4$export$b2cabb342cb0ebe1)), scale = 1, initialScale = ((0, $2796a7dcea5802d4$export$c1cbdee04e18ea8b).isTouch && $82ba1e40433c64f0$var$_win.visualViewport ? $82ba1e40433c64f0$var$_win.visualViewport.scale * $82ba1e40433c64f0$var$_win.visualViewport.width : $82ba1e40433c64f0$var$_win.outerWidth) / $82ba1e40433c64f0$var$_win.innerWidth, wheelRefresh = 0, resolveMomentumDuration = $82ba1e40433c64f0$var$_isFunction(momentum) ? function() {
        return momentum(self);
    } : function() {
        return momentum || 2.8;
    }, lastRefreshID, skipTouchMove, inputObserver = $82ba1e40433c64f0$var$_inputObserver(target, vars.type, true, allowNestedScroll), resumeTouchMove = function resumeTouchMove() {
        return skipTouchMove = false;
    }, scrollClampX = $82ba1e40433c64f0$var$_passThrough, scrollClampY = $82ba1e40433c64f0$var$_passThrough, updateClamps = function updateClamps() {
        maxY = $82ba1e40433c64f0$var$_maxScroll(target, (0, $2796a7dcea5802d4$export$8e40fc98ff518e9d));
        scrollClampY = $82ba1e40433c64f0$var$_clamp($82ba1e40433c64f0$var$_fixIOSBug ? 1 : 0, maxY);
        normalizeScrollX && (scrollClampX = $82ba1e40433c64f0$var$_clamp(0, $82ba1e40433c64f0$var$_maxScroll(target, (0, $2796a7dcea5802d4$export$b2cabb342cb0ebe1))));
        lastRefreshID = $82ba1e40433c64f0$var$_refreshID;
    }, removeContentOffset = function removeContentOffset() {
        content._gsap.y = $82ba1e40433c64f0$var$_round(parseFloat(content._gsap.y) + scrollFuncY.offset) + "px";
        content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + parseFloat(content._gsap.y) + ", 0, 1)";
        scrollFuncY.offset = scrollFuncY.cacheID = 0;
    }, ignoreDrag = function ignoreDrag() {
        if (skipTouchMove) {
            requestAnimationFrame(resumeTouchMove);
            var offset = $82ba1e40433c64f0$var$_round(self.deltaY / 2), scroll = scrollClampY(scrollFuncY.v - offset);
            if (content && scroll !== scrollFuncY.v + scrollFuncY.offset) {
                scrollFuncY.offset = scroll - scrollFuncY.v;
                var y = $82ba1e40433c64f0$var$_round((parseFloat(content && content._gsap.y) || 0) - scrollFuncY.offset);
                content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + y + ", 0, 1)";
                content._gsap.y = y + "px";
                scrollFuncY.cacheID = (0, $2796a7dcea5802d4$export$3cd1cee43d19b683).cache;
                $82ba1e40433c64f0$var$_updateAll();
            }
            return true;
        }
        scrollFuncY.offset && removeContentOffset();
        skipTouchMove = true;
    }, tween, startScrollX, startScrollY, onStopDelayedCall, onResize = function onResize() {
        // if the window resizes, like on an iPhone which Apple FORCES the address bar to show/hide even if we event.preventDefault(), it may be scrolling too far now that the address bar is showing, so we must dynamically adjust the momentum tween.
        updateClamps();
        if (tween.isActive() && tween.vars.scrollY > maxY) scrollFuncY() > maxY ? tween.progress(1) && scrollFuncY(maxY) : tween.resetTo("scrollY", maxY);
    };
    content && $82ba1e40433c64f0$var$gsap.set(content, {
        y: "+=0"
    }); // to ensure there's a cache (element._gsap)
    vars.ignoreCheck = function(e) {
        return $82ba1e40433c64f0$var$_fixIOSBug && e.type === "touchmove" && ignoreDrag(e) || scale > 1.05 && e.type !== "touchstart" || self.isGesturing || e.touches && e.touches.length > 1;
    };
    vars.onPress = function() {
        skipTouchMove = false;
        var prevScale = scale;
        scale = $82ba1e40433c64f0$var$_round(($82ba1e40433c64f0$var$_win.visualViewport && $82ba1e40433c64f0$var$_win.visualViewport.scale || 1) / initialScale);
        tween.pause();
        prevScale !== scale && $82ba1e40433c64f0$var$_allowNativePanning(target, scale > 1.01 ? true : normalizeScrollX ? false : "x");
        startScrollX = scrollFuncX();
        startScrollY = scrollFuncY();
        updateClamps();
        lastRefreshID = $82ba1e40433c64f0$var$_refreshID;
    };
    vars.onRelease = vars.onGestureStart = function(self, wasDragging) {
        scrollFuncY.offset && removeContentOffset();
        if (!wasDragging) onStopDelayedCall.restart(true);
        else {
            (0, $2796a7dcea5802d4$export$3cd1cee43d19b683).cache++; // make sure we're pulling the non-cached value
            // alternate algorithm: durX = Math.min(6, Math.abs(self.velocityX / 800)),	dur = Math.max(durX, Math.min(6, Math.abs(self.velocityY / 800))); dur = dur * (0.4 + (1 - _power4In(dur / 6)) * 0.6)) * (momentumSpeed || 1)
            var dur = resolveMomentumDuration(), currentScroll, endScroll;
            if (normalizeScrollX) {
                currentScroll = scrollFuncX();
                endScroll = currentScroll + dur * 0.05 * -self.velocityX / 0.227; // the constant .227 is from power4(0.05). velocity is inverted because scrolling goes in the opposite direction.
                dur *= $82ba1e40433c64f0$var$_clampScrollAndGetDurationMultiplier(scrollFuncX, currentScroll, endScroll, $82ba1e40433c64f0$var$_maxScroll(target, (0, $2796a7dcea5802d4$export$b2cabb342cb0ebe1)));
                tween.vars.scrollX = scrollClampX(endScroll);
            }
            currentScroll = scrollFuncY();
            endScroll = currentScroll + dur * 0.05 * -self.velocityY / 0.227; // the constant .227 is from power4(0.05)
            dur *= $82ba1e40433c64f0$var$_clampScrollAndGetDurationMultiplier(scrollFuncY, currentScroll, endScroll, $82ba1e40433c64f0$var$_maxScroll(target, (0, $2796a7dcea5802d4$export$8e40fc98ff518e9d)));
            tween.vars.scrollY = scrollClampY(endScroll);
            tween.invalidate().duration(dur).play(0.01);
            if ($82ba1e40433c64f0$var$_fixIOSBug && tween.vars.scrollY >= maxY || currentScroll >= maxY - 1) // iOS bug: it'll show the address bar but NOT fire the window "resize" event until the animation is done but we must protect against overshoot so we leverage an onUpdate to do so.
            $82ba1e40433c64f0$var$gsap.to({}, {
                onUpdate: onResize,
                duration: dur
            });
        }
        onRelease && onRelease(self);
    };
    vars.onWheel = function() {
        tween._ts && tween.pause();
        if ($82ba1e40433c64f0$var$_getTime() - wheelRefresh > 1000) {
            // after 1 second, refresh the clamps otherwise that'll only happen when ScrollTrigger.refresh() is called or for touch-scrolling.
            lastRefreshID = 0;
            wheelRefresh = $82ba1e40433c64f0$var$_getTime();
        }
    };
    vars.onChange = function(self, dx, dy, xArray, yArray) {
        $82ba1e40433c64f0$var$_refreshID !== lastRefreshID && updateClamps();
        dx && normalizeScrollX && scrollFuncX(scrollClampX(xArray[2] === dx ? startScrollX + (self.startX - self.x) : scrollFuncX() + dx - xArray[1])); // for more precision, we track pointer/touch movement from the start, otherwise it'll drift.
        if (dy) {
            scrollFuncY.offset && removeContentOffset();
            var isTouch = yArray[2] === dy, y = isTouch ? startScrollY + self.startY - self.y : scrollFuncY() + dy - yArray[1], yClamped = scrollClampY(y);
            isTouch && y !== yClamped && (startScrollY += yClamped - y);
            scrollFuncY(yClamped);
        }
        (dy || dx) && $82ba1e40433c64f0$var$_updateAll();
    };
    vars.onEnable = function() {
        $82ba1e40433c64f0$var$_allowNativePanning(target, normalizeScrollX ? false : "x");
        $82ba1e40433c64f0$export$875bcbe48555930.addEventListener("refresh", onResize);
        $82ba1e40433c64f0$var$_addListener($82ba1e40433c64f0$var$_win, "resize", onResize);
        if (scrollFuncY.smooth) {
            scrollFuncY.target.style.scrollBehavior = "auto";
            scrollFuncY.smooth = scrollFuncX.smooth = false;
        }
        inputObserver.enable();
    };
    vars.onDisable = function() {
        $82ba1e40433c64f0$var$_allowNativePanning(target, true);
        $82ba1e40433c64f0$var$_removeListener($82ba1e40433c64f0$var$_win, "resize", onResize);
        $82ba1e40433c64f0$export$875bcbe48555930.removeEventListener("refresh", onResize);
        inputObserver.kill();
    };
    vars.lockAxis = vars.lockAxis !== false;
    self = new (0, $2796a7dcea5802d4$export$c1cbdee04e18ea8b)(vars);
    self.iOS = $82ba1e40433c64f0$var$_fixIOSBug; // used in the Observer getCachedScroll() function to work around an iOS bug that wreaks havoc with TouchEvent.clientY if we allow scroll to go all the way back to 0.
    $82ba1e40433c64f0$var$_fixIOSBug && !scrollFuncY() && scrollFuncY(1); // iOS bug causes event.clientY values to freak out (wildly inaccurate) if the scroll position is exactly 0.
    $82ba1e40433c64f0$var$_fixIOSBug && $82ba1e40433c64f0$var$gsap.ticker.add($82ba1e40433c64f0$var$_passThrough); // prevent the ticker from sleeping
    onStopDelayedCall = self._dc;
    tween = $82ba1e40433c64f0$var$gsap.to(self, {
        ease: "power4",
        paused: true,
        inherit: false,
        scrollX: normalizeScrollX ? "+=0.1" : "+=0",
        scrollY: "+=0.1",
        modifiers: {
            scrollY: $82ba1e40433c64f0$var$_interruptionTracker(scrollFuncY, scrollFuncY(), function() {
                return tween.pause();
            })
        },
        onUpdate: $82ba1e40433c64f0$var$_updateAll,
        onComplete: onStopDelayedCall.vars.onComplete
    }); // we need the modifier to sense if the scroll position is altered outside of the momentum tween (like with a scrollTo tween) so we can pause() it to prevent conflicts.
    return self;
};
$82ba1e40433c64f0$export$875bcbe48555930.sort = function(func) {
    if ($82ba1e40433c64f0$var$_isFunction(func)) return $82ba1e40433c64f0$var$_triggers.sort(func);
    var scroll = $82ba1e40433c64f0$var$_win.pageYOffset || 0;
    $82ba1e40433c64f0$export$875bcbe48555930.getAll().forEach(function(t) {
        return t._sortY = t.trigger ? scroll + t.trigger.getBoundingClientRect().top : t.start + $82ba1e40433c64f0$var$_win.innerHeight;
    });
    return $82ba1e40433c64f0$var$_triggers.sort(func || function(a, b) {
        return (a.vars.refreshPriority || 0) * -1000000 + (a.vars.containerAnimation ? 1e6 : a._sortY) - ((b.vars.containerAnimation ? 1e6 : b._sortY) + (b.vars.refreshPriority || 0) * -1000000);
    }); // anything with a containerAnimation should refresh last.
};
$82ba1e40433c64f0$export$875bcbe48555930.observe = function(vars) {
    return new (0, $2796a7dcea5802d4$export$c1cbdee04e18ea8b)(vars);
};
$82ba1e40433c64f0$export$875bcbe48555930.normalizeScroll = function(vars) {
    if (typeof vars === "undefined") return $82ba1e40433c64f0$var$_normalizer;
    if (vars === true && $82ba1e40433c64f0$var$_normalizer) return $82ba1e40433c64f0$var$_normalizer.enable();
    if (vars === false) {
        $82ba1e40433c64f0$var$_normalizer && $82ba1e40433c64f0$var$_normalizer.kill();
        $82ba1e40433c64f0$var$_normalizer = vars;
        return;
    }
    var normalizer = vars instanceof (0, $2796a7dcea5802d4$export$c1cbdee04e18ea8b) ? vars : $82ba1e40433c64f0$var$_getScrollNormalizer(vars);
    $82ba1e40433c64f0$var$_normalizer && $82ba1e40433c64f0$var$_normalizer.target === normalizer.target && $82ba1e40433c64f0$var$_normalizer.kill();
    $82ba1e40433c64f0$var$_isViewport(normalizer.target) && ($82ba1e40433c64f0$var$_normalizer = normalizer);
    return normalizer;
};
$82ba1e40433c64f0$export$875bcbe48555930.core = {
    // smaller file size way to leverage in ScrollSmoother and Observer
    _getVelocityProp: (0, $2796a7dcea5802d4$export$5de019f4480f0f8d),
    _inputObserver: $82ba1e40433c64f0$var$_inputObserver,
    _scrollers: (0, $2796a7dcea5802d4$export$3cd1cee43d19b683),
    _proxies: (0, $2796a7dcea5802d4$export$d8e56d510a804d0a),
    bridge: {
        // when normalizeScroll sets the scroll position (ss = setScroll)
        ss: function ss() {
            $82ba1e40433c64f0$var$_lastScrollTime || $82ba1e40433c64f0$var$_dispatch("scrollStart");
            $82ba1e40433c64f0$var$_lastScrollTime = $82ba1e40433c64f0$var$_getTime();
        },
        // a way to get the _refreshing value in Observer
        ref: function ref() {
            return $82ba1e40433c64f0$var$_refreshing;
        }
    }
};
$82ba1e40433c64f0$var$_getGSAP() && $82ba1e40433c64f0$var$gsap.registerPlugin($82ba1e40433c64f0$export$875bcbe48555930);















var $6255c273005a4429$export$99ee26438460406a = (0, $8w6H4.default).registerPlugin((0, $4ad50e95ed8fc124$export$855822f522f18eef)) || (0, $8w6H4.default), // to protect from tree shaking
$6255c273005a4429$export$7b23975ad686bf91 = $6255c273005a4429$export$99ee26438460406a.core.Tween;


// package.json
var $12aa2a06f48a44b4$var$version = "1.3.17";
// packages/core/src/maths.ts
function $12aa2a06f48a44b4$var$clamp(min, input, max) {
    return Math.max(min, Math.min(input, max));
}
function $12aa2a06f48a44b4$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
function $12aa2a06f48a44b4$var$damp(x, y, lambda, deltaTime) {
    return $12aa2a06f48a44b4$var$lerp(x, y, 1 - Math.exp(-lambda * deltaTime));
}
function $12aa2a06f48a44b4$var$modulo(n, d) {
    return (n % d + d) % d;
}
// packages/core/src/animate.ts
var $12aa2a06f48a44b4$var$Animate = class {
    isRunning = false;
    value = 0;
    from = 0;
    to = 0;
    currentTime = 0;
    // These are instanciated in the fromTo method
    lerp;
    duration;
    easing;
    onUpdate;
    /**
   * Advance the animation by the given delta time
   *
   * @param deltaTime - The time in seconds to advance the animation
   */ advance(deltaTime) {
        if (!this.isRunning) return;
        let completed = false;
        if (this.duration && this.easing) {
            this.currentTime += deltaTime;
            const linearProgress = $12aa2a06f48a44b4$var$clamp(0, this.currentTime / this.duration, 1);
            completed = linearProgress >= 1;
            const easedProgress = completed ? 1 : this.easing(linearProgress);
            this.value = this.from + (this.to - this.from) * easedProgress;
        } else if (this.lerp) {
            this.value = $12aa2a06f48a44b4$var$damp(this.value, this.to, this.lerp * 60, deltaTime);
            if (Math.round(this.value) === this.to) {
                this.value = this.to;
                completed = true;
            }
        } else {
            this.value = this.to;
            completed = true;
        }
        if (completed) this.stop();
        this.onUpdate?.(this.value, completed);
    }
    /** Stop the animation */ stop() {
        this.isRunning = false;
    }
    /**
   * Set up the animation from a starting value to an ending value
   * with optional parameters for lerping, duration, easing, and onUpdate callback
   *
   * @param from - The starting value
   * @param to - The ending value
   * @param options - Options for the animation
   */ fromTo(from, to, { lerp: lerp2, duration: duration, easing: easing, onStart: onStart, onUpdate: onUpdate }) {
        this.from = this.value = from;
        this.to = to;
        this.lerp = lerp2;
        this.duration = duration;
        this.easing = easing;
        this.currentTime = 0;
        this.isRunning = true;
        onStart?.();
        this.onUpdate = onUpdate;
    }
};
// packages/core/src/debounce.ts
function $12aa2a06f48a44b4$var$debounce(callback, delay) {
    let timer;
    return function(...args) {
        let context = this;
        clearTimeout(timer);
        timer = setTimeout(()=>{
            timer = void 0;
            callback.apply(context, args);
        }, delay);
    };
}
// packages/core/src/dimensions.ts
var $12aa2a06f48a44b4$var$Dimensions = class {
    constructor(wrapper, content, { autoResize: autoResize = true, debounce: debounceValue = 250 } = {}){
        this.wrapper = wrapper;
        this.content = content;
        if (autoResize) {
            this.debouncedResize = $12aa2a06f48a44b4$var$debounce(this.resize, debounceValue);
            if (this.wrapper instanceof Window) window.addEventListener("resize", this.debouncedResize, false);
            else {
                this.wrapperResizeObserver = new ResizeObserver(this.debouncedResize);
                this.wrapperResizeObserver.observe(this.wrapper);
            }
            this.contentResizeObserver = new ResizeObserver(this.debouncedResize);
            this.contentResizeObserver.observe(this.content);
        }
        this.resize();
    }
    width = 0;
    height = 0;
    scrollHeight = 0;
    scrollWidth = 0;
    // These are instanciated in the constructor as they need information from the options
    debouncedResize;
    wrapperResizeObserver;
    contentResizeObserver;
    destroy() {
        this.wrapperResizeObserver?.disconnect();
        this.contentResizeObserver?.disconnect();
        if (this.wrapper === window && this.debouncedResize) window.removeEventListener("resize", this.debouncedResize, false);
    }
    resize = ()=>{
        this.onWrapperResize();
        this.onContentResize();
    };
    onWrapperResize = ()=>{
        if (this.wrapper instanceof Window) {
            this.width = window.innerWidth;
            this.height = window.innerHeight;
        } else {
            this.width = this.wrapper.clientWidth;
            this.height = this.wrapper.clientHeight;
        }
    };
    onContentResize = ()=>{
        if (this.wrapper instanceof Window) {
            this.scrollHeight = this.content.scrollHeight;
            this.scrollWidth = this.content.scrollWidth;
        } else {
            this.scrollHeight = this.wrapper.scrollHeight;
            this.scrollWidth = this.wrapper.scrollWidth;
        }
    };
    get limit() {
        return {
            x: this.scrollWidth - this.width,
            y: this.scrollHeight - this.height
        };
    }
};
// packages/core/src/emitter.ts
var $12aa2a06f48a44b4$var$Emitter = class {
    events = {};
    /**
   * Emit an event with the given data
   * @param event Event name
   * @param args Data to pass to the event handlers
   */ emit(event, ...args) {
        let callbacks = this.events[event] || [];
        for(let i = 0, length = callbacks.length; i < length; i++)callbacks[i]?.(...args);
    }
    /**
   * Add a callback to the event
   * @param event Event name
   * @param cb Callback function
   * @returns Unsubscribe function
   */ on(event, cb) {
        this.events[event]?.push(cb) || (this.events[event] = [
            cb
        ]);
        return ()=>{
            this.events[event] = this.events[event]?.filter((i)=>cb !== i);
        };
    }
    /**
   * Remove a callback from the event
   * @param event Event name
   * @param callback Callback function
   */ off(event, callback) {
        this.events[event] = this.events[event]?.filter((i)=>callback !== i);
    }
    /**
   * Remove all event listeners and clean up
   */ destroy() {
        this.events = {};
    }
};
// packages/core/src/virtual-scroll.ts
var $12aa2a06f48a44b4$var$LINE_HEIGHT = 100 / 6;
var $12aa2a06f48a44b4$var$listenerOptions = {
    passive: false
};
var $12aa2a06f48a44b4$var$VirtualScroll = class {
    constructor(element, options = {
        wheelMultiplier: 1,
        touchMultiplier: 1
    }){
        this.element = element;
        this.options = options;
        window.addEventListener("resize", this.onWindowResize, false);
        this.onWindowResize();
        this.element.addEventListener("wheel", this.onWheel, $12aa2a06f48a44b4$var$listenerOptions);
        this.element.addEventListener("touchstart", this.onTouchStart, $12aa2a06f48a44b4$var$listenerOptions);
        this.element.addEventListener("touchmove", this.onTouchMove, $12aa2a06f48a44b4$var$listenerOptions);
        this.element.addEventListener("touchend", this.onTouchEnd, $12aa2a06f48a44b4$var$listenerOptions);
    }
    touchStart = {
        x: 0,
        y: 0
    };
    lastDelta = {
        x: 0,
        y: 0
    };
    window = {
        width: 0,
        height: 0
    };
    emitter = new $12aa2a06f48a44b4$var$Emitter();
    /**
   * Add an event listener for the given event and callback
   *
   * @param event Event name
   * @param callback Callback function
   */ on(event, callback) {
        return this.emitter.on(event, callback);
    }
    /** Remove all event listeners and clean up */ destroy() {
        this.emitter.destroy();
        window.removeEventListener("resize", this.onWindowResize, false);
        this.element.removeEventListener("wheel", this.onWheel, $12aa2a06f48a44b4$var$listenerOptions);
        this.element.removeEventListener("touchstart", this.onTouchStart, $12aa2a06f48a44b4$var$listenerOptions);
        this.element.removeEventListener("touchmove", this.onTouchMove, $12aa2a06f48a44b4$var$listenerOptions);
        this.element.removeEventListener("touchend", this.onTouchEnd, $12aa2a06f48a44b4$var$listenerOptions);
    }
    /**
   * Event handler for 'touchstart' event
   *
   * @param event Touch event
   */ onTouchStart = (event)=>{
        const { clientX: clientX, clientY: clientY } = event.targetTouches ? event.targetTouches[0] : event;
        this.touchStart.x = clientX;
        this.touchStart.y = clientY;
        this.lastDelta = {
            x: 0,
            y: 0
        };
        this.emitter.emit("scroll", {
            deltaX: 0,
            deltaY: 0,
            event: event
        });
    };
    /** Event handler for 'touchmove' event */ onTouchMove = (event)=>{
        const { clientX: clientX, clientY: clientY } = event.targetTouches ? event.targetTouches[0] : event;
        const deltaX = -(clientX - this.touchStart.x) * this.options.touchMultiplier;
        const deltaY = -(clientY - this.touchStart.y) * this.options.touchMultiplier;
        this.touchStart.x = clientX;
        this.touchStart.y = clientY;
        this.lastDelta = {
            x: deltaX,
            y: deltaY
        };
        this.emitter.emit("scroll", {
            deltaX: deltaX,
            deltaY: deltaY,
            event: event
        });
    };
    onTouchEnd = (event)=>{
        this.emitter.emit("scroll", {
            deltaX: this.lastDelta.x,
            deltaY: this.lastDelta.y,
            event: event
        });
    };
    /** Event handler for 'wheel' event */ onWheel = (event)=>{
        let { deltaX: deltaX, deltaY: deltaY, deltaMode: deltaMode } = event;
        const multiplierX = deltaMode === 1 ? $12aa2a06f48a44b4$var$LINE_HEIGHT : deltaMode === 2 ? this.window.width : 1;
        const multiplierY = deltaMode === 1 ? $12aa2a06f48a44b4$var$LINE_HEIGHT : deltaMode === 2 ? this.window.height : 1;
        deltaX *= multiplierX;
        deltaY *= multiplierY;
        deltaX *= this.options.wheelMultiplier;
        deltaY *= this.options.wheelMultiplier;
        this.emitter.emit("scroll", {
            deltaX: deltaX,
            deltaY: deltaY,
            event: event
        });
    };
    onWindowResize = ()=>{
        this.window = {
            width: window.innerWidth,
            height: window.innerHeight
        };
    };
};
// packages/core/src/lenis.ts
var $12aa2a06f48a44b4$var$defaultEasing = (t)=>Math.min(1, 1.001 - Math.pow(2, -10 * t));
var $12aa2a06f48a44b4$export$2e2bcd8739ae039 = class {
    _isScrolling = false;
    // true when scroll is animating
    _isStopped = false;
    // true if user should not be able to scroll - enable/disable programmatically
    _isLocked = false;
    // same as isStopped but enabled/disabled when scroll reaches target
    _preventNextNativeScrollEvent = false;
    _resetVelocityTimeout = null;
    _rafId = null;
    /**
   * Whether or not the user is touching the screen
   */ isTouching;
    /**
   * The time in ms since the lenis instance was created
   */ time = 0;
    /**
   * User data that will be forwarded through the scroll event
   *
   * @example
   * lenis.scrollTo(100, {
   *   userData: {
   *     foo: 'bar'
   *   }
   * })
   */ userData = {};
    /**
   * The last velocity of the scroll
   */ lastVelocity = 0;
    /**
   * The current velocity of the scroll
   */ velocity = 0;
    /**
   * The direction of the scroll
   */ direction = 0;
    /**
   * The options passed to the lenis instance
   */ options;
    /**
   * The target scroll value
   */ targetScroll;
    /**
   * The animated scroll value
   */ animatedScroll;
    // These are instanciated here as they don't need information from the options
    animate = new $12aa2a06f48a44b4$var$Animate();
    emitter = new $12aa2a06f48a44b4$var$Emitter();
    // These are instanciated in the constructor as they need information from the options
    dimensions;
    // This is not private because it's used in the Snap class
    virtualScroll;
    constructor({ wrapper: wrapper = window, content: content = document.documentElement, eventsTarget: eventsTarget = wrapper, smoothWheel: smoothWheel = true, syncTouch: syncTouch = false, syncTouchLerp: syncTouchLerp = 0.075, touchInertiaExponent: touchInertiaExponent = 1.7, duration: duration, easing: // in seconds
    easing, lerp: lerp2 = 0.1, infinite: infinite = false, orientation: orientation = "vertical", gestureOrientation: // vertical, horizontal
    gestureOrientation = orientation === "horizontal" ? "both" : "vertical", touchMultiplier: // vertical, horizontal, both
    touchMultiplier = 1, wheelMultiplier: wheelMultiplier = 1, autoResize: autoResize = true, prevent: prevent, virtualScroll: virtualScroll, overscroll: overscroll = true, autoRaf: autoRaf = false, anchors: anchors = false, autoToggle: autoToggle = false, allowNestedScroll: // https://caniuse.com/?search=transition-behavior
    allowNestedScroll = false, __experimental__naiveDimensions: // @ts-ignore: this will be deprecated in the future
    __experimental__naiveDimensions = false, naiveDimensions: naiveDimensions = __experimental__naiveDimensions, stopInertiaOnNavigate: stopInertiaOnNavigate = false } = {}){
        window.lenisVersion = $12aa2a06f48a44b4$var$version;
        if (!wrapper || wrapper === document.documentElement) wrapper = window;
        if (typeof duration === "number" && typeof easing !== "function") easing = $12aa2a06f48a44b4$var$defaultEasing;
        else if (typeof easing === "function" && typeof duration !== "number") duration = 1;
        this.options = {
            wrapper: wrapper,
            content: content,
            eventsTarget: eventsTarget,
            smoothWheel: smoothWheel,
            syncTouch: syncTouch,
            syncTouchLerp: syncTouchLerp,
            touchInertiaExponent: touchInertiaExponent,
            duration: duration,
            easing: easing,
            lerp: lerp2,
            infinite: infinite,
            gestureOrientation: gestureOrientation,
            orientation: orientation,
            touchMultiplier: touchMultiplier,
            wheelMultiplier: wheelMultiplier,
            autoResize: autoResize,
            prevent: prevent,
            virtualScroll: virtualScroll,
            overscroll: overscroll,
            autoRaf: autoRaf,
            anchors: anchors,
            autoToggle: autoToggle,
            allowNestedScroll: allowNestedScroll,
            naiveDimensions: naiveDimensions,
            stopInertiaOnNavigate: stopInertiaOnNavigate
        };
        this.dimensions = new $12aa2a06f48a44b4$var$Dimensions(wrapper, content, {
            autoResize: autoResize
        });
        this.updateClassName();
        this.targetScroll = this.animatedScroll = this.actualScroll;
        this.options.wrapper.addEventListener("scroll", this.onNativeScroll, false);
        this.options.wrapper.addEventListener("scrollend", this.onScrollEnd, {
            capture: true
        });
        if (this.options.anchors || this.options.stopInertiaOnNavigate) this.options.wrapper.addEventListener("click", this.onClick, false);
        this.options.wrapper.addEventListener("pointerdown", this.onPointerDown, false);
        this.virtualScroll = new $12aa2a06f48a44b4$var$VirtualScroll(eventsTarget, {
            touchMultiplier: touchMultiplier,
            wheelMultiplier: wheelMultiplier
        });
        this.virtualScroll.on("scroll", this.onVirtualScroll);
        if (this.options.autoToggle) {
            this.checkOverflow();
            this.rootElement.addEventListener("transitionend", this.onTransitionEnd, {
                passive: true
            });
        }
        if (this.options.autoRaf) this._rafId = requestAnimationFrame(this.raf);
    }
    /**
   * Destroy the lenis instance, remove all event listeners and clean up the class name
   */ destroy() {
        this.emitter.destroy();
        this.options.wrapper.removeEventListener("scroll", this.onNativeScroll, false);
        this.options.wrapper.removeEventListener("scrollend", this.onScrollEnd, {
            capture: true
        });
        this.options.wrapper.removeEventListener("pointerdown", this.onPointerDown, false);
        if (this.options.anchors || this.options.stopInertiaOnNavigate) this.options.wrapper.removeEventListener("click", this.onClick, false);
        this.virtualScroll.destroy();
        this.dimensions.destroy();
        this.cleanUpClassName();
        if (this._rafId) cancelAnimationFrame(this._rafId);
    }
    on(event, callback) {
        return this.emitter.on(event, callback);
    }
    off(event, callback) {
        return this.emitter.off(event, callback);
    }
    onScrollEnd = (e)=>{
        if (!(e instanceof CustomEvent)) {
            if (this.isScrolling === "smooth" || this.isScrolling === false) e.stopPropagation();
        }
    };
    dispatchScrollendEvent = ()=>{
        this.options.wrapper.dispatchEvent(new CustomEvent("scrollend", {
            bubbles: this.options.wrapper === window,
            // cancelable: false,
            detail: {
                lenisScrollEnd: true
            }
        }));
    };
    get overflow() {
        const property = this.isHorizontal ? "overflow-x" : "overflow-y";
        return getComputedStyle(this.rootElement)[property];
    }
    checkOverflow() {
        if ([
            "hidden",
            "clip"
        ].includes(this.overflow)) this.internalStop();
        else this.internalStart();
    }
    onTransitionEnd = (event)=>{
        if (event.propertyName.includes("overflow")) this.checkOverflow();
    };
    setScroll(scroll) {
        if (this.isHorizontal) this.options.wrapper.scrollTo({
            left: scroll,
            behavior: "instant"
        });
        else this.options.wrapper.scrollTo({
            top: scroll,
            behavior: "instant"
        });
    }
    onClick = (event)=>{
        const path = event.composedPath();
        const anchorElements = path.filter((node)=>node instanceof HTMLAnchorElement && node.getAttribute("href"));
        if (this.options.anchors) {
            const anchor = anchorElements.find((node)=>node.getAttribute("href")?.includes("#"));
            if (anchor) {
                const href = anchor.getAttribute("href");
                if (href) {
                    const options = typeof this.options.anchors === "object" && this.options.anchors ? this.options.anchors : void 0;
                    const target = `#${href.split("#")[1]}`;
                    this.scrollTo(target, options);
                }
            }
        }
        if (this.options.stopInertiaOnNavigate) {
            const internalLink = anchorElements.find((node)=>node.host === window.location.host);
            if (internalLink) this.reset();
        }
    };
    onPointerDown = (event)=>{
        if (event.button === 1) this.reset();
    };
    onVirtualScroll = (data)=>{
        if (typeof this.options.virtualScroll === "function" && this.options.virtualScroll(data) === false) return;
        const { deltaX: deltaX, deltaY: deltaY, event: event } = data;
        this.emitter.emit("virtual-scroll", {
            deltaX: deltaX,
            deltaY: deltaY,
            event: event
        });
        if (event.ctrlKey) return;
        if (event.lenisStopPropagation) return;
        const isTouch = event.type.includes("touch");
        const isWheel = event.type.includes("wheel");
        this.isTouching = event.type === "touchstart" || event.type === "touchmove";
        const isClickOrTap = deltaX === 0 && deltaY === 0;
        const isTapToStop = this.options.syncTouch && isTouch && event.type === "touchstart" && isClickOrTap && !this.isStopped && !this.isLocked;
        if (isTapToStop) {
            this.reset();
            return;
        }
        const isUnknownGesture = this.options.gestureOrientation === "vertical" && deltaY === 0 || this.options.gestureOrientation === "horizontal" && deltaX === 0;
        if (isClickOrTap || isUnknownGesture) return;
        let composedPath = event.composedPath();
        composedPath = composedPath.slice(0, composedPath.indexOf(this.rootElement));
        const prevent = this.options.prevent;
        if (!!composedPath.find((node)=>node instanceof HTMLElement && (typeof prevent === "function" && prevent?.(node) || node.hasAttribute?.("data-lenis-prevent") || isTouch && node.hasAttribute?.("data-lenis-prevent-touch") || isWheel && node.hasAttribute?.("data-lenis-prevent-wheel") || this.options.allowNestedScroll && this.checkNestedScroll(node, {
                deltaX: deltaX,
                deltaY: deltaY
            })))) return;
        if (this.isStopped || this.isLocked) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        const isSmooth = this.options.syncTouch && isTouch || this.options.smoothWheel && isWheel;
        if (!isSmooth) {
            this.isScrolling = "native";
            this.animate.stop();
            event.lenisStopPropagation = true;
            return;
        }
        let delta = deltaY;
        if (this.options.gestureOrientation === "both") delta = Math.abs(deltaY) > Math.abs(deltaX) ? deltaY : deltaX;
        else if (this.options.gestureOrientation === "horizontal") delta = deltaX;
        if (!this.options.overscroll || this.options.infinite || this.options.wrapper !== window && this.limit > 0 && (this.animatedScroll > 0 && this.animatedScroll < this.limit || this.animatedScroll === 0 && deltaY > 0 || this.animatedScroll === this.limit && deltaY < 0)) event.lenisStopPropagation = true;
        if (event.cancelable) event.preventDefault();
        const isSyncTouch = isTouch && this.options.syncTouch;
        const isTouchEnd = isTouch && event.type === "touchend";
        const hasTouchInertia = isTouchEnd;
        if (hasTouchInertia) delta = Math.sign(this.velocity) * Math.pow(Math.abs(this.velocity), this.options.touchInertiaExponent);
        this.scrollTo(this.targetScroll + delta, {
            programmatic: false,
            ...isSyncTouch ? {
                lerp: hasTouchInertia ? this.options.syncTouchLerp : 1
            } : {
                lerp: this.options.lerp,
                duration: this.options.duration,
                easing: this.options.easing
            }
        });
    };
    /**
   * Force lenis to recalculate the dimensions
   */ resize() {
        this.dimensions.resize();
        this.animatedScroll = this.targetScroll = this.actualScroll;
        this.emit();
    }
    emit() {
        this.emitter.emit("scroll", this);
    }
    onNativeScroll = ()=>{
        if (this._resetVelocityTimeout !== null) {
            clearTimeout(this._resetVelocityTimeout);
            this._resetVelocityTimeout = null;
        }
        if (this._preventNextNativeScrollEvent) {
            this._preventNextNativeScrollEvent = false;
            return;
        }
        if (this.isScrolling === false || this.isScrolling === "native") {
            const lastScroll = this.animatedScroll;
            this.animatedScroll = this.targetScroll = this.actualScroll;
            this.lastVelocity = this.velocity;
            this.velocity = this.animatedScroll - lastScroll;
            this.direction = Math.sign(this.animatedScroll - lastScroll);
            if (!this.isStopped) this.isScrolling = "native";
            this.emit();
            if (this.velocity !== 0) this._resetVelocityTimeout = setTimeout(()=>{
                this.lastVelocity = this.velocity;
                this.velocity = 0;
                this.isScrolling = false;
                this.emit();
            }, 400);
        }
    };
    reset() {
        this.isLocked = false;
        this.isScrolling = false;
        this.animatedScroll = this.targetScroll = this.actualScroll;
        this.lastVelocity = this.velocity = 0;
        this.animate.stop();
    }
    /**
   * Start lenis scroll after it has been stopped
   */ start() {
        if (!this.isStopped) return;
        if (this.options.autoToggle) {
            this.rootElement.style.removeProperty("overflow");
            return;
        }
        this.internalStart();
    }
    internalStart() {
        if (!this.isStopped) return;
        this.reset();
        this.isStopped = false;
        this.emit();
    }
    /**
   * Stop lenis scroll
   */ stop() {
        if (this.isStopped) return;
        if (this.options.autoToggle) {
            this.rootElement.style.setProperty("overflow", "clip");
            return;
        }
        this.internalStop();
    }
    internalStop() {
        if (this.isStopped) return;
        this.reset();
        this.isStopped = true;
        this.emit();
    }
    /**
   * RequestAnimationFrame for lenis
   *
   * @param time The time in ms from an external clock like `requestAnimationFrame` or Tempus
   */ raf = (time)=>{
        const deltaTime = time - (this.time || time);
        this.time = time;
        this.animate.advance(deltaTime * 1e-3);
        if (this.options.autoRaf) this._rafId = requestAnimationFrame(this.raf);
    };
    /**
   * Scroll to a target value
   *
   * @param target The target value to scroll to
   * @param options The options for the scroll
   *
   * @example
   * lenis.scrollTo(100, {
   *   offset: 100,
   *   duration: 1,
   *   easing: (t) => 1 - Math.cos((t * Math.PI) / 2),
   *   lerp: 0.1,
   *   onStart: () => {
   *     console.log('onStart')
   *   },
   *   onComplete: () => {
   *     console.log('onComplete')
   *   },
   * })
   */ scrollTo(target, { offset: offset = 0, immediate: immediate = false, lock: lock = false, programmatic: programmatic = true, // called from outside of the class
    lerp: lerp2 = programmatic ? this.options.lerp : void 0, duration: duration = programmatic ? this.options.duration : void 0, easing: easing = programmatic ? this.options.easing : void 0, onStart: onStart, onComplete: onComplete, force: force = false, userData: // scroll even if stopped
    userData } = {}) {
        if ((this.isStopped || this.isLocked) && !force) return;
        if (typeof target === "string" && [
            "top",
            "left",
            "start",
            "#"
        ].includes(target)) target = 0;
        else if (typeof target === "string" && [
            "bottom",
            "right",
            "end"
        ].includes(target)) target = this.limit;
        else {
            let node;
            if (typeof target === "string") {
                node = document.querySelector(target);
                if (!node) {
                    if (target === "#top") target = 0;
                    else console.warn("Lenis: Target not found", target);
                }
            } else if (target instanceof HTMLElement && target?.nodeType) node = target;
            if (node) {
                if (this.options.wrapper !== window) {
                    const wrapperRect = this.rootElement.getBoundingClientRect();
                    offset -= this.isHorizontal ? wrapperRect.left : wrapperRect.top;
                }
                const rect = node.getBoundingClientRect();
                target = (this.isHorizontal ? rect.left : rect.top) + this.animatedScroll;
            }
        }
        if (typeof target !== "number") return;
        target += offset;
        target = Math.round(target);
        if (this.options.infinite) {
            if (programmatic) {
                this.targetScroll = this.animatedScroll = this.scroll;
                const distance = target - this.animatedScroll;
                if (distance > this.limit / 2) target = target - this.limit;
                else if (distance < -this.limit / 2) target = target + this.limit;
            }
        } else target = $12aa2a06f48a44b4$var$clamp(0, target, this.limit);
        if (target === this.targetScroll) {
            onStart?.(this);
            onComplete?.(this);
            return;
        }
        this.userData = userData ?? {};
        if (immediate) {
            this.animatedScroll = this.targetScroll = target;
            this.setScroll(this.scroll);
            this.reset();
            this.preventNextNativeScrollEvent();
            this.emit();
            onComplete?.(this);
            this.userData = {};
            requestAnimationFrame(()=>{
                this.dispatchScrollendEvent();
            });
            return;
        }
        if (!programmatic) this.targetScroll = target;
        if (typeof duration === "number" && typeof easing !== "function") easing = $12aa2a06f48a44b4$var$defaultEasing;
        else if (typeof easing === "function" && typeof duration !== "number") duration = 1;
        this.animate.fromTo(this.animatedScroll, target, {
            duration: duration,
            easing: easing,
            lerp: lerp2,
            onStart: ()=>{
                if (lock) this.isLocked = true;
                this.isScrolling = "smooth";
                onStart?.(this);
            },
            onUpdate: (value, completed)=>{
                this.isScrolling = "smooth";
                this.lastVelocity = this.velocity;
                this.velocity = value - this.animatedScroll;
                this.direction = Math.sign(this.velocity);
                this.animatedScroll = value;
                this.setScroll(this.scroll);
                if (programmatic) this.targetScroll = value;
                if (!completed) this.emit();
                if (completed) {
                    this.reset();
                    this.emit();
                    onComplete?.(this);
                    this.userData = {};
                    requestAnimationFrame(()=>{
                        this.dispatchScrollendEvent();
                    });
                    this.preventNextNativeScrollEvent();
                }
            }
        });
    }
    preventNextNativeScrollEvent() {
        this._preventNextNativeScrollEvent = true;
        requestAnimationFrame(()=>{
            this._preventNextNativeScrollEvent = false;
        });
    }
    checkNestedScroll(node, { deltaX: deltaX, deltaY: deltaY }) {
        const time = Date.now();
        const cache = node._lenis ??= {};
        let hasOverflowX, hasOverflowY, isScrollableX, isScrollableY, scrollWidth, scrollHeight, clientWidth, clientHeight;
        const gestureOrientation = this.options.gestureOrientation;
        if (time - (cache.time ?? 0) > 2e3) {
            cache.time = Date.now();
            const computedStyle = window.getComputedStyle(node);
            cache.computedStyle = computedStyle;
            const overflowXString = computedStyle.overflowX;
            const overflowYString = computedStyle.overflowY;
            hasOverflowX = [
                "auto",
                "overlay",
                "scroll"
            ].includes(overflowXString);
            hasOverflowY = [
                "auto",
                "overlay",
                "scroll"
            ].includes(overflowYString);
            cache.hasOverflowX = hasOverflowX;
            cache.hasOverflowY = hasOverflowY;
            if (!hasOverflowX && !hasOverflowY) return false;
            if (gestureOrientation === "vertical" && !hasOverflowY) return false;
            if (gestureOrientation === "horizontal" && !hasOverflowX) return false;
            scrollWidth = node.scrollWidth;
            scrollHeight = node.scrollHeight;
            clientWidth = node.clientWidth;
            clientHeight = node.clientHeight;
            isScrollableX = scrollWidth > clientWidth;
            isScrollableY = scrollHeight > clientHeight;
            cache.isScrollableX = isScrollableX;
            cache.isScrollableY = isScrollableY;
            cache.scrollWidth = scrollWidth;
            cache.scrollHeight = scrollHeight;
            cache.clientWidth = clientWidth;
            cache.clientHeight = clientHeight;
        } else {
            isScrollableX = cache.isScrollableX;
            isScrollableY = cache.isScrollableY;
            hasOverflowX = cache.hasOverflowX;
            hasOverflowY = cache.hasOverflowY;
            scrollWidth = cache.scrollWidth;
            scrollHeight = cache.scrollHeight;
            clientWidth = cache.clientWidth;
            clientHeight = cache.clientHeight;
        }
        if (!hasOverflowX && !hasOverflowY || !isScrollableX && !isScrollableY) return false;
        if (gestureOrientation === "vertical" && (!hasOverflowY || !isScrollableY)) return false;
        if (gestureOrientation === "horizontal" && (!hasOverflowX || !isScrollableX)) return false;
        let orientation;
        if (gestureOrientation === "horizontal") orientation = "x";
        else if (gestureOrientation === "vertical") orientation = "y";
        else {
            const isScrollingX = deltaX !== 0;
            const isScrollingY = deltaY !== 0;
            if (isScrollingX && hasOverflowX && isScrollableX) orientation = "x";
            if (isScrollingY && hasOverflowY && isScrollableY) orientation = "y";
        }
        if (!orientation) return false;
        let scroll, maxScroll, delta, hasOverflow, isScrollable;
        if (orientation === "x") {
            scroll = node.scrollLeft;
            maxScroll = scrollWidth - clientWidth;
            delta = deltaX;
            hasOverflow = hasOverflowX;
            isScrollable = isScrollableX;
        } else if (orientation === "y") {
            scroll = node.scrollTop;
            maxScroll = scrollHeight - clientHeight;
            delta = deltaY;
            hasOverflow = hasOverflowY;
            isScrollable = isScrollableY;
        } else return false;
        const willScroll = delta > 0 ? scroll < maxScroll : scroll > 0;
        return willScroll && hasOverflow && isScrollable;
    }
    /**
   * The root element on which lenis is instanced
   */ get rootElement() {
        return this.options.wrapper === window ? document.documentElement : this.options.wrapper;
    }
    /**
   * The limit which is the maximum scroll value
   */ get limit() {
        if (this.options.naiveDimensions) {
            if (this.isHorizontal) return this.rootElement.scrollWidth - this.rootElement.clientWidth;
            else return this.rootElement.scrollHeight - this.rootElement.clientHeight;
        } else return this.dimensions.limit[this.isHorizontal ? "x" : "y"];
    }
    /**
   * Whether or not the scroll is horizontal
   */ get isHorizontal() {
        return this.options.orientation === "horizontal";
    }
    /**
   * The actual scroll value
   */ get actualScroll() {
        const wrapper = this.options.wrapper;
        return this.isHorizontal ? wrapper.scrollX ?? wrapper.scrollLeft : wrapper.scrollY ?? wrapper.scrollTop;
    }
    /**
   * The current scroll value
   */ get scroll() {
        return this.options.infinite ? $12aa2a06f48a44b4$var$modulo(this.animatedScroll, this.limit) : this.animatedScroll;
    }
    /**
   * The progress of the scroll relative to the limit
   */ get progress() {
        return this.limit === 0 ? 1 : this.scroll / this.limit;
    }
    /**
   * Current scroll state
   */ get isScrolling() {
        return this._isScrolling;
    }
    set isScrolling(value) {
        if (this._isScrolling !== value) {
            this._isScrolling = value;
            this.updateClassName();
        }
    }
    /**
   * Check if lenis is stopped
   */ get isStopped() {
        return this._isStopped;
    }
    set isStopped(value) {
        if (this._isStopped !== value) {
            this._isStopped = value;
            this.updateClassName();
        }
    }
    /**
   * Check if lenis is locked
   */ get isLocked() {
        return this._isLocked;
    }
    set isLocked(value) {
        if (this._isLocked !== value) {
            this._isLocked = value;
            this.updateClassName();
        }
    }
    /**
   * Check if lenis is smooth scrolling
   */ get isSmooth() {
        return this.isScrolling === "smooth";
    }
    /**
   * The class name applied to the wrapper element
   */ get className() {
        let className = "lenis";
        if (this.options.autoToggle) className += " lenis-autoToggle";
        if (this.isStopped) className += " lenis-stopped";
        if (this.isLocked) className += " lenis-locked";
        if (this.isScrolling) className += " lenis-scrolling";
        if (this.isScrolling === "smooth") className += " lenis-smooth";
        return className;
    }
    updateClassName() {
        this.cleanUpClassName();
        this.rootElement.className = `${this.rootElement.className} ${this.className}`.trim();
    }
    cleanUpClassName() {
        this.rootElement.className = this.rootElement.className.replace(/lenis(-\w+)?/g, "").trim();
    }
};



var $8w6H4 = parcelRequire("8w6H4");

var $0dcef5d2a6da246a$export$99ee26438460406a = (0, $8w6H4.gsap).registerPlugin((0, $4ad50e95ed8fc124$export$855822f522f18eef)) || (0, $8w6H4.gsap), // to protect from tree shaking
$0dcef5d2a6da246a$export$7b23975ad686bf91 = $0dcef5d2a6da246a$export$99ee26438460406a.core.Tween;


var $53274a5c08953c17$exports = {};

/*!
 * imagesLoaded v5.0.0
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */ (function(window1, factory) {
    // universal module definition
    if ($53274a5c08953c17$exports) // CommonJS
    $53274a5c08953c17$exports = factory(window1, (parcelRequire("eaKMK")));
    else // browser global
    window1.imagesLoaded = factory(window1, window1.EvEmitter);
})(typeof window !== 'undefined' ? window : $53274a5c08953c17$exports, function factory(window1, EvEmitter) {
    let $ = window1.jQuery;
    let console = window1.console;
    // -------------------------- helpers -------------------------- //
    // turn element or nodeList into an array
    function makeArray(obj) {
        // use object if already an array
        if (Array.isArray(obj)) return obj;
        let isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
        // convert nodeList to array
        if (isArrayLike) return [
            ...obj
        ];
        // array of single index
        return [
            obj
        ];
    }
    // -------------------------- imagesLoaded -------------------------- //
    /**
 * @param {[Array, Element, NodeList, String]} elem
 * @param {[Object, Function]} options - if function, use as callback
 * @param {Function} onAlways - callback function
 * @returns {ImagesLoaded}
 */ function ImagesLoaded(elem, options, onAlways) {
        // coerce ImagesLoaded() without new, to be new ImagesLoaded()
        if (!(this instanceof ImagesLoaded)) return new ImagesLoaded(elem, options, onAlways);
        // use elem as selector string
        let queryElem = elem;
        if (typeof elem == 'string') queryElem = document.querySelectorAll(elem);
        // bail if bad element
        if (!queryElem) {
            console.error(`Bad element for imagesLoaded ${queryElem || elem}`);
            return;
        }
        this.elements = makeArray(queryElem);
        this.options = {};
        // shift arguments if no options set
        if (typeof options == 'function') onAlways = options;
        else Object.assign(this.options, options);
        if (onAlways) this.on('always', onAlways);
        this.getImages();
        // add jQuery Deferred object
        if ($) this.jqDeferred = new $.Deferred();
        // HACK check async to allow time to bind listeners
        setTimeout(this.check.bind(this));
    }
    ImagesLoaded.prototype = Object.create(EvEmitter.prototype);
    ImagesLoaded.prototype.getImages = function() {
        this.images = [];
        // filter & find items if we have an item selector
        this.elements.forEach(this.addElementImages, this);
    };
    const elementNodeTypes = [
        1,
        9,
        11
    ];
    /**
 * @param {Node} elem
 */ ImagesLoaded.prototype.addElementImages = function(elem) {
        // filter siblings
        if (elem.nodeName === 'IMG') this.addImage(elem);
        // get background image on element
        if (this.options.background === true) this.addElementBackgroundImages(elem);
        // find children
        // no non-element nodes, #143
        let { nodeType: nodeType } = elem;
        if (!nodeType || !elementNodeTypes.includes(nodeType)) return;
        let childImgs = elem.querySelectorAll('img');
        // concat childElems to filterFound array
        for (let img of childImgs)this.addImage(img);
        // get child background images
        if (typeof this.options.background == 'string') {
            let children = elem.querySelectorAll(this.options.background);
            for (let child of children)this.addElementBackgroundImages(child);
        }
    };
    const reURL = /url\((['"])?(.*?)\1\)/gi;
    ImagesLoaded.prototype.addElementBackgroundImages = function(elem) {
        let style = getComputedStyle(elem);
        // Firefox returns null if in a hidden iframe https://bugzil.la/548397
        if (!style) return;
        // get url inside url("...")
        let matches = reURL.exec(style.backgroundImage);
        while(matches !== null){
            let url = matches && matches[2];
            if (url) this.addBackground(url, elem);
            matches = reURL.exec(style.backgroundImage);
        }
    };
    /**
 * @param {Image} img
 */ ImagesLoaded.prototype.addImage = function(img) {
        let loadingImage = new LoadingImage(img);
        this.images.push(loadingImage);
    };
    ImagesLoaded.prototype.addBackground = function(url, elem) {
        let background = new Background(url, elem);
        this.images.push(background);
    };
    ImagesLoaded.prototype.check = function() {
        this.progressedCount = 0;
        this.hasAnyBroken = false;
        // complete if no images
        if (!this.images.length) {
            this.complete();
            return;
        }
        /* eslint-disable-next-line func-style */ let onProgress = (image, elem, message)=>{
            // HACK - Chrome triggers event before object properties have changed. #83
            setTimeout(()=>{
                this.progress(image, elem, message);
            });
        };
        this.images.forEach(function(loadingImage) {
            loadingImage.once('progress', onProgress);
            loadingImage.check();
        });
    };
    ImagesLoaded.prototype.progress = function(image, elem, message) {
        this.progressedCount++;
        this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
        // progress event
        this.emitEvent('progress', [
            this,
            image,
            elem
        ]);
        if (this.jqDeferred && this.jqDeferred.notify) this.jqDeferred.notify(this, image);
        // check if completed
        if (this.progressedCount === this.images.length) this.complete();
        if (this.options.debug && console) console.log(`progress: ${message}`, image, elem);
    };
    ImagesLoaded.prototype.complete = function() {
        let eventName = this.hasAnyBroken ? 'fail' : 'done';
        this.isComplete = true;
        this.emitEvent(eventName, [
            this
        ]);
        this.emitEvent('always', [
            this
        ]);
        if (this.jqDeferred) {
            let jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
            this.jqDeferred[jqMethod](this);
        }
    };
    // --------------------------  -------------------------- //
    function LoadingImage(img) {
        this.img = img;
    }
    LoadingImage.prototype = Object.create(EvEmitter.prototype);
    LoadingImage.prototype.check = function() {
        // If complete is true and browser supports natural sizes,
        // try to check for image status manually.
        let isComplete = this.getIsImageComplete();
        if (isComplete) {
            // report based on naturalWidth
            this.confirm(this.img.naturalWidth !== 0, 'naturalWidth');
            return;
        }
        // If none of the checks above matched, simulate loading on detached element.
        this.proxyImage = new Image();
        // add crossOrigin attribute. #204
        if (this.img.crossOrigin) this.proxyImage.crossOrigin = this.img.crossOrigin;
        this.proxyImage.addEventListener('load', this);
        this.proxyImage.addEventListener('error', this);
        // bind to image as well for Firefox. #191
        this.img.addEventListener('load', this);
        this.img.addEventListener('error', this);
        this.proxyImage.src = this.img.currentSrc || this.img.src;
    };
    LoadingImage.prototype.getIsImageComplete = function() {
        // check for non-zero, non-undefined naturalWidth
        // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671
        return this.img.complete && this.img.naturalWidth;
    };
    LoadingImage.prototype.confirm = function(isLoaded, message) {
        this.isLoaded = isLoaded;
        let { parentNode: parentNode } = this.img;
        // emit progress with parent <picture> or self <img>
        let elem = parentNode.nodeName === 'PICTURE' ? parentNode : this.img;
        this.emitEvent('progress', [
            this,
            elem,
            message
        ]);
    };
    // ----- events ----- //
    // trigger specified handler for event type
    LoadingImage.prototype.handleEvent = function(event) {
        let method = 'on' + event.type;
        if (this[method]) this[method](event);
    };
    LoadingImage.prototype.onload = function() {
        this.confirm(true, 'onload');
        this.unbindEvents();
    };
    LoadingImage.prototype.onerror = function() {
        this.confirm(false, 'onerror');
        this.unbindEvents();
    };
    LoadingImage.prototype.unbindEvents = function() {
        this.proxyImage.removeEventListener('load', this);
        this.proxyImage.removeEventListener('error', this);
        this.img.removeEventListener('load', this);
        this.img.removeEventListener('error', this);
    };
    // -------------------------- Background -------------------------- //
    function Background(url, element) {
        this.url = url;
        this.element = element;
        this.img = new Image();
    }
    // inherit LoadingImage prototype
    Background.prototype = Object.create(LoadingImage.prototype);
    Background.prototype.check = function() {
        this.img.addEventListener('load', this);
        this.img.addEventListener('error', this);
        this.img.src = this.url;
        // check if image is already complete
        let isComplete = this.getIsImageComplete();
        if (isComplete) {
            this.confirm(this.img.naturalWidth !== 0, 'naturalWidth');
            this.unbindEvents();
        }
    };
    Background.prototype.unbindEvents = function() {
        this.img.removeEventListener('load', this);
        this.img.removeEventListener('error', this);
    };
    Background.prototype.confirm = function(isLoaded, message) {
        this.isLoaded = isLoaded;
        this.emitEvent('progress', [
            this,
            this.element,
            message
        ]);
    };
    // -------------------------- jQuery -------------------------- //
    ImagesLoaded.makeJQueryPlugin = function(jQuery) {
        jQuery = jQuery || window1.jQuery;
        if (!jQuery) return;
        // set local variable
        $ = jQuery;
        // $().imagesLoaded()
        $.fn.imagesLoaded = function(options, onAlways) {
            let instance = new ImagesLoaded(this, options, onAlways);
            return instance.jqDeferred.promise($(this));
        };
    };
    // try making plugin
    ImagesLoaded.makeJQueryPlugin();
    // --------------------------  -------------------------- //
    return ImagesLoaded;
});


// Map number x from range [a, b] to [c, d]
const $32cf713314f1c621$export$871de8747c9eaa88 = (x, a, b, c, d)=>(x - a) * (d - c) / (b - a) + c;
// Linear interpolation
const $32cf713314f1c621$export$3a89f8d6f6bf6c9f = (a, b, n)=>(1 - n) * a + n * b;
const $32cf713314f1c621$export$48a16acaeda4ce0e = ()=>{
    return {
        width: window.innerWidth,
        height: window.innerHeight
    };
};
// Gets the mouse position
const $32cf713314f1c621$export$8b59d3c9ad87edcd = (e)=>{
    let posx = 0;
    let posy = 0;
    if (!e) e = window.event;
    if (e.pageX || e.pageY) {
        posx = e.pageX;
        posy = e.pageY;
    } else if (e.clientX || e.clientY) {
        posx = e.clientX + body.scrollLeft + document.documentElement.scrollLeft;
        posy = e.clientY + body.scrollTop + document.documentElement.scrollTop;
    }
    return {
        x: posx,
        y: posy
    };
};
const $32cf713314f1c621$export$231d937d7748069 = (min, max)=>parseFloat(Math.min(min + Math.random() * (max - min), max).toFixed(2));
// Preload images
const $32cf713314f1c621$export$6b05b21262ec0515 = (selector)=>{
    return new Promise((resolve, _)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($53274a5c08953c17$exports)))(document.querySelectorAll(selector), {
            background: true
        }, resolve);
    });
};


class $144cc94666dde40e$var$ImageLayer {
    constructor(el){
        this.DOM = {
            el: el
        };
        this.DOM.image = this.DOM.el.querySelector('.layers__item-img');
    }
}
class $144cc94666dde40e$export$2e2bcd8739ae039 {
    constructor(){
        this.DOM = {
            main: document.querySelector('main')
        };
        this.layers = [];
        [
            ...document.querySelectorAll('.layers__item')
        ].forEach((item)=>this.layers.push(new $144cc94666dde40e$var$ImageLayer(item)));
        this.layersTotal = this.layers.length;
        this.gridItems = [
            ...document.querySelectorAll('.grid__item')
        ];
        this.options = {
            duration: 1,
            panelDelay: 0.15
        };
        this.createTimeline();
    }
    createTimeline() {
        this.tl = (0, $0dcef5d2a6da246a$export$99ee26438460406a).timeline({
            paused: true
        });
        // animate the Image layers
        for(let i = 0, len = this.layersTotal; i <= len - 1; ++i)this.tl.to([
            this.layers[i].DOM.el,
            this.layers[i].DOM.image
        ], {
            duration: this.options.duration,
            ease: 'Power2.easeInOut',
            y: 0
        }, this.options.panelDelay * i);
        this.tl.addLabel('halfway', this.options.panelDelay * (this.layersTotal - 1) + this.options.duration).call(()=>{
            // hide all Image layers except the last one (at this point the last Image layer is visible fullscreen)
            this.layers.filter((_, pos)=>pos != this.layers.length - 1).forEach((panel, pos)=>{
                (0, $0dcef5d2a6da246a$export$99ee26438460406a).set(panel.DOM.el, {
                    opacity: 0
                });
            });
            // also remove intro class from the main element (this will apply the new CSS layout styles for the next section)
            this.DOM.main.classList.remove('intro');
            document.body.classList.add('revealed');
        }, this, 'halfway')// now hide the last Image Layer
        .to([
            this.layers[this.layersTotal - 1].DOM.el,
            this.layers[this.layersTotal - 1].DOM.image
        ], {
            duration: this.options.duration,
            ease: 'Expo.easeInOut',
            y: (index)=>index ? '101%' : '-101%'
        }, 'halfway')// show grid items
        .fromTo(this.gridItems, {
            y: ()=>(0, $32cf713314f1c621$export$231d937d7748069)(100, 500)
        }, {
            duration: this.options.duration * 2,
            ease: 'Expo.easeOut',
            y: 0,
            opacity: 1
        }, 'halfway');
    }
    reveal() {
        this.tl.restart();
    }
}




/**
 * SplitType
 * https://github.com/lukePeavey/SplitType
 * @version 0.3.4
 * @author Luke Peavey <lwpeavey@gmail.com>
 */ // Polyfill the following DOM methods that are not supported in IE 11.
(function() {
    function append() {
        var length = arguments.length;
        for(var i = 0; i < length; i++){
            var node = i < 0 || arguments.length <= i ? undefined : arguments[i];
            if (node.nodeType === 1 || node.nodeType === 11) this.appendChild(node);
            else this.appendChild(document.createTextNode(String(node)));
        }
    }
    function replaceChildren() {
        while(this.lastChild)this.removeChild(this.lastChild);
        if (arguments.length) this.append.apply(this, arguments);
    }
    function replaceWith() {
        var parent = this.parentNode;
        for(var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++)nodes[_key] = arguments[_key];
        var i = nodes.length;
        if (!parent) return;
        if (!i) parent.removeChild(this);
        while(i--){
            var node = nodes[i];
            if (typeof node !== 'object') node = this.ownerDocument.createTextNode(node);
            else if (node.parentNode) node.parentNode.removeChild(node);
            if (!i) parent.replaceChild(node, this);
            else parent.insertBefore(this.previousSibling, node);
        }
    }
    if (typeof Element !== 'undefined') {
        if (!Element.prototype.append) {
            Element.prototype.append = append;
            DocumentFragment.prototype.append = append;
        }
        if (!Element.prototype.replaceChildren) {
            Element.prototype.replaceChildren = replaceChildren;
            DocumentFragment.prototype.replaceChildren = replaceChildren;
        }
        if (!Element.prototype.replaceWith) {
            Element.prototype.replaceWith = replaceWith;
            DocumentFragment.prototype.replaceWith = replaceWith;
        }
    }
})();
function $2835f7b29847c215$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2835f7b29847c215$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $2835f7b29847c215$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2835f7b29847c215$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2835f7b29847c215$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $2835f7b29847c215$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2835f7b29847c215$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2835f7b29847c215$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $2835f7b29847c215$var$ownKeys(Object(source), true).forEach(function(key) {
            $2835f7b29847c215$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $2835f7b29847c215$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2835f7b29847c215$var$_slicedToArray(arr, i) {
    return $2835f7b29847c215$var$_arrayWithHoles(arr) || $2835f7b29847c215$var$_iterableToArrayLimit(arr, i) || $2835f7b29847c215$var$_unsupportedIterableToArray(arr, i) || $2835f7b29847c215$var$_nonIterableRest();
}
function $2835f7b29847c215$var$_toConsumableArray(arr) {
    return $2835f7b29847c215$var$_arrayWithoutHoles(arr) || $2835f7b29847c215$var$_iterableToArray(arr) || $2835f7b29847c215$var$_unsupportedIterableToArray(arr) || $2835f7b29847c215$var$_nonIterableSpread();
}
function $2835f7b29847c215$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $2835f7b29847c215$var$_arrayLikeToArray(arr);
}
function $2835f7b29847c215$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $2835f7b29847c215$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $2835f7b29847c215$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $2835f7b29847c215$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2835f7b29847c215$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2835f7b29847c215$var$_arrayLikeToArray(o, minLen);
}
function $2835f7b29847c215$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2835f7b29847c215$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2835f7b29847c215$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
/**
 * Shallow merges the properties of an object with the target object. Only
 * includes properties that exist on the target object. Non-writable properties
 * on the target object will not be over-written.
 *
 * @param {Object} target
 * @param {Object} object
 */ function $2835f7b29847c215$var$extend(target, object) {
    return Object.getOwnPropertyNames(Object(target)).reduce(function(extended, key) {
        var currentValue = Object.getOwnPropertyDescriptor(Object(target), key);
        var newValue = Object.getOwnPropertyDescriptor(Object(object), key);
        return Object.defineProperty(extended, key, newValue || currentValue);
    }, {});
}
/**
 * Checks if given value is a string
 *
 * @param {any} value
 * @return {boolean} `true` if `value` is a string, else `false`
 */ function $2835f7b29847c215$var$isString(value) {
    return typeof value === 'string';
}
function $2835f7b29847c215$var$isArray(value) {
    return Array.isArray(value);
}
/**
 * Parses user supplied settings objects.
 */ function $2835f7b29847c215$var$parseSettings() {
    var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var object = $2835f7b29847c215$var$extend(settings); // `split` may be used as an alias for the `types` option
    // Parse the `types` settings into an array of valid split types.
    // If `types` is explicitly set to an empty string or array, text will not be
    // split at all.
    var types;
    if (object.types !== undefined) types = object.types;
    else if (object.split !== undefined) types = object.split;
    if (types !== undefined) object.types = ($2835f7b29847c215$var$isString(types) || $2835f7b29847c215$var$isArray(types) ? String(types) : '').split(',').map(function(type) {
        return String(type).trim();
    }).filter(function(type) {
        return /((line)|(word)|(char))/i.test(type);
    });
     // Support `position: absolute` as an alias for `absolute: true`
    if (object.absolute || object.position) object.absolute = object.absolute || /absolute/.test(settings.position);
    return object;
}
/**
 * Takes a list of `types` and returns an object
 *
 * @param {string | string[]} value a comma separated list of split types
 * @return {{lines: boolean, words: boolean, chars: boolean}}
 */ function $2835f7b29847c215$var$parseTypes(value) {
    var types = $2835f7b29847c215$var$isString(value) || $2835f7b29847c215$var$isArray(value) ? String(value) : '';
    return {
        none: !types,
        lines: /line/i.test(types),
        words: /word/i.test(types),
        chars: /char/i.test(types)
    };
}
/**
 * Returns true if `value` is a non-null object.
 * @param {any} value
 * @return {boolean}
 */ function $2835f7b29847c215$var$isObject(value) {
    return value !== null && typeof value === 'object';
}
/**
 * Returns true if `input` is one of the following:
 * - `Element`
 * - `Text`
 * - `DocumentFragment`
 */ function $2835f7b29847c215$var$isNode(input) {
    return $2835f7b29847c215$var$isObject(input) && /^(1|3|11)$/.test(input.nodeType);
}
/**
 * Checks if `value` is a valid array-like length.
 * Original source: Lodash
 *
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3)
 * // => true
 *
 * _.isLength(Number.MIN_VALUE)
 * // => false
 *
 * _.isLength(Infinity)
 * // => false
 *
 * _.isLength('3')
 * // => false
 */ function $2835f7b29847c215$var$isLength(value) {
    return typeof value === 'number' && value > -1 && value % 1 === 0;
}
/**
 * Checks if `value` is an array-like object
 * @param {any} value
 * @return {boolean} true if `value` is array-like`, else `false`
 * @example
 * isArrayLike(new Array())
 * // => true
 *
 * isArrayLike(document.querySelectorAll('div'))
 * // => true
 *
 * isArrayLike(document.getElementsByTagName('div'))
 * // => true
 *
 * isArrayLike(() => {})
 * // => false
 *
 * isArrayLike({foo: 'bar'})
 * // => false
 *
 * * isArrayLike(null)
 * // => false
 */ function $2835f7b29847c215$var$isArrayLike(value) {
    return $2835f7b29847c215$var$isObject(value) && $2835f7b29847c215$var$isLength(value.length);
}
/**
 * Coerces `value` to an `Array`.
 *
 * @param {any} value
 * @return {any[]}
 * @example
 * // If `value` is any `Array`, returns original `Array`
 * let arr = [1, 2]
 * toArray(arr)
 * // => arr
 *
 * // If `value` is an `ArrayLike`, its equivalent to `Array.from(value)`
 * let nodeList = document.querySelectorAll('div')
 * toArray(nodeList)
 * // => HTMLElement[] s
 *
 * // If value is falsy, returns empty array
 * toArray(null)
 * // => []
 *
 * // For any other type of value, its equivalent to `Array.of(value)`
 * let element = document.createElement('div')
 * toArray(element)
 * // => [element]
 *
 */ function $2835f7b29847c215$var$toArray(value) {
    if ($2835f7b29847c215$var$isArray(value)) return value;
    if (value == null) return [];
    return $2835f7b29847c215$var$isArrayLike(value) ? Array.prototype.slice.call(value) : [
        value
    ];
}
/**
 * Processes target elements for the splitType function.
 *
 * @param {any} target Can be one of the following:
 * 1. `string` - A css selector
 * 2. `HTMLElement` - A single element
 * 3. `NodeList` - A nodeList
 * 4. `Element[]` - An array of elements
 * 5. `Array<NodeList|Element[]>` - An nested array of elements
 * @returns {Element[]} A flat array HTML elements
 * @return A flat array of elements or empty array if no elements are found
 */ function $2835f7b29847c215$var$getTargetElements(target) {
    var elements = target; // If `target` is a selector string...
    if ($2835f7b29847c215$var$isString(target)) {
        if (/^(#[a-z]\w+)$/.test(target.trim())) // If `target` is an ID, use `getElementById`
        elements = document.getElementById(target.trim().slice(1));
        else // Else use `querySelectorAll`
        elements = document.querySelectorAll(target);
    } // Return a flattened array of elements
    return $2835f7b29847c215$var$toArray(elements).reduce(function(result, element) {
        return [].concat($2835f7b29847c215$var$_toConsumableArray(result), $2835f7b29847c215$var$_toConsumableArray($2835f7b29847c215$var$toArray(element).filter($2835f7b29847c215$var$isNode)));
    }, []);
}
var $2835f7b29847c215$var$entries = Object.entries;
var $2835f7b29847c215$var$expando = "_splittype";
var $2835f7b29847c215$var$cache = {};
var $2835f7b29847c215$var$uid = 0;
/**
 * Stores data associated with DOM elements or other objects. This is a
 * simplified version of jQuery's data method.
 *
 * @signature Data(owner)
 * @description Get the data store object for the given owner.
 * @param {Object} owner the object that data will be associated with.
 * @return {Object} the data object for given `owner`. If no data exists
 *     for the given object, creates a new data store and returns it.
 *
 * @signature Data(owner, key)
 * @description Get the value
 * @param {Object} owner
 * @param {string} key
 * @return {any} the value of the provided key. If key does not exist, returns
 *     undefined.
 *
 * @signature Data(owner, key, value)
 * @description Sets the given key/value pair in data store
 * @param {Object} owner
 * @param {string} key
 * @param {any} value
 */ function $2835f7b29847c215$var$set(owner, key, value) {
    if (!$2835f7b29847c215$var$isObject(owner)) {
        console.warn('[data.set] owner is not an object');
        return null;
    }
    var id = owner[$2835f7b29847c215$var$expando] || (owner[$2835f7b29847c215$var$expando] = ++$2835f7b29847c215$var$uid);
    var data = $2835f7b29847c215$var$cache[id] || ($2835f7b29847c215$var$cache[id] = {});
    if (value === undefined) {
        if (!!key && Object.getPrototypeOf(key) === Object.prototype) $2835f7b29847c215$var$cache[id] = $2835f7b29847c215$var$_objectSpread2($2835f7b29847c215$var$_objectSpread2({}, data), key);
    } else if (key !== undefined) data[key] = value;
    return value;
}
function $2835f7b29847c215$var$get(owner, key) {
    var id = $2835f7b29847c215$var$isObject(owner) ? owner[$2835f7b29847c215$var$expando] : null;
    var data = id && $2835f7b29847c215$var$cache[id] || {};
    if (key === undefined) return data;
    return data[key];
}
/**
 * Remove all data associated with the given element
 */ function $2835f7b29847c215$var$remove(element) {
    var id = element && element[$2835f7b29847c215$var$expando];
    if (id) {
        delete element[id];
        delete $2835f7b29847c215$var$cache[id];
    }
}
/**
 * Clear all cached data
 */ function $2835f7b29847c215$var$clear() {
    Object.keys($2835f7b29847c215$var$cache).forEach(function(key) {
        delete $2835f7b29847c215$var$cache[key];
    });
}
/**
 * Remove all temporary data from the store.
 */ function $2835f7b29847c215$var$cleanup() {
    $2835f7b29847c215$var$entries($2835f7b29847c215$var$cache).forEach(function(_ref) {
        var _ref2 = $2835f7b29847c215$var$_slicedToArray(_ref, 2), id = _ref2[0], _ref2$ = _ref2[1], isRoot = _ref2$.isRoot, isSplit = _ref2$.isSplit;
        if (!isRoot || !isSplit) {
            $2835f7b29847c215$var$cache[id] = null;
            delete $2835f7b29847c215$var$cache[id];
        }
    });
}
/**
 * Splits a string into an array of words.
 *
 * @param {string} string
 * @param {string | RegExp} [separator = ' ']
 * @return {string[]} Array of words
 */ function $2835f7b29847c215$var$toWords(value) {
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';
    var string = value ? String(value) : '';
    return string.trim().replace(/\s+/g, ' ').split(separator);
}
/**
 * Based on lodash#split <https://lodash.com/license>
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters &
 * Editors
 */ var $2835f7b29847c215$var$rsAstralRange = "\\ud800-\\udfff";
var $2835f7b29847c215$var$rsComboMarksRange = "\\u0300-\\u036f\\ufe20-\\ufe23";
var $2835f7b29847c215$var$rsComboSymbolsRange = "\\u20d0-\\u20f0";
var $2835f7b29847c215$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $2835f7b29847c215$var$rsAstral = "[".concat($2835f7b29847c215$var$rsAstralRange, "]");
var $2835f7b29847c215$var$rsCombo = "[".concat($2835f7b29847c215$var$rsComboMarksRange).concat($2835f7b29847c215$var$rsComboSymbolsRange, "]");
var $2835f7b29847c215$var$rsFitz = "\\ud83c[\\udffb-\\udfff]";
var $2835f7b29847c215$var$rsModifier = "(?:".concat($2835f7b29847c215$var$rsCombo, "|").concat($2835f7b29847c215$var$rsFitz, ")");
var $2835f7b29847c215$var$rsNonAstral = "[^".concat($2835f7b29847c215$var$rsAstralRange, "]");
var $2835f7b29847c215$var$rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}";
var $2835f7b29847c215$var$rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]";
var $2835f7b29847c215$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $2835f7b29847c215$var$reOptMod = "".concat($2835f7b29847c215$var$rsModifier, "?");
var $2835f7b29847c215$var$rsOptVar = "[".concat($2835f7b29847c215$var$rsVarRange, "]?");
var $2835f7b29847c215$var$rsOptJoin = '(?:' + $2835f7b29847c215$var$rsZWJ + '(?:' + [
    $2835f7b29847c215$var$rsNonAstral,
    $2835f7b29847c215$var$rsRegional,
    $2835f7b29847c215$var$rsSurrPair
].join('|') + ')' + $2835f7b29847c215$var$rsOptVar + $2835f7b29847c215$var$reOptMod + ')*';
var $2835f7b29847c215$var$rsSeq = $2835f7b29847c215$var$rsOptVar + $2835f7b29847c215$var$reOptMod + $2835f7b29847c215$var$rsOptJoin;
var $2835f7b29847c215$var$rsSymbol = "(?:".concat([
    "".concat($2835f7b29847c215$var$rsNonAstral).concat($2835f7b29847c215$var$rsCombo, "?"),
    $2835f7b29847c215$var$rsCombo,
    $2835f7b29847c215$var$rsRegional,
    $2835f7b29847c215$var$rsSurrPair,
    $2835f7b29847c215$var$rsAstral
].join('|'), "\n)");
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $2835f7b29847c215$var$reUnicode = RegExp("".concat($2835f7b29847c215$var$rsFitz, "(?=").concat($2835f7b29847c215$var$rsFitz, ")|").concat($2835f7b29847c215$var$rsSymbol).concat($2835f7b29847c215$var$rsSeq), 'g');
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $2835f7b29847c215$var$unicodeRange = [
    $2835f7b29847c215$var$rsZWJ,
    $2835f7b29847c215$var$rsAstralRange,
    $2835f7b29847c215$var$rsComboMarksRange,
    $2835f7b29847c215$var$rsComboSymbolsRange,
    $2835f7b29847c215$var$rsVarRange
];
var $2835f7b29847c215$var$reHasUnicode = RegExp("[".concat($2835f7b29847c215$var$unicodeRange.join(''), "]"));
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $2835f7b29847c215$var$asciiToArray(string) {
    return string.split('');
}
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $2835f7b29847c215$var$hasUnicode(string) {
    return $2835f7b29847c215$var$reHasUnicode.test(string);
}
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $2835f7b29847c215$var$unicodeToArray(string) {
    return string.match($2835f7b29847c215$var$reUnicode) || [];
}
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $2835f7b29847c215$var$stringToArray(string) {
    return $2835f7b29847c215$var$hasUnicode(string) ? $2835f7b29847c215$var$unicodeToArray(string) : $2835f7b29847c215$var$asciiToArray(string);
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values.
 *
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $2835f7b29847c215$var$toString(value) {
    return value == null ? '' : String(value);
}
/**
 * Splits `string` into an array of characters. If `separator` is omitted,
 * it behaves likes split.split('').
 *
 * Unlike native string.split(''), it can split strings that contain unicode
 * characters like emojis and symbols.
 *
 * @param {string} [string=''] The string to split.
 * @param {RegExp|string} [separator=''] The separator pattern to split by.
 * @returns {Array} Returns the string segments.
 * @example
 * toChars('foo');
 * // => ['f', 'o', 'o']
 *
 * toChars('foo bar');
 * // => ["f", "o", "o", " ", "b", "a", "r"]
 *
 * toChars('f😀o');
 * // => ['f', '😀', 'o']
 *
 * toChars('f-😀-o', /-/);
 * // => ['f', '😀', 'o']
 *
 */ function $2835f7b29847c215$var$toChars(string) {
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    string = $2835f7b29847c215$var$toString(string);
    if (string && $2835f7b29847c215$var$isString(string)) {
        if (!separator && $2835f7b29847c215$var$hasUnicode(string)) return $2835f7b29847c215$var$stringToArray(string);
    }
    return string.split(separator);
}
/**
 * Create an HTML element with the the given attributes
 *
 * attributes can include standard HTML attribute, as well as the following
 * "special" properties:
 *   - children: HTMLElement | ArrayLike<HTMLElement>
 *   - textContent: string
 *   - innerHTML: string
 *
 * @param {string} name
 * @param  {Object} [attributes]
 * @returns {HTMLElement}
 */ function $2835f7b29847c215$var$createElement(name, attributes) {
    var element = document.createElement(name);
    if (!attributes) // When called without the second argument, its just return the result
    // of `document.createElement`
    return element;
    Object.keys(attributes).forEach(function(attribute) {
        var rawValue = attributes[attribute];
        var value = $2835f7b29847c215$var$isString(rawValue) ? rawValue.trim() : rawValue; // Ignore attribute if the value is `null` or an empty string
        if (value === null || value === '') return;
        if (attribute === 'children') // Children can be one or more Elements or DOM strings
        element.append.apply(element, $2835f7b29847c215$var$_toConsumableArray($2835f7b29847c215$var$toArray(value)));
        else // Handle standard HTML attributes
        element.setAttribute(attribute, value);
    });
    return element;
}
var $2835f7b29847c215$var$defaults = {
    splitClass: '',
    lineClass: 'line',
    wordClass: 'word',
    charClass: 'char',
    types: [
        'lines',
        'words',
        'chars'
    ],
    absolute: false,
    tagName: 'div'
};
/**
 * Splits the text content of a single TextNode into words and/or characters.
 *
 * This functions gets called for every text node inside the target element. It
 * replaces the text node with a document fragment containing the split text.
 * Returns an array of the split word and character elements from this node.
 *
 * @param {TextNode} textNode
 * @param {Object} settings
 * @return {{words: Element[], chars: Element[]}}
 */ function $2835f7b29847c215$var$splitWordsAndChars(textNode, settings) {
    settings = $2835f7b29847c215$var$extend($2835f7b29847c215$var$defaults, settings); // The split types
    var types = $2835f7b29847c215$var$parseTypes(settings.types); // the tag name for split text nodes
    var TAG_NAME = settings.tagName; // value of the text node
    var VALUE = textNode.nodeValue; // `splitText` is a wrapper to hold the HTML structure
    var splitText = document.createDocumentFragment(); // Arrays of split word and character elements
    var words = [];
    var chars = [];
    if (/^\s/.test(VALUE)) splitText.append(' ');
     // Create an array of wrapped word elements.
    words = $2835f7b29847c215$var$toWords(VALUE).reduce(function(result, WORD, idx, arr) {
        // Let `wordElement` be the wrapped element for the current word
        var wordElement;
        var characterElementsForCurrentWord; // -> If splitting text into characters...
        if (types.chars) // Iterate through the characters in the current word
        characterElementsForCurrentWord = $2835f7b29847c215$var$toChars(WORD).map(function(CHAR) {
            var characterElement = $2835f7b29847c215$var$createElement(TAG_NAME, {
                "class": "".concat(settings.splitClass, " ").concat(settings.charClass),
                style: 'display: inline-block;',
                children: CHAR
            });
            $2835f7b29847c215$var$set(characterElement, 'isChar', true);
            chars = [].concat($2835f7b29847c215$var$_toConsumableArray(chars), [
                characterElement
            ]);
            return characterElement;
        });
         // END IF;
        if (types.words || types.lines) {
            // -> If Splitting Text Into Words...
            //    Create an element to wrap the current word. If we are also
            //    splitting text into characters, the word element will contain the
            //    wrapped character nodes for this word. If not, it will contain the
            //    plain text content (WORD)
            wordElement = $2835f7b29847c215$var$createElement(TAG_NAME, {
                "class": "".concat(settings.wordClass, " ").concat(settings.splitClass),
                style: "display: inline-block; ".concat(types.words && settings.absolute ? "position: relative;" : ''),
                children: types.chars ? characterElementsForCurrentWord : WORD
            });
            $2835f7b29847c215$var$set(wordElement, {
                isWord: true,
                isWordStart: true,
                isWordEnd: true
            });
            splitText.appendChild(wordElement);
        } else // -> If NOT splitting into words OR lines...
        //    Append the characters elements directly to splitText.
        characterElementsForCurrentWord.forEach(function(characterElement) {
            splitText.appendChild(characterElement);
        });
        if (idx < arr.length - 1) // Add a space after the word.
        splitText.append(' ');
         // If not splitting text into words, we return an empty array
        return types.words ? result.concat(wordElement) : result;
    }, []); // END LOOP;
    // Add a trailing white space to maintain word spacing
    if (/\s$/.test(VALUE)) splitText.append(' ');
    textNode.replaceWith(splitText);
    return {
        words: words,
        chars: chars
    };
}
/**
 * Splits the text content of a target element into words and/or characters.
 * The function is recursive, it will also split the text content of any child
 * elements into words/characters, while preserving the nested elements.
 *
 * @param {Node} node an HTML Element or Text Node
 * @param {Object} setting splitType settings
 */ function $2835f7b29847c215$var$split(node, settings) {
    var type = node.nodeType; // Arrays of split words and characters
    var wordsAndChars = {
        words: [],
        chars: []
    }; // Only proceed if `node` is an `Element`, `Fragment`, or `Text`
    if (!/(1|3|11)/.test(type)) return wordsAndChars;
     // A) IF `node` is TextNode that contains characters other than white space...
    //    Split the text content of the node into words and/or characters
    //    return an object containing the split word and character elements
    if (type === 3 && /\S/.test(node.nodeValue)) return $2835f7b29847c215$var$splitWordsAndChars(node, settings);
     // B) ELSE `node` is an 'Element'
    //    Iterate through its child nodes, calling the `split` function
    //    recursively for each child node.
    var childNodes = $2835f7b29847c215$var$toArray(node.childNodes);
    if (childNodes.length) {
        $2835f7b29847c215$var$set(node, 'isSplit', true); // we need to set a few styles on nested html elements
        if (!$2835f7b29847c215$var$get(node).isRoot) {
            node.style.display = 'inline-block';
            node.style.position = 'relative'; // To maintain original spacing around nested elements when we are
            // splitting text into lines, we need to check if the element should
            // have a space before and after, and store that value for later.
            // Note: this was necessary to maintain the correct spacing when nested
            // elements do not align with word boundaries. For example, a nested
            // element only wraps part of a word.
            var nextSibling = node.nextSibling;
            var prevSibling = node.previousSibling;
            var text = node.textContent || '';
            var textAfter = nextSibling ? nextSibling.textContent : ' ';
            var textBefore = prevSibling ? prevSibling.textContent : ' ';
            $2835f7b29847c215$var$set(node, {
                isWordEnd: /\s$/.test(text) || /^\s/.test(textAfter),
                isWordStart: /^\s/.test(text) || /\s$/.test(textBefore)
            });
        }
    } // Iterate through child nodes, calling `split` recursively
    // Returns an object containing all split words and chars
    return childNodes.reduce(function(result, child) {
        var _split = $2835f7b29847c215$var$split(child, settings), words = _split.words, chars = _split.chars;
        return {
            words: [].concat($2835f7b29847c215$var$_toConsumableArray(result.words), $2835f7b29847c215$var$_toConsumableArray(words)),
            chars: [].concat($2835f7b29847c215$var$_toConsumableArray(result.chars), $2835f7b29847c215$var$_toConsumableArray(chars))
        };
    }, wordsAndChars);
}
/**
 * Gets the height and position of an element relative to offset parent.
 * Should be equivalent to offsetTop and offsetHeight, but with sub-pixel
 * precision.
 *
 * TODO needs work
 */ function $2835f7b29847c215$var$getPosition(node, isWord, settings, scrollPos) {
    if (!settings.absolute) return {
        top: isWord ? node.offsetTop : null
    };
    var parent = node.offsetParent;
    var _scrollPos = $2835f7b29847c215$var$_slicedToArray(scrollPos, 2), scrollX = _scrollPos[0], scrollY = _scrollPos[1];
    var parentX = 0;
    var parentY = 0;
    if (parent && parent !== document.body) {
        var parentRect = parent.getBoundingClientRect();
        parentX = parentRect.x + scrollX;
        parentY = parentRect.y + scrollY;
    }
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height, x = _node$getBoundingClie.x, y = _node$getBoundingClie.y;
    var top = y + scrollY - parentY;
    var left = x + scrollX - parentX;
    return {
        width: width,
        height: height,
        top: top,
        left: left
    };
}
/**
 * Recursively "un-splits" text into words.
 * This is used when splitting text into lines but not words.
 * We initially split the text into words so we can maintain the correct line
 * breaks. Once text has been split into lines, we "un-split" the words...
 * @param {Element}
 * @return {void}
 */ function $2835f7b29847c215$var$unSplitWords(element) {
    if (!$2835f7b29847c215$var$get(element).isWord) $2835f7b29847c215$var$toArray(element.children).forEach(function(child) {
        return $2835f7b29847c215$var$unSplitWords(child);
    });
    else {
        $2835f7b29847c215$var$remove(element);
        element.replaceWith.apply(element, $2835f7b29847c215$var$_toConsumableArray(element.childNodes));
    }
}
var $2835f7b29847c215$var$createFragment = function createFragment() {
    return document.createDocumentFragment();
};
function $2835f7b29847c215$var$repositionAfterSplit(element, settings, scrollPos) {
    var types = $2835f7b29847c215$var$parseTypes(settings.types);
    var TAG_NAME = settings.tagName;
    var nodes = element.getElementsByTagName('*');
    var wordsInEachLine = [];
    var wordsInCurrentLine = [];
    var lineOffsetY = null;
    var elementHeight;
    var elementWidth;
    var contentBox;
    var lines = [];
    /**------------------------------------------------
   ** GET STYLES AND POSITIONS
   **-----------------------------------------------*/ // There is no built-in way to detect natural line breaks in text (when a
    // block of text wraps to fit its container). To split text into lines, we
    // have to detect line breaks by checking the top offset of words. This is
    // why text was split into words first. To apply absolute
    // positioning, its also necessary to record the size and position of every
    // split node (lines, words, characters).
    // To consolidate DOM getting/settings, this is all done at the same time,
    // before actually splitting text into lines, which involves restructuring
    // the DOM again.
    // Cache the element's parent and next sibling (for DOM removal).
    var parent = element.parentElement;
    var nextSibling = element.nextElementSibling; // a wrapper for the new HTML structure
    var splitText = $2835f7b29847c215$var$createFragment(); // get the computed style object for the element
    var cs = window.getComputedStyle(element);
    var align = cs.textAlign;
    var fontSize = parseFloat(cs.fontSize);
    var lineThreshold = fontSize * 0.2; // IF using absolute position...
    if (settings.absolute) {
        // Let contentBox be an object containing the width and offset position of
        // the element's content box (the area inside padding box). This is needed
        // (for absolute positioning) to set the width and position of line
        // elements, which have not been created yet.
        contentBox = {
            left: element.offsetLeft,
            top: element.offsetTop,
            width: element.offsetWidth
        }; // Let elementWidth and elementHeight be the actual width/height of the
        // element. Also check if the element has inline height or width styles
        // already set. If it does, cache those values for later.
        elementWidth = element.offsetWidth;
        elementHeight = element.offsetHeight; // Store the original inline height and width of the element
        $2835f7b29847c215$var$set(element, {
            cssWidth: element.style.width,
            cssHeight: element.style.height
        });
    } // Iterate over every node in the target element
    $2835f7b29847c215$var$toArray(nodes).forEach(function(node) {
        // node is a word element or custom html element
        var isWordLike = node.parentElement === element; // TODO needs work
        // Get te size and position of split text nodes
        var _getPosition = $2835f7b29847c215$var$getPosition(node, isWordLike, settings, scrollPos), width = _getPosition.width, height = _getPosition.height, top = _getPosition.top, left = _getPosition.left; // If element is a `<br>` tag return here
        if (/^br$/i.test(node.nodeName)) return;
        if (types.lines && isWordLike) {
            // We compare the top offset of the current word to the top offset of
            // previous words on the current line. If the difference is greater than
            // our defined threshold (20%), we assume this word is on a new line.
            if (lineOffsetY === null || top - lineOffsetY >= lineThreshold) {
                lineOffsetY = top;
                wordsInEachLine.push(wordsInCurrentLine = []);
            } // Add the current word node to the line array
            wordsInCurrentLine.push(node);
        } // END IF
        if (settings.absolute) // Store the size and position split text nodes
        $2835f7b29847c215$var$set(node, {
            top: top,
            left: left,
            width: width,
            height: height
        });
    }); // END LOOP
    // Remove the element from the DOM
    if (parent) parent.removeChild(element);
    /**------------------------------------------------
   ** SPLIT LINES
   **-----------------------------------------------*/ if (types.lines) {
        // Iterate over lines of text (see 11 b)
        // Let `line` be the array of words in the current line.
        // Return an array of the wrapped line elements (lineElements)
        lines = wordsInEachLine.map(function(wordsInThisLine) {
            // Create an element to wrap the current line.
            var lineElement = $2835f7b29847c215$var$createElement(TAG_NAME, {
                "class": "".concat(settings.splitClass, " ").concat(settings.lineClass),
                style: "display: block; text-align: ".concat(align, "; width: 100%;")
            });
            $2835f7b29847c215$var$set(lineElement, 'isLine', true);
            var lineDimensions = {
                height: 0,
                top: 1e4
            }; // Append the `lineElement` to `container`
            splitText.appendChild(lineElement); // Iterate over the word-level elements in the current line.
            // Note: wordOrElement can either be a word node or nested element
            wordsInThisLine.forEach(function(wordOrElement, idx, arr) {
                var _data$get = $2835f7b29847c215$var$get(wordOrElement), isWordEnd = _data$get.isWordEnd, top = _data$get.top, height = _data$get.height;
                var next = arr[idx + 1]; // Determine line height / y-position
                // we use the height and offsetTop of the words which we already
                // recorded. Because custom nested elements could have their own
                // styles, the words on a line may not all be the same height or
                // y position. So we take the greatest height / y - offset of the
                // words on this line.
                lineDimensions.height = Math.max(lineDimensions.height, height);
                lineDimensions.top = Math.min(lineDimensions.top, top); // append the current word/element
                lineElement.appendChild(wordOrElement); // Determine if there should space after the current element...
                // If this is not the last word on the current line.
                // TODO - logic for handing spacing can be improved
                if (isWordEnd && $2835f7b29847c215$var$get(next).isWordStart) lineElement.append(' ');
            }); // END LOOP
            if (settings.absolute) $2835f7b29847c215$var$set(lineElement, {
                height: lineDimensions.height,
                top: lineDimensions.top
            });
            return lineElement;
        }); // END LOOP
        if (!types.words) $2835f7b29847c215$var$unSplitWords(splitText);
         // 10. Insert the new container
        element.replaceChildren(splitText);
    }
    /**------------------------------------------------
   **  SET ABSOLUTE POSITION
   **-----------------------------------------------*/ // Apply absolute positioning to all child elements of the target element.
    // This includes split lines, words, chars, and custom HTML elements that were
    // included by the user. The size and position of child elements has already
    // been recorded before splitting text into lines.
    if (settings.absolute) {
        // Set the width/height of the parent element so it does not collapse
        // when its children are set to absolute position.
        element.style.width = "".concat(element.style.width || elementWidth, "px");
        element.style.height = "".concat(elementHeight, "px"); // Iterate over all child elements
        $2835f7b29847c215$var$toArray(nodes).forEach(function(node) {
            var _data$get2 = $2835f7b29847c215$var$get(node), isLine = _data$get2.isLine, top = _data$get2.top, left = _data$get2.left, width = _data$get2.width, height = _data$get2.height;
            var parentData = $2835f7b29847c215$var$get(node.parentElement);
            var isChildOfLineNode = !isLine && parentData.isLine; // Set the top position of the current node.
            // -> If `node` a line element, we use the top offset of its first child
            // -> If `node` the child of line element, then its top offset is zero
            node.style.top = "".concat(isChildOfLineNode ? top - parentData.top : top, "px"); // Set the left position of the current node.
            // -> IF `node` is a line element, this is equal to the position left of
            //    the content box of the parent element
            // -> IF `node` is the child of a line element, the value has to adjusted
            //    so its relative to the line element
            node.style.left = isLine ? "".concat(contentBox.left, "px") : "".concat(left - (isChildOfLineNode ? contentBox.left : 0), "px"); // Set the height of the current node to the cached value.
            node.style.height = "".concat(height, "px"); //  Set the width of the current node.
            //  If its a line element, width is equal to the width of the contentBox.
            node.style.width = isLine ? "".concat(contentBox.width, "px") : "".concat(width, "px"); // Finally, set the node's position to absolute.
            node.style.position = 'absolute';
        });
    } // end if;
    // 14. Re-attach the element to the DOM
    if (parent) {
        if (nextSibling) parent.insertBefore(element, nextSibling);
        else parent.appendChild(element);
    }
    return lines;
}
var $2835f7b29847c215$var$_defaults = $2835f7b29847c215$var$extend($2835f7b29847c215$var$defaults, {});
var $2835f7b29847c215$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    $2835f7b29847c215$var$_createClass(SplitType, null, [
        {
            key: "clearData",
            /**
     * CLears all data
     */ value: function clearData() {
                $2835f7b29847c215$var$clear();
            }
        },
        {
            key: "setDefaults",
            /**
     * Sets the default settings for all SplitType instances.
     * The provided object will be merged with the existing defaults objects.
     *
     * @param {Object} settings an object containing the settings to override
     * @returns {Object} the new default settings
     * @public
     * @static
     * @example
     * SplitType.setDefaults({ "position": "absolute" })
     */ value: function setDefaults(options) {
                $2835f7b29847c215$var$_defaults = $2835f7b29847c215$var$extend($2835f7b29847c215$var$_defaults, $2835f7b29847c215$var$parseSettings(options));
                return $2835f7b29847c215$var$defaults;
            }
        },
        {
            key: "revert",
            value: function revert(elements) {
                $2835f7b29847c215$var$getTargetElements(elements).forEach(function(element) {
                    var _data$get = $2835f7b29847c215$var$get(element), isSplit = _data$get.isSplit, html = _data$get.html, cssWidth = _data$get.cssWidth, cssHeight = _data$get.cssHeight;
                    if (isSplit) {
                        element.innerHTML = html;
                        element.style.width = cssWidth || '';
                        element.style.height = cssHeight || '';
                        $2835f7b29847c215$var$remove(element);
                    }
                });
            }
        },
        {
            key: "create",
            value: function create(target, options) {
                return new SplitType(target, options);
            }
        },
        {
            key: "data",
            /**
     * The internal data store
     */ get: function get() {
                return $2835f7b29847c215$var$cache;
            }
        },
        {
            key: "defaults",
            get: function get() {
                return $2835f7b29847c215$var$_defaults;
            },
            set: function set(options) {
                $2835f7b29847c215$var$_defaults = $2835f7b29847c215$var$extend($2835f7b29847c215$var$_defaults, $2835f7b29847c215$var$parseSettings(options));
            }
        }
    ]);
    function SplitType(elements, options) {
        $2835f7b29847c215$var$_classCallCheck(this, SplitType);
        this.isSplit = false;
        this.settings = $2835f7b29847c215$var$extend($2835f7b29847c215$var$_defaults, $2835f7b29847c215$var$parseSettings(options));
        this.elements = $2835f7b29847c215$var$getTargetElements(elements); // Start the split process
        this.split();
    }
    /**
   * Splits the text in all target elements. This method is called
   * automatically when a new SplitType instance is created. It can also be
   * called manually to re-split text with new options.
   * @param {Object} options
   * @public
   */ $2835f7b29847c215$var$_createClass(SplitType, [
        {
            key: "split",
            value: function split$1(options) {
                var _this = this;
                // Revert target elements (if they are already split)
                // Note: revert was already called once in the constructor. However, we
                // need to call it again here so text is reverted when the user manually
                // calls the `split` method to re-split text.
                this.revert(); // Store the original html content of each target element
                this.elements.forEach(function(element) {
                    $2835f7b29847c215$var$set(element, 'html', element.innerHTML);
                }); // Create arrays to hold the split lines, words, and characters
                this.lines = [];
                this.words = [];
                this.chars = []; // cache vertical scroll position before splitting
                var scrollPos = [
                    window.pageXOffset,
                    window.pageYOffset
                ]; // If new options were passed into the `split()` method, update settings
                if (options !== undefined) this.settings = $2835f7b29847c215$var$extend(this.settings, $2835f7b29847c215$var$parseSettings(options));
                var types = $2835f7b29847c215$var$parseTypes(this.settings.types); // If the `types` option is set to an empty array, text will not be split.
                // @example new SplitType('#target', { types: [] })
                if (types.none) return;
                 // Split text in each target element
                this.elements.forEach(function(element) {
                    // Add the split text nodes from this element to the arrays of all split
                    // text nodes for this instance.
                    $2835f7b29847c215$var$set(element, 'isRoot', true);
                    var _split2 = $2835f7b29847c215$var$split(element, _this.settings), words = _split2.words, chars = _split2.chars;
                    _this.words = [].concat($2835f7b29847c215$var$_toConsumableArray(_this.words), $2835f7b29847c215$var$_toConsumableArray(words));
                    _this.chars = [].concat($2835f7b29847c215$var$_toConsumableArray(_this.chars), $2835f7b29847c215$var$_toConsumableArray(chars));
                });
                this.elements.forEach(function(element) {
                    if (types.lines || _this.settings.absolute) {
                        var lines = $2835f7b29847c215$var$repositionAfterSplit(element, _this.settings, scrollPos);
                        _this.lines = [].concat($2835f7b29847c215$var$_toConsumableArray(_this.lines), $2835f7b29847c215$var$_toConsumableArray(lines));
                    }
                }); // Set isSplit to true for the SplitType instance
                this.isSplit = true; // Set scroll position to cached value.
                window.scrollTo(scrollPos[0], scrollPos[1]); // Clean up stored data
                $2835f7b29847c215$var$cleanup();
            }
        },
        {
            key: "revert",
            value: function revert() {
                if (this.isSplit) {
                    // Reset instance properties if necessary
                    this.lines = null;
                    this.words = null;
                    this.chars = null;
                    this.isSplit = false;
                }
                SplitType.revert(this.elements);
            }
        }
    ]);
    return SplitType;
}();


class $339202cf0f1689e6$export$d267c32dfbb2bb04 {
    constructor(textElement, options = {}){
        if (!textElement || !(textElement instanceof HTMLElement)) throw new Error('Invalid text element provided.');
        this.textElement = textElement;
        this.options = options;
        this.resizeCallback = options.resizeCallback || null;
        // Initialize SplitType
        this.splitType = new (0, $2835f7b29847c215$export$2e2bcd8739ae039)(this.textElement, {
            types: options.splitTypeTypes || 'words, chars'
        });
        // Handle resize if callback provided
        if (this.resizeCallback) window.addEventListener('resize', this.resizeCallback);
    }
    getChars() {
        return this.splitType.chars;
    }
    getWords() {
        return this.splitType.words;
    }
    revert() {
        this.splitType.revert();
    }
}


(0, $0dcef5d2a6da246a$export$99ee26438460406a).registerPlugin((0, $82ba1e40433c64f0$export$875bcbe48555930));
class $c83df951dc505516$export$824eb2eeafc81b63 {
    constructor(textElement){
        // Check if the provided element is valid.
        if (!textElement || !(textElement instanceof HTMLElement)) throw new Error('Invalid text element provided.');
        this.textElement = textElement;
        // Set up the effect for the provided text element.
        this.initializeEffect();
    }
    // Sets up the initial text effect on the provided element.
    initializeEffect() {
        // Callback to re-trigger animations on resize.
        const textResizeCallback = ()=>this.scroll();
        // Split text for animation and store the reference.
        this.splitter = new (0, $339202cf0f1689e6$export$d267c32dfbb2bb04)(this.textElement, {
            resizeCallback: textResizeCallback,
            splitTypeTypes: 'words'
        });
        // Trigger the initial scroll effect.
        this.scroll();
    }
    // Animates text based on the scroll position.
    scroll() {
        // Query all individual words for animation.
        const words = this.splitter.getWords();
        (0, $0dcef5d2a6da246a$export$99ee26438460406a).fromTo(words, {
            opacity: 0,
            skewX: -20,
            willChange: 'filter, transform',
            filter: 'blur(8px)'
        }, {
            ease: 'sine',
            opacity: 1,
            skewX: 0,
            filter: 'blur(0px)',
            stagger: 0.04,
            scrollTrigger: {
                trigger: this.textElement,
                start: 'top bottom-=15%',
                end: 'bottom center+=15%',
                scrub: true
            }
        });
    }
}




(0, $0dcef5d2a6da246a$export$99ee26438460406a).registerPlugin((0, $82ba1e40433c64f0$export$875bcbe48555930));
class $a763e0a221ade44d$export$fd3780018b3af188 {
    constructor(el){
        if (!el || !(el instanceof HTMLElement)) return;
        this.highlightedElement = el;
        this.selectMarker = this.highlightedElement.querySelector('.hx__select');
        this.textWrapper = this.highlightedElement.querySelector('.char-split');
        this.animationDefaults = {
            duration: 0.5,
            ease: 'power2.out'
        };
        this.initializeEffect();
    }
    initializeEffect() {
        // Hardware acceleration hints to prevent stutter
        if (this.selectMarker) (0, $0dcef5d2a6da246a$export$99ee26438460406a).set(this.selectMarker, {
            force3D: true,
            willChange: 'width, opacity'
        });
        if (this.textWrapper) (0, $0dcef5d2a6da246a$export$99ee26438460406a).set(this.textWrapper, {
            force3D: true,
            willChange: 'color'
        });
        this.scroll();
    }
    scroll() {
        (0, $82ba1e40433c64f0$export$875bcbe48555930).create({
            trigger: this.highlightedElement,
            start: 'top bottom-=10%',
            onEnter: ()=>this.animate(),
            onEnterBack: ()=>this.animate(),
            onLeave: ()=>this.reset(),
            onLeaveBack: ()=>this.reset()
        });
    }
    animate() {
        // 1. Highlight Box Expand
        if (this.selectMarker) (0, $0dcef5d2a6da246a$export$99ee26438460406a).to(this.selectMarker, {
            duration: 0.6,
            ease: this.animationDefaults.ease,
            width: 'calc(100% + 10px)',
            left: '-5px',
            opacity: 1,
            overwrite: 'auto'
        });
        // 2. Text Color Change (Whole text block instead of split chars)
        if (this.textWrapper) {
            const targetColor = this.highlightedElement.dataset.highlightTextColor || '#FFFFFF';
            (0, $0dcef5d2a6da246a$export$99ee26438460406a).to(this.textWrapper, {
                color: targetColor,
                duration: 0.4,
                delay: 0.1,
                ease: 'power1.out',
                overwrite: 'auto'
            });
        }
    }
    reset() {
        // Reset Marker
        if (this.selectMarker) (0, $0dcef5d2a6da246a$export$99ee26438460406a).to(this.selectMarker, {
            width: '0%',
            opacity: 0,
            duration: 0.3,
            overwrite: 'auto'
        });
        // Reset Text
        if (this.textWrapper) (0, $0dcef5d2a6da246a$export$99ee26438460406a).to(this.textWrapper, {
            color: 'inherit',
            duration: 0.3,
            overwrite: 'auto'
        });
    }
}




// Modal and Pin Close Handlers
const $0d92265acd506a0c$export$68163e1cd8f8eca8 = ()=>{
    const modal = document.getElementById('modal-consultation');
    if (!modal) {
        console.error('Modal not found');
        return;
    }
    // Close button
    const closeBtn = modal.querySelector('.modal-close-simple');
    if (closeBtn) {
        closeBtn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            console.log('Closing modal');
            modal.classList.remove('modal--active');
            document.body.style.overflow = 'auto';
        });
        console.log('Modal close button listener added');
    } else console.error('Close button not found');
    // Overlay click
    const overlay = modal.querySelector('.modal__overlay');
    if (overlay) overlay.addEventListener('click', function() {
        modal.classList.remove('modal--active');
        document.body.style.overflow = 'auto';
    });
    // Floating pin close button
    const pinCloseBtn = document.querySelector('.pin-close-btn');
    if (pinCloseBtn) {
        pinCloseBtn.removeAttribute('onclick'); // Remove inline handler
        pinCloseBtn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            const pin = document.querySelector('.pin');
            if (pin) {
                console.log('Toggling pin closed state');
                pin.classList.toggle('pin--closed');
            }
        });
        console.log('Pin close button listener added');
    }
};






(0, $0dcef5d2a6da246a$export$99ee26438460406a).registerPlugin((0, $82ba1e40433c64f0$export$875bcbe48555930), (0, $1ab54fb6e8a09792$export$231c7d2ff66229c3));
function $f28854ed323b9f73$export$2e2bcd8739ae039() {
    const container = document.querySelector('.graph-container');
    const svg = document.querySelector('.inflation-svg');
    if (!container || !svg) return;
    const horizontalLines = svg.querySelectorAll('#horizontalLinesGroup line');
    const axisText = svg.querySelectorAll('#graphTextGroup text');
    const sonoFixedLine = svg.querySelector('#sonoFixedLine');
    const bottomSonoLabel = svg.querySelector('#bottomSonoLabel');
    const graphLine = svg.querySelector('#graphLine'); // Red Path
    const movingDot = svg.querySelector('#movingDot'); // The slider handle
    const hoverPoints = svg.querySelectorAll('.hover-point');
    const pointCircles = svg.querySelectorAll('.hover-point circle'); // 포인트 내부 원들
    const bubbles = svg.querySelectorAll('.hover-bubble');
    const savingTexts = svg.querySelectorAll('#savingTextGroup text');
    const topFutureLabel = svg.querySelector('#topFutureLabel');
    // 현재 핸들의 위치(이미지 상의 progress)를 추적할 객체
    let tracker = {
        progress: 0
    };
    const isMobile = window.innerWidth <= 768;
    // 1. 초기 상태 설정
    (0, $0dcef5d2a6da246a$export$99ee26438460406a).set(horizontalLines, {
        scaleX: 0,
        transformOrigin: "left center"
    });
    (0, $0dcef5d2a6da246a$export$99ee26438460406a).set(axisText, {
        autoAlpha: 0,
        y: "+=10"
    });
    (0, $0dcef5d2a6da246a$export$99ee26438460406a).set(sonoFixedLine, {
        scaleX: 0,
        transformOrigin: "left center"
    });
    // 데스크탑 정위치(700, 310)와 모바일 전용 위치 분리 초기화
    (0, $0dcef5d2a6da246a$export$99ee26438460406a).set(bottomSonoLabel, {
        autoAlpha: 0,
        scale: isMobile ? 1 : 0.8,
        x: isMobile ? 450 : 700,
        y: isMobile ? 320 : 310
    });
    // 683만 라벨 또한 초기 위치 명시 (데스크탑: 590, 0 / 모바일: 400, 10)
    (0, $0dcef5d2a6da246a$export$99ee26438460406a).set(topFutureLabel, {
        autoAlpha: 0,
        x: isMobile ? 400 : 590,
        y: isMobile ? 10 : 0,
        scale: isMobile ? 0.8 : 0.8
    });
    // 레드 곡선 초기화
    if (graphLine) {
        const length = graphLine.getTotalLength();
        (0, $0dcef5d2a6da246a$export$99ee26438460406a).set(graphLine, {
            strokeDasharray: length,
            strokeDashoffset: length,
            autoAlpha: 1
        });
    }
    // 포인트 및 텍스트 초기화
    (0, $0dcef5d2a6da246a$export$99ee26438460406a).set(hoverPoints, {
        scale: 0,
        autoAlpha: 0,
        transformOrigin: "center center"
    });
    (0, $0dcef5d2a6da246a$export$99ee26438460406a).set(pointCircles, {
        autoAlpha: 1
    }); // 포인트 원 기본 노출
    (0, $0dcef5d2a6da246a$export$99ee26438460406a).set(bubbles, {
        scale: 0,
        autoAlpha: 0,
        transformOrigin: "center bottom"
    });
    (0, $0dcef5d2a6da246a$export$99ee26438460406a).set(savingTexts, {
        scale: 0,
        autoAlpha: 0,
        transformOrigin: "center center"
    });
    (0, $0dcef5d2a6da246a$export$99ee26438460406a).set(topFutureLabel, {
        autoAlpha: 0,
        y: -20,
        scale: 0.8
    });
    (0, $0dcef5d2a6da246a$export$99ee26438460406a).set(movingDot, {
        autoAlpha: 0,
        scale: 0,
        x: 0,
        y: 0,
        transformOrigin: "50% 50%"
    });
    // 2. 애니메이션 타임라인
    const tl = (0, $0dcef5d2a6da246a$export$99ee26438460406a).timeline({
        scrollTrigger: {
            trigger: container,
            start: "top 80%",
            once: true
        }
    });
    // STEP 1: 무대 세팅
    if (!isMobile) tl.to(horizontalLines, {
        scaleX: 1,
        duration: 0.8,
        stagger: 0.1,
        ease: "power2.out"
    });
    tl.to(axisText, {
        autoAlpha: 1,
        y: 0,
        duration: 0.5,
        stagger: 0.05,
        ease: "back.out(1.7)"
    }, isMobile ? "0" : "-=0.4").to(sonoFixedLine, {
        scaleX: 1,
        duration: 1,
        ease: "power3.out"
    }, "-=0.2").to(bottomSonoLabel, {
        autoAlpha: 1,
        scale: isMobile ? 1.2 : 1,
        x: isMobile ? 450 : 700,
        y: isMobile ? 320 : 310,
        duration: 0.6,
        ease: isMobile ? "back.out(2)" : "elastic.out(1, 0.5)"
    }, "-=0.4");
    // STEP 2: 물가 상승 (시각화의 핵심)
    if (graphLine && movingDot) {
        tl.set(movingDot, {
            autoAlpha: 1,
            scale: 1,
            motionPath: {
                path: graphLine,
                align: graphLine,
                alignOrigin: [
                    0.5,
                    0.5
                ],
                start: 0,
                end: 0
            }
        }, "+=0.2")// 곡선 드로잉 + 점 이동 (3.5초 동안 드라마틱하게)
        .to(graphLine, {
            strokeDashoffset: 0,
            duration: 3.5,
            ease: "power2.inOut"
        }).to(tracker, {
            progress: 1,
            duration: 3.5,
            ease: "power2.inOut",
            onUpdate: function() {
                (0, $0dcef5d2a6da246a$export$99ee26438460406a).set(movingDot, {
                    motionPath: {
                        path: graphLine,
                        align: graphLine,
                        alignOrigin: [
                            0.5,
                            0.5
                        ],
                        start: tracker.progress,
                        end: tracker.progress
                    }
                });
            }
        }, "<");
        // 이동하는 동안 각 연도별 포인트와 텍스트 등장 동기화
        tl.to(hoverPoints[0], {
            autoAlpha: 1,
            scale: 1,
            duration: 0.3
        }, "-=3.4").to(savingTexts[0], {
            autoAlpha: 1,
            scale: 1,
            duration: 0.4,
            ease: "back.out(1.7)"
        }, "<");
        // 5년 데이터 (모바일에서는 스킵)
        if (!isMobile) tl.to(hoverPoints[1], {
            autoAlpha: 1,
            scale: 1,
            duration: 0.3
        }, "-=2.6").to(bubbles[1], {
            autoAlpha: 1,
            scale: 1,
            duration: 0.4,
            ease: "back.out(2)"
        }, "<").to(savingTexts[1], {
            autoAlpha: 1,
            scale: 1,
            duration: 0.4,
            ease: "back.out(1.7)"
        }, "<");
        // 10년 데이터
        tl.to(hoverPoints[2], {
            autoAlpha: 1,
            scale: 1,
            duration: 0.3
        }, isMobile ? "-=1.8" : "-=1.8").to(bubbles[2], {
            autoAlpha: 1,
            scale: 1,
            duration: 0.4,
            ease: "back.out(2)"
        }, "<").to(savingTexts[2], {
            autoAlpha: 1,
            scale: 1,
            duration: 0.4,
            ease: "back.out(1.7)"
        }, "<");
        // 15년 데이터 (모바일에서는 스킵)
        if (!isMobile) tl.to(hoverPoints[3], {
            autoAlpha: 1,
            scale: 1,
            duration: 0.3
        }, "-=1.0").to(bubbles[3], {
            autoAlpha: 1,
            scale: 1,
            duration: 0.4,
            ease: "back.out(2)"
        }, "<").to(savingTexts[3], {
            autoAlpha: 1,
            scale: 1,
            duration: 0.4,
            ease: "back.out(1.7)"
        }, "<");
        // 20년 데이터 (최종)
        tl.to(hoverPoints[4], {
            autoAlpha: 1,
            scale: 1,
            duration: 0.3
        }, "-=0.2")// 20년 지점의 하얀 말풍선(bubbles[4]) 노출 제거 (레드 라벨로 대체)
        .to(topFutureLabel, {
            autoAlpha: 1,
            // 데스크탑 전용 좌표(590, 0)로 하향 조정하여 하얀 말풍선 자리 대체
            ...isMobile ? {
                x: 400,
                y: 10,
                scale: 1.3
            } : {
                x: 590,
                y: 0,
                scale: 1
            },
            duration: 0.8,
            ease: isMobile ? "back.out(2)" : "elastic.out(1, 0.5)"
        }, "-=0.2").to(savingTexts[4], {
            autoAlpha: 1,
            scale: 1.2,
            duration: 0.6,
            ease: "back.out(2)"
        }, "<");
    }
    // 3. 인터랙션: 포인트 클릭 시 슬라이더 이동 및 텍스트 강조
    hoverPoints.forEach((point, i)=>{
        point.style.cursor = 'pointer';
        point.addEventListener('click', ()=>{
            const targetPos = i * 0.25;
            // 이동 시작 시 모든 포인트 원을 다시 노출
            (0, $0dcef5d2a6da246a$export$99ee26438460406a).to(pointCircles, {
                autoAlpha: 1,
                duration: 0.2
            });
            // 현재 트래커의 progress에서 targetPos까지 '미끄러지듯' 애니메이션
            (0, $0dcef5d2a6da246a$export$99ee26438460406a).to(tracker, {
                progress: targetPos,
                duration: 1.2,
                ease: "power3.inOut",
                onUpdate: ()=>{
                    (0, $0dcef5d2a6da246a$export$99ee26438460406a).set(movingDot, {
                        motionPath: {
                            path: graphLine,
                            align: graphLine,
                            alignOrigin: [
                                0.5,
                                0.5
                            ],
                            start: tracker.progress,
                            end: tracker.progress
                        }
                    });
                },
                onComplete: ()=>{
                    // 도착 후 해당 포인트의 원만 숨겨서 겹침 현상(이중 원) 제거
                    (0, $0dcef5d2a6da246a$export$99ee26438460406a).to(pointCircles[i], {
                        autoAlpha: 0,
                        duration: 0.1
                    });
                    // 데이터 강조
                    savingTexts.forEach((txt, idx)=>{
                        if (i === idx) (0, $0dcef5d2a6da246a$export$99ee26438460406a).to(txt, {
                            scale: 1.8,
                            fill: "#FFF",
                            duration: 0.5,
                            ease: "back.out(2)"
                        });
                        else (0, $0dcef5d2a6da246a$export$99ee26438460406a).to(txt, {
                            scale: 1,
                            fill: "#C5A065",
                            duration: 0.3
                        });
                    });
                    bubbles.forEach((b, idx)=>{
                        // 20년 지점(idx === 4)은 레드 라벨이 대체하므로 하얀 말풍선 숨김 유지
                        if (i === idx && idx !== 4) (0, $0dcef5d2a6da246a$export$99ee26438460406a).to(b, {
                            autoAlpha: 1,
                            scale: 1.2,
                            duration: 0.4,
                            ease: "back.out(1.7)"
                        });
                        else (0, $0dcef5d2a6da246a$export$99ee26438460406a).to(b, {
                            autoAlpha: 0,
                            scale: 0,
                            duration: 0.2
                        });
                    });
                    if (i === 4) // 새 위치(y: 0) 기준으로 강조 효과 조정 (y: -10)
                    (0, $0dcef5d2a6da246a$export$99ee26438460406a).to(topFutureLabel, {
                        autoAlpha: 1,
                        scale: 1.15,
                        duration: 0.5,
                        y: isMobile ? 0 : -10,
                        ease: "back.out(2)"
                    });
                    else // 기본 위치(y: 0)로 복귀
                    (0, $0dcef5d2a6da246a$export$99ee26438460406a).to(topFutureLabel, {
                        scale: 1,
                        y: isMobile ? 10 : 0,
                        duration: 0.3
                    });
                }
            });
        });
    });
}


setTimeout(()=>{
    document.body.classList.remove('loading');
}, 3500);
// Safely register plugins
(0, $6255c273005a4429$export$99ee26438460406a).registerPlugin((0, $82ba1e40433c64f0$export$875bcbe48555930), (0, $9644ab9b72d1ba35$export$f2a139e5d18b9882), (0, $1ab54fb6e8a09792$export$231c7d2ff66229c3));
// Force remove loading class after 3.5 seconds to prevent infinite loading
// (Already moved to top, removing this duplicate block if it exists)
console.log('Index.js initializing...');
// Custom Dot Cursor
const $f9e1d550cec58a8b$var$cursor = document.querySelector('.custom-cursor');
if ($f9e1d550cec58a8b$var$cursor) document.addEventListener('mousemove', (e)=>{
    $f9e1d550cec58a8b$var$cursor.style.left = e.clientX + 'px';
    $f9e1d550cec58a8b$var$cursor.style.top = e.clientY + 'px';
});
// Global instance for hero copy effect
let $f9e1d550cec58a8b$var$heroCopyEffect = null;
// Lenis smooth scrolling
let $f9e1d550cec58a8b$var$lenis;
const $f9e1d550cec58a8b$var$initSmoothScrolling = ()=>{
    $f9e1d550cec58a8b$var$lenis = new (0, $12aa2a06f48a44b4$export$2e2bcd8739ae039)({
        lerp: 0.1,
        smooth: true
    });
    $f9e1d550cec58a8b$var$lenis.on('scroll', (0, $82ba1e40433c64f0$export$875bcbe48555930).update);
    (0, $6255c273005a4429$export$99ee26438460406a).ticker.add((time)=>{
        $f9e1d550cec58a8b$var$lenis.raf(time * 1000);
    });
    (0, $6255c273005a4429$export$99ee26438460406a).ticker.lagSmoothing(0);
    // [FIX] Anchor Link Handling with Lenis
    document.querySelectorAll('a[href^="#"]').forEach((anchor)=>{
        anchor.addEventListener('click', function(e) {
            e.preventDefault();
            const targetId = this.getAttribute('href');
            if (targetId && targetId !== '#') {
                const targetElement = document.querySelector(targetId);
                if (targetElement) $f9e1d550cec58a8b$var$lenis.scrollTo(targetElement); // Lenis 부드러운 이동
            }
        });
    });
};
// Hero Content Fade Out - Ripple/Wave effect tied to scroll
const $f9e1d550cec58a8b$var$initHeroFadeOut = ()=>{
    // 사용자 요청: 비디오가 등장하지 않으므로 히어로 배경 이미지와 텍스트는 항상 고정(유지)되어야 함.
    // 기존의 스크롤에 따른 페이드아웃 로직을 비활성화합니다.
    return;
};
// Show Header Animation
const $f9e1d550cec58a8b$var$showHeader = ()=>{
    const header = document.querySelector('.header');
    if (header) (0, $6255c273005a4429$export$99ee26438460406a).to(header, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: 'power3.out',
        pointerEvents: 'auto'
    });
};
// Logo Click Event
const $f9e1d550cec58a8b$var$initLogoClick = ()=>{
    const logo = document.querySelector('.header__logo-container');
    if (logo && $f9e1d550cec58a8b$var$lenis) {
        logo.style.cursor = 'pointer';
        logo.addEventListener('click', (e)=>{
            e.preventDefault();
            $f9e1d550cec58a8b$var$lenis.scrollTo(0, {
                duration: 2
            });
        });
    }
};
// Go to Home Button (at the bottom)
const $f9e1d550cec58a8b$var$initGoHome = ()=>{
    const btn = document.getElementById('btn-go-home');
    if (btn && $f9e1d550cec58a8b$var$lenis) btn.addEventListener('click', (e)=>{
        e.preventDefault();
        $f9e1d550cec58a8b$var$lenis.scrollTo(0, {
            duration: 2
        });
    });
};
// Sound Toggle Logic
const $f9e1d550cec58a8b$var$initSoundToggle = ()=>{
    const btn = document.querySelector('.sound-toggle');
    const video = document.querySelector('.video-fill');
    const iconOff = document.querySelector('.icon--sound-off');
    const iconOn = document.querySelector('.icon--sound-on');
    if (!btn || !video) return;
    btn.addEventListener('click', ()=>{
        video.muted = !video.muted;
        if (video.muted) {
            iconOn.style.display = 'none';
            iconOff.style.display = 'block';
            btn.setAttribute('aria-label', "\uC74C\uC18C\uAC70 \uD574\uC81C");
        } else {
            iconOff.style.display = 'none';
            iconOn.style.display = 'block';
            btn.setAttribute('aria-label', "\uC74C\uC18C\uAC70");
        }
    });
    // Also update cursor hover effect for this new button
    btn.addEventListener('mouseenter', ()=>{
        const cursor = document.querySelector('.custom-cursor');
        if (cursor) {
            cursor.style.transform = 'translate(-50%, -50%) scale(2.5)';
            cursor.style.opacity = '0.5';
        }
    });
    btn.addEventListener('mouseleave', ()=>{
        const cursor = document.querySelector('.custom-cursor');
        if (cursor) {
            cursor.style.transform = 'translate(-50%, -50%) scale(1)';
            cursor.style.opacity = '1';
        }
    });
};
// Infra (Network/Resort) Toggle Logic
const $f9e1d550cec58a8b$var$initInfraToggle = ()=>{
    const btns = document.querySelectorAll('.infra__toggle-btn');
    const tables = document.querySelectorAll('.infra__table-tab');
    const servicePins = document.querySelectorAll('.infra-pin--service');
    const resortPins = document.querySelectorAll('.infra-pin--resort');
    const infraSection = document.getElementById('infra');
    if (btns.length === 0) return;
    btns.forEach((btn)=>{
        btn.addEventListener('click', ()=>{
            const tabId = btn.getAttribute('data-tab');
            // 1. Update Buttons
            btns.forEach((b)=>b.classList.remove('active'));
            btn.classList.add('active');
            // 2. Update Tables
            tables.forEach((t)=>{
                t.classList.remove('active');
                if (t.id === `tab-${tabId}`) t.classList.add('active');
            });
            // 3. Update Map Pins & Section Theme
            if (tabId === 'service') {
                servicePins.forEach((p)=>p.classList.add('active'));
                resortPins.forEach((p)=>p.classList.remove('active'));
                if (infraSection) infraSection.classList.remove('light-mode');
            } else {
                servicePins.forEach((p)=>p.classList.remove('active'));
                resortPins.forEach((p)=>p.classList.add('active'));
                if (infraSection) infraSection.classList.add('light-mode');
            }
            // Refresh ScrollTrigger as heights might change
            (0, $82ba1e40433c64f0$export$875bcbe48555930).refresh();
        });
    });
};
// Showcase Cards Scroll Animation
const $f9e1d550cec58a8b$var$initShowcaseCardsAnimation = ()=>{
    const showcaseItems = document.querySelectorAll('.showcase__item');
    if (showcaseItems.length > 0) showcaseItems.forEach((item, index)=>{
        (0, $6255c273005a4429$export$99ee26438460406a).fromTo(item, {
            y: 80,
            opacity: 0
        }, {
            y: 0,
            opacity: 1,
            duration: 1.2,
            ease: 'power3.out',
            scrollTrigger: {
                trigger: item,
                start: 'top 85%',
                toggleActions: 'play none none reverse'
            },
            delay: index * 0.15 // Stagger effect for sequential reveal
        });
    });
};
// Service Essence Star Animation
const $f9e1d550cec58a8b$var$initServiceEssenceAnimations = ()=>{
    const starsContainer = document.getElementById('stars-container');
    const starItems = Array.from(document.querySelectorAll('.star-item')).reverse();
    if (starsContainer && starItems.length > 0) (0, $82ba1e40433c64f0$export$875bcbe48555930).create({
        trigger: starsContainer,
        start: 'top 85%',
        onEnter: ()=>{
            starItems.forEach((star, index)=>{
                setTimeout(()=>{
                    star.classList.add('is-active');
                    const player = star.querySelector('lottie-player');
                    if (player) {
                        player.speed = 1.5; // Faster playback
                        if (typeof player.play === 'function') player.play();
                        else player.addEventListener('ready', ()=>{
                            player.speed = 1.5;
                            player.play();
                        });
                    }
                }, index * 100); // Snappier stagger (200ms -> 100ms)
            });
        },
        once: true
    });
    // Scroll-triggered Fade In & Float Up for the 3 Frames
    const essenceFrames = document.querySelectorAll('.essence__q-box, .essence__infographic');
    essenceFrames.forEach((frame)=>{
        (0, $6255c273005a4429$export$99ee26438460406a).fromTo(frame, {
            y: 80,
            opacity: 0
        }, {
            y: 0,
            opacity: 1,
            duration: 1.2,
            ease: 'power3.out',
            scrollTrigger: {
                trigger: frame,
                start: 'top 85%',
                toggleActions: 'play none none reverse' // Reverses when scrolling back up
            }
        });
    });
};
// Floating Card Behavior
const $f9e1d550cec58a8b$var$initFloatingCard = ()=>{
    const selector = '.pin';
    const pin = document.querySelector(selector);
    const hero = document.querySelector('.content');
    if (!pin) return;
    // 1. ScrollTrigger for showing and minimizing
    (0, $82ba1e40433c64f0$export$875bcbe48555930).create({
        start: 'top -100',
        onEnter: ()=>{
            (0, $6255c273005a4429$export$99ee26438460406a).to(pin, {
                opacity: 1,
                duration: 0.8,
                overwrite: 'auto'
            });
            pin.classList.add('pin--minimized');
        },
        onLeaveBack: ()=>{
            // If we scroll back to very top, we might want to keep it minimized or expand 
            // but user said follow for impatient scrollers.
            pin.classList.remove('pin--minimized');
        }
    });
    if (hero) (0, $82ba1e40433c64f0$export$875bcbe48555930).create({
        trigger: hero,
        start: 'top top-=150',
        onEnter: ()=>pin.classList.add('pin--minimized'),
        onLeaveBack: ()=>pin.classList.remove('pin--minimized')
    });
    // 3. Click to Expand (Interaction)
    const btn = pin.querySelector('.pin__button');
    if (btn) btn.addEventListener('click', (e)=>{
        // If minimized, prevent submit and expand instead
        if (pin.classList.contains('pin--minimized')) {
            e.preventDefault();
            pin.classList.remove('pin--minimized');
        }
    });
    // 닫기 버튼: 누르면 다시 접힌 상태 (버튼 형태)로 돌아감
    const closeBtn = pin.querySelector('#btn-floating-close');
    if (closeBtn) closeBtn.addEventListener('click', (e)=>{
        e.preventDefault();
        e.stopPropagation();
        pin.classList.add('pin--minimized');
    });
    // 4. Click Outside to Minimize (Close)
    document.addEventListener('click', (e)=>{
        // If clicking outside the pin AND the pin is NOT minimized AND we are scrolled down (past hero trigger)
        if (!pin.contains(e.target) && !pin.classList.contains('pin--minimized') && window.scrollY > 150) pin.classList.add('pin--minimized');
    });
    // 2. Lag Effect (Desktop Only)
    if (window.innerWidth <= 768) return;
    let scrollTop = 0;
    let pinTop = 0;
    let lastTime;
    const lagAmount = 50;
    const maxSpeed = 100;
    const frameRate = 20;
    const updatePinPosition = (time)=>{
        if (!lastTime) lastTime = time;
        let delta = time - lastTime;
        if (delta >= frameRate) {
            scrollTop = window.scrollY;
            const move = (scrollTop - pinTop) * delta / (lagAmount + delta);
            const direction = move === 0 ? 0 : move / Math.abs(move);
            pinTop = pinTop + Math.min(Math.abs(move), maxSpeed) * direction;
            // Apply transform (removed -50% centering logic)
            pin.style.transform = `translateY(${-move}px)`;
            lastTime = time;
        }
        requestAnimationFrame(updatePinPosition);
    };
    requestAnimationFrame(updatePinPosition);
};
// Video Scroll Behavior
const $f9e1d550cec58a8b$var$initVideoBehavior = ()=>{
    const video = document.querySelector('.video-overlay');
    const content = document.querySelector('.content');
    if (!video || !content) return;
    (0, $82ba1e40433c64f0$export$875bcbe48555930).create({
        trigger: content,
        start: '100px top',
        onEnter: ()=>{
            (0, $6255c273005a4429$export$99ee26438460406a).to(video, {
                opacity: 1,
                mixBlendMode: 'normal',
                duration: 1.5,
                overwrite: 'auto'
            });
        },
        onLeaveBack: ()=>{
            // 히어로 섹션 재진입 시 영상을 더욱 어둡게(0.25) 하여 배경으로 완전히 밀어냄
            (0, $6255c273005a4429$export$99ee26438460406a).to(video, {
                opacity: 0.25,
                mixBlendMode: 'normal',
                duration: 1.5,
                overwrite: 'auto'
            });
        }
    });
};
// Preload images
console.log('Starting image preload...');
(0, $32cf713314f1c621$export$6b05b21262ec0515)('.layers__item-img').then(()=>{
    console.log('Preload complete. Starting intro...');
    document.body.classList.remove('loading');
    let introTimeout;
    try {
        const revealer = new (0, $144cc94666dde40e$export$2e2bcd8739ae039)();
        setTimeout(()=>{
            console.log('Calling revealer.reveal()');
            revealer.reveal();
            // Initialization handled by Unified Initialization block at end of file
            setTimeout(()=>{
                $f9e1d550cec58a8b$var$showHeader();
                // 메인 카피 순차 등장 애니메이션 (사용자 요청: chars + edges stagger + scale)
                const copySub = document.querySelector('.copy__sub');
                const copyMain = document.querySelector('.copy__main');
                const copyDesc = document.querySelector('.copy__desc');
                const tlHero = (0, $6255c273005a4429$export$99ee26438460406a).timeline({
                    onComplete: ()=>{
                        // 모든 히어로 요소 노출 보장
                        (0, $6255c273005a4429$export$99ee26438460406a).set([
                            '.copy__sub',
                            '.copy__main',
                            '.copy__desc',
                            '.scroll-indicator',
                            '.content',
                            '.copy-container'
                        ], {
                            opacity: 1,
                            visibility: 'visible',
                            y: 0
                        });
                        $f9e1d550cec58a8b$var$showHeroVideoPopup();
                    }
                });
                // 1. Sub Copy 등장
                if (copySub) {
                    (0, $6255c273005a4429$export$99ee26438460406a).set(copySub, {
                        opacity: 0,
                        y: 20
                    });
                    tlHero.to(copySub, {
                        opacity: 1,
                        y: 0,
                        duration: 1.2,
                        ease: 'power2.out'
                    });
                }
                // 2. Main Copy (사용자 요청 효과: chars + edges stagger + scale)
                if (copyMain) {
                    // words와 chars로 분할 (컨테이너가 숨겨진 상태에서 수행)
                    const split = new (0, $2835f7b29847c215$export$2e2bcd8739ae039)(copyMain, {
                        types: 'words, chars'
                    });
                    const words = split.words || [];
                    if (words.length > 0) {
                        // 모든 chars를 하나의 배열로 합침
                        const allChars = [];
                        words.forEach((word)=>{
                            const chars = word.querySelectorAll('.char');
                            chars.forEach((char)=>allChars.push(char));
                        });
                        // 글자들을 먼저 숨김
                        (0, $6255c273005a4429$export$99ee26438460406a).set(allChars, {
                            opacity: 0,
                            scale: 1.5,
                            display: 'inline-block',
                            willChange: 'transform, opacity'
                        });
                        // 이제 컨테이너를 보임 (글자들은 이미 숨겨져 있음)
                        (0, $6255c273005a4429$export$99ee26438460406a).set(copyMain, {
                            opacity: 1,
                            visibility: 'visible'
                        });
                        // 문장 전체가 하나의 흐름으로 가속도감(Slow-Fast-Slow) 있게 등장
                        tlHero.fromTo(allChars, {
                            opacity: 0,
                            scale: 1.4,
                            yPercent: 10 // 미세한 y축 이동 추가로 입체감 부여
                        }, {
                            opacity: 1,
                            scale: 1,
                            yPercent: 0,
                            duration: 0.8,
                            ease: 'power2.inOut',
                            stagger: {
                                each: 0.03,
                                from: 'start',
                                ease: 'power2.inOut' // 문장 전체의 파장 곡선 (느리게 시작 -> 중간 가속 -> 마지막 감속)
                            }
                        }, '-=0.8');
                    }
                }
                // 3. Desc Copy 및 Scroll Indicator 등장
                if (copyDesc) {
                    (0, $6255c273005a4429$export$99ee26438460406a).set([
                        '.copy__desc',
                        '.scroll-indicator'
                    ], {
                        opacity: 0,
                        y: 20
                    });
                    tlHero.to([
                        '.copy__desc',
                        '.scroll-indicator'
                    ], {
                        opacity: 1,
                        y: 0,
                        duration: 1.2,
                        ease: 'power2.out'
                    }, '-=0.5');
                }
                // [추가] 배경 그리드(content) 등장 보장
                tlHero.to('.content', {
                    opacity: 1,
                    duration: 1
                }, 0);
                // BlurScrollEffect는 스크롤 기반이므로 자동으로 작동
                (0, $82ba1e40433c64f0$export$875bcbe48555930).refresh();
            // window.scrollTo(0, 0); // Removed to prevent forced scroll to top on refresh
            }, 2000);
        }, 1000);
    } catch (err) {
        console.error('Error during Revealer initialization:', err);
    }
}).catch((err)=>{
    console.warn('Preload failed:', err);
    document.body.classList.remove('loading');
});
// Header Scroll Effect
const $f9e1d550cec58a8b$var$header = document.querySelector('.header');
window.addEventListener('scroll', ()=>{
    if (window.scrollY > 100) $f9e1d550cec58a8b$var$header.classList.add('header--scrolled');
    else $f9e1d550cec58a8b$var$header.classList.remove('header--scrolled');
});
// Cursor
const $f9e1d550cec58a8b$var$updateCursorHover = ()=>{
    const interactives = document.querySelectorAll('a, button, #splash-trigger, .header__link, .header__logo-container, #burger-trigger, #mobile-menu-close');
    interactives.forEach((el)=>{
        el.addEventListener('mouseenter', ()=>{
            $f9e1d550cec58a8b$var$cursor.style.transform = 'translate(-50%, -50%) scale(2.5)';
            $f9e1d550cec58a8b$var$cursor.style.opacity = '0.5';
        });
        el.addEventListener('mouseleave', ()=>{
            $f9e1d550cec58a8b$var$cursor.style.transform = 'translate(-50%, -50%) scale(1)';
            $f9e1d550cec58a8b$var$cursor.style.opacity = '1';
        });
    });
};
$f9e1d550cec58a8b$var$updateCursorHover();
// Mobile Menu (Refactored for Safari stability)
const $f9e1d550cec58a8b$var$burger = document.getElementById('burger-trigger');
const $f9e1d550cec58a8b$var$closeBtn = document.getElementById('mobile-menu-close');
const $f9e1d550cec58a8b$var$mobileItems = document.querySelectorAll('.mobile-menu__item');
if ($f9e1d550cec58a8b$var$burger) $f9e1d550cec58a8b$var$burger.addEventListener('click', (e)=>{
    e.preventDefault();
    document.body.classList.add('mobile-menu-active');
});
if ($f9e1d550cec58a8b$var$closeBtn) $f9e1d550cec58a8b$var$closeBtn.addEventListener('click', (e)=>{
    e.preventDefault();
    document.body.classList.remove('mobile-menu-active');
    // Reset sub-menus when closing
    $f9e1d550cec58a8b$var$mobileItems.forEach((i)=>i.classList.remove('is-active'));
});
$f9e1d550cec58a8b$var$mobileItems.forEach((item)=>{
    const mainLink = item.querySelector('.mobile-menu__link');
    const subLinks = item.querySelectorAll('.mobile-menu__sub a');
    if (mainLink) mainLink.addEventListener('click', (e)=>{
        const isActive = item.classList.contains('is-active');
        // Close other items
        $f9e1d550cec58a8b$var$mobileItems.forEach((otherItem)=>{
            if (otherItem !== item) otherItem.classList.remove('is-active');
        });
        if (!isActive) {
            e.preventDefault();
            item.classList.add('is-active');
        } else // Already open, allow navigation and close menu
        document.body.classList.remove('mobile-menu-active');
    });
    subLinks.forEach((sub)=>{
        sub.addEventListener('click', ()=>{
            document.body.classList.remove('mobile-menu-active');
            item.classList.remove('is-active');
        });
    });
});
// ------- Highlight Effect & Text Splitting ------- //
class $f9e1d550cec58a8b$var$Text3DRevealEffect {
    constructor(el){
        if (!el || !(el instanceof HTMLElement)) return;
        this.highlightedElement = el;
        this.createStructure();
        this.highlightedChars = this.highlightedElement.querySelectorAll('.char');
        this.highlightedWords = this.highlightedElement.querySelectorAll('.word');
        this.animationDefaults = {
            duration: 1.0,
            ease: 'power2.out'
        };
        this.initializeEffect();
    }
    createStructure() {
        const text = this.highlightedElement.innerHTML;
        const processedText = text.replace(/<br\s*\/?>/gi, ' [[br]] ');
        const words = processedText.trim().split(/\s+/);
        let newHTML = '';
        words.forEach((word)=>{
            if (word === '[[br]]') newHTML += '<br>';
            else {
                newHTML += `<span class="word">`;
                let isStrong = false;
                let i = 0;
                while(i < word.length){
                    if (word.slice(i, i + 8) === '<strong>') {
                        isStrong = true;
                        i += 8;
                    } else if (word.slice(i, i + 9) === '</strong>') {
                        isStrong = false;
                        i += 9;
                    } else {
                        const char = word[i];
                        newHTML += `<span class="char">${isStrong ? `<strong>${char}</strong>` : char}</span>`;
                        i++;
                    }
                }
                newHTML += `</span> `;
            }
        });
        this.highlightedElement.innerHTML = newHTML;
    }
    initializeEffect() {
        (0, $6255c273005a4429$export$99ee26438460406a).set(this.highlightedElement, {
            perspective: 800,
            opacity: 1
        });
        (0, $6255c273005a4429$export$99ee26438460406a).set(this.highlightedWords, {
            transformStyle: 'preserve-3d'
        });
        (0, $6255c273005a4429$export$99ee26438460406a).set(this.highlightedChars, {
            opacity: 0,
            z: 300,
            rotationX: -60,
            y: 30
        });
        this.scroll();
    }
    scroll() {
        (0, $82ba1e40433c64f0$export$875bcbe48555930).create({
            trigger: this.highlightedElement,
            start: 'top bottom',
            onEnter: ()=>this.animateChars(),
            onEnterBack: ()=>this.animateChars(),
            onLeave: ()=>this.resetChars(),
            onLeaveBack: ()=>this.resetChars()
        });
    }
    animateChars() {
        (0, $6255c273005a4429$export$99ee26438460406a).killTweensOf(this.highlightedChars);
        (0, $6255c273005a4429$export$99ee26438460406a).fromTo(this.highlightedChars, {
            opacity: 0,
            z: 300,
            rotationX: -60,
            y: 30
        }, {
            stagger: 0.04,
            opacity: 1,
            z: 0,
            rotationX: 0,
            y: 0,
            duration: this.animationDefaults.duration,
            ease: this.animationDefaults.ease,
            overwrite: true
        });
    }
    resetChars() {
        (0, $6255c273005a4429$export$99ee26438460406a).killTweensOf(this.highlightedChars);
        (0, $6255c273005a4429$export$99ee26438460406a).set(this.highlightedChars, {
            opacity: 0,
            z: 300,
            rotationX: -60,
            y: 30
        });
    }
}
// Hero Copy Effect Removed (handled in intro animation)
// Inflation Chart Animation
// Inflation Chart Animation
const $f9e1d550cec58a8b$var$initInflationCharts = ()=>{
    const section = document.querySelector('.section--inflation');
    if (!section) return;
    // 1. Header Text
    // 1. Header Text
    const headerTitle = section.querySelector('.inflation__title');
    // New Message Text Elements
    const messageTitle = section.querySelector('.inflation__message-title');
    const messageBodyLines = section.querySelectorAll('.inflation__message-body p');
    if (headerTitle) (0, $6255c273005a4429$export$99ee26438460406a).from(headerTitle, {
        scrollTrigger: {
            trigger: section,
            start: 'top 70%'
        },
        y: 50,
        opacity: 0,
        duration: 1,
        ease: 'power3.out'
    });
    if (messageTitle) (0, $6255c273005a4429$export$99ee26438460406a).from(messageTitle, {
        scrollTrigger: {
            trigger: section,
            start: 'top 65%'
        },
        y: 30,
        opacity: 0,
        duration: 1,
        delay: 0.3,
        ease: 'power3.out'
    });
    if (messageBodyLines.length > 0) (0, $6255c273005a4429$export$99ee26438460406a).from(messageBodyLines, {
        scrollTrigger: {
            trigger: section,
            start: 'top 65%'
        },
        y: 30,
        opacity: 0,
        duration: 1,
        stagger: 0.3,
        delay: 0.6,
        ease: 'power3.out'
    });
    // 2. Chart Animation
    const chartWrapper = section.querySelector('.chart-wrapper');
    if (chartWrapper) (0, $82ba1e40433c64f0$export$875bcbe48555930).create({
        trigger: chartWrapper,
        start: 'top 75%',
        once: true,
        onEnter: ()=>{
            const cardFear = chartWrapper.querySelector('.chart-card--fear');
            const barGroups = chartWrapper.querySelectorAll('.h-bar-group');
            // Show containers immediately so GSAP can animate them from 0
            (0, $6255c273005a4429$export$99ee26438460406a).set([
                cardFear,
                barGroups
            ], {
                visibility: 'visible',
                opacity: 1
            });
            const tl = (0, $6255c273005a4429$export$99ee26438460406a).timeline();
            tl.from(cardFear, {
                y: 30,
                opacity: 0,
                duration: 0.6,
                ease: 'power2.out'
            }).from(barGroups, {
                x: -20,
                opacity: 0,
                duration: 0.5,
                stagger: 0.1,
                ease: 'power1.out'
            }, '-=0.3').fromTo(chartWrapper.querySelectorAll('.h-bar'), {
                width: 0
            }, {
                width: (i, el)=>el.style.getPropertyValue('--target-width'),
                duration: 1.5,
                ease: 'power3.inOut',
                stagger: 0.15
            }, '-=0.2').to(chartWrapper.querySelector('.tooltip-trigger'), {
                scale: 1,
                opacity: 1,
                duration: 0.6,
                ease: 'elastic.out(1, 0.5)'
            }, '-=0.2');
        }
    });
    // 3. Survey Jelly Blob Slider Animation
    const surveyWrapper = section.querySelector('.survey-wrapper');
    if (surveyWrapper) (0, $82ba1e40433c64f0$export$875bcbe48555930).create({
        trigger: surveyWrapper,
        start: 'top 80%',
        once: true,
        onEnter: ()=>{
            const maxVal = 74.6;
            const trackWidth = 400; // 450 - 50 = 400
            const targetX = maxVal / 100 * trackWidth;
            // Elements
            const blobGroup = surveyWrapper.querySelector('#blob-group');
            const blobDisplay = surveyWrapper.querySelector('#blob-display');
            const blobHandle = surveyWrapper.querySelector('#blob-handle');
            const blobConnector = surveyWrapper.querySelector('#blob-connector'); // New connector
            const fillLine = surveyWrapper.querySelector('#fill-line');
            const textGroup = surveyWrapper.querySelector('#text-group');
            const blobText = surveyWrapper.querySelector('.blob-text');
            const resultText = surveyWrapper.querySelector('.survey-result-text');
            // GSAP Timeline
            const tl = (0, $6255c273005a4429$export$99ee26438460406a).timeline();
            // 1. "Blob Up": Handle pops up a big bubble
            tl.to(blobHandle, {
                attr: {
                    r: 12
                },
                duration: 0.4,
                ease: 'power2.out'
            })// Connector stretches up
            .to(blobConnector, {
                attr: {
                    cy: -48,
                    r: 24
                },
                duration: 0.8,
                ease: 'elastic.out(1, 0.4)'
            }, '-=0.2')// Morph circle to bigger bubble (High floating)
            .to(blobDisplay, {
                attr: {
                    cy: -100,
                    r: 72
                },
                duration: 1,
                ease: 'elastic.out(1, 0.4)'
            }, '-=0.6')// Move text UP into the high bubble
            .to(blobText, {
                attr: {
                    y: -98
                },
                duration: 1,
                ease: 'elastic.out(1, 0.4)'
            }, '<')// Fade text in
            .to(textGroup, {
                opacity: 1,
                duration: 0.3,
                ease: 'power2.out'
            }, '-=0.8')// 2. Slide to Value (Elastic effect)
            // We animate a proxy object and update the SVG elements
            .to({
                val: 0
            }, {
                val: maxVal,
                duration: 2.5,
                // Use a slightly more controlled ease to prevent extreme lag/overshoot mismatch
                ease: 'elastic.out(1, 0.7)',
                onUpdate: function() {
                    const currentVal = this.targets()[0].val;
                    const currentX = currentVal / 100 * trackWidth;
                    // COMPENSATION: The bar has stroke-linecap: round, adding ~3px (half stroke width) 
                    // to the perceived end. We offset the balloon to match the visual tip of the bar.
                    const visualOffset = 2;
                    // Move the entire group (handle + bubble + text + connector)
                    (0, $6255c273005a4429$export$99ee26438460406a).set([
                        blobGroup,
                        textGroup
                    ], {
                        x: currentX + visualOffset
                    });
                    // Stretch the line
                    (0, $6255c273005a4429$export$99ee26438460406a).set(fillLine, {
                        attr: {
                            x2: 50 + currentX
                        }
                    });
                    // Update Text (Inside Blob)
                    if (blobText) blobText.textContent = currentVal.toFixed(1) + '%';
                }
            }, '-=0.5');
        // 3. Keep the blob UP (Speech Bubble state) as per user request
        // No "Blob Down" animation.
        }
    });
    // Bottom Text
    const bottomText = section.querySelector('.inflation__bottom');
    if (bottomText) (0, $6255c273005a4429$export$99ee26438460406a).from(bottomText, {
        scrollTrigger: {
            trigger: bottomText,
            start: 'top 85%'
        },
        y: 30,
        opacity: 0,
        duration: 1,
        ease: 'power3.out'
    });
    // 4. Donut Charts Animation (Scroll-triggered)
    const donutContainers = section.querySelectorAll('.donut-container');
    if (donutContainers.length > 0) donutContainers.forEach((container, index)=>{
        const donutProgress = container.querySelector('.donut-progress');
        const countElement = container.querySelector('.count');
        const checkIcon = container.querySelector('.donut-check-icon');
        const speechBubble = container.querySelector('.speech-bubble');
        const numberWrap = container.querySelector('.donut-number-wrap');
        if (donutProgress && countElement) {
            const targetPct = parseFloat(donutProgress.getAttribute('data-pct'));
            const targetValue = parseFloat(countElement.getAttribute('data-target'));
            const isDecimal = targetValue % 1 !== 0;
            const circumference = 263.89;
            const offset = circumference - targetPct / 100 * circumference;
            // 1. Initial State Setup (Hide elements to animate later)
            (0, $6255c273005a4429$export$99ee26438460406a).set(container, {
                opacity: 0,
                y: 50
            }); // Container hidden
            (0, $6255c273005a4429$export$99ee26438460406a).set(donutProgress, {
                strokeDashoffset: circumference
            }); // Graph empty
            (0, $6255c273005a4429$export$99ee26438460406a).set(countElement, {
                innerText: 0
            }); // Count 0
            if (numberWrap) (0, $6255c273005a4429$export$99ee26438460406a).set(numberWrap, {
                opacity: 0,
                scale: 0.5
            }); // Hide number wrap initially
            if (speechBubble) (0, $6255c273005a4429$export$99ee26438460406a).set(speechBubble, {
                scale: 0,
                opacity: 0,
                transformOrigin: 'center bottom'
            });
            if (checkIcon) (0, $6255c273005a4429$export$99ee26438460406a).set(checkIcon, {
                scale: 0,
                opacity: 0,
                rotation: -30,
                transformOrigin: 'center center'
            });
            // 2. Timeline Animation
            const tl = (0, $6255c273005a4429$export$99ee26438460406a).timeline({
                scrollTrigger: {
                    trigger: container,
                    start: 'top 85%',
                    once: true
                },
                delay: index * 0.2 // Stagger between cards
            });
            // Step 1: Container Fade In
            tl.to(container, {
                y: 0,
                opacity: 1,
                duration: 0.8,
                ease: 'power3.out'
            });
            // Step 2: Show Number (Pop up)
            if (numberWrap) tl.to(numberWrap, {
                opacity: 1,
                scale: 1,
                duration: 0.5,
                ease: 'back.out(1.7)'
            }, '-=0.6');
            // Step 3: Graph Fill & Counting (Concurrent)
            tl.to(donutProgress, {
                strokeDashoffset: offset,
                duration: 1.5,
                ease: 'power2.out'
            }, '-=0.4') // Start filling right after number appears
            .to(countElement, {
                innerText: targetValue,
                duration: 1.5,
                ease: 'power2.out',
                snap: isDecimal ? {
                    innerText: 0.1
                } : {
                    innerText: 1
                },
                onUpdate: function() {
                    const currentValue = parseFloat(this.targets()[0].innerText);
                    countElement.innerText = isDecimal ? currentValue.toFixed(1) : Math.ceil(currentValue);
                }
            }, '<'); // Start with graph
            // Step 3: Speech Bubble Pop (After graph)
            if (speechBubble) tl.to(speechBubble, {
                scale: 1,
                opacity: 1,
                duration: 0.6,
                ease: 'back.out(1.7)'
            }, '-=0.2'); // Slightly before graph ends
            // Step 4: Check Icon Pop (Last)
            if (checkIcon) tl.to(checkIcon, {
                scale: 1,
                opacity: 1,
                rotation: 0,
                duration: 0.6,
                ease: 'elastic.out(1, 0.5)'
            });
        }
    });
};
// ------- Trust Section Animations ------- //
const $f9e1d550cec58a8b$var$initTrustAnimations = ()=>{
    const section = document.querySelector('.section--trust');
    if (!section) return;
    // 1. Text Effects (Blur Scroll)
    const title = section.querySelector('.trust__title');
    const desc = section.querySelector('.trust__desc');
    if (title) new (0, $c83df951dc505516$export$824eb2eeafc81b63)(title);
    if (desc) new (0, $c83df951dc505516$export$824eb2eeafc81b63)(desc);
    // 2. Subtitle (Simple Fade Up)
    const subtitle = section.querySelector('.trust__subtitle');
    if (subtitle) (0, $6255c273005a4429$export$99ee26438460406a).from(subtitle, {
        scrollTrigger: {
            trigger: subtitle,
            start: 'top 90%'
        },
        y: 30,
        opacity: 0,
        duration: 1,
        ease: 'power3.out'
    });
    // 3. Statistics Cards with Counting Animation
    const statsCards = section.querySelectorAll('.trust__stat-card');
    const statNumbers = section.querySelectorAll('.stat-number');
    if (statsCards.length > 0) {
        // Fade in cards
        (0, $6255c273005a4429$export$99ee26438460406a).from(statsCards, {
            scrollTrigger: {
                trigger: '.trust__stats-row',
                start: 'top 85%'
            },
            y: 20,
            opacity: 0,
            duration: 0.8,
            stagger: 0.1,
            ease: 'power3.out',
            clearProps: 'all'
        });
        // Count up numbers
        statNumbers.forEach((numberEl)=>{
            const target = parseFloat(numberEl.getAttribute('data-target'));
            const isDecimal = target % 1 !== 0; // Check if it has decimal places
            (0, $6255c273005a4429$export$99ee26438460406a).to(numberEl, {
                scrollTrigger: {
                    trigger: '.trust__stats-row',
                    start: 'top 85%'
                },
                innerText: target,
                duration: 2,
                ease: 'power2.out',
                snap: isDecimal ? {
                    innerText: 0.1
                } : {
                    innerText: 1
                },
                onUpdate: function() {
                    const currentValue = parseFloat(this.targets()[0].innerText);
                    if (isDecimal) numberEl.innerText = currentValue.toFixed(1);
                    else numberEl.innerText = Math.ceil(currentValue);
                }
            });
        });
    }
    // 4. Certification Items (Fade In & Slide Up)
    const certRow = section.querySelector('.trust__cert-row');
    const certItems = section.querySelectorAll('.trust__cert-item');
    if (certItems.length > 0) (0, $6255c273005a4429$export$99ee26438460406a).from(certItems, {
        scrollTrigger: {
            trigger: certRow || section,
            start: 'top 85%'
        },
        y: 30,
        opacity: 0,
        duration: 1,
        stagger: 0.2,
        ease: 'power3.out'
    });
    // 5. Non-text Elements (Fade In & Float Up)
    const emblem = section.querySelector('.trust__emblem-wrap');
    const guarantee = section.querySelector('.trust__guarantee');
    const items = section.querySelectorAll('.trust__item');
    if (emblem) (0, $6255c273005a4429$export$99ee26438460406a).from(emblem, {
        scrollTrigger: {
            trigger: emblem,
            start: 'top 85%'
        },
        y: 40,
        opacity: 0,
        duration: 1,
        delay: 0.2,
        ease: 'back.out(1.7)'
    });
    if (guarantee) (0, $6255c273005a4429$export$99ee26438460406a).from(guarantee, {
        scrollTrigger: {
            trigger: guarantee,
            start: 'top 85%'
        },
        y: 50,
        opacity: 0,
        duration: 1,
        ease: 'power3.out'
    });
/* 
    if (items.length > 0) {
        gsap.from(items, {
            scrollTrigger: {
                trigger: '.trust__grid',
                start: 'top 85%',
            },
            y: 40,
            opacity: 0,
            duration: 1,
            stagger: 0.1,
            ease: 'power3.out'
        });
    }
    */ };
// ------- Showcase Section Animations ------- //
const $f9e1d550cec58a8b$var$initShowcaseAnimations = ()=>{
    const section = document.querySelector('.section--showcase');
    if (!section) return;
    const title = section.querySelector('.showcase__title');
    const desc = section.querySelector('.showcase__desc');
    if (title) new (0, $c83df951dc505516$export$824eb2eeafc81b63)(title);
    if (desc) new (0, $c83df951dc505516$export$824eb2eeafc81b63)(desc);
};
// ------- Highlight Effect ------- //
const $f9e1d550cec58a8b$var$initHighlightEffect = ()=>{
    const els = document.querySelectorAll('.highlight-text');
    els.forEach((el)=>{
        // PriceHighlight 사용 (Highlight Marker)
        new (0, $a763e0a221ade44d$export$fd3780018b3af188)(el);
    });
};
// ------- Sticky Header Logic ------- //
const $f9e1d550cec58a8b$var$initStickyHeader = ()=>{
    const header = document.querySelector('.header');
    if (!header) return;
    (0, $82ba1e40433c64f0$export$875bcbe48555930).create({
        trigger: document.body,
        start: ()=>"top top-=" + (window.innerHeight - 100),
        toggleClass: {
            targets: header,
            className: "header--scrolled"
        }
    });
};
// ------- Osmo Draw Random Underline Logic ------- //
const $f9e1d550cec58a8b$var$svgVariants = [
    `<svg width="310" height="40" viewBox="0 0 310 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 20.9999C26.7762 16.2245 49.5532 11.5572 71.7979 14.6666C84.9553 16.5057 97.0392 21.8432 109.987 24.3888C116.413 25.6523 123.012 25.5143 129.042 22.6388C135.981 19.3303 142.586 15.1422 150.092 13.3333C156.799 11.7168 161.702 14.6225 167.887 16.8333C181.562 21.7212 194.975 22.6234 209.252 21.3888C224.678 20.0548 239.912 17.991 255.42 18.3055C272.027 18.6422 288.409 18.867 305 17.9999" stroke="currentColor" stroke-width="10" stroke-linecap="round"/></svg>`,
    `<svg width="310" height="40" viewBox="0 0 310 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 24.2592C26.233 20.2879 47.7083 16.9968 69.135 13.8421C98.0469 9.5853 128.407 4.02322 158.059 5.14674C172.583 5.69708 187.686 8.66104 201.598 11.9696C207.232 13.3093 215.437 14.9471 220.137 18.3619C224.401 21.4596 220.737 25.6575 217.184 27.6168C208.309 32.5097 197.199 34.281 186.698 34.8486C183.159 35.0399 147.197 36.2657 155.105 26.5837C158.11 22.9053 162.993 20.6229 167.764 18.7924C178.386 14.7164 190.115 12.1115 201.624 10.3984C218.367 7.90626 235.528 7.06127 252.521 7.49276C258.455 7.64343 264.389 7.92791 270.295 8.41825C280.321 9.25056 296 10.8932 305 13.0242" stroke="currentColor" stroke-width="10" stroke-linecap="round"/></svg>`,
    `<svg width="310" height="40" viewBox="0 0 310 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 29.5014C9.61174 24.4515 12.9521 17.9873 20.9532 17.5292C23.7742 17.3676 27.0987 17.7897 29.6575 19.0014C33.2644 20.7093 35.6481 24.0004 39.4178 25.5014C48.3911 29.0744 55.7503 25.7731 63.3048 21.0292C67.9902 18.0869 73.7668 16.1366 79.3721 17.8903C85.1682 19.7036 88.2173 26.2464 94.4121 27.2514C102.584 28.5771 107.023 25.5064 113.276 20.6125C119.927 15.4067 128.83 12.3333 137.249 15.0014C141.418 16.3225 143.116 18.7528 146.581 21.0014C149.621 22.9736 152.78 23.6197 156.284 24.2514C165.142 25.8479 172.315 17.5185 179.144 13.5014C184.459 10.3746 191.785 8.74853 195.868 14.5292C199.252 19.3205 205.597 22.9057 211.621 22.5014C215.553 22.2374 220.183 17.8356 222.979 15.5569C225.4 13.5845 227.457 11.1105 230.742 10.5292C232.718 10.1794 234.784 12.9691 236.164 14.0014C238.543 15.7801 240.717 18.4775 243.356 19.8903C249.488 23.1729 255.706 21.2551 261.079 18.0014C266.571 14.6754 270.439 11.5202 277.146 13.6125C280.725 14.7289 283.221 17.209 286.393 19.0014C292.321 22.3517 298.255 22.5014 305 22.5014" stroke="currentColor" stroke-width="10" stroke-linecap="round"/></svg>`
];
function $f9e1d550cec58a8b$var$initDrawRandomUnderline() {
    function decorateSVG(svgEl) {
        svgEl.setAttribute('class', 'text-draw__box-svg');
        svgEl.setAttribute('preserveAspectRatio', 'none');
        svgEl.querySelectorAll('path').forEach((path)=>{
            path.setAttribute('stroke', 'currentColor');
        });
    }
    let nextIndex = null;
    document.querySelectorAll('[data-draw-line]').forEach((container)=>{
        const box = container.querySelector('[data-draw-line-box]');
        if (!box) return;
        let enterTween = null;
        let leaveTween = null;
        container.addEventListener('mouseenter', ()=>{
            if (enterTween && enterTween.isActive()) return;
            if (leaveTween && leaveTween.isActive()) leaveTween.kill();
            if (nextIndex === null) nextIndex = Math.floor(Math.random() * $f9e1d550cec58a8b$var$svgVariants.length);
            box.innerHTML = $f9e1d550cec58a8b$var$svgVariants[nextIndex];
            const svg = box.querySelector('svg');
            if (svg) {
                decorateSVG(svg);
                const path = svg.querySelector('path');
                if (path) {
                    const length = path.getTotalLength();
                    (0, $6255c273005a4429$export$99ee26438460406a).set(path, {
                        strokeDasharray: length,
                        strokeDashoffset: length
                    });
                    enterTween = (0, $6255c273005a4429$export$99ee26438460406a).to(path, {
                        duration: 0.5,
                        strokeDashoffset: 0,
                        ease: 'power2.inOut',
                        onComplete: ()=>{
                            enterTween = null;
                        }
                    });
                }
            }
            nextIndex = (nextIndex + 1) % $f9e1d550cec58a8b$var$svgVariants.length;
        });
        container.addEventListener('mouseleave', ()=>{
            const path = box.querySelector('path');
            if (!path) return;
            const playOut = ()=>{
                if (leaveTween && leaveTween.isActive()) return;
                const length = path.getTotalLength();
                leaveTween = (0, $6255c273005a4429$export$99ee26438460406a).to(path, {
                    duration: 0.5,
                    strokeDashoffset: -length,
                    ease: 'power2.inOut',
                    onComplete: ()=>{
                        leaveTween = null;
                        box.innerHTML = '';
                    }
                });
            };
            if (enterTween && enterTween.isActive()) enterTween.eventCallback('onComplete', playOut);
            else playOut();
        });
    });
}
$f9e1d550cec58a8b$var$initDrawRandomUnderline();
// ------- Preparedness Stats Counter ------- //
const $f9e1d550cec58a8b$var$initPreparednessStats = ()=>{
    // Animate title
    (0, $6255c273005a4429$export$99ee26438460406a).from('.preparedness__title', {
        opacity: 0,
        y: 30,
        duration: 1,
        scrollTrigger: {
            trigger: '.preparedness__title',
            start: 'top bottom-=10%'
        }
    });
    // Animate subtitle
    (0, $6255c273005a4429$export$99ee26438460406a).from('.preparedness__subtitle', {
        opacity: 0,
        y: 20,
        duration: 1,
        delay: 0.2,
        scrollTrigger: {
            trigger: '.preparedness__subtitle',
            start: 'top bottom-=10%'
        }
    });
    const statCards = document.querySelectorAll('.prep-stat-content');
    statCards.forEach((card, index)=>{
        const numberEl = card.querySelector('.prep-stat-content__number');
        const unitEl = card.querySelector('.prep-stat-content__unit');
        const target = parseFloat(numberEl.dataset.target);
        const hasDecimal = target % 1 !== 0;
        const counter = {
            value: 0
        };
        (0, $6255c273005a4429$export$99ee26438460406a).to(counter, {
            value: target,
            duration: 2.5,
            ease: 'power2.out',
            delay: index * 0.15,
            scrollTrigger: {
                trigger: card,
                start: 'top bottom-=10%',
                toggleActions: 'play none none none'
            },
            onUpdate: function() {
                if (hasDecimal) numberEl.textContent = counter.value.toFixed(1);
                else numberEl.textContent = Math.round(counter.value);
            },
            onComplete: function() {
                if (unitEl) (0, $6255c273005a4429$export$99ee26438460406a).to(unitEl, {
                    opacity: 1,
                    y: 0,
                    duration: 0.5,
                    ease: 'back.out(1.2)'
                });
            }
        });
        (0, $6255c273005a4429$export$99ee26438460406a).from(card, {
            opacity: 0,
            y: 30,
            duration: 0.8,
            delay: index * 0.1,
            scrollTrigger: {
                trigger: card,
                start: 'top bottom-=5%'
            }
        });
    });
    // Animate bottom text
    (0, $6255c273005a4429$export$99ee26438460406a).from('.preparedness__bottom', {
        opacity: 0,
        y: 20,
        duration: 1,
        scrollTrigger: {
            trigger: '.preparedness__bottom',
            start: 'top bottom-=10%'
        }
    });
};
// ------- Difficulty Section Animations ------- //
const $f9e1d550cec58a8b$var$initDifficultyAnimations = ()=>{
    const section = document.querySelector('.section--difficulty');
    if (!section) return;
    // 1. Header Text
    const title = section.querySelector('.difficulty__title');
    const subtitle = section.querySelector('.difficulty__subtitle');
    if (title) (0, $6255c273005a4429$export$99ee26438460406a).from(title, {
        scrollTrigger: {
            trigger: section,
            start: 'top 70%'
        },
        y: 50,
        opacity: 0,
        duration: 1,
        ease: 'power3.out'
    });
    if (subtitle) (0, $6255c273005a4429$export$99ee26438460406a).from(subtitle, {
        scrollTrigger: {
            trigger: section,
            start: 'top 75%'
        },
        y: 30,
        opacity: 0,
        duration: 1,
        delay: 0.2,
        ease: 'power3.out'
    });
    // 2. Grid Items Stagger
    const items = section.querySelectorAll('.difficulty__item');
    /*
    if (items.length > 0) {
        gsap.from(items, {
            scrollTrigger: {
                trigger: '.difficulty__grid',
                start: 'top 80%',
            },
            y: 50,
            opacity: 0,
            duration: 0.8,
            stagger: 0.15,
            ease: 'power2.out'
        });
    }
    */ // 3. Visual Specific Animations
    // Water Text Filling
    const waterTexts = section.querySelectorAll('.water-text');
    if (waterTexts.length > 0) waterTexts.forEach((text)=>{
        // Set initial state
        text.style.setProperty('--water-p', '0%');
        (0, $6255c273005a4429$export$99ee26438460406a).to(text, {
            scrollTrigger: {
                trigger: '.difficulty__grid',
                start: 'top 70%'
            },
            '--water-p': '55%',
            duration: 2.0,
            ease: 'power2.inOut',
            stagger: 0.2
        });
    });
    // Pie Chart
    const pieFill = section.querySelector('.pie-fill');
    if (pieFill) {
        const percent = 90;
        // Force initial state
        (0, $6255c273005a4429$export$99ee26438460406a).set(pieFill, {
            strokeDashoffset: 100
        });
        (0, $6255c273005a4429$export$99ee26438460406a).to(pieFill, {
            scrollTrigger: {
                trigger: pieFill,
                start: 'top 85%'
            },
            strokeDashoffset: 100 - percent,
            duration: 1.5,
            ease: 'power2.out',
            delay: 0.5
        });
    }
    // Stress Heartbeat Animation
    const stressPath = section.querySelector('.stress-svg path');
    if (stressPath) {
        const length = stressPath.getTotalLength();
        // Set initial state: hidden line
        (0, $6255c273005a4429$export$99ee26438460406a).set(stressPath, {
            strokeDasharray: length,
            strokeDashoffset: length
        });
        (0, $6255c273005a4429$export$99ee26438460406a).to(stressPath, {
            scrollTrigger: {
                trigger: '.difficulty__grid',
                start: 'top 80%'
            },
            strokeDashoffset: 0,
            duration: 2.0,
            ease: "power2.out",
            delay: 0.5
        });
    }
    // Document Badge Pop
    const docBadge = section.querySelector('.doc-badge');
    if (docBadge) (0, $6255c273005a4429$export$99ee26438460406a).from(docBadge, {
        scrollTrigger: {
            trigger: docBadge,
            start: 'top 85%'
        },
        scale: 0,
        opacity: 0,
        duration: 0.5,
        ease: 'back.out(1.7)',
        delay: 0.8
    });
};
// Review Carousel (Based on User Snippet)
const $f9e1d550cec58a8b$var$initReviewCarousel = ()=>{
    const ring = document.querySelector('.review-ring');
    if (!ring) return;
    const reviewData = [
        {
            text: "<b>\uCC98\uC74C \uACAA\uB294 \uC77C\uC744 \uC0C1\uC870\uC0C1\uD488\uC744 \uD1B5\uD574 \uC9C4\uD589\uD558\uB2C8\u2022\u2022\u2022</b> \uC2E0\uACBD \uC368\uC57C \uD560 \uC77C\uB4E4\uC774 \uC904\uC5B4 \uB9C8\uC74C\uC774 \uC870\uAE08 \uD3B8\uC548\uD588\uC2B5\uB2C8\uB2E4. \uB2F4\uB2F9 \uC9C0\uB3C4\uC0AC\uB2D8\uACFC \uC9C1\uC6D0\uBD84\uB4E4\uC774 \uCE5C\uC808\uD558\uAC8C \uC7A5\uB840 \uC9C4\uD589\uC744 \uB3C4\uC640\uC8FC\uC154\uC11C \uAC10\uC0AC\uD55C \uB9C8\uC74C\uC785\uB2C8\uB2E4. \uAC10\uC0AC\uB4DC\uB9BD\uB2C8\uB2E4.",
            date: "25\uB144 12\uC6D4 4\uC77C"
        },
        {
            text: "<b>\uADF8 \uB9C8\uC74C\uACFC \uC190\uAE38\uC774 \uAC10\uC0AC\uD588\uC2B5\uB2C8\uB2E4\u2022\u2022\u2022</b> \uBC24\uB2A6\uAC8C \uC5B4\uBA38\uB2D8\uAED8\uC11C \uB3CC\uC544\uAC00\uC154\uC11C \uB354 \uACBD\uD669\uC774 \uC5C6\uC5C8\uB294\uB370 \uB2A6\uC740 \uC2DC\uAC04\uC5D0\uB3C4 \uCE5C\uC808\uD558\uAC8C \uC751\uB300\uD574 \uC8FC\uC2DC\uACE0 \uC5B4\uBA38\uB2D8 \uC785\uAD00\uB3C4 \uB108\uBB34 \uACF1\uACE0 \uC608\uC058\uAC8C \uC798 \uD574\uC8FC\uC154\uC11C \uADF8 \uB9C8\uC74C\uACFC \uC190\uAE38\uC774 \uC815\uB9D0 \uAC10\uC0AC\uD588\uC2B5\uB2C8\uB2E4.",
            date: "25\uB144 10\uC6D4 27\uC77C"
        },
        {
            text: "<b>\uC21C\uC870\uB85C\uC6B4 \uC9C4\uD589\uC5D0\u2022\u2022\xb7</b> \uC7A5\uB840\uC9C0\uB3C4\uC0AC\uB2D8\uAED8\uC11C \uC124\uBA85\uC744 \uC798\uD574\uC8FC\uC2DC\uACE0 \uC798 \uB9AC\uB4DC\uD574 \uC8FC\uC154\uC11C \uC7A5\uB840 \uCE58\uB974\uB294\uB370 \uB9CE\uC740 \uB3C4\uC6C0\uC744 \uBC1B\uACE0 \uC21C\uC870\uB85C\uC6B4 \uC9C4\uD589\uC5D0 \uB9E4\uC6B0 \uAC10\uC0AC\uB97C \uB4DC\uB9BD\uB2C8\uB2E4.",
            date: "25\uB144 11\uC6D4 17\uC77C"
        },
        {
            text: "<b>\uC8FC\uBCC0\uC5D0\uC11C\uB3C4 \uC5C5\uCCB4 \uBB3C\uC5B4\uBCF4\uBA70\u2026</b> \uB0A9\uC785 \uC644\uB8CC\uAC00 \uB2E4 \uB418\uC5B4\uC11C \uACE0\uBBFC\uD558\uB358 \uC2DC\uAE30\uC5D0 \uC7A5\uB840\uB97C \uCE58\uB974\uAC8C \uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uC784\uC885\uC744 \uB9DE\uC774\uD558\uACE0 \uC0DD\uAC01\uB098\uB358 \uAC74 \uC0C1\uC870\uC0C1\uD488. \uC804\uD654 \uD55C \uD1B5\uC5D0 \uC7A5\uB840\uC2DD\uC7A5\uC5D0 \uBBF8\uB9AC \uC640 \uACC4\uC2DC\uACE0...",
            date: "25\uB144 12\uC6D4 4\uC77C"
        },
        {
            text: "<b>\uC138\uC2EC\uD55C \uBC30\uB824\uC5D0 \uAC10\uB3D9\uBC1B\uC558\uC2B5\uB2C8\uB2E4\u2022\u2022\u2022</b> \uC7A5\uB840 \uC900\uBE44\uBD80\uD130 \uB9C8\uBB34\uB9AC\uAE4C\uC9C0 \uD558\uB098\uD558\uB098 \uC138\uC2EC\uD558\uAC8C \uCC59\uACA8\uC8FC\uC154\uC11C \uC720\uC871\uC73C\uB85C\uC11C \uD070 \uC704\uC548\uC774 \uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uC5B4\uB824\uC6B4 \uC2DC\uAE30\uC5D0 \uB4E0\uB4E0\uD55C \uC9C0\uC6D0\uC774 \uB418\uC5B4\uC8FC\uC154\uC11C \uAC10\uC0AC\uD569\uB2C8\uB2E4.",
            date: "25\uB144 9\uC6D4 15\uC77C"
        },
        {
            text: "<b>\uC804\uBB38\uC801\uC778 \uC11C\uBE44\uC2A4\uC5D0 \uB9CC\uC871\uD569\uB2C8\uB2E4\u2022\u2022\u2022</b> \uC7A5\uB840 \uC808\uCC28\uC5D0 \uB300\uD574 \uC798 \uBAB0\uB790\uB294\uB370, \uCC98\uC74C\uBD80\uD130 \uB05D\uAE4C\uC9C0 \uCE5C\uC808\uD558\uAC8C \uC548\uB0B4\uD574 \uC8FC\uC2DC\uACE0 \uBAA8\uB4E0 \uAC83\uC744 \uC644\uBCBD\uD558\uAC8C \uCC98\uB9AC\uD574 \uC8FC\uC154\uC11C \uC815\uB9D0 \uB9CC\uC871\uC2A4\uB7EC\uC6E0\uC2B5\uB2C8\uB2E4.",
            date: "25\uB144 8\uC6D4 22\uC77C"
        },
        {
            text: "<b>\uBBFF\uACE0 \uB9E1\uAE38 \uC218 \uC788\uC5C8\uC2B5\uB2C8\uB2E4\u2022\u2022\u2022</b> \uC0C1\uC870 \uC11C\uBE44\uC2A4\uB97C \uC774\uC6A9\uD558\uAE38 \uC798\uD588\uB2E4\uB294 \uC0DD\uAC01\uC774 \uB4ED\uB2C8\uB2E4. \uBAA8\uB4E0 \uACFC\uC815\uC774 \uCCB4\uACC4\uC801\uC774\uACE0 \uAE54\uB054\uD558\uAC8C \uC9C4\uD589\uB418\uC5B4 \uACE0\uC778\uC744 \uD3B8\uC548\uD788 \uBCF4\uB0BC \uC218 \uC788\uC5C8\uC2B5\uB2C8\uB2E4.",
            date: "25\uB144 11\uC6D4 3\uC77C"
        },
        {
            text: "<b>\uAC00\uC871\uCC98\uB7FC \uB300\uD574\uC8FC\uC154\uC11C\u2022\u2022\u2022</b> \uC2AC\uD514\uC5D0 \uC7A0\uAE34 \uC800\uD76C \uAC00\uC871\uC744 \uC9C4\uC2EC\uC73C\uB85C \uC704\uB85C\uD574 \uC8FC\uC2DC\uACE0, \uB9C8\uCE58 \uAC00\uC871\uCC98\uB7FC \uB530\uB73B\uD558\uAC8C \uB300\uD574\uC8FC\uC154\uC11C \uD070 \uD798\uC774 \uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uC9C4\uC2EC\uC73C\uB85C \uAC10\uC0AC\uB4DC\uB9BD\uB2C8\uB2E4.",
            date: "25\uB144 10\uC6D4 8\uC77C"
        },
        {
            text: "<b>\uBE60\uB978 \uB300\uC751\uC774 \uC778\uC0C1\uC801\uC774\uC5C8\uC2B5\uB2C8\uB2E4\u2022\u2022\u2022</b> \uAE09\uD558\uAC8C \uC5F0\uB77D\uB4DC\uB838\uB294\uB370\uB3C4 \uC2E0\uC18D\uD558\uAC8C \uCD9C\uB3D9\uD574 \uC8FC\uC2DC\uACE0, \uBAA8\uB4E0 \uC900\uBE44\uB97C \uC644\uBCBD\uD558\uAC8C \uD574\uC8FC\uC154\uC11C \uC815\uB9D0 \uAC10\uC0AC\uD588\uC2B5\uB2C8\uB2E4. \uD504\uB85C\uD398\uC154\uB110\uD55C \uBAA8\uC2B5\uC774 \uC778\uC0C1\uC801\uC774\uC5C8\uC2B5\uB2C8\uB2E4.",
            date: "25\uB144 12\uC6D4 11\uC77C"
        },
        {
            text: "<b>\uD569\uB9AC\uC801\uC778 \uBE44\uC6A9\uC5D0 \uB9CC\uC871\uD569\uB2C8\uB2E4\u2022\u2022\u2022</b> \uD488\uC9C8 \uB192\uC740 \uC11C\uBE44\uC2A4\uB97C \uD569\uB9AC\uC801\uC778 \uBE44\uC6A9\uC73C\uB85C \uBC1B\uC744 \uC218 \uC788\uC5B4\uC11C \uC88B\uC558\uC2B5\uB2C8\uB2E4. \uCD94\uAC00 \uBE44\uC6A9 \uC5C6\uC774 \uC57D\uC18D\uB41C \uC11C\uBE44\uC2A4\uB97C \uBAA8\uB450 \uC81C\uACF5\uBC1B\uC558\uC2B5\uB2C8\uB2E4.",
            date: "25\uB144 9\uC6D4 28\uC77C"
        },
        {
            text: "<b>\uC815\uC131\uC2A4\uB7EC\uC6B4 \uC11C\uBE44\uC2A4\uC5D0 \uAC10\uB3D9\u2022\u2022\u2022</b> \uACE0\uC778\uC744 \uC815\uC131\uC2A4\uB7FD\uAC8C \uBAA8\uC154\uC8FC\uC2DC\uACE0, \uC720\uC871\uB4E4\uC758 \uB9C8\uC74C\uAE4C\uC9C0 \uC138\uC2EC\uD558\uAC8C \uBC30\uB824\uD574 \uC8FC\uC154\uC11C \uC815\uB9D0 \uAC10\uB3D9\uBC1B\uC558\uC2B5\uB2C8\uB2E4. \uCD5C\uACE0\uC758 \uC120\uD0DD\uC774\uC5C8\uC2B5\uB2C8\uB2E4.",
            date: "25\uB144 11\uC6D4 25\uC77C"
        },
        {
            text: "<b>\uC548\uC2EC\uD558\uACE0 \uB9E1\uAE38 \uC218 \uC788\uC5C8\uC2B5\uB2C8\uB2E4\u2022\u2022\u2022</b> \uCC98\uC74C\uBD80\uD130 \uB05D\uAE4C\uC9C0 \uD22C\uBA85\uD558\uAC8C \uC9C4\uD589\uB418\uC5B4 \uC548\uC2EC\uD558\uACE0 \uB9E1\uAE38 \uC218 \uC788\uC5C8\uC2B5\uB2C8\uB2E4. \uC7A5\uB840\uC9C0\uB3C4\uC0AC\uB2D8\uC758 \uC804\uBB38\uC131\uACFC \uCE5C\uC808\uD568\uC5D0 \uAE4A\uC740 \uAC10\uC0AC\uB97C \uB4DC\uB9BD\uB2C8\uB2E4.",
            date: "25\uB144 10\uC6D4 19\uC77C"
        }
    ];
    // Use all 12 unique reviews
    const reviews = reviewData;
    reviews.forEach((item, i)=>{
        const card = document.createElement('div');
        card.classList.add('review-card');
        card.innerHTML = `
            <div class="review-card__icon"></div>
            <p class="review-card__text">"${item.text}"<br><small>${item.date}</small></p>
            <div class="review-card__logo"></div>
        `;
        ring.appendChild(card);
    });
    const cards = ring.querySelectorAll('.review-card');
    let xPos = 0;
    const updateCarousel = ()=>{
        const n = reviews.length;
        const cardWidth = ring.offsetWidth;
        // Calculate radius to make cards touch: Radius = (width/2) / tan(PI/n)
        // Adding a smaller multiplier (1.125) to reduce the gap by half of the previous setting
        const radius = Math.round(cardWidth / 2 / Math.tan(Math.PI / n) * 1.125);
        (0, $6255c273005a4429$export$99ee26438460406a).set(cards, {
            rotateY: (i)=>i * -(360 / n),
            transformOrigin: `50% 50% ${radius}px`,
            z: -radius,
            backfaceVisibility: 'hidden'
        });
        // Set initial rotation
        (0, $6255c273005a4429$export$99ee26438460406a).set(ring, {
            rotationY: 180,
            cursor: 'grab'
        });
    };
    updateCarousel();
    window.addEventListener('resize', updateCarousel);
    (0, $6255c273005a4429$export$99ee26438460406a).timeline().from(cards, {
        duration: 1.5,
        y: 200,
        opacity: 0,
        stagger: 0.1,
        ease: 'expo.out'
    });
    // Hover effects
    cards.forEach((card)=>{
        card.addEventListener('mouseenter', ()=>{
            (0, $6255c273005a4429$export$99ee26438460406a).to(cards, {
                opacity: (i, t)=>t === card ? 1 : 0.5,
                ease: 'power3.out'
            });
        });
        card.addEventListener('mouseleave', ()=>{
            (0, $6255c273005a4429$export$99ee26438460406a).to(cards, {
                opacity: 1,
                ease: 'power2.inOut'
            });
        });
    });
    // Auto-rotation logic (Flipped direction as requested)
    let autoRotate = (0, $6255c273005a4429$export$99ee26438460406a).to(ring, {
        rotationY: "-=360",
        duration: 100,
        repeat: -1,
        ease: "none",
        paused: false
    });
    // Interaction logic
    let isUserInteracted = false;
    const dragStart = (e)=>{
        isUserInteracted = true;
        autoRotate.kill(); // Permanently stop auto-rotation on interaction
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        xPos = Math.round(clientX);
        (0, $6255c273005a4429$export$99ee26438460406a).set(ring, {
            cursor: 'grabbing'
        });
        window.addEventListener('mousemove', drag);
        window.addEventListener('touchmove', drag);
    };
    const drag = (e)=>{
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        const delta = Math.round(clientX) - xPos;
        (0, $6255c273005a4429$export$99ee26438460406a).set(ring, {
            rotationY: `-=${delta * 0.5}`
        });
        xPos = Math.round(clientX);
    };
    const dragEnd = ()=>{
        window.removeEventListener('mousemove', drag);
        window.removeEventListener('touchmove', drag);
        (0, $6255c273005a4429$export$99ee26438460406a).set(ring, {
            cursor: 'grab'
        });
    // No longer resuming auto-rotation here
    };
    ring.addEventListener('mousedown', dragStart);
    ring.addEventListener('touchstart', dragStart, {
        passive: true
    });
    window.addEventListener('mouseup', dragEnd);
    window.addEventListener('touchend', dragEnd);
    // Nav Buttons Logic
    const nextBtn = document.querySelector('#reviews .review-btn--next');
    const prevBtn = document.querySelector('#reviews .review-btn--prev');
    if (nextBtn && prevBtn) {
        const step = 360 / reviews.length;
        nextBtn.addEventListener('click', ()=>{
            isUserInteracted = true;
            autoRotate.kill(); // Kill auto-rotation on button click
            (0, $6255c273005a4429$export$99ee26438460406a).to(ring, {
                rotationY: `-=${step}`,
                duration: 0.8,
                ease: "power2.out"
            });
        });
        prevBtn.addEventListener('click', ()=>{
            isUserInteracted = true;
            autoRotate.kill(); // Kill auto-rotation on button click
            (0, $6255c273005a4429$export$99ee26438460406a).to(ring, {
                rotationY: `+=${step}`,
                duration: 0.8,
                ease: "power2.out"
            });
        });
    }
};
// Specialty Section Entry Animations
const $f9e1d550cec58a8b$var$initSpecialtyAnimations = ()=>{
    // Award Icon
    (0, $6255c273005a4429$export$99ee26438460406a).from('.specialty__award-icon', {
        scrollTrigger: {
            trigger: '.specialty__award-icon',
            start: 'top 85%'
        },
        opacity: 0,
        y: 40,
        scale: 0.8,
        duration: 1.2,
        ease: 'power4.out'
    });
    // Main Title
    (0, $6255c273005a4429$export$99ee26438460406a).from('.specialty__main-title', {
        scrollTrigger: {
            trigger: '.specialty__main-title',
            start: 'top 85%'
        },
        opacity: 0,
        y: 50,
        duration: 1.2,
        ease: 'power3.out',
        delay: 0.2
    });
    // Specialty Cards - Staggered
    (0, $6255c273005a4429$export$99ee26438460406a).from('.specialty-card', {
        scrollTrigger: {
            trigger: '.specialty__grid',
            start: 'top 80%'
        },
        opacity: 0,
        y: 60,
        duration: 1,
        stagger: 0.2,
        ease: 'power2.out'
    });
    // Specialty Rows
    (0, $6255c273005a4429$export$99ee26438460406a).utils.toArray('.specialty-row').forEach((row, i)=>{
        (0, $6255c273005a4429$export$99ee26438460406a).from(row, {
            scrollTrigger: {
                trigger: row,
                start: 'top 90%'
            },
            opacity: 0,
            y: 30,
            duration: 1,
            ease: 'power2.out'
        });
    });
};
// Network Section Scroll Animations
const $f9e1d550cec58a8b$var$initNetworkAnimations = ()=>{
    const section = document.querySelector('.section--network');
    if (!section) return;
    // Header Animation
    (0, $6255c273005a4429$export$99ee26438460406a).from('.network__header', {
        scrollTrigger: {
            trigger: '.network__header',
            start: 'top 85%'
        },
        opacity: 0,
        y: 40,
        duration: 1.2,
        ease: 'power3.out'
    });
    // Table & Map Content Animation
    (0, $6255c273005a4429$export$99ee26438460406a).from([
        '.network__table-wrapper',
        '.network__map-container'
    ], {
        scrollTrigger: {
            trigger: '.network__content',
            start: 'top 80%'
        },
        opacity: 0,
        y: 60,
        duration: 1.2,
        stagger: 0.3,
        ease: 'power3.out'
    });
};
// Redundant block removed.
// Number Count Animation
const $f9e1d550cec58a8b$var$initCountAnimation = ()=>{
    const countElements = document.querySelectorAll('.js-count-up');
    const observer = new IntersectionObserver((entries, observer)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                const element = entry.target;
                const target = parseInt(element.getAttribute('data-target'));
                const duration = 2000; // 2초 동안 진행
                const frameDuration = 1000 / 60;
                const totalFrames = Math.round(duration / frameDuration);
                const easeOutQuad = (t)=>t * (2 - t);
                let frame = 0;
                const counter = setInterval(()=>{
                    frame++;
                    const progress = easeOutQuad(frame / totalFrames);
                    const currentCount = Math.round(target * progress);
                    if (parseInt(element.innerText.replace(/,/g, '')) !== currentCount) element.innerText = currentCount.toLocaleString();
                    if (frame === totalFrames) {
                        clearInterval(counter);
                        element.innerText = target.toLocaleString();
                    }
                }, frameDuration);
                observer.unobserve(element);
            }
        });
    }, {
        threshold: 0.5
    });
    countElements.forEach((el)=>observer.observe(el));
};
// Feature Icon Animations (Animated Transforms)
const $f9e1d550cec58a8b$var$initFeatureIconAnimations = ()=>{
    // Select product cards, quality icon items, and app system visual only (removed report)
    const cards = document.querySelectorAll('.product__feature-card, .q-icon-item, .system-item__visual--app');
    if (!cards.length) return;
    // 모든 카드에 공통적으로 좌우 흔들림(Wobble) 애니메이션 적용
    cards.forEach((card, i)=>{
        const icon = card.querySelector('.feature-icon');
        if (!icon) return;
        // 약간의 시차(delay)를 주어 자연스럽게 연출
        (0, $6255c273005a4429$export$99ee26438460406a).to(icon, {
            '--icon-rot': '5deg',
            duration: 2 + i * 0.1,
            yoyo: true,
            repeat: -1,
            ease: 'power1.inOut',
            delay: i * 0.2 // 순차적 시작
        });
        // 추가: 둥실둥실 부유 효과도 살짝 섞어서 더 입체적으로
        (0, $6255c273005a4429$export$99ee26438460406a).to(icon, {
            '--icon-y': '-10px',
            duration: 3 + i * 0.2,
            yoyo: true,
            repeat: -1,
            ease: 'sine.inOut',
            delay: i * 0.3
        });
    });
};
// Timeline Animation
// Timeline Animation (Click Interactive)
// Timeline Animation
const $f9e1d550cec58a8b$var$initTimelineAnimation = ()=>{
    const timeline = document.querySelector('.product__timeline-wrap');
    if (!timeline) return;
    const steps = document.querySelectorAll('.timeline-step');
    const progressBar = document.querySelector('.timeline-progress');
    const totalSteps = steps.length;
    const bar = document.querySelector('.timeline-bar');
    let mm = (0, $6255c273005a4429$export$99ee26438460406a).matchMedia();
    mm.add("(max-width: 768px)", ()=>{
        // --- Mobile Logic (ScrollTrigger) ---
        // Initial State for Mobile
        (0, $6255c273005a4429$export$99ee26438460406a).set(progressBar, {
            width: '100%',
            height: '0%'
        });
        // Remove active class from all first
        steps.forEach((s)=>{
            s.classList.remove('active');
            (0, $6255c273005a4429$export$99ee26438460406a).set(s.querySelector('.step-content'), {
                opacity: 0.5,
                y: 0
            });
        });
        const st = (0, $82ba1e40433c64f0$export$875bcbe48555930).create({
            trigger: timeline,
            start: "top 70%",
            end: "bottom 70%",
            scrub: 1,
            onUpdate: (self)=>{
                const progress = self.progress * 100;
                // 세로 바 채우기
                (0, $6255c273005a4429$export$99ee26438460406a).to(progressBar, {
                    height: `${progress}%`,
                    duration: 0.1,
                    overwrite: true,
                    ease: "none"
                });
                // 단계별 활성화
                steps.forEach((step, index)=>{
                    // 각 단계가 켜질 임계값 계산 (0, 0.33, 0.66, 1.0)
                    // 조금 더 일찍 켜지도록 -0.1 보정
                    const threshold = index / (totalSteps - 1) - 0.1;
                    if (self.progress >= threshold) {
                        if (!step.classList.contains('active')) {
                            step.classList.add('active');
                            (0, $6255c273005a4429$export$99ee26438460406a).to(step.querySelector('.step-content'), {
                                opacity: 1,
                                y: 0,
                                duration: 0.4,
                                overwrite: true
                            });
                            // 점 효과 강조
                            (0, $6255c273005a4429$export$99ee26438460406a).to(step.querySelector('.step-dot'), {
                                scale: 1.2,
                                borderColor: '#C5A065',
                                boxShadow: '0 0 15px rgba(197, 160, 101, 0.6)',
                                duration: 0.3
                            });
                        }
                    } else if (step.classList.contains('active')) {
                        step.classList.remove('active');
                        (0, $6255c273005a4429$export$99ee26438460406a).to(step.querySelector('.step-content'), {
                            opacity: 0.5,
                            y: 0,
                            duration: 0.4,
                            overwrite: true
                        });
                        // 점 효과 복구
                        (0, $6255c273005a4429$export$99ee26438460406a).to(step.querySelector('.step-dot'), {
                            scale: 1,
                            borderColor: '#C5A065',
                            boxShadow: '0 0 15px rgba(0, 0, 0, 0.5)',
                            duration: 0.3
                        });
                    }
                });
            }
        });
        return ()=>{
            // cleanup if needed when switching to desktop
            if (st) st.kill();
        };
    });
    mm.add("(min-width: 769px)", ()=>{
        // --- Desktop Logic (Click/Hover) ---
        // Initial State for Desktop
        (0, $6255c273005a4429$export$99ee26438460406a).set(progressBar, {
            height: '100%',
            width: '0%'
        });
        const updateDesktopProgress = (targetIndex)=>{
            const targetStep = steps[targetIndex];
            const dot = targetStep.querySelector('.step-dot');
            if (dot && bar) {
                const dotCenter = targetStep.offsetLeft + dot.offsetLeft + dot.offsetWidth / 2;
                const barStart = bar.offsetLeft;
                const barWidth = bar.offsetWidth;
                let progressWidth = dotCenter - barStart;
                let progressPercent = progressWidth / barWidth * 100;
                if (targetIndex === steps.length - 1) progressPercent = 100;
                progressPercent = Math.max(0, Math.min(100, progressPercent));
                (0, $6255c273005a4429$export$99ee26438460406a).to(progressBar, {
                    width: `${progressPercent}%`,
                    duration: 0.6,
                    ease: 'power2.out'
                });
            }
            steps.forEach((step, i)=>{
                const content = step.querySelector('.step-content');
                if (i <= targetIndex) {
                    step.classList.add('active');
                    (0, $6255c273005a4429$export$99ee26438460406a).to(content, {
                        opacity: 1,
                        y: 0,
                        duration: 0.4,
                        delay: i * 0.1,
                        overwrite: true
                    });
                } else {
                    step.classList.remove('active');
                    (0, $6255c273005a4429$export$99ee26438460406a).to(content, {
                        opacity: 0.4,
                        y: 0,
                        duration: 0.4,
                        overwrite: true
                    });
                }
            });
        };
        // Event Listeners
        steps.forEach((step, index)=>{
            step.addEventListener('mouseenter', ()=>updateDesktopProgress(index));
            step.addEventListener('click', ()=>updateDesktopProgress(index));
        });
        // Initialize
        updateDesktopProgress(0);
        return ()=>{
        // cleanup listeners is hard with anonymous functions, 
        // but matchMedia handles basic state cleanup usually.
        // GSAP cleans up animations on context revert.
        // We might want to remove listeners if we want strict cleanup but for this simple case it's okay.
        };
    });
};
const $f9e1d550cec58a8b$var$warrantyData = {
    happy450: {
        title: "\uB354\uD574\uD53C 450 \uC0C1\uD488 \uC0C1\uC138 \uAD6C\uC131",
        content: `
            <table class="product-detail-table-premium">
                <thead>
                    <tr>
                        <th colspan="3">\u{AD6C}\u{BD84}</th>
                        <th style="width: 45%;">\u{C758}\u{C804} \u{AD6C}\u{C131} (\u{C0C1}\u{C138})</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- 1. \u{ACE0}\u{C778}\u{C6A9}\u{D488} \u{BC0F} \u{C218}\u{C2DC}\u{C6A9}\u{D488} -->
                    <tr>
                        <td rowspan="6" class="main-cat">\u{ACE0}\u{C778}\u{C6A9}\u{D488}<br>\u{BC0F}<br>\u{C218}\u{C2DC}\u{C6A9}\u{D488}</td>
                        <td rowspan="2" class="sub-cat">\u{AD00}</td>
                        <td class="third-cat">\u{B9E4}\u{C7A5} \u{C2DC}</td>
                        <td>\u{C624}\u{B3D9}\u{B098}\u{BB34} 45mm</td>
                    </tr>
                    <tr>
                        <td class="third-cat">\u{D654}\u{C7A5} \u{B610}\u{B294} \u{D0C8}\u{AD00} \u{C2DC}</td>
                        <td>\u{C624}\u{B3D9}\u{B098}\u{BB34} 18mm, \u{D6A1}\u{B300} or \u{C720}\u{ACE8}\u{D568} \u{4E2D} \u{D0DD}1</td>
                    </tr>
                    <tr>
                        <td rowspan="2" class="sub-cat">\u{C218}\u{C758}</td>
                        <td class="third-cat">\u{C218}\u{C758}</td>
                        <td>\u{B300}\u{B9C8} (\u{B300}\u{B9C8}100%)</td>
                    </tr>
                    <tr>
                        <td class="third-cat">\u{C218}\u{C758} \u{C900}\u{BE44} \u{ACE0}\u{AC1D}</td>
                        <td>\u{AF43}\u{AD00}\u{BCF4} \u{B610}\u{B294} \u{C7A5}\u{B840}\u{C758}\u{C804} \u{B3C4}\u{C6B0}\u{BBF8} 1\u{BA85}</td>
                    </tr>
                    <tr>
                        <td rowspan="2" class="sub-cat">\u{C785}\u{AD00} \u{BC0F}<br>\u{C218}\u{C2DC}\u{C6A9}\u{D488}</td>
                        <td class="third-cat">\u{B3C4}\u{D3EC}, \u{C6D0}\u{C0BC}, \u{CC9C}\u{AE08}, \u{C9C0}\u{AE08}</td>
                        <td>\u{C218}\u{C758} \u{C81C}\u{D488}\u{ACFC} \u{B3D9}\u{C77C}\u{C81C}\u{D488} \u{C81C}\u{ACF5}</td>
                    </tr>
                    <tr>
                        <td class="third-cat">\u{BA85}\u{C815}, \u{AD00}\u{BCF4}, \u{C2B5}\u{C2E0}, \u{D55C}\u{C9C0} \u{B4F1}</td>
                        <td>\u{ADDC}\u{ACA9}\u{D488} \u{C81C}\u{ACF5}</td>
                    </tr>

                    <!-- 2. \u{BE48}\u{C18C} \u{BC0F} \u{AE30}\u{D0C0}\u{C6A9}\u{D488} -->
                    <tr>
                        <td rowspan="3" class="main-cat">\u{BE48}\u{C18C} \u{BC0F}<br>\u{AE30}\u{D0C0}\u{C6A9}\u{D488}</td>
                        <td class="sub-cat">\u{BE48}\u{C18C}\u{C6A9}\u{D488}</td>
                        <td class="third-cat">\u{D5A5}, \u{CD08}, \u{BD80}\u{C758}\u{B85D}, \u{CD95}\u{BB38}, \u{C704}\u{D328}</td>
                        <td>\u{D544}\u{C694}\u{B7C9} \u{C77C}\u{CCB4} \u{C81C}\u{ACF5}</td>
                    </tr>
                    <tr>
                        <td class="sub-cat">\u{B300}\u{C5EC}\u{C6A9}\u{D488}</td>
                        <td class="third-cat">\u{D5A5}\u{B85C}, \u{CD1B}\u{B300}, \u{C794}\u{B300}</td>
                        <td>\u{B300}\u{C5EC}\u{D488}</td>
                    </tr>
                    <tr>
                        <td class="sub-cat">\u{AE30}\u{D0C0}\u{C6A9}\u{D488}</td>
                        <td class="third-cat">\u{C644}\u{C7A5}, \u{C0C1}\u{C7A5}, \u{C6B4}\u{AD6C}\u{C6A9}\u{C7A5}\u{AC11}</td>
                        <td>\u{D544}\u{C694}\u{B7C9} \u{C77C}\u{CCB4} \u{C81C}\u{ACF5}</td>
                    </tr>

                    <!-- 3. \u{C758}\u{C804}\u{C6A9}\u{D488} -->
                    <tr>
                        <td rowspan="3" class="main-cat">\u{C758}\u{C804}\u{C6A9}\u{D488}</td>
                        <td class="sub-cat">\u{D604}\u{B300}\u{C2DD}</td>
                        <td class="third-cat">\u{B0A8}\u{C131} / \u{C5EC}\u{C131}</td>
                        <td>5\u{BC8C} \u{C81C}\u{ACF5}</td>
                    </tr>
                    <tr>
                        <td rowspan="2" class="sub-cat">\u{C804}\u{D1B5}\u{C2DD}</td>
                        <td class="third-cat">\u{BC14}\u{C9C0}\u{C800}\u{ACE0}\u{B9AC}, \u{C0BC}\u{BCA0}\u{CE58}\u{B9C8} \u{B4F1}</td>
                        <td>\u{D544}\u{C694}\u{B7C9} \u{C77C}\u{CCB4} \u{C81C}\u{ACF5}</td>
                    </tr>
                    <tr>
                        <td class="third-cat">\u{B450}\u{B8E8}\u{B9C8}\u{AE30}, \u{CE58}\u{B9C8}\u{C800}\u{ACE0}\u{B9AC} \u{B4F1}</td>
                        <td>\u{D544}\u{C694}\u{B7C9} \u{C77C}\u{CCB4} \u{C81C}\u{ACF5}</td>
                    </tr>

                    <!-- 4. \u{C81C}\u{B2E8}\u{C7A5}\u{C2DD} -->
                    <tr>
                        <td rowspan="3" class="main-cat">\u{C81C}\u{B2E8}\u{C7A5}\u{C2DD}<br>(\u{AF43}\u{C7A5}\u{C2DD})</td>
                        <td colspan="2" class="sub-cat">\u{C0DD}\u{D654}\u{AF43} \u{C81C}\u{B2E8}\u{C7A5}\u{C2DD}</td>
                        <td>\u{C81C}\u{B2E8} \u{AF43}\u{C7A5}\u{C2DD} 35\u{B9CC}\u{C6D0} \u{C0C1}\u{B2F9}</td>
                    </tr>
                    <tr>
                        <td colspan="2" class="sub-cat">\u{D5CC}\u{D654}\u{C6A9} \u{AD6D}\u{D654}</td>
                        <td>30\u{C1A1}\u{C774} \u{C81C}\u{ACF5}</td>
                    </tr>
                    <tr>
                        <td colspan="2" class="sub-cat">\u{AF43}\u{BC14}\u{AD6C}\u{B2C8}</td>
                        <td>\u{AF43}\u{BC14}\u{AD6C}\u{B2C8} 2\u{AC1C}</td>
                    </tr>

                    <!-- 5. \u{CC28}\u{B7C9}\u{C9C0}\u{C6D0} -->
                    <tr>
                        <td rowspan="3" class="main-cat">\u{CC28}\u{B7C9}\u{C9C0}\u{C6D0}</td>
                        <td colspan="2" class="sub-cat">\u{C6B4}\u{AD6C} \u{C774}\u{C1A1}\u{CC28}\u{B7C9}</td>
                        <td>\u{AD00}\u{B0B4} (\u{C2DC}, \u{AD70}\u{B0B4}) \u{C81C}\u{ACF5}</td>
                    </tr>
                    <tr>
                        <td colspan="2" class="sub-cat">\u{ACE0}\u{C778} \u{B9AC}\u{BB34}\u{C9C4}</td>
                        <td>\u{C655}\u{BCF5} 300km (\u{CD08}\u{ACFC}\u{C2DC} 2,000\u{C6D0}/ km)</td>
                    </tr>
                    <tr>
                        <td colspan="2" class="sub-cat">\u{C720}\u{C871} \u{BC84}\u{C2A4}</td>
                        <td>\u{C655}\u{BCF5} 300km (\u{CD08}\u{ACFC}\u{C2DC} 2,000\u{C6D0}/ km)</td>
                    </tr>

                    <!-- 6. \u{C778}\u{B825}\u{C9C0}\u{C6D0} -->
                    <tr>
                        <td rowspan="2" class="main-cat">\u{C778}\u{B825}\u{C9C0}\u{C6D0}</td>
                        <td colspan="2" class="sub-cat">\u{C7A5}\u{B840}\u{C9C0}\u{B3C4}\u{C0AC}</td>
                        <td>1\u{BA85} (\u{C785}\u{AD00}\u{C9C0}\u{C6D0} 1\u{BA85})</td>
                    </tr>
                    <tr>
                        <td colspan="2" class="sub-cat">\u{C7A5}\u{B840}\u{C758}\u{C804} \u{B3C4}\u{C6B0}\u{BBF8}<br>(1\u{C77C}/10\u{C2DC}\u{AC04})</td>
                        <td>5\u{BA85} (1\u{C778} 10\u{C2DC}\u{AC04})</td>
                    </tr>

                    <!-- 7. \u{D3B8}\u{C758}\u{C11C}\u{BE44}\u{C2A4} -->
                    <tr>
                        <td rowspan="2" class="main-cat">\u{D3B8}\u{C758}\u{C11C}\u{BE44}\u{C2A4}</td>
                        <td colspan="2" class="sub-cat">\u{C77C}\u{D68C}\u{C6A9}\u{C2DD}\u{AE30}\u{C138}\u{D2B8}</td>
                        <td>300 \u{C778}\u{BD84}</td>
                    </tr>
                    <tr>
                        <td colspan="2" class="sub-cat">\u{D3B8}\u{C758}\u{C6A9}\u{D488} (6\u{C778})</td>
                        <td>1\u{C138}\u{D2B8} (6\u{C778})</td>
                    </tr>
                </tbody>
            </table>
        `
    },
    specialty_1: {
        title: "\uCC98\uC74C\uBD80\uD130 \uB05D\uAE4C\uC9C0",
        content: `
            <p class="modal-main-text">\u{C7A5}\u{B840}\u{C9C0}\u{B3C4}\u{C0AC}\u{B294} 1\u{AC74}\u{C758} \u{C7A5}\u{B840}\u{AC00} \u{B05D}\u{B0A0} \u{B54C}\u{AE4C}\u{C9C0} \u{CC45}\u{C784}\u{C9C0}\u{ACE0} \u{D568}\u{AED8}\u{D569}\u{B2C8}\u{B2E4}.</p>
            <p class="modal-sub-text">24\u{C2DC}\u{AC04} \u{AE34}\u{AE09}\u{C758}\u{C804}\u{C13C}\u{D130}(1588-2227)\u{B97C} \u{C6B4}\u{C601}\u{D558}\u{BA70} \u{C811}\u{C218} \u{C2DC} \u{C804}\u{BB38} \u{C7A5}\u{B840}\u{C9C0}\u{B3C4}\u{C0AC}\u{AC00} 2\u{C2DC}\u{AC04} \u{C774}\u{B0B4} \u{D604}\u{C7A5}\u{C5D0} \u{B3C4}\u{CC29}\u{D558}\u{C5EC} \u{B3C4}\u{C640}\u{B4DC}\u{B9BD}\u{B2C8}\u{B2E4}.</p>
            <p class="modal-footnote">*\u{B3C4}\u{C11C} \u{BC0F} \u{C0B0}\u{AC04}\u{C9C0}\u{C5ED} \u{C81C}\u{C678}. \u{C0C1}\u{D669}\u{C5D0} \u{B530}\u{B77C} \u{CD9C}\u{B3D9}\u{C2DC}\u{AC04}\u{C740} \u{BCC0}\u{B3D9}\u{B420} \u{C218} \u{C788}\u{C74C}</p>
        `
    },
    specialty_2: {
        title: "\uC804\uBB38\uAC00\uC640 \uAC19\uC774",
        content: `
            <p class="modal-main-text">\u{ACE0}\u{AC1D} \u{B9CC}\u{C871}\u{B3C4} 99%*\u{C758} \u{C804}\u{BB38} \u{C7A5}\u{B840}\u{C9C0}\u{B3C4}\u{C0AC}\u{AC00} \u{C7A5}\u{B840}\u{BB3C}\u{D488} \u{C900}\u{BE44}\u{BD80}\u{D130} \u{C7A5}\u{B840} \u{C9C4}\u{D589}, \u{D589}\u{C815} \u{C808}\u{CC28}\u{AE4C}\u{C9C0} \u{C720}\u{AC00}\u{C871}\u{C774} \u{D070} \u{C5B4}\u{B824}\u{C6C0} \u{C5C6}\u{C774} \u{B9C8}\u{BB34}\u{B9AC}\u{D560} \u{C218} \u{C788}\u{B3C4}\u{B85D} \u{ACC1}\u{C5D0}\u{C11C} \u{C138}\u{C2EC}\u{D558}\u{AC8C} \u{AD00}\u{B9AC}\u{D574} \u{B4DC}\u{B9BD}\u{B2C8}\u{B2E4}.</p>
            <p class="modal-footnote">*2023\u{B144} \u{AE30}\u{C900}</p>
        `
    },
    specialty_3: {
        title: "\uC6A9\uD488 \uBCF4\uC99D \uC2DC\uC2A4\uD15C",
        content: `
            <p class="modal-main-text">\u{ADDC}\u{ACA9}\u{C6A9}\u{D488}\u{BCF4}\u{B2E4} \u{D558}\u{C704}\u{C6A9}\u{D488}\u{C740} \u{C0AC}\u{C6A9}\u{D558}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.</p>
            <p class="modal-sub-text">\u{C18C}\u{B178}\u{C544}\u{C784}\u{B808}\u{B514}\u{B9CC}\u{C758} \u{B514}\u{C790}\u{C778} \u{D2B9}\u{D5C8} \u{ACE0}\u{AE54}, \u{B300}\u{B9C8} 100% \u{C218}\u{C758} \u{B4F1} \u{BE60}\u{C9D0}\u{C5C6}\u{C774} \u{C815}\u{C9C1}\u{D558}\u{AC8C} \u{C900}\u{BE44}\u{D574} \u{B4DC}\u{B9BD}\u{B2C8}\u{B2E4}.</p>
            <p class="modal-footnote">*\u{ACE0}\u{AE54}: \u{B514}\u{C790}\u{C778}\u{B4F1}\u{B85D}\u{C99D} \u{C81C} 30-1110105\u{D638} / \u{C218}\u{C758} : 2024\u{B144} 1\u{C6D4} fiti \u{C9C1}\u{BB3C}\u{D14C}\u{C2A4}\u{D2B8} \u{AE30}\u{C900} 1\u{B144} \u{B2E8}\u{C704} \u{C8FC}\u{AE30} \u{D14C}\u{C2A4}\u{D2B8} \u{C9C4}\u{D589}</p>
        `
    },
    supplies: {
        title: "\uACE0\uC778\uC6A9\uD488 \uBC0F \uC218\uC2DC\uC6A9\uD488",
        content: `
            <table class="warranty-table">
                <tbody>
                    <tr>
                        <th rowspan="4">\u{ACE0}\u{C778}\u{C6A9}\u{D488}<br>\u{BC0F}<br>\u{C218}\u{C2DC}\u{C6A9}\u{D488}</th>
                        <th class="warranty-sub-th">\u{AD00}</th>
                        <td>\u{B9E4}\u{C7A5} \u{C2DC}: \u{C624}\u{B3D9}\u{B098}\u{BB34} 45mm<br>\u{D654}\u{C7A5} \u{B610}\u{B294} \u{D0C8}\u{AD00} \u{C2DC}: \u{C624}\u{B3D9}\u{B098}\u{BB34} 18mm, \u{D6A1}\u{B300} or \u{C720}\u{ACE8}\u{D568} \u{4E2D} \u{D0DD}1</td>
                    </tr>
                    <tr>
                        <th class="warranty-sub-th">\u{C218}\u{C758}</th>
                        <td>\u{B300}\u{B9C8} (\u{B300}\u{B9C8} 100%)<br><span style="font-size:0.9em; color:#666;">- \u{C218}\u{C758} \u{C900}\u{BE44} \u{ACE0}\u{AC1D}: \u{AF43}\u{AD00}\u{BCF4} \u{B610}\u{B294} \u{C7A5}\u{B840}\u{C758}\u{C804} \u{B3C4}\u{C6B0}\u{BBF8} 1\u{BA85} \u{B300}\u{CCB4}</span></td>
                    </tr>
                    <tr>
                        <th class="warranty-sub-th" rowspan="2">\u{C785}\u{AD00}<br>\u{BC0F}<br>\u{C218}\u{C2DC}\u{C6A9}\u{D488}</th>
                        <td>\u{B3C4}\u{D3EC}, \u{C6D0}\u{C0BC}, \u{CC9C}\u{AE08}, \u{C9C0}\u{AE08} \u{B4F1}<br>(\u{C218}\u{C758} \u{C81C}\u{D488}\u{ACFC} \u{B3D9}\u{C77C}\u{C81C}\u{D488} \u{C81C}\u{ACF5})</td>
                    </tr>
                     <tr>
                        <td>\u{BA85}\u{C815}, \u{AD00}\u{BCF4}, \u{C2B5}\u{C2E0}, \u{D55C}\u{C9C0} \u{B4F1}<br>\u{ADDC}\u{ACA9}\u{D488} \u{C81C}\u{ACF5}</td>
                    </tr>
                </tbody>
            </table>
        `
    },
    mortuary: {
        title: "\uBE48\uC18C \uBC0F \uAE30\uD0C0\uC6A9\uD488",
        content: `
            <table class="warranty-table">
                <tbody>
                    <tr>
                        <th rowspan="3">\u{BE48}\u{C18C}<br>\u{BC0F}<br>\u{AE30}\u{D0C0}\u{C6A9}\u{D488}</th>
                        <th class="warranty-sub-th">\u{BE48}\u{C18C}\u{C6A9}\u{D488}</th>
                        <td>\u{D5A5}, \u{CD08}, \u{BD80}\u{C758}\u{B85D}, \u{CD95}\u{BB38}, \u{C704}\u{D328} (\u{D544}\u{C694}\u{B7C9} \u{C77C}\u{CCB4} \u{C81C}\u{ACF5})</td>
                    </tr>
                    <tr>
                        <th class="warranty-sub-th">\u{B300}\u{C5EC}\u{C6A9}\u{D488}</th>
                        <td>\u{D5A5}\u{B85C}, \u{CD1B}\u{B300}, \u{C794}\u{B300} (\u{B300}\u{C5EC}\u{D488})</td>
                    </tr>
                    <tr>
                        <th class="warranty-sub-th">\u{AE30}\u{D0C0}\u{C6A9}\u{D488}</th>
                        <td>\u{C644}\u{C7A5}, \u{C0C1}\u{C7A5}, \u{C6B4}\u{AD6C}\u{C6A9}\u{C7A5}\u{AC11} (\u{D544}\u{C694}\u{B7C9} \u{C77C}\u{CCB4} \u{C81C}\u{ACF5})</td>
                    </tr>
                </tbody>
            </table>
        `
    },
    clothing: {
        title: "\uC758\uC804\uC6A9\uD488 (\uC0C1\uBCF5)",
        content: `
            <table class="warranty-table">
                <tbody>
                    <tr>
                        <th rowspan="3">\u{C758}\u{C804}\u{C6A9}\u{D488}</th>
                        <th class="warranty-sub-th">\u{D604}\u{B300}\u{C2DD}</th>
                        <td>\u{B0A8}\u{C131} / \u{C5EC}\u{C131} (\u{CD1D} 5\u{BC8C} \u{C81C}\u{ACF5})</td>
                    </tr>
                    <tr>
                        <th class="warranty-sub-th" rowspan="2">\u{C804}\u{D1B5}\u{C2DD}</th>
                        <td>\u{BC14}\u{C9C0}\u{C800}\u{ACE0}\u{B9AC}, \u{C0BC}\u{BCA0}\u{CE58}\u{B9C8} \u{B4F1} (\u{D544}\u{C694}\u{B7C9} \u{C77C}\u{CCB4} \u{C81C}\u{ACF5})</td>
                    </tr>
                     <tr>
                        <td>\u{B450}\u{B8E8}\u{B9C8}\u{AE30}, \u{CE58}\u{B9C8}\u{C800}\u{ACE0}\u{B9AC} \u{B4F1} (\u{D544}\u{C694}\u{B7C9} \u{C77C}\u{CCB4} \u{C81C}\u{ACF5})</td>
                    </tr>
                </tbody>
            </table>
        `
    },
    altar: {
        title: "\uC81C\uB2E8\uC7A5\uC2DD (\uAF43\uC7A5\uC2DD)",
        content: `
            <table class="warranty-table">
                <tbody>
                    <tr>
                        <th rowspan="3">\u{C81C}\u{B2E8}\u{C7A5}\u{C2DD}<br>(\u{AF43}\u{C7A5}\u{C2DD})</th>
                        <th class="warranty-sub-th">\u{C0DD}\u{D654}\u{AF43}<br>\u{C81C}\u{B2E8}\u{C7A5}\u{C2DD}</th>
                        <td>\u{C81C}\u{B2E8} \u{AF43}\u{C7A5}\u{C2DD} 35\u{B9CC}\u{C6D0} \u{C0C1}\u{B2F9} \u{C81C}\u{ACF5}</td>
                    </tr>
                    <tr>
                        <th class="warranty-sub-th">\u{D5CC}\u{D654}\u{C6A9} \u{AD6D}\u{D654}</th>
                        <td>30\u{C1A1}\u{C774} \u{C81C}\u{ACF5}</td>
                    </tr>
                    <tr>
                        <th class="warranty-sub-th">\u{AF43}\u{BC14}\u{AD6C}\u{B2C8}</th>
                        <td>\u{AF43}\u{BC14}\u{AD6C}\u{B2C8} 2\u{AC1C} \u{C81C}\u{ACF5}</td>
                    </tr>
                </tbody>
            </table>
        `
    },
    vehicle: {
        title: "\uCC28\uB7C9\uC9C0\uC6D0",
        content: `
            <table class="warranty-table">
                <tbody>
                    <tr>
                        <th rowspan="3">\u{CC28}\u{B7C9}\u{C9C0}\u{C6D0}</th>
                        <th class="warranty-sub-th">\u{C6B4}\u{AD6C}<br>\u{C774}\u{C1A1}\u{CC28}\u{B7C9}</th>
                        <td>\u{AD00}\u{B0B4} (\u{C2DC}, \u{AD70}\u{B0B4}) \u{BB34}\u{B8CC} \u{C81C}\u{ACF5}</td>
                    </tr>
                    <tr>
                        <th class="warranty-sub-th">\u{ACE0}\u{C778} \u{B9AC}\u{BB34}\u{C9C4}</th>
                        <td>\u{C655}\u{BCF5} 300km (\u{CD08}\u{ACFC} \u{C2DC} 2,000\u{C6D0}/km)</td>
                    </tr>
                    <tr>
                        <th class="warranty-sub-th">\u{C720}\u{C871} \u{BC84}\u{C2A4}</th>
                        <td>\u{C655}\u{BCF5} 300km (\u{CD08}\u{ACFC} \u{C2DC} 2,000\u{C6D0}/km)</td>
                    </tr>
                </tbody>
            </table>
        `
    },
    manpower: {
        title: "\uC778\uB825\uC9C0\uC6D0",
        content: `
            <table class="warranty-table">
                <tbody>
                    <tr>
                        <th rowspan="2">\u{C778}\u{B825}\u{C9C0}\u{C6D0}</th>
                        <th class="warranty-sub-th">\u{C7A5}\u{B840}\u{C9C0}\u{B3C4}\u{C0AC}</th>
                        <td>1\u{BA85} (\u{C785}\u{AD00}\u{C9C0}\u{C6D0} \u{D3EC}\u{D568})</td>
                    </tr>
                    <tr>
                        <th class="warranty-sub-th">\u{C7A5}\u{B840}\u{C758}\u{C804}<br>\u{B3C4}\u{C6B0}\u{BBF8}</th>
                        <td>5\u{BA85} (1\u{C778} 10\u{C2DC}\u{AC04} \u{AE30}\u{C900})<br><span style="font-size:0.9em; color:#666;">(1\u{C77C}/10\u{C2DC}\u{AC04} \u{AE30}\u{C900})</span></td>
                    </tr>
                </tbody>
            </table>
        `
    },
    convenience: {
        title: "\uD3B8\uC758\uC11C\uBE44\uC2A4",
        content: `
            <table class="warranty-table">
                <tbody>
                    <tr>
                        <th rowspan="2">\u{D3B8}\u{C758}\u{C11C}\u{BE44}\u{C2A4}</th>
                        <th class="warranty-sub-th">\u{C77C}\u{D68C}\u{C6A9}<br>\u{C2DD}\u{AE30}\u{C138}\u{D2B8}</th>
                        <td>300\u{C778}\u{BD84} \u{C81C}\u{ACF5}</td>
                    </tr>
                    <tr>
                        <th class="warranty-sub-th">\u{D3B8}\u{C758}\u{C6A9}\u{D488}</th>
                        <td>1\u{C138}\u{D2B8} (6\u{C778} \u{AE30}\u{C900}) \u{C81C}\u{ACF5}</td>
                    </tr>
                </tbody>
            </table>
        `
    }
};
const $f9e1d550cec58a8b$var$initWarrantySystem = ()=>{
    // Select warranty items, specialty buttons, and product more button
    const items = document.querySelectorAll('.warranty-item, .specialty-premium-btn, .product__more-btn');
    const modal = document.getElementById('warrantyModal');
    if (!modal) return;
    const modalTitle = modal.querySelector('.warranty-modal__title');
    const modalBody = modal.querySelector('.warranty-modal__body');
    const closeBtn = modal.querySelector('.warranty-modal__close');
    const overlay = modal.querySelector('.warranty-modal__overlay');
    const closeModal = ()=>{
        modal.classList.remove('is-open');
        document.body.style.overflow = ''; // 스크롤 복구
    };
    items.forEach((item)=>{
        item.addEventListener('click', ()=>{
            const targetId = item.getAttribute('data-modal-target');
            const data = $f9e1d550cec58a8b$var$warrantyData[targetId];
            if (data) {
                modalTitle.textContent = data.title;
                modalBody.innerHTML = data.content;
                modal.classList.add('is-open');
                document.body.style.overflow = 'hidden'; // 배경 스크롤 방지
            }
        });
    });
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (overlay) overlay.addEventListener('click', closeModal);
    // ESC 키로 닫기
    document.addEventListener('keydown', (e)=>{
        if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
};
// Membership Slider
const $f9e1d550cec58a8b$var$initMembershipSlider = ()=>{
    const track = document.querySelector('.membership__track');
    const prevBtn = document.querySelector('.membership-prev');
    const nextBtn = document.querySelector('.membership-next');
    if (!track || !prevBtn || !nextBtn) return;
    const scrollAmount = 300; // 이동 거리
    prevBtn.addEventListener('click', ()=>{
        track.scrollBy({
            left: -scrollAmount,
            behavior: 'smooth'
        });
    });
    nextBtn.addEventListener('click', ()=>{
        track.scrollBy({
            left: scrollAmount,
            behavior: 'smooth'
        });
    });
};
// Benefit Tabs Switching logic
const $f9e1d550cec58a8b$var$initBenefitTabs = ()=>{
    const tabs = document.querySelectorAll('.benefit-tab');
    const panes = document.querySelectorAll('.tab-pane');
    const membershipId = 'membership';
    const hybridId = 'hybrid';
    const switchTab = (target)=>{
        tabs.forEach((t)=>{
            if (t.getAttribute('data-tab') === target) t.classList.add('active');
            else t.classList.remove('active');
        });
        panes.forEach((p)=>{
            if (p.id === `pane-${target}`) p.classList.add('active');
            else p.classList.remove('active');
        });
        // Trigger a custom event or refresh slider if needed
        window.dispatchEvent(new Event('resize'));
    };
    tabs.forEach((tab)=>{
        tab.addEventListener('click', ()=>{
            const target = tab.getAttribute('data-tab');
            switchTab(target);
        // Update URL without jump if possible, or just let it be
        // history.replaceState(null, null, `#${target}`);
        });
    });
    // Handle initial hash or clicks from nav
    const handleHash = ()=>{
        const hash = window.location.hash.replace('#', '');
        if (hash === hybridId) switchTab('hybrid');
        else if (hash === membershipId) switchTab('membership');
    };
    window.addEventListener('hashchange', handleHash);
    handleHash(); // Run on load
};
// FAQ Accordion
const $f9e1d550cec58a8b$var$initFAQ = ()=>{
    const questions = document.querySelectorAll('.faq__question');
    questions.forEach((q)=>{
        q.addEventListener('click', ()=>{
            const item = q.parentElement;
            const isActive = item.classList.contains('active');
            // Close all others
            document.querySelectorAll('.faq__item').forEach((i)=>{
                i.classList.remove('active');
                i.querySelector('.faq__answer').style.height = 0;
            });
            // Toggle current
            if (!isActive) {
                item.classList.add('active');
                const answer = item.querySelector('.faq__answer');
                answer.style.height = answer.scrollHeight + 'px';
            }
        });
    });
};
// Floating Button Visibility Control (Hide when reaching Inquiry Section)
const $f9e1d550cec58a8b$var$initFloatingVisibility = ()=>{
    const pin = document.querySelector('.pin');
    const floatLeft = document.querySelector('.floating-left');
    const inquirySection = document.querySelector('.section--inquiry');
    if (!pin || !inquirySection) return;
    (0, $82ba1e40433c64f0$export$875bcbe48555930).create({
        trigger: inquirySection,
        start: 'top bottom-=100',
        onEnter: ()=>{
            (0, $6255c273005a4429$export$99ee26438460406a).to([
                pin,
                floatLeft
            ], {
                autoAlpha: 0,
                scale: 0.8,
                duration: 0.3
            });
        },
        onLeaveBack: ()=>{
            (0, $6255c273005a4429$export$99ee26438460406a).to([
                pin,
                floatLeft
            ], {
                autoAlpha: 1,
                scale: 1,
                duration: 0.3
            });
        }
    });
};
// Scroll Animations for FAQ & Inquiry
const $f9e1d550cec58a8b$var$initBottomAnimations = ()=>{
    // 1. FAQ Title
    const faqTitle = document.querySelector('.faq__title');
    if (faqTitle) (0, $6255c273005a4429$export$99ee26438460406a).from(faqTitle, {
        scrollTrigger: {
            trigger: '.section--faq',
            start: 'top 80%'
        },
        y: 50,
        opacity: 0,
        duration: 1,
        ease: 'power3.out'
    });
    // 2. FAQ Items (Staggered)
    const faqItems = document.querySelectorAll('.faq__item');
    if (faqItems.length > 0) (0, $6255c273005a4429$export$99ee26438460406a).from(faqItems, {
        scrollTrigger: {
            trigger: '.faq__list',
            start: 'top 85%'
        },
        y: 40,
        opacity: 0,
        duration: 0.8,
        stagger: 0.15,
        ease: 'power2.out'
    });
    // 3. Inquiry Card (Pop up)
    const inquiryCard = document.querySelector('.inquiry__card');
    if (inquiryCard) (0, $6255c273005a4429$export$99ee26438460406a).from(inquiryCard, {
        scrollTrigger: {
            trigger: '.section--inquiry',
            start: 'top 75%'
        },
        y: 80,
        opacity: 0,
        duration: 1.2,
        ease: 'power3.out'
    });
};
// Privacy Policy Toggle
const $f9e1d550cec58a8b$var$initPrivacyToggle = ()=>{
    // Footer privacy toggle
    const link = document.querySelector('.inquiry__agreement-link:not(#toggle-privacy-modal)');
    const box = document.querySelector('.inquiry__privacy-box:not(#privacy-box-modal)');
    if (link && box) link.addEventListener('click', (e)=>{
        e.preventDefault();
        const isHidden = box.style.display === 'none';
        box.style.display = isHidden ? 'block' : 'none';
        link.textContent = isHidden ? "\uB2EB\uAE30" : "\uC790\uC138\uD788";
    });
    // Modal privacy toggle
    const modalLink = document.getElementById('toggle-privacy-modal');
    const modalBox = document.getElementById('privacy-box-modal');
    if (modalLink && modalBox) modalLink.addEventListener('click', (e)=>{
        e.preventDefault();
        const isHidden = modalBox.style.display === 'none';
        modalBox.style.display = isHidden ? 'block' : 'none';
        modalLink.textContent = isHidden ? "\uB2EB\uAE30" : "\uC790\uC138\uD788";
    });
};
// Modal Close Button Handler - imported from modal-close-handler.js
// Footer Modals Logic
const $f9e1d550cec58a8b$var$initFooterModals = ()=>{
    console.log('initFooterModals called');
    const modals = {
        'btn-privacy': 'modal-privacy',
        'btn-privacy-floating': 'modal-privacy',
        'btn-privacy-inquiry': 'modal-privacy',
        'btn-notice': 'modal-notice',
        'btn-consult-modal-1': 'modal-consultation',
        'btn-consult-modal-2': 'modal-consultation',
        'btn-consult-modal-3': 'modal-consultation',
        'btn-consult-modal-essence': 'modal-consultation'
    };
    Object.keys(modals).forEach((btnId)=>{
        const btn = document.getElementById(btnId);
        const modalId = modals[btnId];
        const modal = document.getElementById(modalId);
        console.log(`Checking ${btnId}: btn=${!!btn}, modal=${!!modal}`);
        if (btn && modal) {
            console.log(`Setting up event listener for ${btnId}`);
            // Open Modal
            btn.addEventListener('click', (e)=>{
                e.preventDefault();
                e.stopPropagation();
                console.log(`Button clicked: ${btnId}, opening modal: ${modalId}`);
                modal.style.display = 'flex';
                // Small delay for simple CSS transition if we want fade in
                setTimeout(()=>{
                    modal.classList.add('is-open');
                    console.log(`Modal ${modalId} should now be visible`);
                }, 10);
                document.body.style.overflow = 'hidden'; // Prevent background scrolling
                if (typeof $f9e1d550cec58a8b$var$lenis !== 'undefined' && $f9e1d550cec58a8b$var$lenis) $f9e1d550cec58a8b$var$lenis.stop();
            });
            // Close Modal (Button & Overlay & ESC)
            const closeBtn = modal.querySelector('.modal__close');
            const overlay = modal.querySelector('.modal__overlay');
            const closeModal = ()=>{
                console.log(`Closing modal: ${modalId}`);
                modal.classList.remove('is-open');
                setTimeout(()=>{
                    modal.style.display = 'none';
                }, 300); // Wait for transition
                document.body.style.overflow = '';
                if (typeof $f9e1d550cec58a8b$var$lenis !== 'undefined' && $f9e1d550cec58a8b$var$lenis) $f9e1d550cec58a8b$var$lenis.start();
            };
            if (closeBtn) {
                closeBtn.addEventListener('click', closeModal);
                console.log(`Close button found for ${modalId}`);
            } else console.warn(`No close button found for ${modalId}`);
            if (overlay) {
                overlay.addEventListener('click', closeModal);
                console.log(`Overlay found for ${modalId}`);
            } else console.warn(`No overlay found for ${modalId}`);
            // ESC Key
            document.addEventListener('keydown', (e)=>{
                if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
            });
        } else console.error(`Missing element for ${btnId}: btn=${!!btn}, modal=${!!modal}`);
    });
    console.log('initFooterModals completed');
    // DEBUG: Check what element is actually receiving clicks
    setTimeout(()=>{
        const btn = document.getElementById('btn-consult-modal-1');
        if (btn) {
            const rect = btn.getBoundingClientRect();
            const btnCenterX = rect.left + rect.width / 2;
            const btnCenterY = rect.top + rect.height / 2;
            const elementAtButton = document.elementFromPoint(btnCenterX, btnCenterY);
            console.log('=== BUTTON CLICK DEBUG ===');
            console.log('Button element:', btn);
            console.log('Element at button position:', elementAtButton);
            console.log('Element tag:', elementAtButton?.tagName);
            console.log('Element class:', elementAtButton?.className);
            console.log('Element id:', elementAtButton?.id);
            console.log('Is same element?', elementAtButton === btn);
            console.log('Button computed styles:', {
                pointerEvents: window.getComputedStyle(btn).pointerEvents,
                zIndex: window.getComputedStyle(btn).zIndex,
                position: window.getComputedStyle(btn).position
            });
            if (elementAtButton && elementAtButton !== btn) console.log('BLOCKER computed styles:', {
                pointerEvents: window.getComputedStyle(elementAtButton).pointerEvents,
                zIndex: window.getComputedStyle(elementAtButton).zIndex,
                position: window.getComputedStyle(elementAtButton).position
            });
        }
    }, 2000);
};
// YouTube Section Animations
const $f9e1d550cec58a8b$var$initYoutubeAnimations = ()=>{
    // Header sequence
    (0, $6255c273005a4429$export$99ee26438460406a).from('.youtube__deco-text', {
        scrollTrigger: {
            trigger: '.section--youtube',
            start: 'top 85%'
        },
        opacity: 0,
        scale: 0.9,
        duration: 2.5,
        ease: 'power3.out'
    });
    (0, $6255c273005a4429$export$99ee26438460406a).from(".youtube__icon-3d", {
        scrollTrigger: {
            trigger: ".section--youtube",
            start: "top 70%"
        },
        opacity: 0,
        y: 50,
        scale: 0.2,
        rotation: -45,
        duration: 1.5,
        ease: "back.out(1.7)"
    });
    (0, $6255c273005a4429$export$99ee26438460406a).from('.youtube__tag', {
        scrollTrigger: {
            trigger: '.section--youtube',
            start: 'top 80%'
        },
        opacity: 0,
        y: 20,
        duration: 0.8,
        ease: 'power2.out'
    });
    (0, $6255c273005a4429$export$99ee26438460406a).from('.youtube__title', {
        scrollTrigger: {
            trigger: '.section--youtube',
            start: 'top 75%'
        },
        opacity: 0,
        y: 30,
        duration: 1,
        delay: 0.2,
        ease: 'power3.out'
    });
    (0, $6255c273005a4429$export$99ee26438460406a).from('.youtube__desc', {
        scrollTrigger: {
            trigger: '.section--youtube',
            start: 'top 70%'
        },
        opacity: 0,
        y: 30,
        duration: 1,
        delay: 0.4,
        ease: 'power3.out'
    });
    // Video Wrapper
    (0, $6255c273005a4429$export$99ee26438460406a).from('.youtube__video-wrapper', {
        scrollTrigger: {
            trigger: '.youtube__video-wrapper',
            start: 'top 80%'
        },
        opacity: 0,
        scale: 0.95,
        y: 50,
        duration: 1.2,
        ease: 'power4.out'
    });
    // CTA Box
    (0, $6255c273005a4429$export$99ee26438460406a).from('.youtube__cta-box', {
        scrollTrigger: {
            trigger: '.youtube__cta-box',
            start: 'top 90%'
        },
        opacity: 0,
        y: 30,
        duration: 1,
        ease: 'power3.out'
    });
};
// ------- Trust Section Lighting Animation ------- //
const $f9e1d550cec58a8b$var$initTrustLightingAnimation = ()=>{
    const section = document.querySelector('#trust');
    const overlay = section?.querySelector('.light-up-overlay');
    const container = section?.querySelector('.trust__container');
    if (!section || !overlay || !container) return;
    // Lights go on (Overlay disappears)
    (0, $6255c273005a4429$export$99ee26438460406a).to(overlay, {
        opacity: 0,
        scrollTrigger: {
            trigger: section,
            start: "top 60%",
            end: "top 10%",
            scrub: 1.2
        }
    });
    // Content reveals
    (0, $6255c273005a4429$export$99ee26438460406a).set(container, {
        opacity: 0,
        y: 30
    }); // Initial state
    (0, $6255c273005a4429$export$99ee26438460406a).to(container, {
        opacity: 1,
        y: 0,
        scrollTrigger: {
            trigger: section,
            start: "top 55%",
            end: "top 15%",
            scrub: 1.0
        }
    });
};
// Background Color Transition Logic
const $f9e1d550cec58a8b$var$initColorTransition = ()=>{
    // 0. Ensure initial state is clearly defined via set if needed, but CSS handles var
    (0, $6255c273005a4429$export$99ee26438460406a).set("body", {
        "--bg-color": "#000000"
    });
    // 1. Showcase -> Trust (Black to White)
    (0, $6255c273005a4429$export$99ee26438460406a).to("body", {
        "--bg-color": "#ffffff",
        immediateRender: false,
        scrollTrigger: {
            trigger: "#trust",
            start: "top 60%",
            end: "top 10%",
            scrub: true
        }
    });
    // 2. Trust -> Inflation (White to Black)
    (0, $6255c273005a4429$export$99ee26438460406a).to("body", {
        "--bg-color": "#000000",
        immediateRender: false,
        scrollTrigger: {
            trigger: ".section--inflation",
            start: "top bottom",
            end: "top top",
            scrub: true
        }
    });
};
// Reset color on page refresh to handle potential glitches if starting in middle
(0, $82ba1e40433c64f0$export$875bcbe48555930).addEventListener("refresh", ()=>{
// Optional: Force check but GSAP usually handles this
});
// Hero Video Popup Logic
let $f9e1d550cec58a8b$var$isVideoPopupInitialized = false;
const $f9e1d550cec58a8b$var$initHeroVideoPopup = ()=>{
    if ($f9e1d550cec58a8b$var$isVideoPopupInitialized) return;
    const popup = document.getElementById('hero-video-popup');
    const overlay = document.querySelector('.video-popup-overlay');
    const closeBtn = document.querySelector('.video-popup__close-expanded');
    const dismissBtn = document.querySelector('.video-popup__close-individual');
    const soundBtn = document.querySelector('.video-popup__sound-toggle');
    const video = popup?.querySelector('video');
    if (!popup || !overlay) return;
    $f9e1d550cec58a8b$var$isVideoPopupInitialized = true;
    // Make popup draggable (only when not expanded)
    let draggableInstance = (0, $9644ab9b72d1ba35$export$f2a139e5d18b9882).create(popup, {
        type: 'x,y',
        bounds: 'body',
        edgeResistance: 0.65,
        cursor: 'grab',
        activeCursor: 'grabbing',
        onDragStart: function() {
            popup.style.cursor = 'grabbing';
        },
        onDragEnd: function() {
            popup.style.cursor = 'grab';
        },
        onClick: function(e) {
            // Allow click events to propagate for expand functionality
            return true;
        }
    })[0];
    // Click to Expand
    popup.addEventListener('click', (e)=>{
        if (e.target.closest('.video-popup__sound-toggle') || e.target.closest('.video-popup__close-individual') || e.target.closest('.video-popup__close-expanded')) return;
        if (popup.classList.contains('is-expanded')) return;
        // Disable dragging when expanded
        if (draggableInstance) draggableInstance.disable();
        popup.classList.add('is-expanded');
        overlay.classList.add('is-active');
        if (video) {
            video.muted = true;
            video.play().catch((e)=>console.warn('Video play failed:', e));
        }
        if ($f9e1d550cec58a8b$var$lenis) $f9e1d550cec58a8b$var$lenis.stop();
        setTimeout(()=>(0, $82ba1e40433c64f0$export$875bcbe48555930).refresh(), 200);
    });
    // Dismiss logic (Permanent hide)
    dismissBtn?.addEventListener('click', (e)=>{
        e.preventDefault();
        e.stopPropagation();
        (0, $6255c273005a4429$export$99ee26438460406a).to(popup, {
            opacity: 0,
            scale: 0.8,
            duration: 0.4,
            ease: 'power2.in',
            onComplete: ()=>{
                popup.style.display = 'none';
                (0, $82ba1e40433c64f0$export$875bcbe48555930).refresh();
            }
        });
    });
    // Sound Toggle Logic
    soundBtn?.addEventListener('click', (e)=>{
        e.preventDefault();
        e.stopPropagation();
        if (video) {
            video.muted = !video.muted;
            const unmutedIcon = soundBtn.querySelector('.icon--unmuted');
            const mutedIcon = soundBtn.querySelector('.icon--muted');
            if (unmutedIcon && mutedIcon) {
                unmutedIcon.style.display = video.muted ? 'none' : 'block';
                mutedIcon.style.display = video.muted ? 'block' : 'none';
            }
        }
    });
    // Close Logic Expansion
    const closePopup = (e)=>{
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        popup.classList.remove('is-expanded');
        overlay.classList.remove('is-active');
        if (video) video.muted = true;
        if ($f9e1d550cec58a8b$var$lenis) $f9e1d550cec58a8b$var$lenis.start();
        // Re-enable dragging when closed
        if (draggableInstance) draggableInstance.enable();
        setTimeout(()=>(0, $82ba1e40433c64f0$export$875bcbe48555930).refresh(), 100);
    };
    closeBtn?.addEventListener('click', closePopup);
    overlay?.addEventListener('click', closePopup);
    // Hero Section Visibility Control (Matched to Floating Card Transition)
    // 플로팅 카드가 변하는 시점(스크롤 150px)에서 비디오 팝업도 사라지거나 나타나야 함
    const heroContent = document.querySelector('.content'); // Use same trigger element as floating card
    if (heroContent) (0, $82ba1e40433c64f0$export$875bcbe48555930).create({
        trigger: heroContent,
        start: 'top top-=150',
        onEnter: ()=>{
            // Scrolled DOWN past 150px -> Hide Popup
            if (!popup.classList.contains('is-expanded')) (0, $6255c273005a4429$export$99ee26438460406a).to(popup, {
                opacity: 0,
                duration: 0.3,
                ease: 'power2.in',
                overwrite: true
            });
        },
        onLeaveBack: ()=>{
            // Scrolled UP back into first 150px -> Show Popup
            (0, $6255c273005a4429$export$99ee26438460406a).to(popup, {
                opacity: 1,
                duration: 0.5,
                ease: 'power2.out',
                overwrite: true
            });
        }
    });
};
// Hero Video Popup Show Logic (Called after intro)
const $f9e1d550cec58a8b$var$showHeroVideoPopup = ()=>{
    const popup = document.getElementById('hero-video-popup');
    const pin = document.querySelector('.pin');
    const floatingLeft = document.querySelector('.floating-left');
    // Check if we are past the hero section (matching ScrollTrigger logic at 150px)
    const isPastHero = window.scrollY > 150;
    // Elements to animate
    const elementsToShow = [];
    if (pin) elementsToShow.push(pin);
    if (floatingLeft) elementsToShow.push(floatingLeft);
    // Only show popup if we are in the hero section
    if (popup && !isPastHero) elementsToShow.push(popup);
    else if (popup) // Ensure popup stays hidden if we are scrolled down
    (0, $6255c273005a4429$export$99ee26438460406a).set(popup, {
        opacity: 0
    });
    if (elementsToShow.length === 0) return;
    // display는 건드리지 않음 - CSS 원래 값 유지
    (0, $6255c273005a4429$export$99ee26438460406a).set(elementsToShow, {
        opacity: 0
    });
    // 단순 페이드인만
    (0, $6255c273005a4429$export$99ee26438460406a).to(elementsToShow, {
        opacity: 1,
        duration: 1.2,
        ease: 'power2.out',
        delay: 0.5,
        onComplete: ()=>{
            if (pin) pin.classList.add('is-visible');
            if (floatingLeft) floatingLeft.classList.add('visible');
        }
    });
};
// Unified Initialization
document.addEventListener('DOMContentLoaded', ()=>{
    $f9e1d550cec58a8b$var$initSmoothScrolling();
    // initHeroFadeOut(); // tlHero onComplete에서 호출되도록 유지
    $f9e1d550cec58a8b$var$initHeroVideoPopup();
    $f9e1d550cec58a8b$var$initLogoClick();
    $f9e1d550cec58a8b$var$initGoHome();
    $f9e1d550cec58a8b$var$initSoundToggle();
    $f9e1d550cec58a8b$var$initInfraToggle();
    $f9e1d550cec58a8b$var$initShowcaseCardsAnimation();
    $f9e1d550cec58a8b$var$initServiceEssenceAnimations();
    $f9e1d550cec58a8b$var$initFloatingCard();
    $f9e1d550cec58a8b$var$initInflationCharts();
    $f9e1d550cec58a8b$var$initTrustAnimations();
    $f9e1d550cec58a8b$var$initTrustLightingAnimation();
    $f9e1d550cec58a8b$var$initShowcaseAnimations();
    $f9e1d550cec58a8b$var$initHighlightEffect();
    $f9e1d550cec58a8b$var$initStickyHeader();
    $f9e1d550cec58a8b$var$initPreparednessStats();
    $f9e1d550cec58a8b$var$initDifficultyAnimations();
    $f9e1d550cec58a8b$var$initReviewCarousel();
    $f9e1d550cec58a8b$var$initSpecialtyAnimations();
    $f9e1d550cec58a8b$var$initNetworkAnimations();
    $f9e1d550cec58a8b$var$initColorTransition();
    $f9e1d550cec58a8b$var$initCountAnimation();
    $f9e1d550cec58a8b$var$initFeatureIconAnimations();
    $f9e1d550cec58a8b$var$initTimelineAnimation();
    $f9e1d550cec58a8b$var$initWarrantySystem();
    $f9e1d550cec58a8b$var$initBenefitTabs();
    $f9e1d550cec58a8b$var$initMembershipSlider();
    $f9e1d550cec58a8b$var$initFAQ();
    $f9e1d550cec58a8b$var$initFloatingVisibility();
    $f9e1d550cec58a8b$var$initBottomAnimations();
    $f9e1d550cec58a8b$var$initPrivacyToggle();
    (0, $0d92265acd506a0c$export$68163e1cd8f8eca8)();
    $f9e1d550cec58a8b$var$initFooterModals();
    $f9e1d550cec58a8b$var$initYoutubeAnimations();
    (0, $f28854ed323b9f73$export$2e2bcd8739ae039)();
    $f9e1d550cec58a8b$var$initLeftFloating();
    // Ensure everything is calculated after all initializations
    setTimeout(()=>{
        (0, $82ba1e40433c64f0$export$875bcbe48555930).refresh();
    }, 500);
});
// Inflation Graph Initialization
function $f9e1d550cec58a8b$var$initInflationGraph() {
    const mainSVG = document.querySelector('.mainSVG');
    if (!mainSVG) return;
    const box = document.querySelector('.box');
    const connector = document.querySelector('#connector');
    const dragger = document.querySelector('#dragger');
    const graphDot = document.querySelector('#graphDot');
    // Updated Selectors for the new box structure
    const boxLabelYear = document.querySelector('#boxLabel-Year');
    const boxLabelPrice = document.querySelector('#boxLabel-Price');
    const boxLabelSave = document.querySelector('#boxLabel-Save');
    const nullDot = document.querySelector('#nullDot');
    const graphLine = document.querySelector('#graphLine');
    const savingsLabels = document.querySelectorAll('#savingsMarkers text');
    let isPressed = false;
    const boxPos = {
        x: 0,
        y: 0
    };
    // Data points from user image
    const years = [
        "\uD604\uC7AC",
        "5\uB144",
        "10\uB144",
        "15\uB144",
        "20\uB144"
    ];
    const marketPrices = [
        420,
        465,
        529,
        601,
        683
    ];
    const sonoPrice = 399;
    // Explicitly set initial position to line start (100, 370)
    (0, $6255c273005a4429$export$99ee26438460406a).set([
        dragger,
        graphDot,
        nullDot
    ], {
        transformOrigin: '50% 50%',
        x: 0,
        y: 0
    });
    (0, $6255c273005a4429$export$99ee26438460406a).set(box, {
        x: 100,
        y: 370,
        transformOrigin: '0 0',
        scale: 0,
        opacity: 0
    });
    const tl = (0, $6255c273005a4429$export$99ee26438460406a).timeline({
        paused: true,
        onUpdate: updateGraph
    });
    tl.to([
        graphDot,
        dragger
    ], {
        motionPath: {
            path: graphLine,
            align: graphLine,
            alignOrigin: [
                0.5,
                0.5
            ]
        },
        duration: 5,
        ease: "none"
    });
    function updateGraph() {
        // Prevent flickering by removing duration-based tweens in onUpdate
        const progress = tl.progress();
        const draggerX = (0, $6255c273005a4429$export$99ee26438460406a).getProperty(dragger, "x");
        const draggerY = (0, $6255c273005a4429$export$99ee26438460406a).getProperty(dragger, "y");
        // Use Set for instant updates
        (0, $6255c273005a4429$export$99ee26438460406a).set(box, {
            x: draggerX + 100,
            y: draggerY + 370
        });
        const yearIdx = Math.min(Math.floor(progress * 5), 4);
        boxLabelYear.textContent = years[yearIdx] + " \uC608\uC0C1 \uBB3C\uAC00";
        const currentPrice = (0, $6255c273005a4429$export$99ee26438460406a).utils.interpolate(marketPrices, progress);
        boxLabelPrice.textContent = Math.round(currentPrice).toLocaleString() + "\uB9CC\uC6D0";
        // Proximity highlight
        savingsLabels.forEach((label, i)=>{
            const pointProgress = i * 0.25;
            const distance = Math.abs(progress - pointProgress);
            const isNear = distance < 0.05;
            // Only update if changed to avoid thrashing
            if (isNear !== label.isNear) {
                label.isNear = isNear;
                (0, $6255c273005a4429$export$99ee26438460406a).to(label, {
                    scale: isNear ? 1.4 : 1,
                    fill: isNear ? "#C5A065" : "#FFF",
                    duration: 0.3,
                    overwrite: true
                });
            }
        });
    }
    function updateTimeline() {
        const perc = (0, $6255c273005a4429$export$99ee26438460406a).getProperty(nullDot, "x") / 600;
        // Directly set progress to avoid Tween Fighting (Flickering)
        tl.progress(perc);
    }
    function graphPress() {
        isPressed = true;
        (0, $6255c273005a4429$export$99ee26438460406a).to(dragger, {
            duration: 0.4,
            attr: {
                r: 50
            },
            fill: "rgba(255, 255, 255, 0.15)",
            ease: "power2.out"
        });
        (0, $6255c273005a4429$export$99ee26438460406a).to(box, {
            duration: 0.4,
            scale: 1,
            opacity: 1,
            ease: "back.out(1.7)"
        });
    }
    function graphRelease() {
        isPressed = false;
        (0, $6255c273005a4429$export$99ee26438460406a).to(dragger, {
            duration: 0.3,
            attr: {
                r: 40
            },
            fill: "rgba(255, 255, 255, 0.05)",
            ease: "power2.out"
        });
        // Keep the box visible after interaction
        (0, $6255c273005a4429$export$99ee26438460406a).to(box, {
            duration: 0.4,
            scale: 1,
            opacity: 1,
            ease: "power2.out"
        });
    }
    // Interactive Hover Points reveal and click-to-glide behavior
    const hoverPoints = document.querySelectorAll('.hover-point');
    hoverPoints.forEach((p)=>{
        const bubble = p.querySelector('.hover-bubble');
        const index = parseInt(p.getAttribute('data-index'));
        p.addEventListener('mouseenter', ()=>{
            (0, $6255c273005a4429$export$99ee26438460406a).to(bubble, {
                duration: 0.3,
                opacity: 1,
                y: -5,
                ease: "power2.out"
            });
        });
        p.addEventListener('mouseleave', ()=>{
            (0, $6255c273005a4429$export$99ee26438460406a).to(bubble, {
                duration: 0.3,
                opacity: 0,
                y: 0,
                ease: "power2.in"
            });
        });
        // Click to glide to this point
        p.addEventListener('click', ()=>{
            if (autoPlayTween) autoPlayTween.kill();
            graphPress();
            (0, $6255c273005a4429$export$99ee26438460406a).to(nullDot, {
                duration: 1,
                x: index * 150,
                ease: "power2.inOut",
                onUpdate: updateTimeline,
                onComplete: ()=>{
                    // Slight visual reset for dragger but keep box visible
                    (0, $6255c273005a4429$export$99ee26438460406a).to(dragger, {
                        duration: 0.3,
                        fill: "rgba(255, 255, 255, 0.05)"
                    });
                }
            });
        });
    });
    let autoPlayTween;
    function startAutoPlay() {
        graphPress();
        autoPlayTween = (0, $6255c273005a4429$export$99ee26438460406a).to(nullDot, {
            duration: 5,
            x: 600,
            ease: "power1.inOut",
            onUpdate: updateTimeline,
            onComplete: ()=>{
                (0, $6255c273005a4429$export$99ee26438460406a).delayedCall(1, graphRelease);
            }
        });
    }
    (0, $9644ab9b72d1ba35$export$f2a139e5d18b9882).create(nullDot, {
        type: 'x',
        trigger: dragger,
        bounds: {
            minX: 0,
            maxX: 600
        },
        onPress: ()=>{
            if (autoPlayTween) autoPlayTween.kill();
            graphPress();
        },
        onDrag: updateTimeline,
        onRelease: graphRelease,
        onThrowUpdate: updateTimeline,
        zIndexBoost: false
    });
    const introTl = (0, $6255c273005a4429$export$99ee26438460406a).timeline({
        scrollTrigger: {
            trigger: ".section--inflation-graph",
            start: "top 75%"
        },
        onComplete: ()=>{
            (0, $6255c273005a4429$export$99ee26438460406a).delayedCall(0.5, startAutoPlay);
        }
    });
    // Drawing lines first, then showing markers
    introTl.from('#horizontalLinesGroup line', {
        duration: 0.8,
        scaleX: 0,
        opacity: 0,
        stagger: 0.05,
        ease: "power2.out"
    }).from('#graphTextGroup text', {
        duration: 0.6,
        opacity: 0,
        stagger: 0.05,
        ease: "power2.out"
    }, "-=0.4")// Explicit Left->Right Draw using fromTo
    .fromTo(graphLine, {
        strokeDasharray: 2000,
        strokeDashoffset: 2000
    }, {
        duration: 2.5,
        strokeDashoffset: 0,
        ease: "power2.inOut"
    }, "-=0.2")// Explicit Left->Right Draw using fromTo
    .fromTo('#sonoFixedLine', {
        strokeDasharray: 1000,
        strokeDashoffset: 1000
    }, {
        duration: 1.5,
        strokeDashoffset: 0,
        ease: "power2.out"
    }, "-=2").from([
        graphDot,
        dragger
    ], {
        duration: 0.8,
        opacity: 0,
        scale: 0,
        ease: "back.out(1.7)"
    }, "-=1").to([
        '#hoverPoints',
        '#savingsMarkers',
        '#sonoFixedLabel'
    ], {
        duration: 1.2,
        opacity: 1,
        stagger: 0.1,
        ease: "power2.in"
    }, "-=0.8");
}
/**
 * Left Floating Buttons Logic (Revision)
 * Handles KakaoTalk & Gift modals and visibility
 */ function $f9e1d550cec58a8b$var$initLeftFloating() {
    var floatingLeft = document.querySelector('.floating-left');
    var btnKakao = document.getElementById('btn-kakao-open');
    var btnGift = document.getElementById('btn-gift-open');
    var modalKakao = document.getElementById('modal-kakao-float');
    var modalGift = document.getElementById('modal-gift-float');
    var btnGiftTrigger = document.getElementById('btn-gift-consult-trigger');
    if (!floatingLeft) return;
    // 2. Local Modal Helpers
    // 2. Local Modal Helpers with GSAP Animations
    var openFloatModal = function(m) {
        if (!m) return;
        m.style.display = 'flex';
        document.body.style.overflow = 'hidden';
        var content = m.querySelector('.modal__content');
        var overlay = m.querySelector('.modal__overlay');
        // Initial state
        (0, $6255c273005a4429$export$99ee26438460406a).set(overlay, {
            opacity: 0
        });
        (0, $6255c273005a4429$export$99ee26438460406a).set(content, {
            opacity: 0,
            y: 50,
            scale: 0.95
        });
        // Animation
        m.classList.add('is-open');
        (0, $6255c273005a4429$export$99ee26438460406a).to(overlay, {
            duration: 0.4,
            opacity: 1,
            ease: 'power2.out'
        });
        (0, $6255c273005a4429$export$99ee26438460406a).to(content, {
            duration: 0.6,
            opacity: 1,
            y: 0,
            scale: 1,
            ease: 'back.out(1.7)',
            clearProps: 'transform' // Clear to prevent conflicts with other CSS
        });
    };
    var closeFloatModal = function(m) {
        if (!m) return;
        m.classList.remove('is-open');
        var content = m.querySelector('.modal__content');
        var overlay = m.querySelector('.modal__overlay');
        (0, $6255c273005a4429$export$99ee26438460406a).to(content, {
            opacity: 0,
            y: 50,
            scale: 0.95,
            duration: 0.4,
            ease: 'power2.in'
        });
        (0, $6255c273005a4429$export$99ee26438460406a).to(overlay, {
            duration: 0.4,
            opacity: 0,
            ease: 'power2.in',
            onComplete: function() {
                m.style.display = 'none';
                document.body.style.overflow = '';
            }
        });
    };
    // 1. Scroll-based Visibility (Mobile Only Logic)
    // 모바일에서 히어로 섹션을 벗어났을 때만 버튼이 보이도록 설정
    const updateMobileFloatingVisibility = ()=>{
        if (window.innerWidth <= 768) {
            if (window.scrollY > 150) floatingLeft.classList.add('is-active-mobile');
            else floatingLeft.classList.remove('is-active-mobile');
        } else // 데스크탑에서는 항상 보이거나 다른 로직(showHeroVideoPopup)에 따름
        // 데스크탑에서 불필요하게 클래스가 남아있을 수 있으므로 제거
        floatingLeft.classList.remove('is-active-mobile');
    };
    window.addEventListener('scroll', updateMobileFloatingVisibility);
    window.addEventListener('resize', updateMobileFloatingVisibility);
    updateMobileFloatingVisibility(); // Initial check
    var closeFloatModal = function(m) {
        if (!m) return;
        m.classList.remove('is-open');
        var content = m.querySelector('.modal__content');
        var overlay = m.querySelector('.modal__overlay');
        (0, $6255c273005a4429$export$99ee26438460406a).to(overlay, {
            duration: 0.3,
            opacity: 0,
            ease: 'power2.in'
        });
        (0, $6255c273005a4429$export$99ee26438460406a).to(content, {
            duration: 0.4,
            opacity: 0,
            y: 30,
            scale: 0.95,
            ease: 'power2.in',
            onComplete: function() {
                m.style.display = 'none';
                document.body.style.overflow = '';
            }
        });
    };
    // 3. Button Listeners
    if (btnKakao) btnKakao.addEventListener('click', function(e) {
        e.preventDefault();
        openFloatModal(modalKakao);
    });
    if (btnGift) btnGift.addEventListener('click', function(e) {
        e.preventDefault();
        openFloatModal(modalGift);
    });
    // 4. Close Listeners (Overlay & Close Button)
    var modals = [
        modalKakao,
        modalGift
    ];
    modals.forEach(function(m) {
        if (!m) return;
        var cb = m.querySelector('.modal__close');
        var ov = m.querySelector('.modal__overlay');
        if (cb) cb.addEventListener('click', function() {
            closeFloatModal(m);
        });
        if (ov) ov.addEventListener('click', function() {
            closeFloatModal(m);
        });
    });
    // 5. Gift Modal -> Main Consultation Modal Link
    if (btnGiftTrigger) btnGiftTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        closeFloatModal(modalGift);
        // Re-use existing consultation modal logic
        var mainConsultModal = document.getElementById('modal-consultation');
        if (mainConsultModal) setTimeout(function() {
            mainConsultModal.style.display = 'flex';
            mainConsultModal.classList.add('is-open');
            document.body.style.overflow = 'hidden';
        }, 350);
    });
}
// --- New Inflation Graph Animation (ScrollTrigger) ---
function $f9e1d550cec58a8b$var$initNewInflationGraph() {
    const container = document.querySelector('.graph-container');
    const svg = document.querySelector('.inflation-svg');
    // Safety check
    if (!container || !svg) {
        console.warn('Inflation Graph elements not found');
        return;
    }
    console.log('Initializing Inflation Graph Animation...');
    // Elements
    const graphLine = svg.querySelector('#graphLine');
    const sonoFixedLine = svg.querySelector('#sonoFixedLine');
    const sonoFixedLabel = svg.querySelector('#sonoFixedLabel');
    const hoverPointsGroup = svg.querySelector('#hoverPoints'); // Parent Group
    const hoverPoints = svg.querySelectorAll('.hover-point');
    const bubbles = svg.querySelectorAll('.hover-bubble');
    const horizontalLines = svg.querySelectorAll('#horizontalLinesGroup line');
    const axisText = svg.querySelectorAll('#graphTextGroup text');
    // 1. Initial States (Hide everything first)
    if (graphLine) {
        const length = graphLine.getTotalLength();
        (0, $6255c273005a4429$export$99ee26438460406a).set(graphLine, {
            strokeDasharray: length,
            strokeDashoffset: length,
            opacity: 1
        });
    }
    if (sonoFixedLine) (0, $6255c273005a4429$export$99ee26438460406a).set(sonoFixedLine, {
        scaleX: 0,
        transformOrigin: 'left center',
        opacity: 1
    });
    // Ensure Parent Group is visible
    if (hoverPointsGroup) (0, $6255c273005a4429$export$99ee26438460406a).set(hoverPointsGroup, {
        attr: {
            opacity: 1
        },
        opacity: 1
    });
    if (sonoFixedLabel) (0, $6255c273005a4429$export$99ee26438460406a).set(sonoFixedLabel, {
        autoAlpha: 0,
        y: 20
    });
    (0, $6255c273005a4429$export$99ee26438460406a).set(hoverPoints, {
        scale: 0,
        transformOrigin: 'center center',
        autoAlpha: 0
    });
    (0, $6255c273005a4429$export$99ee26438460406a).set(bubbles, {
        autoAlpha: 0,
        scale: 0,
        transformOrigin: 'center bottom'
    });
    (0, $6255c273005a4429$export$99ee26438460406a).set(horizontalLines, {
        scaleX: 0,
        transformOrigin: 'left center',
        autoAlpha: 0
    });
    (0, $6255c273005a4429$export$99ee26438460406a).set(axisText, {
        autoAlpha: 0,
        y: 10
    });
    // 2. Timeline
    const tl = (0, $6255c273005a4429$export$99ee26438460406a).timeline({
        scrollTrigger: {
            trigger: container,
            start: "top 75%",
            once: true
        }
    });
    tl// Step 1: Background
    .to(horizontalLines, {
        scaleX: 1,
        opacity: 0.1,
        duration: 0.8,
        stagger: 0.1,
        ease: "power2.out"
    }).to(axisText, {
        opacity: 0.6,
        y: 0,
        duration: 0.6,
        stagger: 0.05,
        ease: "power2.out"
    }, "-=0.6")// Step 2: Lines
    .to(graphLine, {
        strokeDashoffset: 0,
        duration: 2,
        ease: "power2.inOut"
    }, "-=0.2").to(sonoFixedLine, {
        scaleX: 1,
        duration: 1.5,
        ease: "power2.out"
    }, "<")// Step 3: Label
    .to(sonoFixedLabel, {
        autoAlpha: 1,
        y: 0,
        duration: 0.8,
        ease: "back.out(1.7)"
    }, "-=1")// Step 4: Points & Bubbles
    .to(hoverPoints, {
        autoAlpha: 1,
        scale: 1,
        duration: 0.5,
        stagger: 0.25,
        ease: "back.out(2)"
    }, "-=1.2").to(bubbles, {
        autoAlpha: 1,
        scale: 1,
        duration: 0.4,
        stagger: 0.25,
        ease: "back.out(1.5)"
    }, "<+=0.1");
    // 3. Hover Interaction
    hoverPoints.forEach((point)=>{
        point.addEventListener('mouseenter', ()=>{
            (0, $6255c273005a4429$export$99ee26438460406a).to(point, {
                scale: 1.3,
                duration: 0.3,
                ease: 'back.out(1.7)'
            });
        });
        point.addEventListener('mouseleave', ()=>{
            (0, $6255c273005a4429$export$99ee26438460406a).to(point, {
                scale: 1,
                duration: 0.3,
                ease: 'power2.out'
            });
        });
    });
}


//# sourceMappingURL=path0.fea37ce8.js.map
